import { LitElement as e, css as t, html as n, nothing as r, svg as i } from "lit";
import { customElement as a, property as o, query as s, state as c } from "lit/decorators.js";
import { nothing as l } from "lit/html.js";
import { directive as u } from "lit/directive.js";
import { AsyncDirective as d } from "lit/async-directive.js";
import { unsafeHTML as f } from "lit/directives/unsafe-html.js";
import { consume as p, createContext as ee, provide as m } from "@lit-labs/context";
import { ref as h } from "lit/directives/ref.js";
import { styleMap as g } from "lit/directives/style-map.js";
import { html as _ } from "lit-element";
//#region \0rolldown/runtime.js
var te = Object.create, ne = Object.defineProperty, v = Object.getOwnPropertyDescriptor, re = Object.getOwnPropertyNames, ie = Object.getPrototypeOf, y = Object.prototype.hasOwnProperty, b = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), ae = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = re(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !y.call(e, s) && s !== n && ne(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = v(t, s)) || r.enumerable
	});
	return e;
}, oe = (e, t, n) => (n = e == null ? {} : te(ie(e)), ae(t || !e || !e.__esModule ? ne(n, "default", {
	value: e,
	enumerable: !0
}) : n, e));
//#endregion
//#region \0@oxc-project+runtime@0.133.0/helpers/esm/decorateMetadata.js
function x(e, t) {
	if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(e, t);
}
//#endregion
//#region \0@oxc-project+runtime@0.133.0/helpers/esm/decorate.js
function S(e, t, n, r) {
	var i = arguments.length, a = i < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, n) : r, o;
	if (typeof Reflect == "object" && typeof Reflect.decorate == "function") a = Reflect.decorate(e, t, n, r);
	else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
	return i > 3 && a && Object.defineProperty(t, n, a), a;
}
//#endregion
//#region src/helpers/base-element.ts
var C = class extends e {
	constructor() {
		super(), this.customClass = "", this.customStyle = "";
	}
	getAttributesToExclude() {
		return [];
	}
	getAttributesToRemoveFromParent() {
		return ["class"];
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.mutationObserver?.disconnect();
	}
	removeParentAttributes() {
		this.getAttributesToRemoveFromParent().forEach((e) => {
			e === "class" && this.hasAttribute("class") && (this.customClass = this.getAttribute("class") || ""), e === "style" && this.hasAttribute("style") && (this.customStyle = this.getAttribute("style") || ""), this.hasAttribute(e) && this.removeAttribute(e);
		});
	}
	getFilteredAttributes() {
		let e = {};
		return Array.from(this.attributes).forEach((t) => {
			this.getAttributesToExclude().includes(t.name) || (e[t.name] = t.value ?? "");
		}), e;
	}
	isCustomPropertySet(e) {
		let t = getComputedStyle(this).getPropertyValue(e).trim();
		return t !== "inherit" && t.length > 0;
	}
	applyCustomClass(e, t, n = "") {
		let r = "";
		e.some((e) => this.isCustomPropertySet(e)) && (r = n), r && this.shadowRoot?.querySelector(t)?.classList.add(r);
	}
	removeDuplicateContent() {
		let e = document.createTreeWalker(this, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, { acceptNode: (e) => e.nodeType === Node.COMMENT_NODE || e.nodeType === Node.TEXT_NODE && !e.textContent?.trim() ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT }), t = /* @__PURE__ */ new Map(), n = [], r;
		for (; r = e.nextNode();) {
			let e;
			if (r.nodeType === Node.TEXT_NODE) {
				let t = r.textContent?.trim();
				if (!t) continue;
				e = `text:${t}`;
			} else if (r instanceof HTMLElement) {
				let t = Array.from(r.attributes).map((e) => `${e.name}=${e.value}`).sort().join(":");
				e = `element:${r.tagName}:${t}`;
			} else continue;
			if (t.has(e)) {
				let i = t.get(e);
				i && i.parentNode && n.push(i), t.set(e, r);
			} else t.set(e, r);
		}
		n.forEach((e) => {
			e.parentNode && (console.log("Removing duplicate:", e), e.parentNode.removeChild(e));
		});
	}
	moveLightDomChildrenInto(e, t) {
		let n;
		if (t && t.length > 0) {
			n = t.filter((t) => this.contains(t) && t !== e && !t.contains(e));
			for (let t of n) {
				let n = Array.from(e.childNodes).find((e) => e.isEqualNode?.(t));
				n && e.removeChild(n);
			}
		} else n = Array.from(this.childNodes).filter((t) => t !== e && !e.contains(t) && !t.contains(e));
		for (let t of n) e.appendChild(t);
	}
	normalizeEnum(e, t, n) {
		if (!e) return n;
		let r = Object.values(t), i = Object.keys(t);
		return r.includes(e) ? e : i.includes(e) ? t[e] : n;
	}
	observeStyleAndClassSync(e) {
		this.mutationObserver = new MutationObserver((t) => {
			for (let n of t) if (n.type === "attributes") {
				if (n.attributeName === "style") {
					let e = this.getAttribute("style") || "";
					e && (this.customStyle = e, this.removeAttribute("style"));
				}
				if (n.attributeName === "class") {
					let t = this.getAttribute("class") || "";
					t && (e.className = t, this.removeAttribute("class"));
				}
			}
		}), this.mutationObserver.observe(this, {
			attributes: !0,
			attributeFilter: ["style", "class"]
		});
	}
};
S([o({
	type: String,
	reflect: !0
}), x("design:type", Object)], C.prototype, "customClass", void 0), S([o({
	type: String,
	reflect: !0
}), x("design:type", Object)], C.prototype, "customStyle", void 0);
//#endregion
//#region src/helpers/genrate-uuid.helper.ts
function w() {
	let e = (/* @__PURE__ */ new Date()).getTime();
	return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(t) {
		let n = (e + Math.random() * 16) % 16 | 0;
		return (t == "x" ? n : n & 3 | 8).toString(16);
	});
}
//#endregion
//#region src/styles/tw.styles.ts
var se = t` 
@font-face {
  font-family: 'GeistSans';

  src: url('assets/fonts/Geist/GeistVariableVF.woff2') format('woff2');
}

/*
! tailwindcss v3.4.10 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box;
  /* 1 */
  border-width: 0;
  /* 2 */
  border-style: solid;
  /* 2 */
  border-color: #e5e7eb;
  /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured sans font-family by default.
5. Use the user's configured sans font-feature-settings by default.
6. Use the user's configured sans font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5;
  /* 1 */
  -webkit-text-size-adjust: 100%;
  /* 2 */
  -moz-tab-size: 4;
  /* 3 */
  -o-tab-size: 4;
     tab-size: 4;
  /* 3 */
  font-family: var(--font-sans), ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  /* 4 */
  font-feature-settings: normal;
  /* 5 */
  font-variation-settings: normal;
  /* 6 */
  -webkit-tap-highlight-color: transparent;
  /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from html so users can set them as a class directly on the html element.
*/

body {
  margin: 0;
  /* 1 */
  line-height: inherit;
  /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0;
  /* 1 */
  color: inherit;
  /* 2 */
  border-top-width: 1px;
  /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured mono font-family by default.
2. Use the user's configured mono font-feature-settings by default.
3. Use the user's configured mono font-variation-settings by default.
4. Correct the odd em font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  /* 1 */
  font-feature-settings: normal;
  /* 2 */
  font-variation-settings: normal;
  /* 3 */
  font-size: 1em;
  /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent sub and sup elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0;
  /* 1 */
  border-color: inherit;
  /* 2 */
  border-collapse: collapse;
  /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  /* 1 */
  font-feature-settings: inherit;
  /* 1 */
  font-variation-settings: inherit;
  /* 1 */
  font-size: 100%;
  /* 1 */
  font-weight: inherit;
  /* 1 */
  line-height: inherit;
  /* 1 */
  letter-spacing: inherit;
  /* 1 */
  color: inherit;
  /* 1 */
  margin: 0;
  /* 2 */
  padding: 0;
  /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button;
  /* 1 */
  background-color: transparent;
  /* 2 */
  background-image: none;
  /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional :invalid styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield;
  /* 1 */
  outline-offset: -2px;
  /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to inherit in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button;
  /* 1 */
  font: inherit;
  /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1;
  /* 1 */
  color: #9ca3af;
  /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1;
  /* 1 */
  color: #9ca3af;
  /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements display: block by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add vertical-align: middle to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block;
  /* 1 */
  vertical-align: middle;
  /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden] {
  display: none;
}

:root {
  --background: 0 0% 100%;
  --foreground: 240 10% 3.9%;
  --card: 0 0% 100%;
  --card-foreground: 240 10% 3.9%;
  --popover: 0 0% 100%;
  --popover-foreground: 240 10% 3.9%;
  --primary: 240 5.9% 10%;
  --primary-foreground: 0 0% 98%;
  --secondary: 240 4.8% 95.9%;
  --secondary-foreground: 240 5.9% 10%;
  --muted: 240 4.8% 95.9%;
  --muted-foreground: 240 4% 46%;
  --accent: 240 5% 96%;
  --accent-foreground: 240 6% 10%;
  --destructive: 0 84.2% 60.2%;
  --destructive-foreground: 0 0% 98%;
  --border: 240 5.9% 90%;
  --input: 240 5.9% 90%;
  --ring: 240 5.9% 10%;
  --radius: 0.5rem;
  --green-100: #d4f8e8;
  --green-200: #bbf7d0;
  --green-800: #166534;
  --red-100: #fddddd;
  --red-200: #fecaca;
  --red-800: #991b1b;
  --yellow-100: #fef4d9;
  --yellow-200: #fef08a;
  --yellow-800: #854d0e;
  --blue-100: #dbeafe;
  --blue-200: #bfdbfe;
  --blue-800: #1e40af;
}

.dark {
  --background: 240 10% 4%;
  --foreground: 0 0% 98%;
  --card: 240 10% 3.9%;
  --card-foreground: 0 0% 98%;
  --popover: 240 10% 3.9%;
  --popover-foreground: 0 0% 98%;
  --primary: 0 0% 98%;
  --primary-foreground: 240 5.9% 10%;
  --secondary: 240 3.7% 15.9%;
  --secondary-foreground: 0 0% 98%;
  --muted: 240 3.7% 15.9%;
  --muted-foreground: 240 5% 65%;
  --accent: 240 4% 16%;
  --accent-foreground: 0 0% 98%;
  --destructive: 0 62.8% 30.6%;
  --destructive-foreground: 0 0% 98%;
  --border: 240 3.7% 15.9%;
  --input: 240 3.7% 15.9%;
  --ring: 240 4.9% 83.9%;
  --green-100: #d4f8e8;
  --green-200: #bbf7d0;
  --green-800: #166534;
  --red-100: #fddddd;
  --red-200: #fecaca;
  --red-800: #991b1b;
  --yellow-100: #fef4d9;
  --yellow-200: #fef08a;
  --yellow-800: #854d0e;
  --blue-100: #dbeafe;
  --blue-200: #bfdbfe;
  --blue-800: #1e40af;
}

* {
  border-color: hsl(var(--border));
  font-family: GeistSans, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}

body {
  background-color: hsl(var(--background));
  color: hsl(var(--foreground));
  font-synthesis-weight: none;
  text-rendering: optimizeLegibility;
}

/* p {
    margin-top: 6px;
    margin-block-start: 6px;
  } */

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 2rem;
  padding-left: 2rem;
}

@media (min-width: 1400px) {
  .container {
    max-width: 1400px;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.pointer-events-none {
  pointer-events: none;
}

.pointer-events-auto {
  pointer-events: auto;
}

.visible {
  visibility: visible;
}

.invisible {
  visibility: hidden;
}

.collapse {
  visibility: collapse;
}

.static {
  position: static;
}

.fixed {
  position: fixed;
}

.absolute {
  position: absolute;
}

.relative {
  position: relative;
}

.inset-0 {
  inset: 0px;
}

.bottom-0 {
  bottom: 0px;
}

.end-3 {
  inset-inline-end: 0.75rem;
}

.left-2 {
  left: 0.5rem;
}

.left-\\[50\\%\\] {
  left: 50%;
}

.right-0 {
  right: 0px;
}

.right-1 {
  right: 0.25rem;
}

.right-4 {
  right: 1rem;
}

.top-0 {
  top: 0px;
}

.top-1 {
  top: 0.25rem;
}

.top-4 {
  top: 1rem;
}

.top-\\[50\\%\\] {
  top: 50%;
}

.top-auto {
  top: auto;
}

.z-10 {
  z-index: 10;
}

.z-50 {
  z-index: 50;
}

.z-\\[100\\] {
  z-index: 100;
}

.col-span-2 {
  grid-column: span 2 / span 2;
}

.col-span-3 {
  grid-column: span 3 / span 3;
}

.m-5 {
  margin: 1.25rem;
}

.m-auto {
  margin: auto;
}

.-mx-1 {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}

.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}

.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}

.mx-5 {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.my-10 {
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}

.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}

.mb-1 {
  margin-bottom: 0.25rem;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.mb-6 {
  margin-bottom: 1.5rem;
}

.ml-auto {
  margin-left: auto;
}

.mr-10 {
  margin-right: 2.5rem;
}

.mr-2 {
  margin-right: 0.5rem;
}

.mt-1 {
  margin-top: 0.25rem;
}

.mt-2 {
  margin-top: 0.5rem;
}

.mt-4 {
  margin-top: 1rem;
}

.mt-5 {
  margin-top: 1.25rem;
}

.mt-6 {
  margin-top: 1.5rem;
}

.mt-7 {
  margin-top: 1.75rem;
}

.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.block {
  display: block;
}

.inline {
  display: inline;
}

.flex {
  display: flex;
}



.inline-flex {
  display: inline-flex;
}

.table {
  display: table;
}

.grid {
  display: grid;
}

.contents {
  display: contents;
}

.hidden {
  display: none;
}

.aspect-square {
  aspect-ratio: 1 / 1;
}

.size-24 {
  width: 6rem;
  height: 6rem;
}

.size-3 {
  width: 0.75rem;
  height: 0.75rem;
}

.size-3\\.5 {
  width: 0.875rem;
  height: 0.875rem;
}

.size-4 {
  width: 1rem;
  height: 1rem;
}

.size-max {
  width: -moz-max-content;
  width: max-content;
  height: -moz-max-content;
  height: max-content;
}

.h-0{
  height: 0px
}
.h-1 {
  height: 0.25rem;
}

.h-10 {
  height: 2.5rem;
}

.h-11 {
  height: 2.75rem;
}

.h-2 {
  height: 0.5rem;
}

.h-3 {
  height: 0.75rem;
}

.h-3\\.5 {
  height: 0.875rem;
}

.h-4 {
  height: 1rem;
}

.h-5 {
  height: 1.25rem;
}

.h-7 {
  height: 1.75rem;
}

.h-8 {
  height: 2rem;
}

.h-9 {
  height: 2.25rem;
}

.h-\\[1px\\] {
  height: 1px;
}

.h-\\[400px\\] {
  height: 400px;
}

.h-\\[40px\\] {
  height: 40px;
}

.h-full {
  height: 100%;
}

.h-px {
  height: 1px;
}

.max-h-72 {
  max-height: 18rem;
}

.max-h-\\[300px\\] {
  max-height: 300px;
}

.max-h-screen {
  max-height: 100vh;
}

.min-h-\\[80px\\] {
  min-height: 80px;
}

.w-0{
  width: 0px
}

.w-1 {
  width: 0.25rem;
}

.w-10 {
  width: 2.5rem;
}

.w-2 {
  width: 0.5rem;
}

.w-3 {
  width: 0.75rem;
}

.w-3\\.5 {
  width: 0.875rem;
}

.w-32 {
  width: 8rem;
}

.w-4 {
  width: 1rem;
}

.w-5 {
  width: 1.25rem;
}

.w-64 {
  width: 16rem;
}

.w-72 {
  width: 18rem;
}

.w-8 {
  width: 2rem;
}

.w-80 {
  width: 20rem;
}

.w-9 {
  width: 2.25rem;
}

.w-96 {
  width: 24rem;
}

.w-\\[180px\\] {
  width: 180px;
}

.w-\\[1px\\] {
  width: 1px;
}

.w-\\[350px\\] {
  width: 350px;
}

.w-\\[400px\\] {
  width: 400px;
}

.w-\\[40px\\] {
  width: 40px;
}

.w-auto {
  width: auto;
}

.w-full {
  width: 100%;
}

.w-max {
  width: -moz-max-content;
  width: max-content;
}

.w-min {
  width: -moz-min-content;
  width: min-content;
}

.min-w-60 {
  min-width: 15rem;
}

.min-w-80 {
  min-width: 20rem;
}

.min-w-\\[8rem\\] {
  min-width: 8rem;
}

.max-w-\\[260px\\] {
  max-width: 260px;
}

.max-w-lg {
  max-width: 32rem;
}

.max-w-md {
  max-width: 28rem;
}

.max-w-sm {
  max-width: 24rem;
}

.flex-1 {
  flex: 1 1 0%;
}

.flex-auto {
  flex: 1 1 auto;
}

.flex-shrink {
  flex-shrink: 1;
}

.shrink-0 {
  flex-shrink: 0;
}

.flex-grow {
  flex-grow: 1;
}

.border-collapse {
  border-collapse: collapse;
}

.border-spacing-2 {
  --tw-border-spacing-x: 0.5rem;
  --tw-border-spacing-y: 0.5rem;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
}

.border-spacing-6 {
  --tw-border-spacing-x: 1.5rem;
  --tw-border-spacing-y: 1.5rem;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
}

.-translate-y-1 {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-\\[-50\\%\\] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-y-\\[-50\\%\\] {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.scale-95 {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}

.cursor-default {
  cursor: default;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.cursor-pointer {
  cursor: pointer;
}

.select-none {
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.resize {
  resize: both;
}

.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.flex-row {
  flex-direction: row;
}

.flex-row-reverse{
  flex-direction: row-reverse;
}

.flex-col {
  flex-direction: column;
}

.flex-col-reverse {
  flex-direction: column-reverse;
}

.flex-wrap {
  flex-wrap: wrap;
}

.flex-nowrap {
  flex-wrap: nowrap;
}

.items-start {
  align-items: flex-start;
}

.items-center {
  align-items: center;
}

.items-stretch {
  align-items: stretch;
}

.justify-start {
  justify-content: flex-start;
}

.justify-end {
  justify-content: flex-end;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.justify-stretch {
  justify-content: stretch;
}

.gap-1 {
  gap: 0.25rem;
}

.gap-1\\.5 {
  gap: 0.375rem;
}

.gap-10 {
  gap: 2.5rem;
}

.gap-2 {
  gap: 0.5rem;
}

.gap-20 {
  gap: 5rem;
}

.gap-3 {
  gap: 0.75rem;
}

.gap-4 {
  gap: 1rem;
}

.gap-5 {
  gap: 1.25rem;
}

.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}

.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}

.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}

.space-y-10 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
}

.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}

.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}

.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}

.overflow-hidden {
  overflow: hidden;
}

.overflow-y-auto {
  overflow-y: auto;
}

.overflow-x-hidden {
  overflow-x: hidden;
}

.whitespace-nowrap {
  white-space: nowrap;
}

.text-wrap {
  text-wrap: wrap;
}

.break-words {
  overflow-wrap: break-word;
}

.rounded {
  border-radius: 0.25rem;
}

.rounded-full {
  border-radius: 9999px;
}

.rounded-2xl {
  border-radius: calc(var(--radius) + 8px);
}

.rounded-xl {
  border-radius: calc(var(--radius) + 4px);
}

.rounded-lg {
  border-radius: var(--radius);
}

.rounded-md {
  border-radius: calc(var(--radius) - 2px);
}

.rounded-sm {
  border-radius: calc(var(--radius) - 4px);
}

.rounded-r-md {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.border {
  border-width: 1px;
}

.border-0 {
  border-width: 0px;
}

.border-2 {
  border-width: 2px;
}

.border-4 {
  border-width: 4px;
}

.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}

.border-b {
  border-bottom-width: 1px;
}

.border-b-2 {
  border-bottom-width: 2px;
}

.border-l {
  border-left-width: 1px;
}

.border-r {
  border-right-width: 1px;
}

.border-t-2 {
  border-top-width: 2px;
}

.border-blue-200 {
  border-color: var(--blue-200);
}

.border-destructive {
  border-color: hsl(var(--destructive));
}

.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}

.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}

.border-green-200 {
  border-color: var(--green-200);
}

.border-input {
  border-color: hsl(var(--input));
}

.border-muted {
  border-color: hsl(var(--muted));
}

.border-primary {
  border-color: hsl(var(--primary));
}

.border-red-200 {
  border-color: var(--red-200);
}

.border-slate-50 {
  --tw-border-opacity: 1;
  border-color: rgb(248 250 252 / var(--tw-border-opacity));
}

.border-slate-500 {
  --tw-border-opacity: 1;
  border-color: rgb(100 116 139 / var(--tw-border-opacity));
}

.border-transparent {
  border-color: transparent;
}

.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.border-yellow-200 {
  border-color: var(--yellow-200);
}

.bg-accent {
  background-color: hsl(var(--accent));
}

.bg-background {
  background-color: hsl(var(--background));
}

.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}

.bg-black\\/80 {
  background-color: rgb(0 0 0 / 0.8);
}

.bg-blue-100 {
  background-color: var(--blue-100);
}

.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}

.bg-border {
  background-color: hsl(var(--border));
}

.bg-card {
  background-color: hsl(var(--card));
}

.bg-destructive {
  background-color: hsl(var(--destructive));
}

.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.bg-green-100 {
  background-color: var(--green-100);
}

.bg-muted {
  background-color: hsl(var(--muted));
}

.bg-popover {
  background-color: hsl(var(--popover));
}

.bg-primary {
  background-color: hsl(var(--primary));
}

.bg-red-100 {
  background-color: var(--red-100);
}

.bg-red-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity));
}

.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}

.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity));
}

.bg-secondary {
  background-color: hsl(var(--secondary));
}

.bg-transparent {
  background-color: transparent;
}

.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.bg-yellow-100 {
  background-color: var(--yellow-100);
}

.fill-current {
  fill: currentColor;
}

.fill-primary {
  fill: hsl(var(--primary));
}

.object-cover {
  -o-object-fit: cover;
     object-fit: cover;
}

.p-0 {
  padding: 0;
}

.p-1 {
  padding: 0.25rem;
}

.p-3 {
  padding: 0.75rem;
}

.p-4 {
  padding: 1rem;
}

.p-5 {
  padding: 1.25rem;
}

.p-6 {
  padding: 1.5rem;
}

.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}

.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}

.py-0 {
  padding-top: 0;
  padding-bottom: 0;
}

.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}

.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.pb-1 {
  padding-bottom: 0.25rem;
}

.pb-4 {
  padding-bottom: 1rem;
}

.pe-9 {
  padding-inline-end: 2.25rem;
}

.pr-6 {
  padding-right: 1.5rem;
}

.ps-4 {
  padding-inline-start: 1rem;
}

.pt-0 {
  padding-top: 0;
}

.pt-1 {
  padding-top: 0.25rem;
}

.pt-2 {
  padding-top: 0.5rem;
}

.pt-3 {
  padding-top: 0.75rem;
}

.pt-4 {
  padding-top: 1rem;
}

.pt-6 {
  padding-top: 1.5rem;
}

.text-left {
  text-align: left;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.align-baseline {
  vertical-align: baseline;
}

.align-top {
  vertical-align: top;
}

.align-middle {
  vertical-align: middle;
}

.align-bottom {
  vertical-align: bottom;
}

.font-geist {
  font-family: GeistSans, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}

.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}

.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}

.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}

.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}

.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}

.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}

.font-bold {
  font-weight: 700;
}

.font-medium {
  font-weight: 500;
}

.font-normal {
  font-weight: 400;
}
.font-thin {
  font-weight: 300;
}

.font-semibold {
  font-weight: 600;
}

.uppercase {
  text-transform: uppercase;
}

.capitalize {
  text-transform: capitalize;
}

.leading-none {
  line-height: 1;
}

.tracking-tight {
  letter-spacing: -0.025em;
}

.tracking-widest {
  letter-spacing: 0.1em;
}

.text-accent-foreground {
  color: hsl(var(--accent-foreground));
}

.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity));
}

.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity));
}

.text-blue-800 {
  color: var(--blue-800);
}

.text-card-foreground {
  color: hsl(var(--card-foreground));
}

.text-current {
  color: currentColor;
}

.text-destructive-foreground {
  color: hsl(var(--destructive-foreground));
}

.text-foreground {
  color: hsl(var(--foreground));
}

.text-foreground\\/50 {
  color: hsl(var(--foreground) / 0.5);
}

.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}

.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}

.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}

.text-green-800 {
  color: var(--green-800);
}

.text-muted {
  color: hsl(var(--muted));
}

.text-muted-foreground {
  color: hsl(var(--muted-foreground));
}

.text-popover-foreground {
  color: hsl(var(--popover-foreground));
}

.text-primary {
  color: hsl(var(--primary));
}

.text-primary-foreground {
  color: hsl(var(--primary-foreground));
}

.text-red-300 {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity));
}

.text-red-800 {
  color: var(--red-800);
}

.text-secondary {
  color: hsl(var(--secondary));
}

.text-secondary-foreground {
  color: hsl(var(--secondary-foreground));
}

.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.text-yellow-800 {
  color: var(--yellow-800);
}

.underline {
  text-decoration-line: underline;
}

.underline-offset-4 {
  text-underline-offset: 4px;
}

.opacity-0 {
  opacity: 0;
}

.opacity-100 {
  opacity: 1;
}

.opacity-40 {
  opacity: 0.4;
}

.opacity-50 {
  opacity: 0.5;
}

.opacity-70 {
  opacity: 0.7;
}

.opacity-90 {
  opacity: 0.9;
}

.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.outline {
  outline-style: solid;
}

.ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.ring-ring {
  --tw-ring-color: hsl(var(--ring));
}

.ring-offset-background {
  --tw-ring-offset-color: hsl(var(--background));
}

.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.duration-200 {
  transition-duration: 200ms;
}

.duration-500 {
  transition-duration: 500ms;
}

@keyframes enter {
  from {
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}

@keyframes exit {
  to {
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}

.slide-in-from-left-1 {
  --tw-enter-translate-x: -0.25rem;
}

.slide-out-to-left-1 {
  --tw-exit-translate-x: -0.25rem;
}

.duration-200 {
  animation-duration: 200ms;
}

.duration-500 {
  animation-duration: 500ms;
}

@media (max-width: 640px) {
  .container {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

.file\\:border-0::file-selector-button {
  border-width: 0px;
}

.file\\:bg-transparent::file-selector-button {
  background-color: transparent;
}

.file\\:text-sm::file-selector-button {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.file\\:font-medium::file-selector-button {
  font-weight: 500;
}

.file\\:text-foreground::file-selector-button {
  color: hsl(var(--foreground));
}

.placeholder\\:text-muted-foreground::-moz-placeholder {
  color: hsl(var(--muted-foreground));
}

.placeholder\\:text-muted-foreground::placeholder {
  color: hsl(var(--muted-foreground));
}

.first\\:rounded-l-md:first-child {
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}

.first\\:border-l:first-child {
  border-left-width: 1px;
}

.last\\:rounded-r-md:last-child {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}

.hover\\:bg-accent:hover {
  background-color: hsl(var(--accent));
}

.hover\\:bg-destructive\\/90:hover {
  background-color: hsl(var(--destructive) / 0.9);
}

.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.hover\\:bg-muted:hover {
  background-color: hsl(var(--muted));
}

.hover\\:bg-primary\\/90:hover {
  background-color: hsl(var(--primary) / 0.9);
}

.hover\\:bg-secondary:hover {
  background-color: hsl(var(--secondary));
}

.hover\\:bg-secondary\\/80:hover {
  background-color: hsl(var(--secondary) / 0.8);
}

.hover\\:text-accent-foreground:hover {
  color: hsl(var(--accent-foreground));
}

.hover\\:text-foreground:hover {
  color: hsl(var(--foreground));
}

.hover\\:text-muted-foreground:hover {
  color: hsl(var(--muted-foreground));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:opacity-100:hover {
  opacity: 1;
}

.focus\\:border:focus {
  border-width: 1px;
}

.focus\\:border-\\[3px\\]:focus {
  border-width: 3px;
}

.focus\\:border-\\[\\#c1c1c1\\]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(193 193 193 / var(--tw-border-opacity));
}

.focus\\:bg-accent:focus {
  background-color: hsl(var(--accent));
}

.focus\\:bg-gray-100:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.focus\\:text-accent-foreground:focus {
  color: hsl(var(--accent-foreground));
}

.focus\\:opacity-100:focus {
  opacity: 1;
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-ring:focus {
  --tw-ring-color: hsl(var(--ring));
}

.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:ring-0:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-1:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-ring:focus-visible {
  --tw-ring-color: hsl(var(--ring));
}

.focus-visible\\:ring-offset-2:focus-visible {
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:ring-offset-background:focus-visible {
  --tw-ring-offset-color: hsl(var(--background));
}

.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}

.group.destructive .group-\\[\\.destructive\\]\\:border-muted\\/40 {
  border-color: hsl(var(--muted) / 0.4);
}

.group.destructive .group-\\[\\.destructive\\]\\:text-red-300 {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity));
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:hover {
  border-color: hsl(var(--destructive) / 0.3);
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:bg-destructive:hover {
  background-color: hsl(var(--destructive));
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground:hover {
  color: hsl(var(--destructive-foreground));
}

.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-red-50:hover {
  --tw-text-opacity: 1;
  color: rgb(254 242 242 / var(--tw-text-opacity));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-destructive:focus {
  --tw-ring-color: hsl(var(--destructive));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity));
}

.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:focus {
  --tw-ring-offset-color: #dc2626;
}

.peer:disabled ~ .peer-disabled\\:cursor-not-allowed {
  cursor: not-allowed;
}

.peer:disabled ~ .peer-disabled\\:opacity-70 {
  opacity: 0.7;
}

.aria-selected\\:bg-accent[aria-selected="true"] {
  background-color: hsl(var(--accent));
}

.aria-selected\\:text-accent-foreground[aria-selected="true"] {
  color: hsl(var(--accent-foreground));
}

.data-\\[disabled\\]\\:pointer-events-none[data-disabled] {
  pointer-events: none;
}

.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe="cancel"] {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe="end"] {
  --tw-translate-x: var(--radix-toast-swipe-end-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"] {
  --tw-translate-x: var(--radix-toast-swipe-move-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@keyframes accordion-up {
  from {
    height: var(--radix-accordion-content-height);
  }

  to {
    height: 0;
  }
}

.data-\\[state\\=closed\\]\\:animate-accordion-up[data-state="closed"] {
  animation: accordion-up 0.2s ease-out;
}

@keyframes accordion-down {
  from {
    height: 0;
  }

  to {
    height: var(--radix-accordion-content-height);
  }
}

.data-\\[state\\=open\\]\\:animate-accordion-down[data-state="open"] {
  animation: accordion-down 0.2s ease-out;
}

.data-\\[state\\=active\\]\\:bg-background[data-state="active"] {
  background-color: hsl(var(--background));
}

.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"] {
  background-color: hsl(var(--primary));
}

.data-\\[state\\=on\\]\\:bg-accent[data-state="on"] {
  background-color: hsl(var(--accent));
}

.data-\\[state\\=open\\]\\:bg-accent[data-state="open"] {
  background-color: hsl(var(--accent));
}

.data-\\[state\\=active\\]\\:text-foreground[data-state="active"] {
  color: hsl(var(--foreground));
}

.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"] {
  color: hsl(var(--primary-foreground));
}

.data-\\[state\\=on\\]\\:text-accent-foreground[data-state="on"] {
  color: hsl(var(--accent-foreground));
}

.data-\\[state\\=open\\]\\:text-muted-foreground[data-state="open"] {
  color: hsl(var(--muted-foreground));
}

.data-\\[disabled\\]\\:opacity-50[data-disabled] {
  opacity: 0.5;
}

.data-\\[state\\=active\\]\\:shadow-sm[data-state="active"] {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\\[swipe\\=move\\]\\:transition-none[data-swipe="move"] {
  transition-property: none;
}

.data-\\[state\\=open\\]\\:animate-in[data-state="open"] {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}

.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[swipe\\=end\\]\\:animate-out[data-swipe="end"] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"] {
  --tw-exit-opacity: 0;
}

.data-\\[state\\=closed\\]\\:fade-out-80[data-state="closed"] {
  --tw-exit-opacity: 0.8;
}

.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"] {
  --tw-enter-opacity: 0;
}

.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"] {
  --tw-exit-scale: .95;
}

.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"] {
  --tw-enter-scale: .95;
}

.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"] {
  --tw-enter-translate-y: -0.5rem;
}

.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"] {
  --tw-enter-translate-x: 0.5rem;
}

.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"] {
  --tw-enter-translate-x: -0.5rem;
}

.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"] {
  --tw-enter-translate-y: 0.5rem;
}

.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"] {
  --tw-exit-translate-x: -50%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-right-full[data-state="closed"] {
  --tw-exit-translate-x: 100%;
}

.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"] {
  --tw-exit-translate-y: -48%;
}

.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"] {
  --tw-enter-translate-x: -50%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"] {
  --tw-enter-translate-y: -48%;
}

.data-\\[state\\=open\\]\\:slide-in-from-top-full[data-state="open"] {
  --tw-enter-translate-y: -100%;
}

.dark\\:border-neutral-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(64 64 64 / var(--tw-border-opacity));
}

.dark\\:bg-neutral-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(23 23 23 / var(--tw-bg-opacity));
}

.dark\\:text-blue-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}

.dark\\:text-neutral-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(229 229 229 / var(--tw-text-opacity));
}

.dark\\:text-neutral-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(115 115 115 / var(--tw-text-opacity));
}

.dark\\:hover\\:bg-neutral-800:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(38 38 38 / var(--tw-bg-opacity));
}

.dark\\:focus\\:bg-neutral-800:focus:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(38 38 38 / var(--tw-bg-opacity));
}

@media (min-width: 640px) {
  .sm\\:bottom-0 {
    bottom: 0px;
  }

  .sm\\:right-0 {
    right: 0px;
  }

  .sm\\:top-auto {
    top: auto;
  }

  .sm\\:max-w-\\[425px\\] {
    max-width: 425px;
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:flex-col {
    flex-direction: column;
  }

  .sm\\:justify-end {
    justify-content: flex-end;
  }

  .sm\\:gap-2\\.5 {
    gap: 0.625rem;
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:rounded-lg {
    border-radius: var(--radius);
  }

  .sm\\:text-left {
    text-align: left;
  }

  .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full[data-state="open"] {
    --tw-enter-translate-y: 100%;
  }
}

@media (min-width: 768px) {
  .md\\:max-w-\\[420px\\] {
    max-width: 420px;
  }
}

.\\[\\&\\+div\\]\\:text-xs+div {
  font-size: 0.75rem;
  line-height: 1rem;
}

.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:rounded-full::-webkit-scrollbar-thumb {
  border-radius: 9999px;
}

.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:bg-gray-300::-webkit-scrollbar-thumb {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}

.dark\\:\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:bg-neutral-500:is(.dark *)::-webkit-scrollbar-thumb {
  --tw-bg-opacity: 1;
  background-color: rgb(115 115 115 / var(--tw-bg-opacity));
}

.\\[\\&\\:\\:-webkit-scrollbar-track\\]\\:bg-gray-100::-webkit-scrollbar-track {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.dark\\:\\[\\&\\:\\:-webkit-scrollbar-track\\]\\:bg-neutral-700:is(.dark *)::-webkit-scrollbar-track {
  --tw-bg-opacity: 1;
  background-color: rgb(64 64 64 / var(--tw-bg-opacity));
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:w-2::-webkit-scrollbar {
  width: 0.5rem;
}

.\\[\\&\\>svg\\]\\:size-3\\.5>svg {
  width: 0.875rem;
  height: 0.875rem;
}

.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&_\\[rtgcmd-group-heading\\]\\]\\:px-2 [rtgcmd-group-heading] {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.\\[\\&_\\[rtgcmd-group-heading\\]\\]\\:py-1\\.5 [rtgcmd-group-heading] {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.\\[\\&_\\[rtgcmd-group-heading\\]\\]\\:text-xs [rtgcmd-group-heading] {
  font-size: 0.75rem;
  line-height: 1rem;
}

.\\[\\&_\\[rtgcmd-group-heading\\]\\]\\:font-medium [rtgcmd-group-heading] {
  font-weight: 500;
}

.\\[\\&_\\[rtgcmd-group-heading\\]\\]\\:text-muted-foreground [rtgcmd-group-heading] {
  color: hsl(var(--muted-foreground));
}

.\\[\\&_svg\\]\\:pointer-events-none svg {
  pointer-events: none;
}

.\\[\\&_svg\\]\\:size-4 svg {
  width: 1rem;
  height: 1rem;
}

.\\[\\&_svg\\]\\:shrink-0 svg {
  flex-shrink: 0;
}
 `, T = new CSSStyleSheet();
T.replaceSync(se.cssText || se.toString());
var E = class extends e {
	static {
		this.styles = t`
    :host {
      display: block;
      border: 2px solid black;
      padding: 10px;
    }
    .wrapper {
      display: block;
    }
  `;
	}
	constructor() {
		super();
	}
	connectedCallback() {
		super.connectedCallback(), this.shadowRoot ? this.shadowRoot.adoptedStyleSheets = [...this.shadowRoot.adoptedStyleSheets, T] : console.error("Shadow root not available in ShadowWrapper");
	}
	render() {
		return n`<div><slot></slot></div>`;
	}
};
customElements.define("shadow-wrapper", E);
//#endregion
//#region node_modules/clsx/dist/clsx.mjs
function ce(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") if (Array.isArray(e)) {
		var i = e.length;
		for (t = 0; t < i; t++) e[t] && (n = ce(e[t])) && (r && (r += " "), r += n);
	} else for (n in e) e[n] && (r && (r += " "), r += n);
	return r;
}
function le() {
	for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = ce(e)) && (r && (r += " "), r += t);
	return r;
}
//#endregion
//#region node_modules/tailwind-merge/dist/bundle-mjs.mjs
var D = "-", ue = (e) => {
	let t = me(e), { conflictingClassGroups: n, conflictingClassGroupModifiers: r } = e;
	return {
		getClassGroupId: (e) => {
			let n = e.split(D);
			return n[0] === "" && n.length !== 1 && n.shift(), de(n, t) || pe(e);
		},
		getConflictingClassGroupIds: (e, t) => {
			let i = n[e] || [];
			return t && r[e] ? [...i, ...r[e]] : i;
		}
	};
}, de = (e, t) => {
	if (e.length === 0) return t.classGroupId;
	let n = e[0], r = t.nextPart.get(n), i = r ? de(e.slice(1), r) : void 0;
	if (i) return i;
	if (t.validators.length === 0) return;
	let a = e.join(D);
	return t.validators.find(({ validator: e }) => e(a))?.classGroupId;
}, fe = /^\[(.+)\]$/, pe = (e) => {
	if (fe.test(e)) {
		let t = fe.exec(e)[1], n = t?.substring(0, t.indexOf(":"));
		if (n) return "arbitrary.." + n;
	}
}, me = (e) => {
	let { theme: t, prefix: n } = e, r = {
		nextPart: /* @__PURE__ */ new Map(),
		validators: []
	};
	return ve(Object.entries(e.classGroups), n).forEach(([e, n]) => {
		he(n, r, e, t);
	}), r;
}, he = (e, t, n, r) => {
	e.forEach((e) => {
		if (typeof e == "string") {
			let r = e === "" ? t : ge(t, e);
			r.classGroupId = n;
			return;
		}
		if (typeof e == "function") {
			if (_e(e)) {
				he(e(r), t, n, r);
				return;
			}
			t.validators.push({
				validator: e,
				classGroupId: n
			});
			return;
		}
		Object.entries(e).forEach(([e, i]) => {
			he(i, ge(t, e), n, r);
		});
	});
}, ge = (e, t) => {
	let n = e;
	return t.split(D).forEach((e) => {
		n.nextPart.has(e) || n.nextPart.set(e, {
			nextPart: /* @__PURE__ */ new Map(),
			validators: []
		}), n = n.nextPart.get(e);
	}), n;
}, _e = (e) => e.isThemeGetter, ve = (e, t) => t ? e.map(([e, n]) => [e, n.map((e) => typeof e == "string" ? t + e : typeof e == "object" ? Object.fromEntries(Object.entries(e).map(([e, n]) => [t + e, n])) : e)]) : e, ye = (e) => {
	if (e < 1) return {
		get: () => void 0,
		set: () => {}
	};
	let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), i = (i, a) => {
		n.set(i, a), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
	};
	return {
		get(e) {
			let t = n.get(e);
			if (t !== void 0) return t;
			if ((t = r.get(e)) !== void 0) return i(e, t), t;
		},
		set(e, t) {
			n.has(e) ? n.set(e, t) : i(e, t);
		}
	};
}, be = "!", xe = (e) => {
	let { separator: t, experimentalParseClassName: n } = e, r = t.length === 1, i = t[0], a = t.length, o = (e) => {
		let n = [], o = 0, s = 0, c;
		for (let l = 0; l < e.length; l++) {
			let u = e[l];
			if (o === 0) {
				if (u === i && (r || e.slice(l, l + a) === t)) {
					n.push(e.slice(s, l)), s = l + a;
					continue;
				}
				if (u === "/") {
					c = l;
					continue;
				}
			}
			u === "[" ? o++ : u === "]" && o--;
		}
		let l = n.length === 0 ? e : e.substring(s), u = l.startsWith(be);
		return {
			modifiers: n,
			hasImportantModifier: u,
			baseClassName: u ? l.substring(1) : l,
			maybePostfixModifierPosition: c && c > s ? c - s : void 0
		};
	};
	return n ? (e) => n({
		className: e,
		parseClassName: o
	}) : o;
}, Se = (e) => {
	if (e.length <= 1) return e;
	let t = [], n = [];
	return e.forEach((e) => {
		e[0] === "[" ? (t.push(...n.sort(), e), n = []) : n.push(e);
	}), t.push(...n.sort()), t;
}, Ce = (e) => ({
	cache: ye(e.cacheSize),
	parseClassName: xe(e),
	...ue(e)
}), we = /\s+/, O = (e, t) => {
	let { parseClassName: n, getClassGroupId: r, getConflictingClassGroupIds: i } = t, a = [], o = e.trim().split(we), s = "";
	for (let e = o.length - 1; e >= 0; --e) {
		let t = o[e], { modifiers: c, hasImportantModifier: l, baseClassName: u, maybePostfixModifierPosition: d } = n(t), f = !!d, p = r(f ? u.substring(0, d) : u);
		if (!p) {
			if (!f) {
				s = t + (s.length > 0 ? " " + s : s);
				continue;
			}
			if (p = r(u), !p) {
				s = t + (s.length > 0 ? " " + s : s);
				continue;
			}
			f = !1;
		}
		let ee = Se(c).join(":"), m = l ? ee + be : ee, h = m + p;
		if (a.includes(h)) continue;
		a.push(h);
		let g = i(p, f);
		for (let e = 0; e < g.length; ++e) {
			let t = g[e];
			a.push(m + t);
		}
		s = t + (s.length > 0 ? " " + s : s);
	}
	return s;
};
function Te() {
	let e = 0, t, n, r = "";
	for (; e < arguments.length;) (t = arguments[e++]) && (n = Ee(t)) && (r && (r += " "), r += n);
	return r;
}
var Ee = (e) => {
	if (typeof e == "string") return e;
	let t, n = "";
	for (let r = 0; r < e.length; r++) e[r] && (t = Ee(e[r])) && (n && (n += " "), n += t);
	return n;
};
function k(e, ...t) {
	let n, r, i, a = o;
	function o(o) {
		return n = Ce(t.reduce((e, t) => t(e), e())), r = n.cache.get, i = n.cache.set, a = s, s(o);
	}
	function s(e) {
		let t = r(e);
		if (t) return t;
		let a = O(e, n);
		return i(e, a), a;
	}
	return function() {
		return a(Te.apply(null, arguments));
	};
}
var A = (e) => {
	let t = (t) => t[e] || [];
	return t.isThemeGetter = !0, t;
}, De = /^\[(?:([a-z-]+):)?(.+)\]$/i, Oe = /^\d+\/\d+$/, ke = /*#__PURE__*/ new Set([
	"px",
	"full",
	"screen"
]), Ae = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, je = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Me = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, Ne = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Pe = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Fe = (e) => Le(e) || ke.has(e) || Oe.test(e), Ie = (e) => Je(e, "length", Ye), Le = (e) => !!e && !Number.isNaN(Number(e)), Re = (e) => Je(e, "number", Le), ze = (e) => !!e && Number.isInteger(Number(e)), Be = (e) => e.endsWith("%") && Le(e.slice(0, -1)), j = (e) => De.test(e), M = (e) => Ae.test(e), Ve = /*#__PURE__*/ new Set([
	"length",
	"size",
	"percentage"
]), He = (e) => Je(e, Ve, Xe), Ue = (e) => Je(e, "position", Xe), We = /*#__PURE__*/ new Set(["image", "url"]), Ge = (e) => Je(e, We, Qe), Ke = (e) => Je(e, "", Ze), qe = () => !0, Je = (e, t, n) => {
	let r = De.exec(e);
	return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, Ye = (e) => je.test(e) && !Me.test(e), Xe = () => !1, Ze = (e) => Ne.test(e), Qe = (e) => Pe.test(e), $e = /*#__PURE__*/ k(() => {
	let e = A("colors"), t = A("spacing"), n = A("blur"), r = A("brightness"), i = A("borderColor"), a = A("borderRadius"), o = A("borderSpacing"), s = A("borderWidth"), c = A("contrast"), l = A("grayscale"), u = A("hueRotate"), d = A("invert"), f = A("gap"), p = A("gradientColorStops"), ee = A("gradientColorStopPositions"), m = A("inset"), h = A("margin"), g = A("opacity"), _ = A("padding"), te = A("saturate"), ne = A("scale"), v = A("sepia"), re = A("skew"), ie = A("space"), y = A("translate"), b = () => [
		"auto",
		"contain",
		"none"
	], ae = () => [
		"auto",
		"hidden",
		"clip",
		"visible",
		"scroll"
	], oe = () => [
		"auto",
		j,
		t
	], x = () => [j, t], S = () => [
		"",
		Fe,
		Ie
	], C = () => [
		"auto",
		Le,
		j
	], w = () => [
		"bottom",
		"center",
		"left",
		"left-bottom",
		"left-top",
		"right",
		"right-bottom",
		"right-top",
		"top"
	], se = () => [
		"solid",
		"dashed",
		"dotted",
		"double",
		"none"
	], T = () => [
		"normal",
		"multiply",
		"screen",
		"overlay",
		"darken",
		"lighten",
		"color-dodge",
		"color-burn",
		"hard-light",
		"soft-light",
		"difference",
		"exclusion",
		"hue",
		"saturation",
		"color",
		"luminosity"
	], E = () => [
		"start",
		"end",
		"center",
		"between",
		"around",
		"evenly",
		"stretch"
	], ce = () => [
		"",
		"0",
		j
	], le = () => [
		"auto",
		"avoid",
		"all",
		"avoid-page",
		"page",
		"left",
		"right",
		"column"
	], D = () => [Le, j];
	return {
		cacheSize: 500,
		separator: ":",
		theme: {
			colors: [qe],
			spacing: [Fe, Ie],
			blur: [
				"none",
				"",
				M,
				j
			],
			brightness: D(),
			borderColor: [e],
			borderRadius: [
				"none",
				"",
				"full",
				M,
				j
			],
			borderSpacing: x(),
			borderWidth: S(),
			contrast: D(),
			grayscale: ce(),
			hueRotate: D(),
			invert: ce(),
			gap: x(),
			gradientColorStops: [e],
			gradientColorStopPositions: [Be, Ie],
			inset: oe(),
			margin: oe(),
			opacity: D(),
			padding: x(),
			saturate: D(),
			scale: D(),
			sepia: ce(),
			skew: D(),
			space: x(),
			translate: x()
		},
		classGroups: {
			aspect: [{ aspect: [
				"auto",
				"square",
				"video",
				j
			] }],
			container: ["container"],
			columns: [{ columns: [M] }],
			"break-after": [{ "break-after": le() }],
			"break-before": [{ "break-before": le() }],
			"break-inside": [{ "break-inside": [
				"auto",
				"avoid",
				"avoid-page",
				"avoid-column"
			] }],
			"box-decoration": [{ "box-decoration": ["slice", "clone"] }],
			box: [{ box: ["border", "content"] }],
			display: [
				"block",
				"inline-block",
				"inline",
				"flex",
				"inline-flex",
				"table",
				"inline-table",
				"table-caption",
				"table-cell",
				"table-column",
				"table-column-group",
				"table-footer-group",
				"table-header-group",
				"table-row-group",
				"table-row",
				"flow-root",
				"grid",
				"inline-grid",
				"contents",
				"list-item",
				"hidden"
			],
			float: [{ float: [
				"right",
				"left",
				"none",
				"start",
				"end"
			] }],
			clear: [{ clear: [
				"left",
				"right",
				"both",
				"none",
				"start",
				"end"
			] }],
			isolation: ["isolate", "isolation-auto"],
			"object-fit": [{ object: [
				"contain",
				"cover",
				"fill",
				"none",
				"scale-down"
			] }],
			"object-position": [{ object: [...w(), j] }],
			overflow: [{ overflow: ae() }],
			"overflow-x": [{ "overflow-x": ae() }],
			"overflow-y": [{ "overflow-y": ae() }],
			overscroll: [{ overscroll: b() }],
			"overscroll-x": [{ "overscroll-x": b() }],
			"overscroll-y": [{ "overscroll-y": b() }],
			position: [
				"static",
				"fixed",
				"absolute",
				"relative",
				"sticky"
			],
			inset: [{ inset: [m] }],
			"inset-x": [{ "inset-x": [m] }],
			"inset-y": [{ "inset-y": [m] }],
			start: [{ start: [m] }],
			end: [{ end: [m] }],
			top: [{ top: [m] }],
			right: [{ right: [m] }],
			bottom: [{ bottom: [m] }],
			left: [{ left: [m] }],
			visibility: [
				"visible",
				"invisible",
				"collapse"
			],
			z: [{ z: [
				"auto",
				ze,
				j
			] }],
			basis: [{ basis: oe() }],
			"flex-direction": [{ flex: [
				"row",
				"row-reverse",
				"col",
				"col-reverse"
			] }],
			"flex-wrap": [{ flex: [
				"wrap",
				"wrap-reverse",
				"nowrap"
			] }],
			flex: [{ flex: [
				"1",
				"auto",
				"initial",
				"none",
				j
			] }],
			grow: [{ grow: ce() }],
			shrink: [{ shrink: ce() }],
			order: [{ order: [
				"first",
				"last",
				"none",
				ze,
				j
			] }],
			"grid-cols": [{ "grid-cols": [qe] }],
			"col-start-end": [{ col: [
				"auto",
				{ span: [
					"full",
					ze,
					j
				] },
				j
			] }],
			"col-start": [{ "col-start": C() }],
			"col-end": [{ "col-end": C() }],
			"grid-rows": [{ "grid-rows": [qe] }],
			"row-start-end": [{ row: [
				"auto",
				{ span: [ze, j] },
				j
			] }],
			"row-start": [{ "row-start": C() }],
			"row-end": [{ "row-end": C() }],
			"grid-flow": [{ "grid-flow": [
				"row",
				"col",
				"dense",
				"row-dense",
				"col-dense"
			] }],
			"auto-cols": [{ "auto-cols": [
				"auto",
				"min",
				"max",
				"fr",
				j
			] }],
			"auto-rows": [{ "auto-rows": [
				"auto",
				"min",
				"max",
				"fr",
				j
			] }],
			gap: [{ gap: [f] }],
			"gap-x": [{ "gap-x": [f] }],
			"gap-y": [{ "gap-y": [f] }],
			"justify-content": [{ justify: ["normal", ...E()] }],
			"justify-items": [{ "justify-items": [
				"start",
				"end",
				"center",
				"stretch"
			] }],
			"justify-self": [{ "justify-self": [
				"auto",
				"start",
				"end",
				"center",
				"stretch"
			] }],
			"align-content": [{ content: [
				"normal",
				...E(),
				"baseline"
			] }],
			"align-items": [{ items: [
				"start",
				"end",
				"center",
				"baseline",
				"stretch"
			] }],
			"align-self": [{ self: [
				"auto",
				"start",
				"end",
				"center",
				"stretch",
				"baseline"
			] }],
			"place-content": [{ "place-content": [...E(), "baseline"] }],
			"place-items": [{ "place-items": [
				"start",
				"end",
				"center",
				"baseline",
				"stretch"
			] }],
			"place-self": [{ "place-self": [
				"auto",
				"start",
				"end",
				"center",
				"stretch"
			] }],
			p: [{ p: [_] }],
			px: [{ px: [_] }],
			py: [{ py: [_] }],
			ps: [{ ps: [_] }],
			pe: [{ pe: [_] }],
			pt: [{ pt: [_] }],
			pr: [{ pr: [_] }],
			pb: [{ pb: [_] }],
			pl: [{ pl: [_] }],
			m: [{ m: [h] }],
			mx: [{ mx: [h] }],
			my: [{ my: [h] }],
			ms: [{ ms: [h] }],
			me: [{ me: [h] }],
			mt: [{ mt: [h] }],
			mr: [{ mr: [h] }],
			mb: [{ mb: [h] }],
			ml: [{ ml: [h] }],
			"space-x": [{ "space-x": [ie] }],
			"space-x-reverse": ["space-x-reverse"],
			"space-y": [{ "space-y": [ie] }],
			"space-y-reverse": ["space-y-reverse"],
			w: [{ w: [
				"auto",
				"min",
				"max",
				"fit",
				"svw",
				"lvw",
				"dvw",
				j,
				t
			] }],
			"min-w": [{ "min-w": [
				j,
				t,
				"min",
				"max",
				"fit"
			] }],
			"max-w": [{ "max-w": [
				j,
				t,
				"none",
				"full",
				"min",
				"max",
				"fit",
				"prose",
				{ screen: [M] },
				M
			] }],
			h: [{ h: [
				j,
				t,
				"auto",
				"min",
				"max",
				"fit",
				"svh",
				"lvh",
				"dvh"
			] }],
			"min-h": [{ "min-h": [
				j,
				t,
				"min",
				"max",
				"fit",
				"svh",
				"lvh",
				"dvh"
			] }],
			"max-h": [{ "max-h": [
				j,
				t,
				"min",
				"max",
				"fit",
				"svh",
				"lvh",
				"dvh"
			] }],
			size: [{ size: [
				j,
				t,
				"auto",
				"min",
				"max",
				"fit"
			] }],
			"font-size": [{ text: [
				"base",
				M,
				Ie
			] }],
			"font-smoothing": ["antialiased", "subpixel-antialiased"],
			"font-style": ["italic", "not-italic"],
			"font-weight": [{ font: [
				"thin",
				"extralight",
				"light",
				"normal",
				"medium",
				"semibold",
				"bold",
				"extrabold",
				"black",
				Re
			] }],
			"font-family": [{ font: [qe] }],
			"fvn-normal": ["normal-nums"],
			"fvn-ordinal": ["ordinal"],
			"fvn-slashed-zero": ["slashed-zero"],
			"fvn-figure": ["lining-nums", "oldstyle-nums"],
			"fvn-spacing": ["proportional-nums", "tabular-nums"],
			"fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
			tracking: [{ tracking: [
				"tighter",
				"tight",
				"normal",
				"wide",
				"wider",
				"widest",
				j
			] }],
			"line-clamp": [{ "line-clamp": [
				"none",
				Le,
				Re
			] }],
			leading: [{ leading: [
				"none",
				"tight",
				"snug",
				"normal",
				"relaxed",
				"loose",
				Fe,
				j
			] }],
			"list-image": [{ "list-image": ["none", j] }],
			"list-style-type": [{ list: [
				"none",
				"disc",
				"decimal",
				j
			] }],
			"list-style-position": [{ list: ["inside", "outside"] }],
			"placeholder-color": [{ placeholder: [e] }],
			"placeholder-opacity": [{ "placeholder-opacity": [g] }],
			"text-alignment": [{ text: [
				"left",
				"center",
				"right",
				"justify",
				"start",
				"end"
			] }],
			"text-color": [{ text: [e] }],
			"text-opacity": [{ "text-opacity": [g] }],
			"text-decoration": [
				"underline",
				"overline",
				"line-through",
				"no-underline"
			],
			"text-decoration-style": [{ decoration: [...se(), "wavy"] }],
			"text-decoration-thickness": [{ decoration: [
				"auto",
				"from-font",
				Fe,
				Ie
			] }],
			"underline-offset": [{ "underline-offset": [
				"auto",
				Fe,
				j
			] }],
			"text-decoration-color": [{ decoration: [e] }],
			"text-transform": [
				"uppercase",
				"lowercase",
				"capitalize",
				"normal-case"
			],
			"text-overflow": [
				"truncate",
				"text-ellipsis",
				"text-clip"
			],
			"text-wrap": [{ text: [
				"wrap",
				"nowrap",
				"balance",
				"pretty"
			] }],
			indent: [{ indent: x() }],
			"vertical-align": [{ align: [
				"baseline",
				"top",
				"middle",
				"bottom",
				"text-top",
				"text-bottom",
				"sub",
				"super",
				j
			] }],
			whitespace: [{ whitespace: [
				"normal",
				"nowrap",
				"pre",
				"pre-line",
				"pre-wrap",
				"break-spaces"
			] }],
			break: [{ break: [
				"normal",
				"words",
				"all",
				"keep"
			] }],
			hyphens: [{ hyphens: [
				"none",
				"manual",
				"auto"
			] }],
			content: [{ content: ["none", j] }],
			"bg-attachment": [{ bg: [
				"fixed",
				"local",
				"scroll"
			] }],
			"bg-clip": [{ "bg-clip": [
				"border",
				"padding",
				"content",
				"text"
			] }],
			"bg-opacity": [{ "bg-opacity": [g] }],
			"bg-origin": [{ "bg-origin": [
				"border",
				"padding",
				"content"
			] }],
			"bg-position": [{ bg: [...w(), Ue] }],
			"bg-repeat": [{ bg: ["no-repeat", { repeat: [
				"",
				"x",
				"y",
				"round",
				"space"
			] }] }],
			"bg-size": [{ bg: [
				"auto",
				"cover",
				"contain",
				He
			] }],
			"bg-image": [{ bg: [
				"none",
				{ "gradient-to": [
					"t",
					"tr",
					"r",
					"br",
					"b",
					"bl",
					"l",
					"tl"
				] },
				Ge
			] }],
			"bg-color": [{ bg: [e] }],
			"gradient-from-pos": [{ from: [ee] }],
			"gradient-via-pos": [{ via: [ee] }],
			"gradient-to-pos": [{ to: [ee] }],
			"gradient-from": [{ from: [p] }],
			"gradient-via": [{ via: [p] }],
			"gradient-to": [{ to: [p] }],
			rounded: [{ rounded: [a] }],
			"rounded-s": [{ "rounded-s": [a] }],
			"rounded-e": [{ "rounded-e": [a] }],
			"rounded-t": [{ "rounded-t": [a] }],
			"rounded-r": [{ "rounded-r": [a] }],
			"rounded-b": [{ "rounded-b": [a] }],
			"rounded-l": [{ "rounded-l": [a] }],
			"rounded-ss": [{ "rounded-ss": [a] }],
			"rounded-se": [{ "rounded-se": [a] }],
			"rounded-ee": [{ "rounded-ee": [a] }],
			"rounded-es": [{ "rounded-es": [a] }],
			"rounded-tl": [{ "rounded-tl": [a] }],
			"rounded-tr": [{ "rounded-tr": [a] }],
			"rounded-br": [{ "rounded-br": [a] }],
			"rounded-bl": [{ "rounded-bl": [a] }],
			"border-w": [{ border: [s] }],
			"border-w-x": [{ "border-x": [s] }],
			"border-w-y": [{ "border-y": [s] }],
			"border-w-s": [{ "border-s": [s] }],
			"border-w-e": [{ "border-e": [s] }],
			"border-w-t": [{ "border-t": [s] }],
			"border-w-r": [{ "border-r": [s] }],
			"border-w-b": [{ "border-b": [s] }],
			"border-w-l": [{ "border-l": [s] }],
			"border-opacity": [{ "border-opacity": [g] }],
			"border-style": [{ border: [...se(), "hidden"] }],
			"divide-x": [{ "divide-x": [s] }],
			"divide-x-reverse": ["divide-x-reverse"],
			"divide-y": [{ "divide-y": [s] }],
			"divide-y-reverse": ["divide-y-reverse"],
			"divide-opacity": [{ "divide-opacity": [g] }],
			"divide-style": [{ divide: se() }],
			"border-color": [{ border: [i] }],
			"border-color-x": [{ "border-x": [i] }],
			"border-color-y": [{ "border-y": [i] }],
			"border-color-s": [{ "border-s": [i] }],
			"border-color-e": [{ "border-e": [i] }],
			"border-color-t": [{ "border-t": [i] }],
			"border-color-r": [{ "border-r": [i] }],
			"border-color-b": [{ "border-b": [i] }],
			"border-color-l": [{ "border-l": [i] }],
			"divide-color": [{ divide: [i] }],
			"outline-style": [{ outline: ["", ...se()] }],
			"outline-offset": [{ "outline-offset": [Fe, j] }],
			"outline-w": [{ outline: [Fe, Ie] }],
			"outline-color": [{ outline: [e] }],
			"ring-w": [{ ring: S() }],
			"ring-w-inset": ["ring-inset"],
			"ring-color": [{ ring: [e] }],
			"ring-opacity": [{ "ring-opacity": [g] }],
			"ring-offset-w": [{ "ring-offset": [Fe, Ie] }],
			"ring-offset-color": [{ "ring-offset": [e] }],
			shadow: [{ shadow: [
				"",
				"inner",
				"none",
				M,
				Ke
			] }],
			"shadow-color": [{ shadow: [qe] }],
			opacity: [{ opacity: [g] }],
			"mix-blend": [{ "mix-blend": [
				...T(),
				"plus-lighter",
				"plus-darker"
			] }],
			"bg-blend": [{ "bg-blend": T() }],
			filter: [{ filter: ["", "none"] }],
			blur: [{ blur: [n] }],
			brightness: [{ brightness: [r] }],
			contrast: [{ contrast: [c] }],
			"drop-shadow": [{ "drop-shadow": [
				"",
				"none",
				M,
				j
			] }],
			grayscale: [{ grayscale: [l] }],
			"hue-rotate": [{ "hue-rotate": [u] }],
			invert: [{ invert: [d] }],
			saturate: [{ saturate: [te] }],
			sepia: [{ sepia: [v] }],
			"backdrop-filter": [{ "backdrop-filter": ["", "none"] }],
			"backdrop-blur": [{ "backdrop-blur": [n] }],
			"backdrop-brightness": [{ "backdrop-brightness": [r] }],
			"backdrop-contrast": [{ "backdrop-contrast": [c] }],
			"backdrop-grayscale": [{ "backdrop-grayscale": [l] }],
			"backdrop-hue-rotate": [{ "backdrop-hue-rotate": [u] }],
			"backdrop-invert": [{ "backdrop-invert": [d] }],
			"backdrop-opacity": [{ "backdrop-opacity": [g] }],
			"backdrop-saturate": [{ "backdrop-saturate": [te] }],
			"backdrop-sepia": [{ "backdrop-sepia": [v] }],
			"border-collapse": [{ border: ["collapse", "separate"] }],
			"border-spacing": [{ "border-spacing": [o] }],
			"border-spacing-x": [{ "border-spacing-x": [o] }],
			"border-spacing-y": [{ "border-spacing-y": [o] }],
			"table-layout": [{ table: ["auto", "fixed"] }],
			caption: [{ caption: ["top", "bottom"] }],
			transition: [{ transition: [
				"none",
				"all",
				"",
				"colors",
				"opacity",
				"shadow",
				"transform",
				j
			] }],
			duration: [{ duration: D() }],
			ease: [{ ease: [
				"linear",
				"in",
				"out",
				"in-out",
				j
			] }],
			delay: [{ delay: D() }],
			animate: [{ animate: [
				"none",
				"spin",
				"ping",
				"pulse",
				"bounce",
				j
			] }],
			transform: [{ transform: [
				"",
				"gpu",
				"none"
			] }],
			scale: [{ scale: [ne] }],
			"scale-x": [{ "scale-x": [ne] }],
			"scale-y": [{ "scale-y": [ne] }],
			rotate: [{ rotate: [ze, j] }],
			"translate-x": [{ "translate-x": [y] }],
			"translate-y": [{ "translate-y": [y] }],
			"skew-x": [{ "skew-x": [re] }],
			"skew-y": [{ "skew-y": [re] }],
			"transform-origin": [{ origin: [
				"center",
				"top",
				"top-right",
				"right",
				"bottom-right",
				"bottom",
				"bottom-left",
				"left",
				"top-left",
				j
			] }],
			accent: [{ accent: ["auto", e] }],
			appearance: [{ appearance: ["none", "auto"] }],
			cursor: [{ cursor: [
				"auto",
				"default",
				"pointer",
				"wait",
				"text",
				"move",
				"help",
				"not-allowed",
				"none",
				"context-menu",
				"progress",
				"cell",
				"crosshair",
				"vertical-text",
				"alias",
				"copy",
				"no-drop",
				"grab",
				"grabbing",
				"all-scroll",
				"col-resize",
				"row-resize",
				"n-resize",
				"e-resize",
				"s-resize",
				"w-resize",
				"ne-resize",
				"nw-resize",
				"se-resize",
				"sw-resize",
				"ew-resize",
				"ns-resize",
				"nesw-resize",
				"nwse-resize",
				"zoom-in",
				"zoom-out",
				j
			] }],
			"caret-color": [{ caret: [e] }],
			"pointer-events": [{ "pointer-events": ["none", "auto"] }],
			resize: [{ resize: [
				"none",
				"y",
				"x",
				""
			] }],
			"scroll-behavior": [{ scroll: ["auto", "smooth"] }],
			"scroll-m": [{ "scroll-m": x() }],
			"scroll-mx": [{ "scroll-mx": x() }],
			"scroll-my": [{ "scroll-my": x() }],
			"scroll-ms": [{ "scroll-ms": x() }],
			"scroll-me": [{ "scroll-me": x() }],
			"scroll-mt": [{ "scroll-mt": x() }],
			"scroll-mr": [{ "scroll-mr": x() }],
			"scroll-mb": [{ "scroll-mb": x() }],
			"scroll-ml": [{ "scroll-ml": x() }],
			"scroll-p": [{ "scroll-p": x() }],
			"scroll-px": [{ "scroll-px": x() }],
			"scroll-py": [{ "scroll-py": x() }],
			"scroll-ps": [{ "scroll-ps": x() }],
			"scroll-pe": [{ "scroll-pe": x() }],
			"scroll-pt": [{ "scroll-pt": x() }],
			"scroll-pr": [{ "scroll-pr": x() }],
			"scroll-pb": [{ "scroll-pb": x() }],
			"scroll-pl": [{ "scroll-pl": x() }],
			"snap-align": [{ snap: [
				"start",
				"end",
				"center",
				"align-none"
			] }],
			"snap-stop": [{ snap: ["normal", "always"] }],
			"snap-type": [{ snap: [
				"none",
				"x",
				"y",
				"both"
			] }],
			"snap-strictness": [{ snap: ["mandatory", "proximity"] }],
			touch: [{ touch: [
				"auto",
				"none",
				"manipulation"
			] }],
			"touch-x": [{ "touch-pan": [
				"x",
				"left",
				"right"
			] }],
			"touch-y": [{ "touch-pan": [
				"y",
				"up",
				"down"
			] }],
			"touch-pz": ["touch-pinch-zoom"],
			select: [{ select: [
				"none",
				"text",
				"all",
				"auto"
			] }],
			"will-change": [{ "will-change": [
				"auto",
				"scroll",
				"contents",
				"transform",
				j
			] }],
			fill: [{ fill: [e, "none"] }],
			"stroke-w": [{ stroke: [
				Fe,
				Ie,
				Re
			] }],
			stroke: [{ stroke: [e, "none"] }],
			sr: ["sr-only", "not-sr-only"],
			"forced-color-adjust": [{ "forced-color-adjust": ["auto", "none"] }]
		},
		conflictingClassGroups: {
			overflow: ["overflow-x", "overflow-y"],
			overscroll: ["overscroll-x", "overscroll-y"],
			inset: [
				"inset-x",
				"inset-y",
				"start",
				"end",
				"top",
				"right",
				"bottom",
				"left"
			],
			"inset-x": ["right", "left"],
			"inset-y": ["top", "bottom"],
			flex: [
				"basis",
				"grow",
				"shrink"
			],
			gap: ["gap-x", "gap-y"],
			p: [
				"px",
				"py",
				"ps",
				"pe",
				"pt",
				"pr",
				"pb",
				"pl"
			],
			px: ["pr", "pl"],
			py: ["pt", "pb"],
			m: [
				"mx",
				"my",
				"ms",
				"me",
				"mt",
				"mr",
				"mb",
				"ml"
			],
			mx: ["mr", "ml"],
			my: ["mt", "mb"],
			size: ["w", "h"],
			"font-size": ["leading"],
			"fvn-normal": [
				"fvn-ordinal",
				"fvn-slashed-zero",
				"fvn-figure",
				"fvn-spacing",
				"fvn-fraction"
			],
			"fvn-ordinal": ["fvn-normal"],
			"fvn-slashed-zero": ["fvn-normal"],
			"fvn-figure": ["fvn-normal"],
			"fvn-spacing": ["fvn-normal"],
			"fvn-fraction": ["fvn-normal"],
			"line-clamp": ["display", "overflow"],
			rounded: [
				"rounded-s",
				"rounded-e",
				"rounded-t",
				"rounded-r",
				"rounded-b",
				"rounded-l",
				"rounded-ss",
				"rounded-se",
				"rounded-ee",
				"rounded-es",
				"rounded-tl",
				"rounded-tr",
				"rounded-br",
				"rounded-bl"
			],
			"rounded-s": ["rounded-ss", "rounded-es"],
			"rounded-e": ["rounded-se", "rounded-ee"],
			"rounded-t": ["rounded-tl", "rounded-tr"],
			"rounded-r": ["rounded-tr", "rounded-br"],
			"rounded-b": ["rounded-br", "rounded-bl"],
			"rounded-l": ["rounded-tl", "rounded-bl"],
			"border-spacing": ["border-spacing-x", "border-spacing-y"],
			"border-w": [
				"border-w-s",
				"border-w-e",
				"border-w-t",
				"border-w-r",
				"border-w-b",
				"border-w-l"
			],
			"border-w-x": ["border-w-r", "border-w-l"],
			"border-w-y": ["border-w-t", "border-w-b"],
			"border-color": [
				"border-color-s",
				"border-color-e",
				"border-color-t",
				"border-color-r",
				"border-color-b",
				"border-color-l"
			],
			"border-color-x": ["border-color-r", "border-color-l"],
			"border-color-y": ["border-color-t", "border-color-b"],
			"scroll-m": [
				"scroll-mx",
				"scroll-my",
				"scroll-ms",
				"scroll-me",
				"scroll-mt",
				"scroll-mr",
				"scroll-mb",
				"scroll-ml"
			],
			"scroll-mx": ["scroll-mr", "scroll-ml"],
			"scroll-my": ["scroll-mt", "scroll-mb"],
			"scroll-p": [
				"scroll-px",
				"scroll-py",
				"scroll-ps",
				"scroll-pe",
				"scroll-pt",
				"scroll-pr",
				"scroll-pb",
				"scroll-pl"
			],
			"scroll-px": ["scroll-pr", "scroll-pl"],
			"scroll-py": ["scroll-pt", "scroll-pb"],
			touch: [
				"touch-x",
				"touch-y",
				"touch-pz"
			],
			"touch-x": ["touch"],
			"touch-y": ["touch"],
			"touch-pz": ["touch"]
		},
		conflictingClassGroupModifiers: { "font-size": ["leading"] }
	};
});
//#endregion
//#region src/helpers/style.helpers.ts
function N(...e) {
	return $e(le(e));
}
//#endregion
//#region node_modules/@open-wc/lit-helpers/src/spread.js
var et = class extends d {
	constructor() {
		super(...arguments), this.prevData = {};
	}
	render(e) {
		return l;
	}
	update(e, [t]) {
		this.element !== e.element && (this.element = e.element), this.host = e.options?.host || this.element, this.apply(t), this.groom(t), this.prevData = { ...t };
	}
	apply(e) {
		if (!e) return;
		let { prevData: t, element: n } = this;
		for (let r in e) {
			let i = e[r];
			i !== t[r] && (n[r] = i);
		}
	}
	groom(e) {
		let { prevData: t, element: n } = this;
		if (t) for (let r in t) (!e || !(r in e) && n[r] === t[r]) && (n[r] = void 0);
	}
};
u(et);
var tt = class extends et {
	constructor() {
		super(...arguments), this.eventData = {};
	}
	apply(e) {
		if (e) for (let t in e) {
			let n = e[t];
			n !== this.eventData[t] && this.applyEvent(t, n);
		}
	}
	applyEvent(e, t) {
		let { prevData: n, element: r } = this;
		this.eventData[e] = t, n[e] && r.removeEventListener(e, this, t), r.addEventListener(e, this, t);
	}
	groom(e) {
		let { prevData: t, element: n } = this;
		if (t) for (let r in t) (!e || !(r in e) && n[r] === t[r]) && this.groomEvent(r, t[r]);
	}
	groomEvent(e, t) {
		let { element: n } = this;
		delete this.eventData[e], n.removeEventListener(e, this, t);
	}
	handleEvent(e) {
		let t = this.eventData[e.type];
		typeof t == "function" ? t.call(this.host, e) : t.handleEvent(e);
	}
	disconnected() {
		let { eventData: e, element: t } = this;
		for (let n in e) {
			let r = n.slice(1), i = e[n];
			t.removeEventListener(r, this, i);
		}
	}
	reconnected() {
		let { eventData: e, element: t } = this;
		for (let n in e) {
			let r = n.slice(1), i = e[n];
			t.addEventListener(r, this, i);
		}
	}
};
u(tt);
var P = u(class extends tt {
	apply(e) {
		if (!e) return;
		let { prevData: t, element: n } = this;
		for (let r in e) {
			let i = e[r];
			if (i === t[r]) continue;
			let a = r.slice(1);
			switch (r[0]) {
				case "@":
					this.eventData[a] = i, this.applyEvent(a, i);
					break;
				case ".":
					n[a] = i;
					break;
				case "?":
					i ? n.setAttribute(a, "") : n.removeAttribute(a);
					break;
				default:
					i == null ? n.removeAttribute(r) : n.setAttribute(r, String(i));
					break;
			}
		}
	}
	groom(e) {
		let { prevData: t, element: n } = this;
		if (t) for (let r in t) {
			let i = r.slice(1);
			if (!e || !(r in e) && n[i] === t[r]) switch (r[0]) {
				case "@":
					this.groomEvent(i, t[r]);
					break;
				case ".":
					n[i] = void 0;
					break;
				case "?":
					n.removeAttribute(i);
					break;
				default:
					n.removeAttribute(r);
					break;
			}
		}
	}
}), nt = {
	base: [""],
	item: ["rtg-border-b-accordion-item-width-border rtg-border-b-accordion-item-color-border"],
	trigger: [
		"rtg-flex rtg-flex-1 rtg-gap-accordion-trigger-space-gap rtg-justify-between rtg-items-start",
		"rtg-py-accordion-trigger-space-py",
		"rtg-w-accordion-trigger-space-w",
		"rtg-rounded-accordion-trigger-radius rtg-outline-none",
		"rtg-text-accordion-trigger-font rtg-font-accordion-trigger-font-weight rtg-text-left",
		"rtg-transition-all",
		"hover:rtg-underline",
		"focus-visible:rtg-border-accordion-trigger-width-border-focus focus-visible:rtg-border-accordion-trigger-color-border-focus",
		"focus-visible:rtg-ring-accordion-trigger-width-ring-focus focus-visible:rtg-ring-accordion-trigger-color-ring-focus",
		"disabled:rtg-pointer-events-none disabled:rtg-opacity-50",
		"[&[data-state=open]>svg]:rtg-rotate-180"
	],
	chevron: [
		"rtg-shrink-0",
		"rtg-size-accordion-trigger-icon-space-size",
		"rtg-text-accordion-trigger-icon-color-text",
		"rtg-translate-y-0.5 rtg-transition-transform rtg-duration-200",
		"rtg-pointer-events-none"
	],
	content: [
		"rtg-overflow-hidden",
		"rtg-text-accordion-content-font rtg-font-accordion-content-font-weight",
		"data-[state=closed]:rtg-h-accordion-content-space-h-closed",
		"data-[state=closed]:rtg-animate-accordion-content-animate-closed",
		"data-[state=open]:rtg-animate-accordion-content-animate-open",
		"data-[state=open]:rtg-h-fit",
		"[&>div]:rtg-pt-accordion-content-div-space-pt [&>div]:rtg-pb-accordion-content-div-space-pb"
	]
}, rt = class extends C {
	constructor(...e) {
		super(...e), this._onAccordionClick = () => {
			this.requestUpdate();
		};
	}
	get _accordion() {
		let e = this.parentElement;
		for (; e && !(e instanceof ot);) e = e.parentElement;
		return e;
	}
	get _item() {
		let e = this.parentElement;
		for (; e && !(e instanceof F);) e = e.parentElement;
		return e;
	}
	getAttributesToExclude() {
		return [];
	}
	createRenderRoot() {
		return this;
	}
	connectedCallback() {
		super.connectedCallback(), this._accordion?.addEventListener("clicked-accordion", this._onAccordionClick);
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this._accordion?.removeEventListener("clicked-accordion", this._onAccordionClick);
	}
	firstUpdated(e) {
		this.removeDuplicateContent();
	}
	hasActiveState() {
		return !!this._item?.value && !!this._accordion?.selectedItems.includes(this._item.value);
	}
	render() {
		return n`
      <div
        part="accordion-content"
        role="region"
        data-state=${this.hasActiveState() ? "open" : "closed"}
        data-orientation="vertical"
        class=${N(nt.content, this.className)}
        @click=${(e) => e.stopPropagation()}
      >
        <div>${f(this.textContent?.trim() || "")}</div>
      </div>
    `;
	}
};
rt = S([a("rtg-accordion-content")], rt);
//#endregion
//#region src/components/ui/accordion/accordion-item.ts
var F = class extends C {
	constructor(...e) {
		super(...e), this.value = "", this.tabindex = 0, this._initialChildren = [], this._onClick = (e) => {
			let t = e.target.closest("rtg-accordion-trigger");
			!t || !this._accordion || (e.preventDefault(), e.stopPropagation(), this._accordion.raiseEvent(this.value), t.requestUpdate(), setTimeout(() => this.requestUpdate(), 0));
		}, this._onAccordionClick = () => {
			this.requestUpdate();
		};
	}
	get _accordion() {
		let e = this.parentElement;
		for (; e && !(e instanceof ot);) e = e.parentElement;
		return e;
	}
	getAttributesToExclude() {
		return [
			"aria-orientation",
			"role",
			"data-orientation",
			"data-testid"
		];
	}
	createRenderRoot() {
		return this;
	}
	connectedCallback() {
		super.connectedCallback(), this._initialChildren = this.filterChildren(), this.addEventListener("click", this._onClick), this._accordion?.addEventListener("clicked-accordion", this._onAccordionClick);
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.removeEventListener("click", this._onClick), this._accordion?.removeEventListener("clicked-accordion", this._onAccordionClick);
	}
	filterChildren() {
		return Array.from(this.children).filter((e) => e instanceof it || e instanceof rt);
	}
	render() {
		let e = this._accordion?.selectedItems.includes(this.value), t = this._initialChildren.length ? this._initialChildren : this.filterChildren();
		return n`
      <div
        data-state=${e ? "open" : "closed"}
        class="${N(nt.item, this.className)}"
        value=${this.value}
        role="tablist"
        data-orientation="vertical"
        part="accordion-item"
      >
        ${t}
      </div>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], F.prototype, "value", void 0), S([o({ type: Number }), x("design:type", Object)], F.prototype, "tabindex", void 0), F = S([a("rtg-accordion-item")], F);
//#endregion
//#region src/components/ui/accordion/accordion-trigger.ts
var it = class extends C {
	get _item() {
		let e = this.parentElement;
		for (; e && !(e instanceof F);) e = e.parentElement;
		return e;
	}
	get _accordion() {
		let e = this.parentElement;
		for (; e && !(e instanceof ot);) e = e.parentElement;
		return e;
	}
	getAttributesToExclude() {
		return ["value", "defaultValue"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.removeDuplicateContent();
	}
	hasActiveState() {
		return !!this._item?.value && !!this._accordion?.selectedItems.includes(this._item.value);
	}
	render() {
		let e = this.hasActiveState();
		return n`
      <button
        type="button"
        part="accordion-trigger"
        role="tab"
        value=${this._item?.value || ""}
        aria-selected=${e}
        aria-expanded=${e}
        data-state=${e ? "open" : "closed"}
        class="${N(nt.trigger, this.className)}"
        tabindex="-1"
        data-orientation="horizontal"
        data-radix-collection-item
      >
        ${f(this.textContent || "")}

        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class=${N(nt.chevron, "lucide lucide-chevron-down-icon lucide-chevron-down")}
        >
          <path d="m6 9 6 6 6-6" />
        </svg>
      </button>
    `;
	}
};
it = S([a("rtg-accordion-trigger")], it);
//#endregion
//#region src/components/ui/accordion/accordion.defs.ts
var at = /* @__PURE__ */ function(e) {
	return e.MULTIPLE = "multiple", e.SINGLE = "single", e;
}({}), ot = class extends C {
	constructor(...e) {
		super(...e), this.type = at.MULTIPLE, this.selectedItems = [], this._initialChildren = [];
	}
	getAttributesToExclude() {
		return ["variant", "data-testid"];
	}
	createRenderRoot() {
		return this;
	}
	connectedCallback() {
		super.connectedCallback(), this._initialChildren = Array.from(this.children).filter((e) => e instanceof F);
	}
	willUpdate(e) {
		e.has("type") && (this.type === at.SINGLE && this.selectedItems.length > 1 && (this.selectedItems = this.selectedItems.slice(0, 1)), this._initialChildren.forEach((e) => {
			e instanceof F && e.requestUpdate();
		}));
	}
	updated(e) {
		e.has("type") && this._initialChildren.forEach((e) => {
			e instanceof F && e.requestUpdate();
		});
	}
	setSelectedItems(e) {
		let t = this.selectedItems.indexOf(e);
		if (t > -1) if (this.type === at.SINGLE) this.selectedItems = [];
		else if (this.type === at.MULTIPLE) this.selectedItems.splice(t, 1);
		else throw Error("Invalid accordion type");
		else if (this.type === at.SINGLE) this.selectedItems = [e];
		else if (this.type === at.MULTIPLE) this.selectedItems.push(e);
		else throw Error("Invalid accordion type");
	}
	raiseEvent(e) {
		this.setSelectedItems(e), this.dispatchEvent(new CustomEvent("clicked-accordion", {
			bubbles: !0,
			composed: !0,
			detail: { selectedItems: this.selectedItems }
		}));
	}
	render() {
		let e = this._initialChildren.length ? this._initialChildren : Array.from(this.children).filter((e) => e instanceof F);
		return n`
      <div
        data-orientation="vertical"
        ${P(this.getFilteredAttributes())}
        part="accordion"
        class="${N(nt.base, this.className)}"
      >
        ${e}
      </div>
    `;
	}
};
S([o({ type: String }), x("design:type", at === void 0 ? Object : at)], ot.prototype, "type", void 0), ot = S([a("rtg-accordion")], ot);
//#endregion
//#region src/components/ui/alert/_alert.ts
var st = class extends e {
	constructor(...e) {
		super(...e), this.variant = "default";
	}
	get _rootSlot() {
		return this.querySelector("[data-slot=\"alert\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._rootSlot && this._rootSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<div data-slot="alert" data-variant=${this.variant}></div>`;
	}
};
S([o({ type: String }), x("design:type", Object)], st.prototype, "variant", void 0), st = S([a("rtg-alert")], st);
//#endregion
//#region src/components/ui/alert/_alert-title.ts
var ct = class extends e {
	get _titleSlot() {
		return this.querySelector("[data-slot=\"alert-title\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._titleSlot && this._titleSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<div data-slot="alert-title"></div>`;
	}
};
ct = S([a("rtg-alert-title")], ct);
//#endregion
//#region src/components/ui/alert/_alert-description.ts
var lt = class extends e {
	get _descriptionSlot() {
		return this.querySelector("[data-slot=\"alert-description\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._descriptionSlot && this._descriptionSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<div data-slot="alert-description"></div>`;
	}
};
lt = S([a("rtg-alert-description")], lt);
//#endregion
//#region src/components/ui/alert/_alert-action.ts
var ut = class extends e {
	get _actionSlot() {
		return this.querySelector("[data-slot=\"alert-action\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._actionSlot && this._actionSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<div data-slot="alert-action"></div>`;
	}
};
ut = S([a("rtg-alert-action")], ut);
//#endregion
//#region src/components/ui/aspect-ratio/aspect-ratio.styles.ts
var dt = {
	host: ["rtg-block rtg-relative rtg-w-full"],
	self: ["rtg-absolute rtg-inset-0"]
}, ft = class extends e {
	constructor(...e) {
		super(...e), this.ratio = 1 / 1, this._userClass = "", this._userStyle = "";
	}
	createRenderRoot() {
		return this;
	}
	connectedCallback() {
		super.connectedCallback(), this._userClass = this.getAttribute("class") ?? "", this._userStyle = this.getAttribute("style") ?? "", this._userClass && this.removeAttribute("class"), this._userStyle && this.removeAttribute("style"), this.className = N(this.className, dt.host);
	}
	updated(e) {
		e.has("ratio") && (this.style.paddingBottom = this.ratio > 0 ? `${100 / this.ratio}%` : "0%");
	}
	firstUpdated() {
		this.style.paddingBottom = this.ratio > 0 ? `${100 / this.ratio}%` : "0%";
		let e = this.querySelector(".aspect-ratio");
		if (e) {
			if (this._userClass && (e.className = N(e.className, this._userClass)), this._userStyle) {
				let t = e.getAttribute("style")?.trim(), n = this._userStyle.trim();
				e.setAttribute("style", [t, n].filter(Boolean).join("; "));
			}
			Array.from(this.childNodes).forEach((t) => {
				t !== e && e.appendChild(t);
			});
		}
	}
	render() {
		return n`
      <div class="${N("aspect-ratio", dt.self)}"></div>
    `;
	}
};
S([o({
	type: Number,
	reflect: !0
}), x("design:type", Object)], ft.prototype, "ratio", void 0), ft = S([a("rtg-aspect-ratio")], ft);
//#endregion
//#region src/components/ui/avatar/_avatar.ts
var pt = class extends e {
	constructor(...e) {
		super(...e), this.size = "default", this._imageLoaded = !1, this._imageError = !1;
	}
	get _rootSlot() {
		return this.querySelector("[data-slot=\"avatar\"]");
	}
	get _avatarImageChild() {
		return this.querySelector("rtg-avatar-image");
	}
	get _avatarFallbackChild() {
		return this.querySelector("rtg-avatar-fallback");
	}
	_syncChildren() {
		let e = this._imageError || !this._imageLoaded;
		this._avatarImageChild && (this._avatarImageChild.style.display = e ? "none" : ""), this._avatarFallbackChild && (this._avatarFallbackChild.style.display = e ? "" : "none");
	}
	_onImageLoad() {
		this._imageLoaded = !0, this._imageError = !1, this._syncChildren();
	}
	_onImageError() {
		this._imageLoaded = !1, this._imageError = !0, this._syncChildren();
	}
	connectedCallback() {
		super.connectedCallback(), this.addEventListener("rtg-avatar:image-load", this._onImageLoad), this.addEventListener("rtg-avatar:image-error", this._onImageError);
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.removeEventListener("rtg-avatar:image-load", this._onImageLoad), this.removeEventListener("rtg-avatar:image-error", this._onImageError);
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._rootSlot && this._rootSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<span data-slot="avatar" data-size=${this.size}></span>`;
	}
};
S([o({ type: String }), x("design:type", Object)], pt.prototype, "size", void 0), S([c(), x("design:type", Object)], pt.prototype, "_imageLoaded", void 0), S([c(), x("design:type", Object)], pt.prototype, "_imageError", void 0), pt = S([a("rtg-avatar")], pt);
//#endregion
//#region src/components/ui/avatar/_avatar-image.ts
var mt = class extends e {
	_onLoad() {
		this.dispatchEvent(new CustomEvent("rtg-avatar:image-load", {
			bubbles: !0,
			composed: !0
		}));
	}
	_onError() {
		this.dispatchEvent(new CustomEvent("rtg-avatar:image-error", {
			bubbles: !0,
			composed: !0
		}));
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <img
        data-slot="avatar-image"
        src=${this.src ?? ""}
        alt=${this.alt ?? ""}
        @load=${this._onLoad}
        @error=${this._onError}
      />
    `;
	}
};
S([o({ type: String }), x("design:type", String)], mt.prototype, "src", void 0), S([o({ type: String }), x("design:type", String)], mt.prototype, "alt", void 0), mt = S([a("rtg-avatar-image")], mt);
//#endregion
//#region src/components/ui/avatar/_avatar-fallback.ts
var ht = class extends e {
	get _fallbackSlot() {
		return this.querySelector("[data-slot=\"avatar-fallback\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._fallbackSlot && this._fallbackSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<span data-slot="avatar-fallback"></span>`;
	}
};
ht = S([a("rtg-avatar-fallback")], ht);
//#endregion
//#region src/components/ui/avatar/_avatar-badge.ts
var gt = class extends e {
	get _badgeSlot() {
		return this.querySelector("[data-slot=\"avatar-badge\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._badgeSlot && this._badgeSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<span data-slot="avatar-badge"></span>`;
	}
};
gt = S([a("rtg-avatar-badge")], gt);
//#endregion
//#region src/components/ui/avatar/_avatar-group.ts
var _t = class extends e {
	get _groupSlot() {
		return this.querySelector("[data-slot=\"avatar-group\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._groupSlot && this._groupSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<div data-slot="avatar-group"></div>`;
	}
};
_t = S([a("rtg-avatar-group")], _t);
//#endregion
//#region src/components/ui/avatar/_avatar-group-count.ts
var vt = class extends e {
	get _groupCountSlot() {
		return this.querySelector("[data-slot=\"avatar-group-count\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._groupCountSlot && this._groupCountSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<div data-slot="avatar-group-count"></div>`;
	}
};
vt = S([a("rtg-avatar-group-count")], vt);
//#endregion
//#region src/components/ui/badge/_badge.ts
var yt = class extends e {
	constructor(...e) {
		super(...e), this.variant = "default";
	}
	createRenderRoot() {
		return this;
	}
	get _rootSlot() {
		return this.querySelector("[data-slot=\"badge\"]");
	}
	firstUpdated() {
		let e = this._rootSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return this.href ? n`
        <a
          data-slot="badge"
          data-variant=${this.variant}
          href=${this.href}
          target=${this.target ?? r}
          aria-label=${this.ariaLabel ?? r}
          aria-invalid=${this.invalid || this.ariaInvalid === "true" ? "true" : r}
        ></a>
      ` : n`
      <span
        data-slot="badge"
        data-variant=${this.variant}
        aria-label=${this.ariaLabel ?? r}
        aria-invalid=${this.invalid || this.ariaInvalid === "true" ? "true" : r}
      ></span>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], yt.prototype, "variant", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], yt.prototype, "invalid", void 0), S([o({ type: String }), x("design:type", String)], yt.prototype, "href", void 0), S([o({ type: String }), x("design:type", Object)], yt.prototype, "target", void 0), yt = S([a("rtg-badge")], yt);
//#endregion
//#region src/components/ui/breadcrumb/breadcrumb.styles.ts
var bt = {
	list: ["rtg-flex rtg-flex-wrap rtg-gap-breadcrumb-list-space-gap-sm sm:rtg-gap-breadcrumb-list-space-gap rtg-items-center", "rtg-text-breadcrumb-list-font rtg-font-breadcrumb-list-font-weight rtg-text-breadcrumb-list-color-text rtg-break-words"],
	item: ["rtg-inline-flex rtg-gap-breadcrumb-item-space-gap rtg-items-center"],
	link: ["rtg-transition-colors", "hover:rtg-text-breadcrumb-link-color-text-hover"],
	page: ["rtg-font-breadcrumb-page-font-weight rtg-text-breadcrumb-page-color-text"],
	separator: ["[&>svg]:rtg-size-breadcrumb-separator-icon-space-size"],
	ellipsis: [
		"rtg-flex rtg-justify-center rtg-items-center",
		"rtg-size-breadcrumb-ellipsis-space-size",
		"[&>svg]:rtg-size-breadcrumb-ellipsis-icon-space-size"
	]
}, xt = class extends C {
	getAttributesToExclude() {
		return [""];
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <span
        ${P(this.getFilteredAttributes())}
        id="rtg-bread-crumb-ellipsis"
        role="presentation"
        aria-hidden="true"
        class="${N(bt.ellipsis, this.className)}"
        part="breadcrumb-ellipsis"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-ellipsis-icon lucide-ellipsis"
        >
          <circle cx="12" cy="12" r="1" />
          <circle cx="19" cy="12" r="1" />
          <circle cx="5" cy="12" r="1" />
        </svg>
      </span>
    `;
	}
};
xt = S([a("rtg-bread-crumb-ellipsis")], xt);
//#endregion
//#region src/components/ui/breadcrumb/breadcrumb-item.ts
var St = class extends C {
	get _containerElement() {
		return this.querySelector("li[part=breadcrumb-item]");
	}
	getAttributesToExclude() {
		return ["variant"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <li
        ${P(this.getFilteredAttributes())}
        id="rtg-bread-crumb-item"
        class="${N(bt.item, this.className)}"
        part="breadcrumb-item"
      ></li>
    `;
	}
};
St = S([a("rtg-bread-crumb-item")], St);
//#endregion
//#region src/components/ui/breadcrumb/breadcrumb-link.ts
var Ct = class extends C {
	constructor(...e) {
		super(...e), this.href = "/";
	}
	get _containerElement() {
		return this.querySelector("a[part=breadcrumb-link]");
	}
	getAttributesToExclude() {
		return [""];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <a
        ${P(this.getFilteredAttributes())}
        id="rtg-bread-crumb-link"
        class="${N(bt.link, this.className)}"
        href="${this.href}"
        part="breadcrumb-link"
      >
      </a>
    `;
	}
};
S([o({ type: String }), x("design:type", String)], Ct.prototype, "href", void 0), Ct = S([a("rtg-bread-crumb-link")], Ct);
//#endregion
//#region src/components/ui/breadcrumb/breadcrumb-list.ts
var wt = class extends C {
	get _containerElement() {
		return this.querySelector("ol[part=breadcrumb-list]");
	}
	getAttributesToExclude() {
		return ["variant"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <ol
        ${P(this.getFilteredAttributes())}
        id="rtg-bread-crumb-list"
        class="${N(bt.list, this.className)}"
        part="breadcrumb-list"
      ></ol>
    `;
	}
};
wt = S([a("rtg-bread-crumb-list")], wt);
//#endregion
//#region src/components/ui/breadcrumb/breadcrumb-separator.ts
var Tt = class extends C {
	getAttributesToExclude() {
		return [""];
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <li
        ${P(this.getFilteredAttributes())}
        id="rtg-bread-crumb-separator"
        role="presentation"
        aria-hidden="true"
        class="${N(bt.separator, this.className)}"
        part="breadcrumb-separator"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-chevron-right-icon lucide-chevron-right"
        >
          <path d="m9 18 6-6-6-6" />
        </svg>
      </li>
    `;
	}
};
Tt = S([a("rtg-bread-crumb-separator")], Tt);
//#endregion
//#region src/components/ui/breadcrumb/breadcrumb-text.ts
var Et = class extends C {
	get _containerElement() {
		return this.querySelector("span[part=breadcrumb-text]");
	}
	getAttributesToExclude() {
		return [""];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <span
        ${P(this.getFilteredAttributes())}
        id="rtg-bread-crumb-text"
        aria-disabled="true"
        aria-current="page"
        class="${N(bt.page, this.className)}"
        part="breadcrumb-text"
      >
      </span>
    `;
	}
};
Et = S([a("rtg-bread-crumb-text")], Et);
//#endregion
//#region src/components/ui/breadcrumb/breadcrumb.ts
var Dt = class extends C {
	get _containerElement() {
		return this.querySelector("nav[part=breadcrumb]");
	}
	getAttributesToExclude() {
		return [""];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <nav
        ${P(this.getFilteredAttributes())}
        part="breadcrumb"
        class="${N(this.className)}"
        aria-label="breadcrumb"
      ></nav>
    `;
	}
};
Dt = S([a("rtg-bread-crumb")], Dt);
//#endregion
//#region src/components/ui/button/_button.ts
var I = class extends e {
	constructor(...e) {
		super(...e), this.variant = "default", this.size = "default", this.type = "button";
	}
	get _rootSlot() {
		return this.querySelector("[data-slot=\"button\"]");
	}
	_handleClick(e) {
		this.onClick && this.onClick(e);
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._rootSlot && this._rootSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return this.href ? n`
        <a
          data-slot="button"
          data-variant=${this.variant}
          data-size=${this.size}
          href=${this.href}
          target=${this.target ?? r}
          ?disabled=${this.disabled}
          aria-label=${this.ariaLabel ?? r}
          aria-invalid=${this.invalid || this.ariaInvalid === "true" ? "true" : r}
          @click=${this._handleClick}
        ></a>
      ` : n`
      <button
        data-slot="button"
        data-variant=${this.variant}
        data-size=${this.size}
        type=${this.type}
        ?disabled=${this.disabled}
        aria-label=${this.ariaLabel ?? r}
        aria-invalid=${this.invalid || this.ariaInvalid === "true" ? "true" : r}
        @click=${this._handleClick}
      ></button>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], I.prototype, "variant", void 0), S([o({ type: String }), x("design:type", Object)], I.prototype, "size", void 0), S([o({ type: String }), x("design:type", Object)], I.prototype, "type", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], I.prototype, "disabled", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], I.prototype, "invalid", void 0), S([o({ type: String }), x("design:type", String)], I.prototype, "href", void 0), S([o({ type: String }), x("design:type", Object)], I.prototype, "target", void 0), S([o({
	attribute: !1,
	type: Function
}), x("design:type", Function)], I.prototype, "onClick", void 0), I = S([a("rtg-button")], I);
//#endregion
//#region src/components/ui/calendar/calendar.helpers.ts
var Ot = [
	"Sunday",
	"Monday",
	"Tuesday",
	"Wednesday",
	"Thursday",
	"Friday",
	"Saturday"
];
function kt(e) {
	let t = e % 100;
	if (t >= 11 && t <= 13) return "th";
	switch (e % 10) {
		case 1: return "st";
		case 2: return "nd";
		case 3: return "rd";
		default: return "th";
	}
}
function At(e) {
	let t = new Intl.DateTimeFormat("en-US", { weekday: "long" }).format(e), n = new Intl.DateTimeFormat("en-US", { month: "long" }).format(e), r = e.getDate(), i = e.getFullYear();
	return `${t}, ${n} ${r}${kt(r)}, ${i}`;
}
//#endregion
//#region node_modules/class-variance-authority/dist/index.mjs
var jt = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Mt = le, Nt = (e, t) => (n) => {
	if (t?.variants == null) return Mt(e, n?.class, n?.className);
	let { variants: r, defaultVariants: i } = t, a = Object.keys(r).map((e) => {
		let t = n?.[e], a = i?.[e];
		if (t === null) return null;
		let o = jt(t) || jt(a);
		return r[e][o];
	}), o = n && Object.entries(n).reduce((e, t) => {
		let [n, r] = t;
		return r === void 0 || (e[n] = r), e;
	}, {});
	return Mt(e, a, t?.compoundVariants?.reduce((e, t) => {
		let { class: n, className: r, ...a } = t;
		return Object.entries(a).every((e) => {
			let [t, n] = e;
			return Array.isArray(n) ? n.includes({
				...i,
				...o
			}[t]) : {
				...i,
				...o
			}[t] === n;
		}) ? [
			...e,
			n,
			r
		] : e;
	}, []), n?.class, n?.className);
}, Pt = Nt([
	"rtg-inline-flex rtg-items-center rtg-justify-center rtg-shrink-0",
	"rtg-text-button-font-size rtg-font-button-font-weight rtg-whitespace-nowrap",
	"rtg-rounded-button-radius rtg-outline-none",
	"rtg-transition-all",
	"disabled:rtg-opacity-button-opacity-disabled disabled:rtg-pointer-events-none",
	"focus-visible:rtg-border-button-width-border-focus focus-visible:rtg-border-button-color-border-focus focus-visible:rtg-ring-button-width-ring-focus",
	"aria-invalid:rtg-border-button-width-border-invalid aria-invalid:rtg-border-button-color-border-invalid",
	"aria-invalid:rtg-ring-button-width-ring-invalid aria-invalid:rtg-ring-button-color-ring-invalid",
	"[&_svg]:rtg-pointer-events-none [&_svg:not([class*=\"rtg-size-\"])]:rtg-size-button-icon-space-size [&_svg]:rtg-shrink-0"
], {
	variants: {
		variant: {
			default: [
				"rtg-bg-button-default-color-bg rtg-text-button-default-color-text",
				"hover:rtg-bg-button-default-color-bg-hover",
				"focus-visible:rtg-ring-button-default-color-ring-focus"
			],
			destructive: [
				"rtg-bg-button-destructive-color-bg rtg-text-button-destructive-color-text",
				"hover:rtg-bg-button-destructive-color-bg-hover",
				"focus-visible:rtg-ring-button-destructive-color-ring-focus"
			],
			outline: [
				"rtg-bg-button-outline-color-bg",
				"rtg-border-button-outline-width-border rtg-border-button-outline-color-border",
				"hover:rtg-bg-button-outline-color-bg-hover hover:rtg-text-button-outline-color-text-hover",
				"focus-visible:rtg-ring-button-outline-color-ring-focus"
			],
			secondary: [
				"rtg-bg-button-secondary-color-bg rtg-text-button-secondary-color-text",
				"hover:rtg-bg-button-secondary-color-bg-hover",
				"focus-visible:rtg-ring-button-secondary-color-ring-focus"
			],
			ghost: ["hover:rtg-bg-button-ghost-color-bg-hover hover:rtg-text-button-ghost-color-text-hover", "focus-visible:rtg-ring-button-ghost-color-ring-focus"],
			link: [
				"rtg-text-button-link-color-text rtg-underline-offset-4",
				"hover:rtg-underline",
				"focus-visible:rtg-ring-button-link-color-ring-focus"
			]
		},
		size: {
			default: [
				"rtg-h-button-space-h-default",
				"rtg-gap-button-space-gap-default rtg-px-button-space-px-default rtg-py-button-space-py-default",
				"has-[>svg]:rtg-px-button-space-px-default-has-icon"
			],
			sm: [
				"rtg-h-button-space-h-sm",
				"rtg-gap-button-space-gap-sm rtg-px-button-space-px-sm",
				"has-[>svg]:rtg-px-button-space-px-sm-has-icon"
			],
			lg: [
				"rtg-h-button-space-h-lg",
				"rtg-gap-button-space-gap-lg rtg-px-button-space-px-lg",
				"has-[>svg]:rtg-px-button-space-px-lg-has-icon"
			],
			icon: "rtg-size-button-space-size-icon",
			"icon-sm": "rtg-size-button-space-size-icon-sm",
			"icon-lg": "rtg-size-button-space-size-icon-lg"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
}), L = {
	host: ["rtg-contents"],
	root: [
		"group/calendar",
		"rtg-relative",
		"rtg-p-calendar-space-p",
		"rtg-w-fit",
		"rtg-bg-calendar-color-bg"
	],
	months: ["rtg-flex rtg-relative", "rtg-flex-col md:rtg-flex-row rtg-gap-calendar-months-space-gap"],
	nav: [
		"rtg-flex rtg-absolute rtg-top-0 rtg-inset-x-0",
		"rtg-gap-calendar-nav-space-gap rtg-justify-between rtg-items-center",
		"rtg-w-full"
	],
	month: [
		"rtg-flex",
		"rtg-flex-col rtg-gap-calendar-month-space-gap",
		"rtg-w-full"
	],
	buttonPrevious: [
		N(Pt({
			variant: "ghost",
			size: "icon-sm"
		})),
		"rtg-select-none",
		"aria-disabled:rtg-opacity-calendar-button-previous-opacity-disabled"
	],
	buttonNext: [
		N(Pt({
			variant: "ghost",
			size: "icon-sm"
		})),
		"rtg-select-none",
		"aria-disabled:rtg-opacity-calendar-button-next-opacity-disabled"
	],
	chevron: ["rtg-size-calendar-chevron-space-size"],
	monthCaption: [
		"rtg-flex rtg-justify-center rtg-items-center",
		"rtg-px-calendar-month-caption-space-px",
		"rtg-w-full rtg-h-calendar-month-caption-space-h"
	],
	captionLabel: ["rtg-text-calendar-caption-label-font rtg-font-calendar-caption-label-font-weight", "rtg-select-none"],
	monthGrid: ["rtg-w-full", "rtg-border-collapse"],
	weekdays: ["rtg-flex"],
	weekday: [
		"rtg-flex-1",
		"rtg-text-calendar-weekday-font rtg-font-calendar-weekday-font-weight rtg-text-calendar-weekday-color-text",
		"rtg-rounded-calendar-weekday-radius",
		"rtg-select-none"
	],
	weeks: [""],
	week: [
		"rtg-flex",
		"rtg-mt-calendar-week-space-mt",
		"rtg-w-full"
	],
	day: {
		base: [
			"group/day",
			"rtg-aspect-square rtg-relative",
			"rtg-w-full rtg-h-full",
			"rtg-p-calendar-day-space-p",
			"rtg-text-center",
			"rtg-select-none"
		],
		today: ["rtg-bg-calendar-day-today-color-bg", "rtg-rounded-calendar-day-radius"],
		selected: {
			common: ["rtg-bg-calendar-day-color-bg-selected"],
			single: ["rtg-rounded-calendar-day-radius"],
			range: {
				start: ["rtg-rounded-l-calendar-day-radius"],
				middle: ["rtg-rounded-none"],
				end: ["rtg-rounded-r-calendar-day-radius"]
			}
		},
		index: {
			first: ["rtg-rounded-l-calendar-day-radius"],
			last: ["rtg-rounded-r-calendar-day-radius"]
		},
		hidden: ["rtg-invisible"]
	},
	dayButton: {
		base: [
			Pt({
				variant: "ghost",
				size: "icon"
			}),
			"rtg-aspect-square rtg-flex",
			"rtg-flex-col rtg-gap-calendar-day-button-space-gap",
			"rtg-size-auto rtg-w-full rtg-min-w-calendar-day-button-space-min-w",
			"rtg-text-calendar-day-button-font rtg-font-calendar-day-button-font-weight",
			"disabled:rtg-text-calendar-day-button-color-text-disabled disabled:rtg-opacity-calendar-day-button-opacity-disabled",
			"data-[selected-single=true]:rtg-text-calendar-day-button-color-text-single-selected data-[selected-single=true]:rtg-bg-calendar-day-button-color-bg-single-selected",
			"data-[range-start=true]:rtg-text-calendar-day-button-color-text-range-start data-[range-start=true]:rtg-bg-calendar-day-button-color-bg-range-start",
			"data-[range-middle=true]:rtg-text-calendar-day-button-color-text-range-middle data-[range-middle=true]:rtg-bg-calendar-day-button-color-bg-range-middle",
			"data-[range-end=true]:rtg-text-calendar-day-button-color-text-range-end data-[range-end=true]:rtg-bg-calendar-day-button-color-bg-range-end",
			"[&>span]:rtg-text-calendar-day-button-span-font [&>span]:rtg-opacity-calendar-day-button-span-opacity",
			"group-data-[focused=true]/day:rtg-relative group-data-[focused=true]/day:rtg-z-10",
			"group-data-[focused=true]/day:rtg-border-calendar-day-width-border-focus group-data-[focused=true]/day:rtg-border-calendar-day-color-border-focus",
			"group-data-[focused=true]/day:rtg-ring-calendar-day-width-ring-focus group-data-[focused=true]/day:rtg-ring-calendar-day-color-ring-focus"
		],
		outside: ["rtg-text-calendar-day-button-outside-color-text"],
		today: ["rtg-text-calendar-day-button-today-color-text", "rtg-bg-calendar-day-button-today-color-bg"]
	}
}, Ft = class extends e {
	constructor(...e) {
		super(...e), this.currentDate = /* @__PURE__ */ new Date(), this.selectedStartDate = null, this.selectedEndDate = null, this.mode = "single", this._userClass = "", this._userStyle = "";
	}
	getDaysInMonth(e, t) {
		return new Date(e, t + 1, 0).getDate();
	}
	previousMonth() {
		this.currentDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() - 1);
	}
	nextMonth() {
		this.currentDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1);
	}
	selectDate(e, t) {
		if (!t) {
			let t = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), e);
			t.getMonth() === this.currentDate.getMonth() && (this.mode === "single" ? (this.selectedStartDate = t, this.selectedEndDate = null) : this.mode === "range" && (!this.selectedStartDate || this.selectedEndDate ? (this.selectedStartDate = t, this.selectedEndDate = null) : t >= this.selectedStartDate ? this.selectedEndDate = t : (this.selectedEndDate = this.selectedStartDate, this.selectedStartDate = t)), this.dispatchEvent(new CustomEvent("date-selected", {
				detail: {
					startDate: this.selectedStartDate,
					endDate: this.selectedEndDate
				},
				bubbles: !0,
				composed: !0
			})));
		}
	}
	isDayInRange(e, t) {
		return !this.selectedStartDate || !this.selectedEndDate || e.getMonth() !== this.currentDate.getMonth() ? !1 : t ? e > this.selectedStartDate && e < this.selectedEndDate : e >= this.selectedStartDate && e <= this.selectedEndDate;
	}
	createRenderRoot() {
		return this;
	}
	connectedCallback() {
		super.connectedCallback(), this._userClass = this.getAttribute("class")?.replace(N(L.host), "") ?? "", this._userStyle = this.getAttribute("style") ?? "", this._userClass && this.removeAttribute("class"), this._userStyle && this.removeAttribute("style"), this.className = N(L.host);
	}
	firstUpdated(e) {
		let t = this.querySelector(".calendar");
		if (t && (this._userClass && (t.className = N("calendar", L.root, this._userClass)), this._userStyle)) {
			let e = t.getAttribute("style")?.trim(), n = this._userStyle.trim();
			t.setAttribute("style", [e, n].filter(Boolean).join("; "));
		}
	}
	render() {
		let e = this.currentDate.getFullYear(), t = this.currentDate.getMonth(), r = this.getDaysInMonth(e, t), i = new Date(e, t, 1).getDay(), a = new Date(e, t, 0).getDate(), o = [];
		for (let e = i - 1; e >= 0; e--) o.push({
			day: String(a - e),
			month: t - 1,
			isOutside: !0
		});
		for (let e = 1; e <= r; e++) o.push({
			day: String(e),
			month: t,
			isOutside: !1
		});
		let s = o.length % 7;
		if (s !== 0) {
			let e = 7 - s;
			for (let n = 1; n <= e; n++) o.push({
				day: String(n),
				month: t + 1,
				isOutside: !0
			});
		}
		let c = this.currentDate.toLocaleString("default", {
			month: "long",
			year: "numeric"
		}), l = this.currentDate.toLocaleString("default", {
			month: "long",
			year: "numeric"
		});
		return n`
      <div
        class=${N("calendar", L.root, this._userClass)}
        data-slot="calendar"
        data-mode=${this.mode}
        part="calendar"
        style=${this._userStyle}
      >
        <div class=${N("calendar-months", L.months)}>
          <nav class=${N("calendar-nav", L.nav)}>
            <button
              class=${N("calendar-button-previous", L.buttonPrevious)}
              aria-label="Go to the Previous Month"
              @click="${this.previousMonth}"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class=${N("calendar-chevron", L.chevron, "lucide lucide-chevron-left-icon lucide-chevron-left")}
              >
                <path d="m15 18-6-6 6-6" />
              </svg>
            </button>

            <button
              class=${N("calendar-button-next", L.buttonNext)}
              aria-label="Go to the Next Month"
              @click="${this.nextMonth}"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class=${N("calendar-chevron", L.chevron, "lucide lucide-chevron-right-icon lucide-chevron-right")}
              >
                <path d="m9 18 6-6-6-6" />
              </svg>
            </button>
          </nav>

          <div class=${N("calendar-month", L.month)}>
            <div
              class=${N("calendar-month-caption", L.monthCaption)}
            >
              <span
                class=${N("calendar-caption-label", L.captionLabel)}
                role="status"
                aria-live="polite"
              >
                ${c}
              </span>
            </div>

            <table
              class=${N("calendar-month-grid", L.monthGrid)}
              role="grid"
              aria-label=${l}
              aria-multiselectable=${this.mode === "range" ? "true" : "false"}
            >
              <thead aria-hidden="true">
                <tr class=${N("calendar-weekdays", L.weekdays)}>
                  ${Ot.map((e) => n`
                      <th
                        class=${N("calendar-weekday", L.weekday)}
                        scope="col"
                        aria-label=${e}
                      >
                        ${e.slice(0, 2)}
                      </th>
                    `)}
                </tr>
              </thead>

              <tbody class=${N("calendar-weeks", L.weeks)}>
                ${Array.from({ length: Math.ceil(o.length / 7) }, (e, t) => n`
                    <tr class=${N("calendar-week", L.week)}>
                      ${o.slice(t * 7, (t + 1) * 7).map((e, t) => {
			let r = new Date(this.currentDate.getFullYear(), e.month, Number(e.day)), i = r.toDateString() === (/* @__PURE__ */ new Date()).toDateString(), a = this.mode === "range" && r.toDateString() === this.selectedStartDate?.toDateString(), o = this.mode === "range" && this.isDayInRange(r, !0), s = this.mode === "range" && r.toDateString() === this.selectedEndDate?.toDateString(), c = this.mode === "single" && r.toDateString() === this.selectedStartDate?.toDateString(), l = c || a || o || s, u = t === 0, d = t === 6, f = i ? "Today, " : "";
			return f += At(r), f += l ? ", selected" : "", n`
                            <td
                              class=${N("calendar-day", L.day.base, i && !l && L.day.today, l && L.day.selected.common, c && L.day.selected.single, a && L.day.selected.range.start, o && L.day.selected.range.middle, s && L.day.selected.range.end, u && L.day.index.first, d && L.day.index.last, !1)}
                              role="gridcell"
                              data-day=${r.toISOString().slice(0, 10)}
                              ?data-disabled=${void 0}
                              ?data-focused=${void 0}
                              ?data-hidden=${void 0}
                              ?data-outside=${e.isOutside ? "true" : void 0}
                              ?data-today=${i ? "true" : void 0}
                              ?data-selected=${l ? "true" : void 0}
                              ?aria-disabled=${void 0}
                              ?aria-hidden=${void 0}
                              ?aria-selected=${l ? "true" : void 0}
                            >
                              <button
                                class=${N("calendar-day-button", L.dayButton.base, e.isOutside && L.dayButton.outside, i && L.dayButton.today)}
                                ?disabled=${void 0}
                                data-variant="ghost"
                                data-size="icon"
                                data-selected-single=${c.toString()}
                                data-range-start=${a.toString()}
                                data-range-middle=${o.toString()}
                                data-range-end=${s.toString()}
                                tabindex=${c || s ? "0" : "-1"}
                                type="button"
                                aria-label=${f}
                                @click="${() => this.selectDate(Number(e.day), e.isOutside)}"
                              >
                                ${e.day}
                              </button>
                            </td>
                          `;
		})}
                    </tr>
                  `)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    `;
	}
};
S([o({ type: Object }), x("design:type", typeof Date > "u" ? Object : Date)], Ft.prototype, "currentDate", void 0), S([o({ type: Object }), x("design:type", Object)], Ft.prototype, "selectedStartDate", void 0), S([o({ type: Object }), x("design:type", Object)], Ft.prototype, "selectedEndDate", void 0), S([o({ type: String }), x("design:type", Object)], Ft.prototype, "mode", void 0), Ft = S([a("rtg-calendar")], Ft);
//#endregion
//#region src/components/ui/card/_card.ts
var It = class extends e {
	constructor(...e) {
		super(...e), this.size = "default";
	}
	get _rootSlot() {
		return this.querySelector("[data-slot=\"card\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._rootSlot && this._rootSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<div data-slot="card" data-size=${this.size}></div>`;
	}
};
S([o({ type: String }), x("design:type", Object)], It.prototype, "size", void 0), It = S([a("rtg-card")], It);
//#endregion
//#region src/components/ui/card/_card-header.ts
var Lt = class extends e {
	get _headerSlot() {
		return this.querySelector("[data-slot=\"card-header\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._headerSlot && this._headerSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div data-slot="card-header" ?data-border=${this.border}></div>
    `;
	}
};
S([o({ type: Boolean }), x("design:type", Boolean)], Lt.prototype, "border", void 0), Lt = S([a("rtg-card-header")], Lt);
//#endregion
//#region src/components/ui/card/_card-title.ts
var Rt = class extends e {
	get _titleSlot() {
		return this.querySelector("[data-slot=\"card-title\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._titleSlot && this._titleSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<div data-slot="card-title"></div>`;
	}
};
Rt = S([a("rtg-card-title")], Rt);
//#endregion
//#region src/components/ui/card/_card-description.ts
var zt = class extends e {
	get _descriptionSlot() {
		return this.querySelector("[data-slot=\"card-description\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._descriptionSlot && this._descriptionSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<div data-slot="card-description"></div>`;
	}
};
zt = S([a("rtg-card-description")], zt);
//#endregion
//#region src/components/ui/card/_card-action.ts
var Bt = class extends e {
	get _actionSlot() {
		return this.querySelector("[data-slot=\"card-action\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._actionSlot && this._actionSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<div data-slot="card-action"></div>`;
	}
};
Bt = S([a("rtg-card-action")], Bt);
//#endregion
//#region src/components/ui/card/_card-content.ts
var Vt = class extends e {
	get _contentSlot() {
		return this.querySelector("[data-slot=\"card-content\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._contentSlot && this._contentSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<div data-slot="card-content"></div>`;
	}
};
Vt = S([a("rtg-card-content")], Vt);
//#endregion
//#region src/components/ui/card/_card-footer.ts
var Ht = class extends e {
	get _footerSlot() {
		return this.querySelector("[data-slot=\"card-footer\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._footerSlot && this._footerSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div data-slot="card-footer" ?data-border=${this.border}></div>
    `;
	}
};
S([o({ type: Boolean }), x("design:type", Boolean)], Ht.prototype, "border", void 0), Ht = S([a("rtg-card-footer")], Ht);
//#endregion
//#region src/assets/icons/arrows.icon.ts
function Ut() {
	return i` <svg
  class="shrink-0 size-3.5 text-gray-500 dark:text-neutral-500"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="m7 15 5 5 5-5"></path>
  <path d="m7 9 5-5 5 5"></path>
</svg>
  `;
}
//#endregion
//#region src/assets/icons/carousel-arrow-left.ts
function Wt() {
	return i` 
   <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="lucide lucide-arrow-left h-4 w-4"
    >   
        <path d="m12 19-7-7 7-7"></path>
        <path d="M19 12H5"></path>
    </svg>
  `;
}
//#endregion
//#region src/assets/icons/carousel-arrow-right.ts
function Gt() {
	return i` 
   <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="lucide lucide-arrow-right h-4 w-4"
            >
            <path d="M5 12h14"></path>
            <path d="m12 5 7 7-7 7"></path>
        </svg>
  `;
}
//#endregion
//#region src/assets/icons/check.icon.ts
function Kt(e) {
	return n`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class=${N("lucide lucide-check-icon lucide-check", e ?? "")}
    >
      <path d="M20 6 9 17l-5-5"/>
    </svg>
  `;
}
//#endregion
//#region src/assets/icons/minus.icon.ts
function qt(e) {
	return n`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class=${N("lucide lucide-minus-icon lucide-minus", e ?? "")}
    >
      <path d="M5 12h14"/>
    </svg>
  `;
}
//#endregion
//#region src/assets/icons/search.icon.ts
function Jt(e) {
	return n`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class=${N("lucide lucide-search-icon lucide-search", e ?? "")}
    >
      <path d="m21 21-4.34-4.34"/>
      <circle cx="11" cy="11" r="8"/>
    </svg>
  `;
}
//#endregion
//#region src/assets/icons/tick.icon.ts
function Yt() {
	return i`
             <svg
                class="rtg-shrink-0 rtg-size-3.5 rtg-text-primary"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M20 6 9 17l-5-5"></path>
              </svg>
  `;
}
//#endregion
//#region src/assets/icons/up.ts
function Xt() {
	return i`
       <svg width="7" height="4" viewBox="0 0 7 4" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.565616 3.3941L3.39404 0.565674L6.22247 3.3941" stroke="currentColor" stroke-width="0.8" stroke-linecap="square"/>
</svg>

  `;
}
//#endregion
//#region src/assets/icons/down.ts
function Zt() {
	return i`
    <svg width="7" height="4" viewBox="0 0 7 4" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.565616 0.565674L3.39404 3.3941L6.22247 0.565674" stroke="currentColor" stroke-width="0.8" stroke-linecap="square"/>
    </svg>
  `;
}
//#endregion
//#region src/components/ui/carousel/carousel.styles.ts
var R = {
	root: ["rtg-relative rtg-mx-carousel-space-mx rtg-h-carousel-space-h rtg-w-carousel-space-w"],
	viewport: ["rtg-w-carousel-viewport-space-w rtg-h-carousel-viewport-space-h rtg-overflow-hidden"],
	slidesWrapper: {
		base: ["rtg-flex rtg-transition-transform rtg-duration-carousel-motion-duration rtg-ease-carousel-motion-fn"],
		orientation: {
			horizontal: ["rtg-flex-row"],
			vertical: ["rtg-flex-col"]
		}
	},
	slide: {
		base: ["rtg-min-w-0 rtg-basis-full rtg-h-carousel-slide-space-h rtg-flex-shrink-0 rtg-flex-grow-0 rtg-transition-transform rtg-duration-carousel-motion-duration rtg-px-carousel-slide-space-px rtg-py-carousel-slide-space-py"],
		size: {
			true: ["lg:rtg-basis-1/3 lg:rtg-h-1/2 md:rtg-basis-1/2 md:rtg-h-1/2"],
			false: [""]
		}
	},
	controls: {
		base: ["rtg-absolute rtg-z-10 rtg-flex"],
		orientation: {
			horizontal: ["rtg-top-1/2 rtg-left-carousel-control-horizontal-space-left rtg-right-carousel-control-horizontal-space-right rtg-justify-between"],
			vertical: ["rtg-w-carousel-control-vertical-space-w rtg-h-carousel-control-vertical-space-h rtg-top-0 rtg-flex-col rtg-justify-between rtg-items-center"]
		}
	},
	controlButton: {
		base: ["rtg-bg-carousel-button-color-bg rtg-text-carousel-button-color-text rtg-border-none rtg-px-carousel-button-space-px rtg-py-carousel-button-space-py rtg-cursor-pointer rtg-z-10 rtg-rounded-carousel-button-radius rtg-w-carousel-button-space-w rtg-h-carousel-button-space-h rtg-flex rtg-items-center rtg-justify-center hover:rtg-bg-carousel-button-color-bg-hover disabled:rtg-opacity-carousel-button-opacity-disabled"],
		orientation: {
			verticalPrev: ["rtg-relative rtg-top-carousel-button-vertical-prev-space-top rtg-rotate-90"],
			verticalNext: ["rtg-relative rtg-top-carousel-button-vertical-next-space-top rtg-rotate-90"]
		}
	}
}, Qt = class extends e {
	constructor(...e) {
		super(...e), this.currentIndex = 0, this.items = [], this.orientation = "horizontal", this.size = !1, this.handleResize = () => {
			this.updateSlides(), this.currentIndex = 0, this.querySelectorAll(".slide").forEach((e) => {
				e.className = this.getSlideClasses();
			});
		};
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated() {
		this.restructureSlides();
	}
	restructureSlides() {
		let e = this.querySelector(".slides");
		if (e) for (let t = 0; t < this.items.length; t++) {
			let n = `slide-${t}`, r = this.querySelector(`[slot="${n}"]`);
			if (r && r.parentElement !== e) {
				let t = document.createElement("div");
				t.className = this.getSlideClasses(), e.appendChild(t), t.appendChild(r);
			}
		}
	}
	getSlideClasses() {
		return N(R.slide.base, this.size ? R.slide.size.true : R.slide.size.false);
	}
	nextSlide() {
		this.currentIndex < this.items.length - 1 && (this.currentIndex += 1, this.updateSlides());
	}
	prevSlide() {
		this.currentIndex > 0 && (--this.currentIndex, this.updateSlides());
	}
	updateSlides() {
		let e;
		e = this.size ? window.innerWidth >= 1024 ? 33.3333 : window.innerWidth >= 768 ? 50 : 100 : 100;
		let t = this.orientation === "vertical" ? 100 / this.items.length : 100;
		this.slides && (this.slides.style.transform = this.orientation === "horizontal" ? `translateX(-${this.currentIndex * e}%)` : `translateY(-${this.currentIndex * t}%)`);
	}
	connectedCallback() {
		super.connectedCallback(), window.addEventListener("resize", this.handleResize);
	}
	disconnectedCallback() {
		super.disconnectedCallback(), window.removeEventListener("resize", this.handleResize);
	}
	render() {
		let e = this.currentIndex === 0, t = this.size ? window.innerWidth >= 1024 ? 3 : window.innerWidth >= 768 ? 2 : 1 : 1, r = this.currentIndex >= this.items.length - t, i = N(R.slidesWrapper.base, R.slidesWrapper.orientation[this.orientation]), a = N(R.controls.base, R.controls.orientation[this.orientation]), o = N(R.controlButton.base, this.orientation === "vertical" && R.controlButton.orientation.verticalPrev), s = N(R.controlButton.base, this.orientation === "vertical" && R.controlButton.orientation.verticalNext);
		return n`
      <div
        part="rtg-carousel"
        class="${N(R.root, this.className)}"
        size="${this.size}"
        orientation="${this.orientation}"
      >
        <div class="${N(R.viewport, this.className)}">
          <div class="slides ${i}"></div>

          <div class="${a}">
            <button
              @click="${this.prevSlide}"
              ?disabled="${e}"
              class="${o}"
            >
              ${Wt()}
            </button>

            <button
              @click="${this.nextSlide}"
              ?disabled="${r}"
              class="${s}"
            >
              ${Gt()}
            </button>
          </div>
        </div>
      </div>
    `;
	}
};
S([o({ type: Number }), x("design:type", Object)], Qt.prototype, "currentIndex", void 0), S([o({ type: Array }), x("design:type", Array)], Qt.prototype, "items", void 0), S([o({ type: String }), x("design:type", String)], Qt.prototype, "orientation", void 0), S([o({ type: Boolean }), x("design:type", Object)], Qt.prototype, "size", void 0), S([s(".slides"), x("design:type", typeof HTMLElement > "u" ? Object : HTMLElement)], Qt.prototype, "slides", void 0), Qt = S([a("rtg-carousel")], Qt);
//#endregion
//#region src/components/ui/checkbox/_checkbox.ts
var z = class extends e {
	constructor(...e) {
		super(...e), this.value = "on";
	}
	createRenderRoot() {
		return this;
	}
	_isControlled() {
		return this.checked !== void 0;
	}
	_getState() {
		return this._checked ? "checked" : "unchecked";
	}
	updated(e) {
		e.has("checked") && this._isControlled() && (this._checked = this.checked);
	}
	firstUpdated(e) {
		this._checked = this.defaultChecked || this.checked;
	}
	_handleClick() {
		if (this.disabled) return;
		let e = !this._checked;
		this._isControlled() || (this._checked = e), this.dispatchEvent(new CustomEvent("rtg-checkbox:checked-change", {
			detail: { checked: e },
			bubbles: !0,
			composed: !0
		})), this.onCheckedChange !== void 0 && this.onCheckedChange(e);
	}
	_renderIndicator() {
		return this._checked ? n`
      <span
        data-slot="checkbox-indicator"
        data-state=${this._getState()}
        ?data-disabled=${this.disabled}
      >
        ${Kt()}
      </span>
    ` : null;
	}
	_renderInput() {
		return this.name === void 0 ? null : n`
      <input
        data-slot="checkbox-input"
        type="checkbox"
        name=${this.name}
        value=${this.value}
        ?checked=${this._checked}
        tabindex="-1"
        ?disabled=${this.disabled}
        ?required=${this.required}
        aria-hidden="true"
      />
    `;
	}
	render() {
		return n`
      <button
        data-slot="checkbox"
        data-state=${this._getState()}
        ?data-disabled=${this.disabled}
        type="button"
        role="checkbox"
        ?disabled=${this.disabled}
        value=${this.value}
        aria-checked=${this._checked ? "true" : "false"}
        aria-required=${this.required ? "true" : r}
        aria-invalid=${this.invalid || this.ariaInvalid === "true" ? "true" : r}
        @click=${this._handleClick}
      >
        ${this._renderIndicator()}
      </button>

      ${this._renderInput()}
    `;
	}
};
S([o({
	attribute: "default-checked",
	type: Boolean
}), x("design:type", Boolean)], z.prototype, "defaultChecked", void 0), S([o({
	attribute: !0,
	type: Boolean
}), x("design:type", Boolean)], z.prototype, "checked", void 0), S([o({
	attribute: !1,
	type: Function
}), x("design:type", Function)], z.prototype, "onCheckedChange", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], z.prototype, "disabled", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], z.prototype, "required", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], z.prototype, "invalid", void 0), S([o({ type: String }), x("design:type", String)], z.prototype, "name", void 0), S([o({ type: String }), x("design:type", Object)], z.prototype, "value", void 0), S([c(), x("design:type", Boolean)], z.prototype, "_checked", void 0), z = S([a("rtg-checkbox")], z);
//#endregion
//#region src/components/ui/collapsible/collapsible-trigger.ts
var $t = class extends C {
	getAttributesToExclude() {
		return [""];
	}
	get _containerElement() {
		return this.querySelector("div[part=collapsible-trigger]");
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	createRenderRoot() {
		return this;
	}
	get _collapsible() {
		let e = this.parentElement;
		for (; e && !(e instanceof tn);) e = e.parentElement;
		return e;
	}
	onTrigger() {
		let e = this._collapsible;
		e && (e.open = !e.open, this.dispatchEvent(new CustomEvent("click-collapsible-event", {
			bubbles: !0,
			composed: !0
		})));
	}
	render() {
		let e = this.getFilteredAttributes();
		return n`
      <div
        @click=${this.onTrigger}
        ${P(e)}
        part="collapsible-trigger"
      ></div>
    `;
	}
};
$t = S([a("rtg-collapsible-trigger")], $t);
//#endregion
//#region src/components/ui/collapsible/collapsible-content.ts
var en = class extends C {
	constructor(...e) {
		super(...e), this._toggleHandler = (e) => {
			let t = e;
			requestAnimationFrame(() => {
				let e = this._containerElement;
				e && (e.style.display = t.detail.open ? "block" : "none");
			});
		};
	}
	get _containerElement() {
		return this.querySelector("div[part=collapsible-content]");
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	createRenderRoot() {
		return this;
	}
	getAttributesToExclude() {
		return [""];
	}
	connectedCallback() {
		super.connectedCallback(), this.addEventListener("toggle-collapsible-content", this._toggleHandler);
	}
	disconnectedCallback() {
		this.removeEventListener("toggle-collapsible-content", this._toggleHandler), super.disconnectedCallback();
	}
	render() {
		return n`
      <div
        ${P(this.getFilteredAttributes())}
        class="${N("", this.className)}"
        style="display: none;--radix-collapsible-content-height: 100px; --radix-collapsible-content-width: 350px;"
        part="collapsible-content"
      ></div>
    `;
	}
};
en = S([a("rtg-collapsible-content")], en);
//#endregion
//#region src/components/ui/collapsible/collapsible.ts
var tn = class extends C {
	constructor(...e) {
		super(...e), this.open = !1, this._clickHandler = () => {
			this.querySelector("rtg-collapsible-content")?.dispatchEvent(new CustomEvent("toggle-collapsible-content", { detail: { open: this.open } }));
		};
	}
	getAttributesToExclude() {
		return [""];
	}
	createRenderRoot() {
		return this;
	}
	get _containerElement() {
		return this.querySelector("div[part=collapsible]");
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	connectedCallback() {
		super.connectedCallback(), this.addEventListener("click-collapsible-event", this._clickHandler);
	}
	disconnectedCallback() {
		this.removeEventListener("click-collapsible-event", this._clickHandler), super.disconnectedCallback();
	}
	render() {
		return n`
      <div
        ${P(this.getFilteredAttributes())}
        class="${N("", this.className)}"
        part="collapsible"
      ></div>
    `;
	}
};
S([o({ type: Boolean }), x("design:type", Object)], tn.prototype, "open", void 0), tn = S([a("rtg-collapsible")], tn);
//#endregion
//#region src/components/ui/combobox/combo-box.styles.ts
var nn = {
	empty: [
		"rtg-py-combo-box-empty-space-py",
		"rtg-text-center",
		"rtg-text-combo-box-empty-font"
	],
	group: { base: [
		"rtg-pointer-events-none",
		"rtg-invisible",
		"rtg-absolute",
		"rtg-z-50",
		"rtg-mt-combo-box-group-space-mt",
		"rtg-max-h-combo-box-group-space-max-h",
		"rtg-w-combo-box-group-space-w",
		"rtg-origin-top",
		"rtg-scale-y-0",
		"rtg-transform",
		"rtg-overflow-hidden",
		"rtg-overflow-y-auto",
		"rtg-rounded-combo-box-group-radius",
		"rtg-border-combo-box-group-width-border",
		"rtg-border-combo-box-group-color-border",
		"rtg-bg-combo-box-group-color-bg",
		"rtg-px-combo-box-group-space-px",
		"rtg-py-combo-box-group-space-py",
		"rtg-opacity-0",
		"rtg-shadow-combo-box-group-shadow",
		"rtg-transition-opacity",
		"rtg-duration-combo-box-group-motion-duration",
		"rtg-ease-combo-box-group-motion-fn",
		"[&::-webkit-scrollbar]:rtg-w-0"
	] },
	input: [
		"rtg-flex",
		"rtg-h-combo-box-input-space-h",
		"rtg-w-combo-box-input-space-w",
		"rtg-rounded-combo-box-input-radius",
		"rtg-border-0",
		"rtg-bg-combo-box-input-color-bg",
		"rtg-px-combo-box-input-space-px",
		"rtg-py-combo-box-input-space-py",
		"rtg-text-combo-box-input-font",
		"rtg-text-combo-box-input-color-text",
		"rtg-shadow-none",
		"placeholder:rtg-text-combo-box-input-color-text-placeholder",
		"focus:rtg-outline-none",
		"focus-visible:rtg-ring-0"
	],
	trigger: { base: [
		"rtg-z-20",
		"rtg-flex",
		"rtg-h-combo-box-trigger-space-h",
		"rtg-flex-row-reverse",
		"rtg-items-center",
		"rtg-justify-between",
		"rtg-rounded-combo-box-trigger-radius",
		"rtg-border-combo-box-trigger-width-border",
		"rtg-border-combo-box-trigger-color-border",
		"rtg-bg-combo-box-trigger-color-bg",
		"rtg-px-combo-box-trigger-space-px",
		"rtg-py-combo-box-trigger-space-py",
		"rtg-text-combo-box-trigger-font",
		"focus:rtg-outline-none",
		"focus:rtg-ring-combo-box-trigger-width-ring-focus",
		"focus:rtg-ring-combo-box-trigger-color-ring-focus",
		"focus:rtg-ring-offset-combo-box-trigger-width-ring-offset-focus",
		"disabled:rtg-cursor-not-allowed",
		"disabled:rtg-opacity-combo-box-trigger-opacity-disabled"
	] },
	value: [
		"rtg-line-clamp-1",
		"rtg-flex",
		"rtg-w-combo-box-value-space-w"
	],
	item: { base: [
		"rtg-flex",
		"rtg-w-combo-box-item-space-w",
		"rtg-cursor-pointer",
		"rtg-flex-row-reverse",
		"rtg-items-center",
		"rtg-justify-between",
		"rtg-rounded-combo-box-item-radius",
		"rtg-px-combo-box-item-space-px",
		"rtg-py-combo-box-item-space-py",
		"hover:rtg-bg-accent",
		"focus:rtg-bg-combo-box-item-color-bg-hover",
		"focus:rtg-outline-none"
	] }
}, rn = class extends C {
	constructor(...e) {
		super(...e), this.handleClick = () => {
			this._comboBox && ([...document.getElementsByTagName("rtg-combo-box")].forEach((e) => {
				e.uuid !== this._comboBox?.uuid && (e.isOpen = !1);
			}), this._comboBox.isOpen = !this._comboBox.isOpen);
		};
	}
	get _comboBox() {
		let e = this.parentElement;
		for (; e && !(e instanceof V);) e = e.parentElement;
		return e;
	}
	getAttributesToExclude() {
		return [];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		super.firstUpdated(e), this.moveLightDomChildrenInto(this.buttonElement), this.addEventListener("click", (e) => {
			e.stopPropagation();
		});
	}
	render() {
		return n`
      <button
        type="button"
        part="combo-box-trigger-button"
        role="tab"
        class="${N(nn.trigger.base, this.className)}"
        tabindex="-1"
        data-orientation="horizontal"
        data-radix-collection-item=""
        @click=${this.handleClick}
      >
        ${Ut()}
      </button>
    `;
	}
};
S([s("button"), x("design:type", typeof HTMLButtonElement > "u" ? Object : HTMLButtonElement)], rn.prototype, "buttonElement", void 0), rn = S([a("rtg-combo-box-trigger")], rn);
//#endregion
//#region src/components/ui/combobox/combo-box-value.ts
var an = class extends e {
	constructor(...e) {
		super(...e), this.placeholder = "select a value", this.handleClick = () => {
			this._comboBox && ([...document.getElementsByTagName("rtg-combo-box")].forEach((e) => {
				e.uuid !== this._comboBox?.uuid && (e.isOpen = !1);
			}), this._comboBox.isOpen = !this._comboBox.isOpen);
		}, this.renderLabel = () => this._comboBox && this._comboBox.selectedValue.length > 0 ? this._comboBox.selectedValue : this.placeholder;
	}
	get _comboBox() {
		let e = this.parentElement;
		for (; e && !(e instanceof V);) e = e.parentElement;
		return e;
	}
	connectedCallback() {
		super.connectedCallback(), document.addEventListener("clicked-combo-box-item", () => {
			this.requestUpdate();
		});
	}
	firstUpdated(e) {
		super.firstUpdated(e), this.addEventListener("click", (e) => {
			e.stopPropagation();
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <span
        part="combo-box-value"
        class="${N(nn.value, this.className)}"
        @click=${this.handleClick}
        >${this.renderLabel()}</span
      >
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], an.prototype, "placeholder", void 0), an = S([a("rtg-combo-box-value")], an);
//#endregion
//#region src/components/ui/separator/_separator.ts
var on = class extends e {
	constructor(...e) {
		super(...e), this.orientation = "horizontal";
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        data-slot="separator"
        data-orientation=${this.orientation}
        role=${this.decorative ? "none" : "separator"}
        aria-orientation=${this.decorative ? r : this.orientation}
      ></div>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], on.prototype, "orientation", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], on.prototype, "decorative", void 0), on = S([a("rtg-separator")], on);
//#endregion
//#region src/components/ui/combobox/combo-box-group.ts
var sn = class extends C {
	constructor(...e) {
		super(...e), this.searchKey = "", this.focusedIndex = 0, this.selectedValue = "", this.isOpen = !1, this.handleItemClicked = () => {
			this.requestUpdate();
		}, this.handleTriggerComboBox = (e) => {
			e.detail.isOpen !== this._comboBox?.isOpen && this.requestUpdate(), e.detail.isOpen && this._comboBox?.selectedValue && (this.focusedIndex = this.comboBoxItems.findIndex((e) => e.getAttribute("value") === this._comboBox?.selectedValue), this.requestUpdate());
		}, this.handleKeyDown = (e) => {
			if (!this._comboBox?.isOpen) return;
			e.preventDefault();
			let t = this.filteredItems;
			switch (e.key) {
				case "ArrowDown":
					if (t.length === 0) return;
					this.focusedIndex = (this.focusedIndex + 1) % t.length;
					break;
				case "ArrowUp":
					if (t.length === 0) return;
					this.focusedIndex = (this.focusedIndex - 1 + t.length) % t.length;
					break;
				case "Enter":
					if (this.focusedIndex >= 0 && this.focusedIndex < t.length) {
						let e = t[this.focusedIndex].getAttribute("value");
						this.dispatchEvent(new CustomEvent("clicked-combo-box-item", {
							bubbles: !0,
							composed: !0,
							detail: { selectedItem: e }
						}));
					}
					break;
			}
		}, this.handleMouseOver = (e, t) => {
			e.preventDefault(), this.focusedIndex = t;
		}, this.onSelectedValue = (e, t) => {
			this.focusedIndex = t, this.selectedValue = e;
		}, this.boundHandleComboBoxStateChanged = this.handleComboBoxStateChanged.bind(this), this.boundHandleKeyDown = this.handleKeyDown.bind(this);
	}
	get comboBoxItems() {
		return Array.from(this.querySelectorAll("[data-managed=\"true\"][tag=\"rtg-combo-box-item\"], rtg-combo-box-item")).filter((e) => e.hasAttribute("value"));
	}
	get comboBoxInput() {
		return this.querySelector("rtg-combo-box-input");
	}
	get comboBoxEmpty() {
		return this.querySelector("rtg-combo-box-empty");
	}
	get hasResults() {
		return !this.filteredItems.length;
	}
	get filteredItems() {
		let e = this.searchKey?.toLowerCase();
		return this.comboBoxItems.filter((t) => t.getAttribute("value")?.toLowerCase().includes(e));
	}
	get _comboBox() {
		let e = this.parentElement;
		for (; e && !(e instanceof V);) e = e.parentElement;
		return e;
	}
	handleComboBoxStateChanged(e) {
		let { isOpen: t, targetComboBoxId: n } = e.detail;
		if (this.isOpen = t, n !== this._comboBox?.uuid) return;
		let r = this.renderRoot.querySelector("[part=\"select-group\"]");
		r && (t ? (clearTimeout(r._hideTimeout), r.classList.remove("rtg-scale-y-0", "rtg-opacity-0"), r.classList.add("rtg-scale-y-100", "rtg-opacity-100"), r.classList.remove("rtg-invisible", "rtg-pointer-events-none"), r.classList.add("rtg-visible", "rtg-pointer-events-auto")) : (r.classList.remove("rtg-opacity-100"), r.classList.add("rtg-opacity-0"), r._hideTimeout = setTimeout(() => {
			r.classList.remove("rtg-visible", "rtg-pointer-events-auto", "rtg-scale-y-100"), r.classList.add("rtg-invisible", "rtg-pointer-events-none", "rtg-scale-y-0");
		}, 300)));
	}
	moveChildren() {
		let e = this.renderRoot.querySelector("[part=\"select-group\"]");
		if (!e) return;
		let t = {
			top: e.querySelector("#topSlot"),
			empty: e.querySelector("#emptySlot"),
			list: e.querySelector("#listSlot")
		}, n = {
			"rtg-combo-box-input": "top",
			"rtg-combo-box-empty": "empty",
			"rtg-combo-box-item": "list"
		};
		Array.from(this.children).forEach((e) => {
			let r = n[e.tagName.toLowerCase()];
			r && (e.setAttribute("data-managed", "true"), t[r]?.appendChild(e));
		});
	}
	renderFilteredItems() {
		return this.comboBoxItems.forEach((e) => e.setAttribute("hidden", "true")), this.filteredItems.map((e, t) => {
			let r = e.getAttribute("value") ?? "", i = t === this.focusedIndex, a = r.toLowerCase() === this._comboBox?.selectedValue.toLowerCase();
			return n`
        <rtg-combo-box-item
          @mouseover="${(e) => this.handleMouseOver(e, t)}"
          .value=${r}
          .selectItemIndex=${t}
          .isFocus=${i}
          .onSelect=${this.onSelectedValue}
          .isSelected=${a}
        >
          ${e.textContent}
        </rtg-combo-box-item>
      `;
		});
	}
	getAttributesToExclude() {
		return [];
	}
	connectedCallback() {
		super.connectedCallback(), document.addEventListener("rtg-combo-box-state-changed", this.boundHandleComboBoxStateChanged), document.addEventListener("clicked-combo-box-item", this.handleItemClicked), document.addEventListener("trigger-combo-box", this.handleTriggerComboBox);
	}
	disconnectedCallback() {
		super.disconnectedCallback(), document.removeEventListener("clicked-combo-box-item", this.handleItemClicked), document.removeEventListener("trigger-combo-box", this.handleTriggerComboBox), document.removeEventListener("rtg-combo-box-state-changed", this.boundHandleComboBoxStateChanged), document.removeEventListener("keydown", this.boundHandleKeyDown);
	}
	firstUpdated(e) {
		this.moveChildren(), document.addEventListener("keydown", this.boundHandleKeyDown);
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="select-group"
        class="${N(nn.group.base, this.className)}"
        data-hs-combo-box-output=""
        data-testId="select-group"
      >
        <rtg-separator
          id="topSlot"
          data-testid="horizontal-separator"
        ></rtg-separator>
        <div id="emptySlot" ?hidden=${!this.hasResults}></div>
        <div id="listSlot" ?hidden=${this.hasResults}>
          ${this.renderFilteredItems()}
        </div>
      </div>
    `;
	}
};
S([c(), x("design:type", Object)], sn.prototype, "searchKey", void 0), S([c(), x("design:type", Object)], sn.prototype, "focusedIndex", void 0), S([c(), x("design:type", Object)], sn.prototype, "selectedValue", void 0), S([c(), x("design:type", Boolean)], sn.prototype, "isOpen", void 0), sn = S([a("rtg-combo-box-group")], sn);
//#endregion
//#region src/components/ui/combobox/combo-box-item.ts
var B = class extends C {
	constructor(...e) {
		super(...e), this.value = "", this.key = "", this.tabindex = 0, this.isSelected = !1, this.isFocus = !1, this.class = "", this.selectItemIndex = -1, this.onSelect = (e, t) => {}, this.onMouseOver = (e, t) => {}, this.handleClick = (e) => {
			this.onSelect(this.value, this.selectItemIndex), e.stopPropagation();
			let t = new CustomEvent("clicked-combo-box-item", {
				bubbles: !0,
				composed: !0,
				detail: { selectedItem: this.value }
			});
			this.dispatchEvent(t);
		};
	}
	getAttributesToExclude() {
		return [
			"aria-orientation",
			"role",
			"data-orientation",
			"data-testid"
		];
	}
	connectedCallback() {
		super.connectedCallback();
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this.itemDivContainer);
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        ${P(this.getFilteredAttributes())}
        @click=${this.handleClick}
        class="${N(nn.item.base, this.className)}"
        data-hs-combo-box-value=${this.value}
        aria-selected="${this.isSelected}"
        data-selected="${this.isSelected}"
        id="rtg-combo-box-item"
      >
        <span
          class="${this.isSelected ? "rtg-visible" : "rtg-invisible"} data-hs-combo-box-value rtg-mr-2"
        >
          ${Yt()}
        </span>
      </div>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], B.prototype, "value", void 0), S([o({ type: String }), x("design:type", Object)], B.prototype, "key", void 0), S([o({ type: Number }), x("design:type", Object)], B.prototype, "tabindex", void 0), S([o({ type: Boolean }), x("design:type", Object)], B.prototype, "isSelected", void 0), S([o({ type: Boolean }), x("design:type", Object)], B.prototype, "isFocus", void 0), S([o({ type: String }), x("design:type", Object)], B.prototype, "class", void 0), S([o({ type: Number }), x("design:type", Object)], B.prototype, "selectItemIndex", void 0), S([o({ type: Function }), x("design:type", Object)], B.prototype, "onSelect", void 0), S([o({ type: Function }), x("design:type", Object)], B.prototype, "onMouseOver", void 0), S([s("#rtg-combo-box-item"), x("design:type", typeof HTMLDivElement > "u" ? Object : HTMLDivElement)], B.prototype, "itemDivContainer", void 0), B = S([a("rtg-combo-box-item")], B);
//#endregion
//#region src/components/ui/combobox/combo-box-input.ts
var cn = class extends e {
	constructor(...e) {
		super(...e), this.placeholder = "Search Item ...", this.searchValue = "";
	}
	get _comboBoxGroup() {
		let e = this.parentElement;
		for (; e && !(e instanceof sn);) e = e.parentElement;
		return e;
	}
	handleSearch(e) {
		e.stopPropagation();
		let t = e.target;
		this.searchValue = t.value, this._comboBoxGroup && (this._comboBoxGroup.searchKey = this.searchValue);
	}
	handleKeyDown(e) {
		e.stopPropagation();
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div class="rtg-flex rtg-items-center rtg-px-2">
        ${Jt()}
        <input
          part="combo-box-input"
          type="text"
          class="${N(nn.input, this.className)}"
          placeholder=${this.placeholder}
          autocomplete="off"
          autocorrect="off"
          spellcheck="false"
          aria-autocomplete="list"
          role="combobox"
          value=${this.searchValue}
          @input="${this.handleSearch}"
          @keydown="${this.handleKeyDown}"
        />
      </div>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], cn.prototype, "placeholder", void 0), S([c(), x("design:type", Object)], cn.prototype, "searchValue", void 0), cn = S([a("rtg-combo-box-input")], cn);
//#endregion
//#region src/components/ui/combobox/combo-box-empty.ts
var ln = class extends C {
	createRenderRoot() {
		return this;
	}
	getAttributesToExclude() {
		return [];
	}
	firstUpdated(e) {
		this.removeDuplicateContent();
	}
	render() {
		return n`
      <div
        class="${N(nn.empty, this.className)}"
        role="presentation"
      >
        ${Array.from(this.childNodes)[0].textContent}
      </div>
    `;
	}
};
ln = S([a("rtg-combo-box-empty")], ln);
//#endregion
//#region src/components/ui/combobox/combo-box.ts
var V = class extends C {
	constructor() {
		super(), this.isOpen = !1, this.selectedValue = "", this.searchTerm = "", this.focusedIndex = -1, this.filteredItems = [], this.uuid = w(), this.label = "Select an item", this.items = [], this.handleClickOutside = (e) => {
			let t = this.renderRoot?.querySelector("[data-combo-box-uuid]"), n = e.target;
			if (!n.tagName.includes("RTG-COMBO") && !(n.shadowRoot && n.shadowRoot.innerHTML.includes(t?.innerHTML))) {
				if (this.isOpen && !t || !t?.contains(n)) this.isOpen = !1;
				else if (!n?.firstElementChild) return;
			}
		};
	}
	connectedCallback() {
		super.connectedCallback(), document.addEventListener("clicked-combo-box-item", (e) => {
			this.isOpen && (this.selectedValue = e.detail.selectedItem, this.isOpen = !1, this.requestUpdate());
		});
	}
	getAttributesToExclude() {
		return [];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this.parentDiveElement), this.items && this.items.length > 0 && (this.filteredItems = this.items.filter((e) => e.toLowerCase().includes(this.searchTerm)));
	}
	updated(e) {
		super.updated(e), e.has("isOpen") && (this.dispatchEvent(new CustomEvent("rtg-combo-box-state-changed", {
			detail: {
				isOpen: this.isOpen,
				targetComboBoxId: this.uuid
			},
			bubbles: !0,
			composed: !0
		})), this.isOpen ? document.addEventListener("mousedown", this.handleClickOutside) : document.removeEventListener("mousedown", this.handleClickOutside));
	}
	disconnectedCallback() {
		document.removeEventListener("mousedown", this.handleClickOutside), super.disconnectedCallback();
	}
	selectItem(e) {
		let t = e.target;
		if (t instanceof HTMLElement) {
			let e = t.closest("rtg-combo-box-item");
			e ? (this.selectedValue = e.getAttribute("data-hs-combo-box-value") || "", this.isOpen = !1) : console.log("No valid rtg-combo-box-item found");
		} else console.log("Event target is not an HTMLElement");
	}
	render() {
		return n`
      <div
        class="${N("rtg-relative", this.className)}"
        data-hs-combo-box=""
        data-combo-box-uuid=${this.uuid}
        part="combo-box"
      ></div>
    `;
	}
};
S([o({ type: Boolean }), x("design:type", Object)], V.prototype, "isOpen", void 0), S([c(), x("design:type", Object)], V.prototype, "selectedValue", void 0), S([c(), x("design:type", Object)], V.prototype, "searchTerm", void 0), S([c(), x("design:type", Object)], V.prototype, "focusedIndex", void 0), S([c(), x("design:type", Array)], V.prototype, "filteredItems", void 0), S([c(), x("design:type", Object)], V.prototype, "uuid", void 0), S([o({ type: String }), x("design:type", String)], V.prototype, "label", void 0), S([o({ type: Array }), x("design:type", Object)], V.prototype, "items", void 0), S([s("[part=\"combo-box\"]"), x("design:type", typeof HTMLDivElement > "u" ? Object : HTMLDivElement)], V.prototype, "parentDiveElement", void 0), V = S([a("rtg-combo-box"), x("design:paramtypes", [])], V);
//#endregion
//#region src/components/ui/command/command.styles.ts
var un = {
	root: [
		"rtg-flex rtg-overflow-hidden",
		"rtg-flex-col",
		"rtg-w-command-space-w rtg-h-command-space-h",
		"rtg-text-command-color-text",
		"rtg-bg-command-color-bg",
		"rtg-rounded-command-radius"
	],
	input: {
		wrapper: [
			"rtg-flex",
			"rtg-gap-command-input-wrapper-space-gap rtg-items-center",
			"rtg-px-command-input-wrapper-space-px",
			"rtg-h-command-input-wrapper-space-h",
			"rtg-border-b-command-input-wrapper-width-border rtg-border-b-command-input-wrapper-color-border"
		],
		icon: [
			"rtg-shrink-0",
			"rtg-size-command-input-icon-space-size",
			"rtg-opacity-command-input-icon-opacity"
		],
		input: [
			"rtg-flex",
			"rtg-py-command-input-space-py",
			"rtg-w-command-input-space-w rtg-h-command-input-space-h",
			"rtg-text-command-input-font",
			"rtg-bg-command-input-color-bg",
			"rtg-rounded-command-input-radius rtg-outline-hidden",
			"focus:rtg-outline-none",
			"disabled:rtg-opacity-command-input-opacity-disabled disabled:rtg-cursor-not-allowed",
			"placeholder:rtg-text-command-input-placeholder-color-text"
		]
	},
	list: [
		"rtg-overflow-x-hidden rtg-overflow-y-auto",
		"rtg-max-h-command-list-space-max-h",
		"rtg-scroll-py-1"
	],
	empty: ["rtg-py-command-empty-space-py", "rtg-text-command-empty-font rtg-text-center"],
	group: [
		"rtg-overflow-hidden",
		"rtg-p-command-group-space-p",
		"rtg-text-command-group-color-text"
	],
	heading: ["rtg-px-command-heading-space-px rtg-py-command-heading-space-py", "rtg-text-command-heading-font rtg-font-command-heading-font-weight rtg-text-command-heading-color-text"],
	separator: [
		"rtg-command-separator-space-mx",
		"rtg-h-command-separator-space-h",
		"rtg-bg-command-separator-color-bg"
	],
	item: [
		"rtg-flex rtg-relative",
		"rtg-gap-command-item-space-gap rtg-items-center",
		"rtg-px-command-item-space-px rtg-py-command-item-space-py",
		"rtg-text-command-item-font",
		"rtg-rounded-command-item-radius rtg-outline-hidden",
		"rtg-cursor-default rtg-select-none",
		"hover:rtg-text-command-item-color-text-hover hover:rtg-bg-command-item-color-bg-hover",
		"aria-selected:rtg-text-command-item-color-text-selected aria-selected:rtg-bg-command-item-color-bg-selected",
		"data-[disabled=\"true\"]:rtg-opacity-command-item-opacity-disabled data-[disabled=\"true\"]:rtg-pointer-events-none",
		"[&_svg]:rtg-shrink-0 [&_svg:not([class*=\"rtg-size-\"])]:rtg-size-command-item-icon-space-size [&_svg:not([class*=\"rtg-text-\"])]:rtg-text-command-item-icon-color-text [&_svg]:rtg-pointer-events-none"
	],
	shortcut: ["rtg-ml-auto", "rtg-text-command-shortcut-font rtg-text-command-shortcut-color-text"]
}, dn, fn = class extends C {
	static {
		dn = this;
	}
	constructor(...e) {
		super(...e), this._id = "", this._hidden = "true";
	}
	static {
		this._counter = 0;
	}
	get containerElement() {
		return this.querySelector(`#${this.identifier}`);
	}
	get identifier() {
		if (this._id !== "") return this._id;
		let e = this.parentElement;
		return e ? this._id = `${e.getAttribute("id")}e${dn._counter++}` : this._id = `rtgcmdrxlxe${dn._counter++}`, this._id;
	}
	getAttributesToExclude() {
		return [];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this.containerElement);
	}
	render() {
		return n`
      <div
        rtgcmd-empty
        id="${this.identifier}"
        part="command-empty"
        role="presentation"
        class=${N(un.empty, this._hidden === "true" && "rtg-hidden", this.className)}
      ></div>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], fn.prototype, "_id", void 0), S([o({
	attribute: "aria-hidden",
	type: String
}), x("design:type", Object)], fn.prototype, "_hidden", void 0), fn = dn = S([a("rtg-command-empty")], fn);
//#endregion
//#region src/components/ui/command/command-group.atom.ts
var pn, mn = class extends C {
	static {
		pn = this;
	}
	constructor(...e) {
		super(...e), this.heading = "", this._id = "", this._hidden = "";
	}
	static {
		this._counter = 0;
	}
	get itemsContainerElement() {
		return this.querySelector(`#${this.identifier}g`);
	}
	get identifier() {
		if (this._id !== "") return this._id;
		let e = this.parentElement;
		return e ? this._id = `${e.getAttribute("id")}g${pn._counter++}` : this._id = `rtgcmdrxlxg${pn._counter++}`, this._id;
	}
	createRenderRoot() {
		return this;
	}
	getAttributesToExclude() {
		return [];
	}
	firstUpdated(e) {
		let t = this.itemsContainerElement;
		if (t) {
			for (; t.firstChild;) t.removeChild(t.firstChild);
			this.moveLightDomChildrenInto(t);
		}
	}
	render() {
		return n`
      <div
        rtgcmd-group
        id="${this.identifier}"
        part="command-group"
        role="presentation"
        class=${N(un.group, this._hidden === "true" && "rtg-hidden", this.className)}
      >
        <div
          rtgcmd-group-heading
          aria-hidden="true"
          id="${this.identifier}h"
          class=${N(un.heading)}
        >
          ${this.heading}
        </div>
        <div
          rtgcmd-group-items
          id="${this.identifier}g"
          role="group"
          aria-labelledby="${this.identifier}h"
        ></div>
      </div>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], mn.prototype, "heading", void 0), S([o({
	attribute: "id",
	type: String
}), x("design:type", Object)], mn.prototype, "_id", void 0), S([o({
	attribute: "aria-hidden",
	type: String
}), x("design:type", Object)], mn.prototype, "_hidden", void 0), mn = pn = S([a("rtg-command-group")], mn);
//#endregion
//#region src/components/ui/command/command-input.atom.ts
var hn = class extends e {
	constructor(...e) {
		super(...e), this.placeholder = "Type a command or search...", this._value = "";
	}
	get identifier() {
		let e = this.parentElement;
		return e ? `${e.getAttribute("id")}i` : "rtgcmdrxi";
	}
	filterItems() {
		let e = this.parentElement;
		if (e) {
			let t = !0, n = e.querySelectorAll("rtg-command-group");
			n && n.forEach((e) => {
				let n = !0, r = e.querySelectorAll("rtg-command-item");
				r && r.forEach((e) => {
					(e.value || "").toLowerCase().includes(this._value.toLowerCase()) ? (n = !1, t = !1, e._hidden = "false") : e._hidden = "true";
				}), e._hidden = n ? "true" : "false";
				let i = e.previousElementSibling;
				i && (i._hidden = n || i.previousElementSibling?.getAttribute("aria-hidden") === "true" ? "true" : "false"), i = e.nextElementSibling, i && (i._hidden = n || i.nextElementSibling?.getAttribute("aria-hidden") === "true" ? "true" : "false");
			});
			let r = e.querySelector("rtg-command-empty");
			r && r.setAttribute("aria-hidden", t ? "false" : "true");
		}
	}
	handleChange(e) {
		let t = e.target;
		t && (this._value = t.value, this.filterItems());
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="command-input"
        class=${N(un.input.wrapper, this.className)}
        name="rtgcmd-input-container"
        data-slot="rtg-command-input-wrapper"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class=${N(un.input.icon, "lucide lucide-search-icon lucide-search")}
        >
          <path d="m21 21-4.34-4.34" />
          <circle cx="11" cy="11" r="8" />
        </svg>

        <input
          rtgcmd-input
          id="${this.identifier}"
          type="text"
          role="combobox"
          placeholder="${this.placeholder}"
          data-value="${this._value}"
          autocomplete="off"
          autocorrect="off"
          spellcheck="false"
          aria-autocomplete="list"
          aria-expanded="true"
          aria-controls=":r1oe:"
          aria-labelledby=":r1of:"
          @input="${this.handleChange}"
          class=${N(un.input.input)}
        />
      </div>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], hn.prototype, "placeholder", void 0), S([o({
	attribute: "value",
	type: String
}), x("design:type", Object)], hn.prototype, "_value", void 0), hn = S([a("rtg-command-input")], hn);
//#endregion
//#region src/components/ui/command/command-item.atom.ts
var gn, _n = class extends C {
	static {
		gn = this;
	}
	constructor(...e) {
		super(...e), this.selected = !1, this._id = "", this._hidden = "false", this.onSelect = () => {}, this.disabled = "false";
	}
	static {
		this._counter = 0;
	}
	get containerElement() {
		return this.querySelector(`#${this.identifier}`);
	}
	get identifier() {
		if (this._id !== "") return this._id;
		let e = this.parentElement;
		return e ? this._id = `${e.getAttribute("id")}li${gn._counter++}` : this._id = `rtgcmdrxgxli${gn._counter++}`, this._id;
	}
	get value() {
		return this.textContent?.trim() || "";
	}
	handleMouseEvent(e) {
		(e.type === "mouseover" || e.type === "focus") && (this.selected = !0), e.type === "mouseleave" && (this.selected = !1);
	}
	createRenderRoot() {
		return this;
	}
	getAttributesToExclude() {
		return [];
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this.containerElement);
	}
	updated(e) {}
	render() {
		return n`
      <div
        rtgcmd-item
        id="${this.identifier}"
        part="command-item"
        role="option"
        data-selected="${this.selected}"
        data-value="${this.value}"
        aria-selected="${this.selected}"
        aria-hidden="${this._hidden}"
        data-disabled=${this.disabled}
        @mouseover="${this.handleMouseEvent}"
        @mouseleave="${this.handleMouseEvent}"
        @focus="${this.handleMouseEvent}"
        @click="${this.onSelect}"
        class=${N(un.item, this._hidden === "true" && "rtg-hidden", this.className)}
      ></div>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], _n.prototype, "_id", void 0), S([o({
	attribute: "aria-hidden",
	type: String
}), x("design:type", Object)], _n.prototype, "_hidden", void 0), S([o({ type: Function }), x("design:type", Object)], _n.prototype, "onSelect", void 0), S([
	o({
		attribute: "data-value",
		type: String
	}),
	o({ type: Boolean }),
	x("design:type", Object),
	x("design:paramtypes", [])
], _n.prototype, "containerElement", null), S([o({
	attribute: "data-disabled",
	type: String
}), x("design:type", String)], _n.prototype, "disabled", void 0), _n = gn = S([a("rtg-command-item")], _n);
//#endregion
//#region src/components/ui/command/command-list.atom.ts
var vn = class extends C {
	get identifier() {
		let e = this.parentElement;
		return e ? `${e.getAttribute("id")}l` : "rtgcmdrxl";
	}
	get containerElement() {
		return this.querySelector("div[rtgcmd-list]");
	}
	createRenderRoot() {
		return this;
	}
	getAttributesToExclude() {
		return [];
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this.containerElement);
	}
	render() {
		return n`
      <div
        rtgcmd-list
        id="${this.identifier}"
        part="command-list"
        role="listbox"
        class=${N(un.list, this.className)}
      >
        <div></div>
      </div>
    `;
	}
};
vn = S([a("rtg-command-list")], vn);
//#endregion
//#region src/components/ui/command/command-separator.atom.ts
var yn, bn = class extends e {
	static {
		yn = this;
	}
	constructor(...e) {
		super(...e), this._id = "", this._hidden = "";
	}
	static {
		this._counter = 0;
	}
	get identifier() {
		if (this._id !== "") return this._id;
		let e = this.parentElement;
		return e ? this._id = `${e.getAttribute("id")}s${yn._counter++}` : this._id = `rtgcmdrxlxs${yn._counter++}`, this._id;
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`${this._hidden === "true" ? r : n`
          <div
            rtgcmd-separator
            id="${this.identifier}"
            part="command-separator"
            role="separator"
            class=${N(un.separator, this.className)}
          ></div>
        `}`;
	}
};
S([o({ type: String }), x("design:type", Object)], bn.prototype, "_id", void 0), S([o({
	attribute: "aria-hidden",
	type: String
}), x("design:type", Object)], bn.prototype, "_hidden", void 0), bn = yn = S([a("rtg-command-separator")], bn);
//#endregion
//#region src/components/ui/command/command.ts
var xn = class extends C {
	get containerElement() {
		return this.querySelector("div[rtgcmd-root]");
	}
	getAttributesToExclude() {
		return [];
	}
	getAttributesToRemoveFromParent() {
		return ["class", "style"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.removeParentAttributes(), this.moveLightDomChildrenInto(this.containerElement), this.containerElement && this.observeStyleAndClassSync(this.containerElement);
	}
	render() {
		let e = this.customClass || "", t = this.customStyle || "";
		return n`
      <div
        part="command"
        class="${N(un.root, e)}"
        style="${t}"
        id="rtgcmdr1"
        rtgcmd-root
      ></div>
    `;
	}
};
xn = S([a("rtg-command")], xn);
//#endregion
//#region src/components/ui/context-menu/context-menu.styles.ts
var H = {
	root: [""],
	trigger: [""],
	content: [
		"rtg-overflow-x-hidden rtg-overflow-y-auto rtg-z-50",
		"rtg-p-context-menu-content-space-p",
		"rtg-min-w-context-menu-content-space-min-w",
		"rtg-text-context-menu-content-color-text",
		"rtg-bg-context-menu-content-color-bg",
		"rtg-rounded-context-menu-content-radius rtg-border-context-menu-content-width-border rtg-border-context-menu-content-color-border",
		"rtg-shadow-context-menu-content-shadow",
		"rtg-translate-y-0.5",
		"rtg-slide-in-from-top-2",
		"data-[state=open]:rtg-animate-in data-[state=open]:rtg-fade-in-0 data-[state=open]:rtg-zoom-in-95",
		"data-[state=closed]:rtg-animate-out data-[state=closed]:rtg-fade-out-0 data-[state=closed]:rtg-zoom-out-95"
	],
	group: [""],
	item: [
		"rtg-flex rtg-relative",
		"rtg-gap-context-menu-item-space-gap rtg-items-center",
		"rtg-px-context-menu-item-space-px rtg-py-context-menu-item-space-py",
		"rtg-text-context-menu-item-font",
		"rtg-rounded-context-menu-item-radius rtg-outline-hidden",
		"rtg-cursor-default",
		"rtg-select-none",
		"hover:rtg-bg-context-menu-item-color-bg-hover hover:rtg-text-context-menu-item-color-text-hover",
		"focus:rtg-bg-context-menu-item-color-bg-focus focus:rtg-text-context-menu-item-color-text-focus",
		"data-[disabled]:rtg-opacity-context-menu-item-opacity-disabled data-[disabled]:rtg-pointer-events-none",
		"[&_svg]:rtg-shrink-0 [&_svg:not([class*=\"rtg-size-\"])]:rtg-size-context-menu-item-icon-space-size [&_svg:not([class*=\"rtg-text-\"])]:rtg-text-context-menu-item-icon-color-text [&_svg]:rtg-pointer-events-none"
	],
	checkboxItem: {
		base: [
			"rtg-flex rtg-relative",
			"rtg-gap-context-menu-checkbox-item-space-gap rtg-items-center",
			"rtg-pl-context-menu-checkbox-item-space-pl rtg-pr-context-menu-checkbox-item-space-pr rtg-py-context-menu-checkbox-item-space-py",
			"rtg-text-context-menu-checkbox-item-font",
			"rtg-rounded-context-menu-checkbox-item-radius rtg-outline-hidden",
			"rtg-cursor-default",
			"rtg-select-none",
			"aria-selected:rtg-bg-context-menu-checkbox-item-color-bg-focus aria-selected:rtg-text-context-menu-checkbox-item-color-text-focus",
			"data-[disabled]:rtg-opacity-context-menu-checkbox-item-opacity-disabled data-[disabled]:rtg-pointer-events-none"
		],
		span: [
			"rtg-flex rtg-absolute rtg-left-2",
			"rtg-justify-center rtg-items-center",
			"rtg-size-context-menu-checkbox-item-icon-container-space-size",
			"rtg-pointer-events-none"
		],
		icon: [
			"rtg-shrink-0",
			"rtg-size-context-menu-checkbox-item-icon-space-size",
			"rtg-pointer-events-none"
		]
	},
	radioItem: {
		base: [
			"rtg-flex rtg-relative",
			"rtg-gap-context-menu-radio-item-space-gap rtg-items-center",
			"rtg-pl-context-menu-radio-item-space-pl rtg-pr-context-menu-radio-item-space-pr rtg-py-context-menu-radio-item-space-py",
			"rtg-text-context-menu-radio-item-font",
			"rtg-rounded-context-menu-radio-item-radius rtg-outline-hidden",
			"rtg-cursor-default",
			"rtg-select-none",
			"aria-selected:rtg-bg-context-menu-radio-item-color-bg-focus aria-selected:rtg-text-context-menu-radio-item-color-text-focus",
			"data-[disabled]:rtg-opacity-context-menu-radio-item-opacity-disabled data-[disabled]:rtg-pointer-events-none"
		],
		span: [
			"rtg-flex rtg-absolute rtg-left-2",
			"rtg-justify-center rtg-items-center",
			"rtg-size-context-menu-radio-item-icon-container-space-size",
			"rtg-pointer-events-none"
		],
		icon: [
			"rtg-shrink-0",
			"rtg-size-context-menu-radio-item-icon-space-size",
			"rtg-pointer-events-none",
			"rtg-fill-current"
		]
	},
	label: ["rtg-px-context-menu-label-space-px rtg-py-context-menu-label-space-py", "rtg-text-context-menu-label-font rtg-font-context-menu-label-font-weight"],
	separator: [
		"rtg-mx-context-menu-separator-space-mx rtg-my-context-menu-separator-space-my",
		"rtg-h-context-menu-separator-space-h",
		"rtg-bg-context-menu-separator-color-bg"
	],
	shortcut: ["rtg-ml-auto", "rtg-text-context-menu-shortcut-font rtg-text-context-menu-shortcut-color-text"]
}, Sn = class extends C {
	constructor(...e) {
		super(...e), this._id = "", this.selected = !1, this.checked = !1, this.disabled = !1;
	}
	get value() {
		return this.textContent?.trim() || "";
	}
	get _containerElement() {
		return this.querySelector("div[part=context-menu-checkbox-item-container]");
	}
	getAttributesToExclude() {
		return ["data-testid"];
	}
	handleMouseEvent(e) {
		(e.type === "mouseover" || e.type === "focus") && (this.selected = !0), e.type === "mouseleave" && (this.selected = !1);
	}
	toggleChecked() {
		this.checked = !this.checked;
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <div
        rtgcmd-item
        part="context-menu-checkbox"
        role="option"
        data-selected="${this.selected}"
        data-value="${this.value}"
        ?data-disabled=${this.disabled}
        aria-selected="${this.selected}"
        @click=${this.toggleChecked}
        @mouseover="${this.handleMouseEvent}"
        @mouseleave="${this.handleMouseEvent}"
        @focus="${this.handleMouseEvent}"
        class=${N(H.checkboxItem.base, this.className)}
      >
        <span class=${N(H.checkboxItem.span)}>
          ${this.checked ? n`
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class=${N(H.checkboxItem.icon, "lucide lucide-check-icon lucide-check")}
                >
                  <path d="M20 6 9 17l-5-5" />
                </svg>
              ` : r}
        </span>
        <div part="context-menu-checkbox-item-container"></div>
      </div>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], Sn.prototype, "_id", void 0), S([
	o({
		attribute: "data-value",
		type: String
	}),
	x("design:type", Object),
	x("design:paramtypes", [])
], Sn.prototype, "value", null), S([o({ type: Boolean }), x("design:type", Object)], Sn.prototype, "selected", void 0), S([o({ type: Boolean }), x("design:type", Object)], Sn.prototype, "checked", void 0), S([o({
	attribute: "data-disabled",
	type: Boolean
}), x("design:type", Object)], Sn.prototype, "disabled", void 0), Sn = S([a("rtg-context-menu-checkbox-item")], Sn);
//#endregion
//#region src/components/ui/context-menu/context-menu-content.ts
var Cn = class extends C {
	constructor() {
		super(), this.isOpen = !1, this.handleClickOutside = this.handleClickOutside.bind(this);
	}
	get _containerElement() {
		return this.querySelector("div[part=context-menu-content");
	}
	connectedCallback() {
		super.connectedCallback(), document.addEventListener("click", this.handleClickOutside);
	}
	disconnectedCallback() {
		document.removeEventListener("click", this.handleClickOutside), super.disconnectedCallback();
	}
	handleClickOutside(e) {
		let t = this?.querySelector("button");
		!this.contains(e.target) && !t?.contains(e.target) && requestAnimationFrame(() => {
			this._containerElement.style.display = "none", this._containerElement.style.position = "absolute", this._containerElement.dataset.state = "closed", this.isOpen = !1;
		});
	}
	getAttributesToExclude() {
		return [];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <div
        part="context-menu-content"
        class=${N(H.content, this.className)}
      ></div>
    `;
	}
};
S([c(), x("design:type", Object)], Cn.prototype, "isOpen", void 0), Cn = S([a("rtg-context-menu-content"), x("design:paramtypes", [])], Cn);
//#endregion
//#region src/components/ui/context-menu/context-menu-group.ts
var wn = class extends C {
	constructor(...e) {
		super(...e), this.heading = "";
	}
	get _containerElement() {
		return this.querySelector("div[  rtgcontext-group-items]");
	}
	createRenderRoot() {
		return this;
	}
	getAttributesToExclude() {
		return ["data-testid"];
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <div
        rtgcmd-group
        part="context-menu-group"
        role="presentation"
        class=${N(H.group, this.className)}
      >
        <div rtgcmd-group-heading class=${N(H.label)}>
          ${this.heading}
        </div>

        <div rtgcontext-group-items role="group"></div>
      </div>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], wn.prototype, "heading", void 0), wn = S([a("rtg-context-menu-group")], wn);
//#endregion
//#region src/components/ui/context-menu/context-menu-item.ts
var Tn = class extends C {
	constructor(...e) {
		super(...e), this.disabled = !1;
	}
	get _containerElement() {
		return this.querySelector("div[part=context-menu-item]");
	}
	getAttributesToExclude() {
		return [];
	}
	get value() {
		return this.textContent?.trim() || "";
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement), this._containerElement?.addEventListener("click", () => {
			this.dispatchEvent(new MouseEvent("click", {
				bubbles: !0,
				composed: !0,
				cancelable: !0
			})), this.dispatchEvent(new CustomEvent("close-context-menu", {
				bubbles: !0,
				composed: !0
			}));
		});
	}
	connectedCallback() {
		super.connectedCallback();
	}
	disconnectedCallback() {}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="context-menu-item"
        role="option"
        data-value="${this.value}"
        ?data-disabled=${this.disabled}
        class=${N(H.item, this.className)}
      ></div>
    `;
	}
};
S([
	o({
		attribute: "data-value",
		type: String
	}),
	x("design:type", Object),
	x("design:paramtypes", [])
], Tn.prototype, "value", null), S([o({
	attribute: "data-disabled",
	type: Boolean
}), x("design:type", Object)], Tn.prototype, "disabled", void 0), Tn = S([a("rtg-context-menu-item")], Tn);
//#endregion
//#region src/components/ui/context-menu/context-menu-radio-item.ts
var En = class extends C {
	constructor(...e) {
		super(...e), this._id = "", this.selected = !1, this.checked = !1, this.disabled = !1;
	}
	get value() {
		return this.textContent?.trim() || "";
	}
	get _containerElement() {
		return this.querySelector("div[part=context-menu-radio-item-container]");
	}
	getAttributesToExclude() {
		return ["data-testid"];
	}
	handleMouseEvent(e) {
		(e.type === "mouseover" || e.type === "focus") && (this.selected = !0), e.type === "mouseleave" && (this.selected = !1);
	}
	toggleChecked() {
		this.checked || (this.checked = !0, this.dispatchEvent(new CustomEvent("radio-selected", {
			bubbles: !0,
			composed: !0
		})));
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <div
        rtgcmd-item
        part="context-menu-radio"
        role="option"
        data-selected="${this.selected}"
        data-value="${this.value}"
        ?data-disabled=${this.disabled}
        aria-selected="${this.selected}"
        @click=${this.toggleChecked}
        @mouseover="${this.handleMouseEvent}"
        @mouseleave="${this.handleMouseEvent}"
        @focus="${this.handleMouseEvent}"
        class=${N(H.radioItem.base, this.className)}
      >
        <span class=${N(H.radioItem.span)}>
          ${this.checked ? n`<svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class=${N(H.radioItem.icon, "lucide lucide-circle-icon lucide-circle")}
              >
                <circle cx="12" cy="12" r="10" />
              </svg>` : r}
        </span>
        <div part="context-menu-radio-item-container"></div>
      </div>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], En.prototype, "_id", void 0), S([
	o({
		attribute: "data-value",
		type: String
	}),
	x("design:type", Object),
	x("design:paramtypes", [])
], En.prototype, "value", null), S([o({ type: Boolean }), x("design:type", Object)], En.prototype, "selected", void 0), S([o({ type: Boolean }), x("design:type", Object)], En.prototype, "checked", void 0), S([o({
	attribute: "data-disabled",
	type: Boolean
}), x("design:type", Object)], En.prototype, "disabled", void 0), En = S([a("rtg-context-menu-radio-item")], En);
//#endregion
//#region src/components/ui/context-menu/context-menu-seperator.ts
var Dn = class extends e {
	constructor(...e) {
		super(...e), this._id = "";
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        rtgcmd-separator
        part="context-menu-separator"
        role="separator"
        class=${N(H.separator, this.className)}
      ></div>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], Dn.prototype, "_id", void 0), Dn = S([a("rtg-context-menu-separator")], Dn);
//#endregion
//#region src/components/ui/context-menu/context-menu-shortcut.ts
var On = class extends C {
	get _containerElement() {
		return this.querySelector("span[part=context-menu-shortcut]");
	}
	getAttributesToExclude() {
		return [];
	}
	createRenderRoot() {
		return this.classList = N(H.shortcut), this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <span
        part="context-menu-shortcut"
        class=${N(H.shortcut, this.className)}
      >
      </span>
    `;
	}
};
On = S([a("rtg-context-menu-shortcut")], On);
//#endregion
//#region src/components/ui/context-menu/context-menu-trigger.ts
var kn = class extends e {
	createRenderRoot() {
		return this;
	}
	render() {
		return n``;
	}
};
kn = S([a("rtg-context-menu-trigger")], kn);
//#endregion
//#region src/components/ui/context-menu/context-menu.ts
var An = class extends C {
	constructor(...e) {
		super(...e), this.isOpen = !1, this.handleClickOutside = (e) => {
			let t = e.target;
			this?.contains(t) || (this.isOpen = !1);
		};
	}
	get _containerElement() {
		return this.querySelector("div[part=context-menu]");
	}
	get _triggerElement() {
		return this.querySelector("rtg-context-menu-trigger");
	}
	get _content() {
		return this?.querySelector("div[part=context-menu-content]");
	}
	connectedCallback() {
		super.connectedCallback(), document.addEventListener("click", this.handleClickOutside), this.addEventListener("radio-selected", this._handleRadioSelected), this.addEventListener("close-context-menu", () => {
			this.isOpen = !1, requestAnimationFrame(() => {
				let e = this._content;
				e && (e.style.display = "none");
			});
		});
	}
	disconnectedCallback() {
		document.removeEventListener("click", this.handleClickOutside), super.disconnectedCallback();
	}
	toggleDropdown(e) {
		e.preventDefault(), e.stopPropagation();
		let { clientX: t, clientY: n } = e, r = e.target.getBoundingClientRect();
		requestAnimationFrame(() => {
			let e = this._content;
			e && (e.style.display = "", e.style.position = "absolute", e.style.left = `${t - r.left}px`, e.style.top = `${n - r.top}px`, e.dataset.state = "open", this.isOpen = !0);
		});
	}
	updated(e) {
		super.updated(e);
		let t = this._content;
		t && (t.dataset.state = this.isOpen ? "open" : "closed");
	}
	_handleRadioSelected(e) {
		this.querySelectorAll("rtg-context-menu-radio-item").forEach((t) => {
			t !== e.target && (t.checked = !1);
		});
	}
	getAttributesToExclude() {
		return [];
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement), this._triggerElement?.addEventListener("contextmenu", (e) => {
			this.toggleDropdown(e);
		}), this.style.position = "relative";
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="context-menu"
        class=${N(H.root, this.className)}
      ></div>
    `;
	}
};
S([c(), x("design:type", Object)], An.prototype, "isOpen", void 0), An = S([a("rtg-context-menu")], An);
//#endregion
//#region src/components/ui/popover/popover.style.ts
var jn = {
	root: ["rtg-relative"],
	trigger: [""],
	content: [
		"rtg-fixed rtg-z-50",
		"rtg-p-popover-content-space-p",
		"rtg-w-popover-content-space-w",
		"rtg-text-popover-content-color-text",
		"rtg-bg-popover-content-color-bg",
		"rtg-rounded-popover-content-radius rtg-border-popover-content-width-border rtg-border-popover-content-color-border rtg-outline-hidden",
		"rtg-shadow-popover-content-shadow",
		"data-[state=\"open\"]:rtg-block data-[state=\"closed\"]:rtg-hidden",
		"data-[state=\"open\"]:rtg-animate-in data-[state=\"open\"]:rtg-fade-in-0 data-[state=\"open\"]:rtg-zoom-in-95",
		"data-[state=\"closed\"]:rtg-animate-out data-[state=\"closed\"]:rtg-fade-out-0 data-[state=\"closed\"]:rtg-zoom-out-95",
		"rtg-translate-y-0.5"
	]
}, Mn = class extends C {
	constructor(...e) {
		super(...e), this.enableDefaultStyle = !0, this.styleContent = !0, this.side = "bottom", this.state = "closed";
	}
	get _popover() {
		let e = this.parentElement;
		for (; e && !(e instanceof Pn);) e = e.parentElement;
		return e;
	}
	get _containerElement() {
		return this.querySelector("div[part=popover-content]");
	}
	handleClickOutside(e) {
		let t = this._popover;
		t && !t.contains(e.target) && (t.isOpen = !1);
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement), window.addEventListener("click", this.handleClickOutside.bind(this));
	}
	updated(e) {
		this._popover?.isOpen || window.removeEventListener("click", this.handleClickOutside.bind(this));
	}
	preventClickPropagation(e) {
		e.stopPropagation();
	}
	getAttributesToExclude() {
		return ["data-testid"];
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="popover-content"
        data-state=${this.state}
        class=${N(jn.content, this.className)}
        @click="${this.preventClickPropagation}"
      ></div>
    `;
	}
};
S([o({ type: Boolean }), x("design:type", Object)], Mn.prototype, "enableDefaultStyle", void 0), S([o({ type: Boolean }), x("design:type", Object)], Mn.prototype, "styleContent", void 0), S([o({ type: String }), x("design:type", String)], Mn.prototype, "side", void 0), S([o({
	attribute: "data-state",
	type: String
}), x("design:type", String)], Mn.prototype, "state", void 0), Mn = S([a("rtg-popover-content")], Mn);
//#endregion
//#region src/components/ui/popover/popover-trigger.ts
var Nn = class extends C {
	constructor(...e) {
		super(...e), this.handleClick = () => {
			let e = this._popover;
			e && (e.isOpen = !e.isOpen);
		};
	}
	get _popover() {
		let e = this.parentElement;
		for (; e && !(e instanceof Pn);) e = e.parentElement;
		return e;
	}
	get _containerElement() {
		return this.querySelector("div[part=popover-trigger]");
	}
	firstUpdated(e) {
		super.firstUpdated(e), this.moveLightDomChildrenInto(this._containerElement), this.addEventListener("click", (e) => {
			this.handleClick(), e.stopPropagation();
		});
	}
	createRenderRoot() {
		return this;
	}
	getAttributesToExclude() {
		return ["data-testid"];
	}
	render() {
		return n`
      <div
        part="popover-trigger"
        class=${N(jn.trigger, this.className)}
      ></div>
    `;
	}
};
Nn = S([a("rtg-popover-trigger")], Nn);
//#endregion
//#region src/components/ui/popover/popover.ts
var Pn = class extends C {
	constructor(...e) {
		super(...e), this.isOpen = !1;
	}
	get _containerElement() {
		return this.querySelector("div[part=popover]");
	}
	get _contentElement() {
		return this.querySelector("rtg-popover-content");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	updated(e) {
		this._contentElement.state = this.isOpen ? "open" : "closed", this._contentElement.requestUpdate();
	}
	render() {
		return n`
      <div part="popover" class=${N(jn.root, this.className)}></div>
    `;
	}
};
S([c(), x("design:type", Boolean)], Pn.prototype, "isOpen", void 0), Pn = S([a("rtg-popover")], Pn);
//#endregion
//#region src/components/ui/date-picker/date-picker.styles.ts
var Fn = {
	root: [""],
	trigger: [""],
	triggerButton: [
		Pt({ variant: "outline" }).replace("rtg-justify-center", ""),
		"rtg-justify-start",
		"rtg-w-date-picker-trigger-button-space-w",
		"rtg-text-left rtg-font-date-picker-trigger-button-font-weight",
		"data-[empty=true]:rtg-text-date-picker-trigger-button-color-text-empty"
	],
	content: ["rtg-p-date-picker-content-space-p", "rtg-w-auto"]
}, In = class extends e {
	constructor(...e) {
		super(...e), this.selectedDate = null;
	}
	handleDateSelected(e) {
		this.selectedDate = e.detail.startDate, this.requestUpdate();
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <rtg-popover
        class=${N("date-picker", Fn.root, this.className)}
        @date-selected=${this.handleDateSelected}
      >
        <rtg-popover-trigger
          as-child
          class=${N("date-picker-trigger", Fn.trigger)}
        >
          <button
            data-variant="outline"
            data-size="default"
            data-empty=${this.selectedDate ? "false" : "true"}
            class=${N("date-picker-trigger-button", Fn.triggerButton)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-calendar-icon lucide-calendar"
            >
              <path d="M8 2v4" />
              <path d="M16 2v4" />
              <rect width="18" height="18" x="3" y="4" rx="2" />
              <path d="M3 10h18" />
            </svg>

            ${this.selectedDate ? this.selectedDate.toLocaleDateString("en-US", {
			month: "long",
			day: "numeric",
			year: "numeric"
		}).replace(/(\d+)/, (e, t) => {
			let n = parseInt(t, 10);
			return n + (n > 3 ? "th" : [
				"st",
				"nd",
				"rd"
			][n - 1] || "th");
		}) : n`<span>Pick a date</span>`}
          </button>
        </rtg-popover-trigger>

        <rtg-popover-content
          class=${N("date-picker-content", Fn.content)}
        >
          <rtg-calendar mode="single"></rtg-calendar>
        </rtg-popover-content>
      </rtg-popover>
    `;
	}
};
S([o({ type: Object }), x("design:type", Object)], In.prototype, "selectedDate", void 0), In = S([a("rtg-date-picker")], In);
//#endregion
//#region src/components/ui/dialog/dialog.styles.ts
var Ln = {
	root: [""],
	trigger: [""],
	close: [""],
	overlay: [
		"rtg-fixed rtg-inset-0 rtg-z-50",
		"rtg-bg-dialog-overlay-color-bg",
		"data-[state=open]:rtg-animate-in data-[state=open]:rtg-fade-in-0",
		"data-[state=closed]:rtg-animate-out data-[state=closed]:rtg-fade-out-0"
	],
	content: {
		base: [
			"rtg-fixed rtg-top-[50%] rtg-left-[50%] rtg-z-50",
			"rtg-grid rtg-gap-dialog-content-space-gap",
			"rtg-p-dialog-content-space-p",
			"rtg-w-dialog-content-space-w rtg-max-w-dialog-content-space-max-w-sm sm:rtg-max-w-dialog-content-space-max-w",
			"rtg-bg-dialog-content-color-bg",
			"rtg-rounded-dialog-content-radius rtg-border-dialog-content-width-border rtg-border-dialog-content-color-border rtg-outline-none",
			"rtg-shadow-dialog-content-shadow",
			"rtg-duration-200",
			"rtg-translate-x-[-50%] rtg-translate-y-[-50%]",
			"data-[state=open]:rtg-animate-in data-[state=open]:rtg-fade-in-0 data-[state=open]:rtg-zoom-in-95",
			"data-[state=closed]:rtg-animate-out data-[state=closed]:rtg-fade-out-0 data-[state=closed]:rtg-zoom-out-95"
		],
		close: {
			base: [
				"rtg-absolute rtg-top-4 rtg-right-4",
				"rtg-rounded-dialog-close-radius",
				"rtg-ring-offset-dialog-close-color-ring-offset",
				"rtg-transition-opacity",
				"focus:rtg-ring-dialog-close-width-ring-focus focus:rtg-ring-dialog-close-color-ring-focus focus:rtg-ring-offset-dialog-close-width-ring-offset focus:rtg-outline-hidden",
				"disabled:rtg-pointer-events-none",
				"data-[state=open]:rtg-bg-dialog-close-color-bg data-[state=open]:rtg-text-dialog-close-color-text"
			],
			icon: [
				"rtg-shrink-0",
				"rtg-size-dialog-close-icon-space-size",
				"rtg-pointer-events-none"
			]
		}
	},
	header: [
		"rtg-flex rtg-flex-col rtg-gap-dialog-header-space-gap",
		"rtg-text-center",
		"sm:rtg-text-left"
	],
	footer: ["rtg-flex rtg-flex-col-reverse rtg-gap-dialog-footer-space-gap", "sm:rtg-flex-row sm:rtg-justify-end"],
	title: ["rtg-text-dialog-title-font rtg-font-dialog-title-font-weight"],
	description: ["rtg-text-dialog-description-font rtg-font-dialog-description-font-weight rtg-text-dialog-description-color-text"]
}, Rn = "closed", zn = class extends C {
	get _dialog() {
		let e = this.parentElement;
		for (; e;) {
			if (e instanceof Yn) return e;
			e = e.parentElement;
		}
		return e;
	}
	get _containerElement() {
		return this.querySelector("div[part=dialog-close]");
	}
	firstUpdated(e) {
		super.firstUpdated(e), this.moveLightDomChildrenInto(this._containerElement), this.addEventListener("click", () => {
			let e = this._dialog;
			e && (e.dataset.state = Rn);
		});
	}
	getAttributesToExclude() {
		return ["data-testid"];
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="dialog-close"
        class=${N(Ln.close, this.className)}
      ></div>
    `;
	}
};
zn = S([a("rtg-dialog-close")], zn);
//#endregion
//#region src/components/ui/dialog/dialog-content.ts
var Bn = "closed", Vn = class extends C {
	constructor(...e) {
		super(...e), this.state = Bn, this.showCloseButton = !1, this.handleCloseButtonClick = () => {
			let e = this._dialog;
			e && (e.dataset.state = Bn);
		};
	}
	get _containerElement() {
		return this.querySelector("div[part=dialog-content-slot]");
	}
	get ـcomponentElement() {
		return this.querySelector("div[part=dialog-content]");
	}
	get _dialog() {
		let e = this.parentElement;
		for (; e;) {
			if (e instanceof Yn) return e;
			e = e.parentElement;
		}
		return e;
	}
	getAttributesToExclude() {
		return ["date-testid"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	updated(e) {
		requestAnimationFrame(() => {
			e.get("state") === Bn ? this.ـcomponentElement.style.display = "grid" : this.ـcomponentElement.style.display = "none";
		});
	}
	render() {
		return n`
      <div
        rtgdlg-content
        part="dialog-content"
        class=${N(Ln.content.base, this.className)}
      >
        <div part="dialog-content-slot"></div>

        ${this.showCloseButton ? n`
              <button
                data-slot="dialog-content-close"
                type="button"
                @click=${this.handleCloseButtonClick}
                class=${N(Ln.content.close.base)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class=${N(Ln.content.close.icon, "lucide lucide-x-icon lucide-x")}
                >
                  <path d="M18 6 6 18" />
                  <path d="m6 6 12 12" />
                </svg>

                <span class="rtg-sr-only">Close</span>
              </button>
            ` : ""}
      </div>
    `;
	}
};
S([o({
	attribute: "data-state",
	type: String
}), x("design:type", Object)], Vn.prototype, "state", void 0), S([o({
	attribute: "show-close-button",
	type: Boolean
}), x("design:type", Object)], Vn.prototype, "showCloseButton", void 0), Vn = S([a("rtg-dialog-content")], Vn);
//#endregion
//#region src/components/ui/dialog/dialog-footer.ts
var Hn = class extends C {
	get _containerElement() {
		return this.querySelector("div[part=dialog-footer]");
	}
	getAttributesToExclude() {
		return [];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <div
        part="dialog-footer"
        class=${N(Ln.footer, this.className)}
      ></div>
    `;
	}
};
Hn = S([a("rtg-dialog-footer")], Hn);
//#endregion
//#region src/components/ui/dialog/dialog-header.ts
var Un = class extends e {
	constructor(...e) {
		super(...e), this._title = "", this.description = "";
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="dialog-header"
        class=${N(Ln.header, this.className)}
      >
        <h2 class=${N(Ln.title, this.className)}>${this._title}</h2>

        <p class=${N(Ln.description, this.className)}>
          ${this.description}
        </p>
      </div>
    `;
	}
};
S([o({
	attribute: "title",
	type: String
}), x("design:type", Object)], Un.prototype, "_title", void 0), S([o({ type: String }), x("design:type", Object)], Un.prototype, "description", void 0), Un = S([a("rtg-dialog-header")], Un);
//#endregion
//#region src/components/ui/dialog/dialog-overly.ts
var Wn = class extends e {
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="dialog-overly"
        class=${N(Ln.overlay, this.className)}
      ></div>
    `;
	}
};
Wn = S([a("rtg-dialog-overlay")], Wn);
//#endregion
//#region src/components/ui/dialog/dialog-trigger.ts
var Gn = "open", Kn = class extends C {
	constructor(...e) {
		super(...e), this.handleClick = () => {
			let e = this._dialog;
			e && (e.dataset.state = Gn);
		};
	}
	get _dialog() {
		let e = this.parentElement;
		for (; e;) {
			if (e instanceof Yn) return e;
			e = e.parentElement;
		}
		return e;
	}
	get _containerElement() {
		return this.querySelector("div[part=dialog-trigger]");
	}
	firstUpdated(e) {
		super.firstUpdated(e), this.moveLightDomChildrenInto(this._containerElement), this.addEventListener("click", (e) => {
			e.stopPropagation(), this.handleClick();
		});
	}
	getAttributesToExclude() {
		return [];
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="dialog-trigger"
        class=${N(Ln.trigger, this.className)}
      ></div>
    `;
	}
};
Kn = S([a("rtg-dialog-trigger")], Kn);
//#endregion
//#region src/components/ui/dialog/dialog.ts
var qn = "open", Jn = "closed", Yn = class extends C {
	constructor(...e) {
		super(...e), this.state = Jn;
	}
	get _containerElement() {
		return this.querySelector("div[rtgdlg-root]");
	}
	get _content() {
		return this.querySelector("rtg-dialog-content") || null;
	}
	updated(e) {
		super.updated(e);
		let t = this._content;
		t && (t.dataset.state = this.state);
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	createRenderRoot() {
		return this;
	}
	getAttributesToExclude() {
		return [];
	}
	render() {
		return n`
      <div
        rtgdlg-root
        part="dialog"
        class=${N(Ln.root, this.className)}
      >
        ${this.state === qn ? n` <rtg-dialog-overlay></rtg-dialog-overlay>` : r}
      </div>
    `;
	}
};
S([o({
	attribute: "data-state",
	type: String
}), x("design:type", Object)], Yn.prototype, "state", void 0), Yn = S([a("rtg-dialog")], Yn);
//#endregion
//#region src/components/ui/drawer/drawer.helpers.ts
var Xn = {
	open: "open",
	closed: "closed"
}, Zn = {
	root: [""],
	trigger: [""],
	close: [""],
	overlay: [
		"rtg-fixed rtg-inset-0 rtg-z-50",
		"rtg-bg-drawer-overlay-color-bg",
		"data-[state=open]:rtg-animate-in data-[state=open]:rtg-fade-in-0",
		"data-[state=closed]:rtg-animate-out data-[state=closed]:rtg-fade-out-0"
	],
	content: {
		base: [
			"rtg-fixed rtg-inset-x-0 rtg-bottom-0 rtg-z-50",
			"rtg-flex rtg-flex-col",
			"rtg-mt-drawer-content-space-mt",
			"rtg-h-auto rtg-max-h-[80vh]",
			"rtg-bg-drawer-content-color-bg",
			"rtg-rounded-t-drawer-content-radius rtg-border-t-drawer-content-width-border rtg-border-t-drawer-content-color-border"
		],
		thumb: [
			"rtg-shrink-0",
			"rtg-mx-auto rtg-mt-drawer-thumb-space-mt",
			"rtg-w-drawer-thumb-space-w rtg-h-drawer-thumb-space-h",
			"rtg-bg-drawer-thumb-color-bg",
			"rtg-rounded-drawer-thumb-radius"
		]
	},
	header: [
		"rtg-flex rtg-flex-col rtg-gap-drawer-header-space-gap-sm md:rtg-gap-drawer-header-space-gap",
		"rtg-p-drawer-header-space-p",
		"rtg-text-center"
	],
	footer: ["rtg-flex rtg-flex-col rtg-gap-drawer-footer-space-gap", "rtg-p-drawer-footer-space-p rtg-mt-auto"],
	title: ["rtg-text-drawer-title-font rtg-font-drawer-title-font-weight rtg-text-drawer-title-color-text"],
	description: ["rtg-text-drawer-description-font rtg-font-drawer-description-font-weight rtg-text-drawer-description-color-text"]
}, Qn = class extends C {
	get _drawer() {
		let e = this.parentElement;
		for (; e;) {
			if (e instanceof or) return e;
			e = e.parentElement;
		}
		return e;
	}
	get _containerElement() {
		return this.querySelector("div[part=drawer-close]");
	}
	async firstUpdated(e) {
		super.firstUpdated(e), await this.updateComplete;
		let t = this._containerElement;
		if (t) {
			this.moveLightDomChildrenInto(t);
			let e = t.querySelector("button, [data-close], [role=button]");
			e && e.addEventListener("click", (e) => {
				e.stopPropagation();
				let t = this._drawer;
				t && (t.dataset.state = Xn.closed);
			});
		}
	}
	getAttributesToExclude() {
		return ["data-testid"];
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="drawer-close"
        class=${N(Zn.close, this.className)}
      ></div>
    `;
	}
};
Qn = S([a("rtg-drawer-close")], Qn);
//#endregion
//#region src/components/ui/drawer/drawer-content.ts
var $n = class extends C {
	constructor(...e) {
		super(...e), this.state = Xn.closed;
	}
	connectedCallback() {
		super.connectedCallback();
		let e = document.createElement("style");
		e.textContent = "\n      @keyframes slideInUp {\n        from { transform: translateY(100%); }\n        to { transform: translateY(0); }\n      }\n      @keyframes slideOutDown {\n        from { transform: translateY(0); }\n        to { transform: translateY(100%); }\n      }\n      .drawer-animation {\n        touch-action: none;\n        will-change: transform;\n        transition: transform 0.5s cubic-bezier(0.32, 0.72, 0, 1);\n      }\n      .drawer-open {\n        animation: slideInUp 0.5s cubic-bezier(0.32, 0.72, 0, 1) forwards;\n      }\n      .drawer-closed {\n        animation: slideOutDown 0.5s cubic-bezier(0.32, 0.72, 0, 1) forwards;\n      }\n    ", this.querySelector("style[data-injected]") || (e.setAttribute("data-injected", "true"), this.prepend(e));
	}
	get _containerElement() {
		return this.querySelector("div[part=drawer-content-slot]");
	}
	get ـcomponentElement() {
		return this.querySelector("div[part=drawer-content]");
	}
	getAttributesToExclude() {
		return ["date-testid"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	updated(e) {
		requestAnimationFrame(() => {
			e.get("state") === Xn.closed ? this.ـcomponentElement.style.display = "flex" : this.ـcomponentElement.style.display = "none";
		});
	}
	render() {
		return n`
      <div
        rtgdlg-content
        part="drawer-content"
        class=${N(Zn.content.base, this.state === Xn.open ? "drawer-open" : "drawer-closed", this.className)}
      >
        <div part="drawer-thumb" class=${N(Zn.content.thumb)}></div>
        <div part="drawer-content-slot"></div>
      </div>
    `;
	}
};
S([o({
	attribute: "data-state",
	type: String
}), x("design:type", Object)], $n.prototype, "state", void 0), $n = S([a("rtg-drawer-content")], $n);
//#endregion
//#region src/components/ui/drawer/drawer-description.ts
var er = class extends C {
	get _containerElement() {
		return this.querySelector("p[part=drawer-description");
	}
	getAttributesToExclude() {
		return [];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <p
        part="drawer-description"
        class=${N(Zn.description, this.className)}
      ></p>
    `;
	}
};
er = S([a("rtg-drawer-description")], er);
//#endregion
//#region src/components/ui/drawer/drawer-footer.ts
var tr = class extends C {
	get _containerElement() {
		return this.querySelector("div[part=drawer-footer]");
	}
	getAttributesToExclude() {
		return [];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <div
        part="drawer-footer"
        class=${N(Zn.footer, this.className)}
      ></div>
    `;
	}
};
tr = S([a("rtg-drawer-footer")], tr);
//#endregion
//#region src/components/ui/drawer/drawer-header.ts
var nr = class extends C {
	get _containerElement() {
		return this.querySelector("div[part=drawer-header");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <div
        part="drawer-header"
        class=${N(Zn.header, this.className)}
      ></div>
    `;
	}
};
nr = S([a("rtg-drawer-header")], nr);
//#endregion
//#region src/components/ui/drawer/drawer-overlay.ts
var rr = class extends e {
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="drawer-overly"
        class=${N(Zn.overlay, this.className)}
      ></div>
    `;
	}
};
rr = S([a("rtg-drawer-overlay")], rr);
//#endregion
//#region src/components/ui/drawer/drawer-title.ts
var ir = class extends C {
	get _containerElement() {
		return this.querySelector("h2[part=drawer-title");
	}
	getAttributesToExclude() {
		return [];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <h2
        part="drawer-title"
        class=${N(Zn.title, this.className)}
      ></h2>
    `;
	}
};
ir = S([a("rtg-drawer-title")], ir);
//#endregion
//#region src/components/ui/drawer/drawer-trigger.ts
var ar = class extends C {
	constructor(...e) {
		super(...e), this.handleClick = () => {
			let e = this._drawer;
			e && (e.dataset.state = Xn.open);
		};
	}
	get _drawer() {
		let e = this.parentElement;
		for (; e;) {
			if (e instanceof or) return e;
			e = e.parentElement;
		}
		return e;
	}
	get _containerElement() {
		return this.querySelector("div[part=drawer-trigger]");
	}
	firstUpdated(e) {
		super.firstUpdated(e), this.moveLightDomChildrenInto(this._containerElement), this.addEventListener("click", (e) => {
			e.stopPropagation(), this.handleClick();
		});
	}
	getAttributesToExclude() {
		return [];
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="drawer-trigger"
        class=${N(Zn.trigger, this.className)}
      ></div>
    `;
	}
};
ar = S([a("rtg-drawer-trigger")], ar);
//#endregion
//#region src/components/ui/drawer/drawer.ts
var or = class extends C {
	constructor(...e) {
		super(...e), this.state = Xn.closed, this.handleOutsideClick = (e) => {
			let t = this._content;
			this.state === Xn.open && t && (t.contains(e.target) || (this.state = Xn.closed, this.dispatchEvent(new CustomEvent("drawer-close"))));
		};
	}
	get _containerElement() {
		return this.querySelector("div[rtgdlg-root]");
	}
	get _content() {
		return this.querySelector("rtg-drawer-content") || null;
	}
	connectedCallback() {
		super.connectedCallback(), this.setupOutsideClickHandler();
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.removeOutsideClickHandler();
	}
	updated(e) {
		super.updated(e);
		let t = this._content;
		t && (t.dataset.state = this.state), e.has("state") && this.setupOutsideClickHandler();
	}
	setupOutsideClickHandler() {
		this.state === Xn.open ? document.addEventListener("click", this.handleOutsideClick) : this.removeOutsideClickHandler();
	}
	removeOutsideClickHandler() {
		document.removeEventListener("click", this.handleOutsideClick);
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	createRenderRoot() {
		return this;
	}
	getAttributesToExclude() {
		return [];
	}
	render() {
		return n`
      <div
        rtgdlg-root
        part="drawer"
        class=${N(Zn.root, this.className)}
      >
        ${this.state === Xn.open ? n` <rtg-drawer-overlay></rtg-drawer-overlay>` : r}
      </div>
    `;
	}
};
S([o({
	attribute: "data-state",
	type: String
}), x("design:type", Object)], or.prototype, "state", void 0), or = S([a("rtg-drawer")], or);
//#endregion
//#region src/components/ui/dropdown-menu/dropdown-menu.styles.ts
var U = {
	root: ["rtg-relative"],
	trigger: [""],
	content: [
		"rtg-overflow-x-hidden rtg-overflow-y-auto rtg-z-50 rtg-absolute",
		"rtg-p-dropdown-menu-content-space-p",
		"rtg-min-w-dropdown-menu-content-space-min-w",
		"rtg-text-dropdown-menu-content-color-text",
		"rtg-bg-dropdown-menu-content-color-bg",
		"rtg-rounded-dropdown-menu-content-radius rtg-border-dropdown-menu-content-width-border rtg-border-dropdown-menu-content-color-border",
		"rtg-shadow-dropdown-menu-content-shadow",
		"rtg-translate-y-0.5",
		"rtg-slide-in-from-top-2",
		"data-[state=open]:rtg-animate-in data-[state=open]:rtg-fade-in-0 data-[state=open]:rtg-zoom-in-95",
		"data-[state=closed]:rtg-animate-out data-[state=closed]:rtg-fade-out-0 data-[state=closed]:rtg-zoom-out-95"
	],
	group: [""],
	item: [
		"rtg-flex rtg-relative",
		"rtg-gap-dropdown-menu-item-space-gap rtg-items-center",
		"rtg-px-dropdown-menu-item-space-px rtg-py-dropdown-menu-item-space-py",
		"rtg-text-dropdown-menu-item-font",
		"rtg-rounded-dropdown-menu-item-radius rtg-outline-hidden",
		"rtg-cursor-default",
		"rtg-select-none",
		"hover:rtg-bg-dropdown-menu-item-color-bg-hover hover:rtg-text-dropdown-menu-item-color-text-hover",
		"focus:rtg-bg-dropdown-menu-item-color-bg-focus focus:rtg-text-dropdown-menu-item-color-text-focus",
		"data-[disabled]:rtg-opacity-dropdown-menu-item-opacity-disabled data-[disabled]:rtg-pointer-events-none",
		"[&_svg]:rtg-shrink-0 [&_svg:not([class*=\"rtg-size-\"])]:rtg-size-dropdown-menu-item-icon-space-size [&_svg:not([class*=\"rtg-text-\"])]:rtg-text-dropdown-menu-item-icon-color-text [&_svg]:rtg-pointer-events-none"
	],
	checkboxItem: {
		base: [
			"rtg-flex rtg-relative",
			"rtg-gap-dropdown-menu-checkbox-item-space-gap rtg-items-center",
			"rtg-pl-dropdown-menu-checkbox-item-space-pl rtg-pr-dropdown-menu-checkbox-item-space-pr rtg-py-dropdown-menu-checkbox-item-space-py",
			"rtg-text-dropdown-menu-checkbox-item-font",
			"rtg-rounded-dropdown-menu-checkbox-item-radius rtg-outline-hidden",
			"rtg-cursor-default",
			"rtg-select-none",
			"aria-selected:rtg-bg-dropdown-menu-checkbox-item-color-bg-focus aria-selected:rtg-text-dropdown-menu-checkbox-item-color-text-focus",
			"data-[disabled]:rtg-opacity-dropdown-menu-checkbox-item-opacity-disabled data-[disabled]:rtg-pointer-events-none"
		],
		span: [
			"rtg-flex rtg-absolute rtg-left-2",
			"rtg-justify-center rtg-items-center",
			"rtg-size-dropdown-menu-checkbox-item-icon-container-space-size",
			"rtg-pointer-events-none"
		],
		icon: [
			"rtg-shrink-0",
			"rtg-size-dropdown-menu-checkbox-item-icon-space-size",
			"rtg-pointer-events-none"
		]
	},
	radioItem: {
		base: [
			"rtg-flex rtg-relative",
			"rtg-gap-dropdown-menu-radio-item-space-gap rtg-items-center",
			"rtg-pl-dropdown-menu-radio-item-space-pl rtg-pr-dropdown-menu-radio-item-space-pr rtg-py-dropdown-menu-radio-item-space-py",
			"rtg-text-dropdown-menu-radio-item-font",
			"rtg-rounded-dropdown-menu-radio-item-radius rtg-outline-hidden",
			"rtg-cursor-default",
			"rtg-select-none",
			"aria-selected:rtg-bg-dropdown-menu-radio-item-color-bg-focus aria-selected:rtg-text-dropdown-menu-radio-item-color-text-focus",
			"data-[disabled]:rtg-opacity-dropdown-menu-radio-item-opacity-disabled data-[disabled]:rtg-pointer-events-none"
		],
		span: [
			"rtg-flex rtg-absolute rtg-left-2",
			"rtg-justify-center rtg-items-center",
			"rtg-size-dropdown-menu-radio-item-icon-container-space-size",
			"rtg-pointer-events-none"
		],
		icon: [
			"rtg-shrink-0",
			"rtg-size-dropdown-menu-radio-item-icon-space-size",
			"rtg-pointer-events-none",
			"rtg-fill-current"
		]
	},
	label: ["rtg-px-dropdown-menu-label-space-px rtg-py-dropdown-menu-label-space-py", "rtg-text-dropdown-menu-label-font rtg-font-dropdown-menu-label-font-weight"],
	separator: [
		"rtg-mx-dropdown-menu-separator-space-mx rtg-my-dropdown-menu-separator-space-my",
		"rtg-h-dropdown-menu-separator-space-h",
		"rtg-bg-dropdown-menu-separator-color-bg"
	],
	shortcut: ["rtg-ml-auto", "rtg-text-dropdown-menu-shortcut-font rtg-text-dropdown-menu-shortcut-color-text"]
}, sr = class extends C {
	constructor(...e) {
		super(...e), this._id = "", this.selected = !1, this.checked = !1, this.disabled = !1;
	}
	get value() {
		return this.textContent?.trim() || "";
	}
	get _containerElement() {
		return this.querySelector("div[part=dropdown-menu-checkbox-item-container]");
	}
	get _dropdownMenu() {
		let e = this.parentElement;
		for (; e && !(e instanceof gr);) e = e.parentElement;
		return e;
	}
	handleMouseEvent(e) {
		(e.type === "mouseover" || e.type === "focus") && (this.selected = !0), e.type === "mouseleave" && (this.selected = !1);
	}
	toggleChecked() {
		this._dropdownMenu.isOpen = !1, this.checked = !this.checked;
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <div
        rtgcmd-item
        part="dropdown-menu-item"
        role="option"
        data-selected="${this.selected}"
        data-value="${this.value}"
        ?data-disabled=${this.disabled}
        aria-checked="${this.checked}"
        aria-selected="${this.selected}"
        aria-hidden="${this.hidden}"
        @click=${this.toggleChecked}
        @mouseover="${this.handleMouseEvent}"
        @mouseleave="${this.handleMouseEvent}"
        @focus="${this.handleMouseEvent}"
        class=${N(U.checkboxItem.base, this.className)}
      >
        <span class=${N(U.checkboxItem.span)}>
          ${this.checked ? n`
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class=${N(U.checkboxItem.icon, "lucide lucide-check-icon lucide-check")}
                >
                  <path d="M20 6 9 17l-5-5" />
                </svg>
              ` : r}
        </span>
        <div part="dropdown-menu-checkbox-item-container"></div>
      </div>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], sr.prototype, "_id", void 0), S([
	o({
		attribute: "data-value",
		type: String
	}),
	x("design:type", Object),
	x("design:paramtypes", [])
], sr.prototype, "value", null), S([o({ type: Boolean }), x("design:type", Object)], sr.prototype, "selected", void 0), S([o({ type: Boolean }), x("design:type", Object)], sr.prototype, "checked", void 0), S([o({
	attribute: "data-disabled",
	type: Boolean
}), x("design:type", Object)], sr.prototype, "disabled", void 0), sr = S([a("rtg-dropdown-menu-checkbox-item")], sr);
//#endregion
//#region src/components/ui/popover/popover.types.ts
var cr = "closed", lr = class extends C {
	constructor() {
		super(), this.state = cr, this.isOpen = !1, this.handleWindowChange = this.handleWindowChange.bind(this);
	}
	get _dropdownMenu() {
		let e = this.parentElement;
		for (; e && !(e instanceof gr);) e = e.parentElement;
		return e;
	}
	get _containerElement() {
		return this.querySelector("div[part=dropdown-menu-content]");
	}
	connectedCallback() {
		super.connectedCallback(), window.addEventListener("resize", this.handleWindowChange), window.addEventListener("scroll", this.handleWindowChange, !0);
	}
	disconnectedCallback() {
		window.removeEventListener("resize", this.handleWindowChange), window.removeEventListener("scroll", this.handleWindowChange, !0), super.disconnectedCallback();
	}
	handleWindowChange() {
		this.isOpen && requestAnimationFrame(() => this.positionContent());
	}
	updated(e) {
		super.updated(e), this.state === "open" ? (this.isOpen = !0, requestAnimationFrame(() => this.positionContent())) : this.isOpen = !1;
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	positionContent() {
		let e = this._dropdownMenu, t = this._containerElement, n = e?._triggerElement;
		if (!e || !t || !n || !this.isOpen) return;
		let r = document.documentElement.clientWidth, i = document.documentElement.clientHeight, a = n.getBoundingClientRect();
		t.style.position = "fixed", t.style.minWidth = `${Math.max(a.width, t.offsetWidth)}px`, t.style.maxWidth = `${Math.min(t.offsetWidth, r - 16)}px`;
		let o = a.left, s = a.bottom, c = t.getBoundingClientRect(), l = r - o >= c.width + 8, u = a.right >= c.width + 8, d = i - s >= c.height + 8, f = a.top >= c.height + 8;
		l || !u && d ? (t.style.left = `${o}px`, t.style.right = "auto") : (t.style.left = "auto", t.style.right = `${r - a.right}px`), d || !f && l ? (t.style.top = `${s}px`, t.style.bottom = "auto") : (t.style.top = "auto", t.style.bottom = `${i - a.top}px`), requestAnimationFrame(() => {
			let e = t.getBoundingClientRect();
			if (e.right > r - 8) {
				let n = e.right - (r - 8), i = parseFloat(t.style.left || "0");
				Number.isNaN(i) || (t.style.left = `${Math.max(0, i - n)}px`);
			}
			if (e.left < 8) {
				let n = 8 - e.left, r = parseFloat(t.style.left || "0");
				Number.isNaN(r) || (t.style.left = `${Math.max(0, r + n)}px`);
			}
			if (e.bottom > i - 8) {
				let n = e.bottom - (i - 8), r = parseFloat(t.style.bottom || "0");
				Number.isNaN(r) || (t.style.bottom = `${Math.max(0, r + n)}px`);
			}
			if (e.top < 8) {
				let n = 8 - e.top, r = parseFloat(t.style.top || "0");
				Number.isNaN(r) || (t.style.top = `${Math.max(0, r + n)}px`);
			}
		});
	}
	render() {
		return n`
      <div
        data-slot="dropdown-menu-content"
        part="dropdown-menu-content"
        style="display: ${this.isOpen ? "block" : "none"};"
        class=${N(U.content, this.className)}
      ></div>
    `;
	}
};
S([o({
	attribute: "data-state",
	type: String
}), x("design:type", Object)], lr.prototype, "state", void 0), S([c(), x("design:type", Object)], lr.prototype, "isOpen", void 0), lr = S([a("rtg-dropdown-menu-content"), x("design:paramtypes", [])], lr);
//#endregion
//#region src/components/ui/dropdown-menu/dropdown-menu-group.ts
var ur = class extends C {
	constructor(...e) {
		super(...e), this.heading = "", this._id = "", this._hidden = "";
	}
	get _containerElement() {
		return this.querySelector("div[rtgcmd-group-items]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`${this._hidden === "true" ? r : n`
          <div
            rtgcmd-group
            part="dropdown-menu-group"
            role="presentation"
            class=${N(U.group, this.className)}
          >
            <div rtgcmd-group-heading class=${N(U.label)}>
              ${this.heading}
            </div>

            <div rtgcmd-group-items role="group"></div>
          </div>
        `}`;
	}
};
S([o({ type: String }), x("design:type", Object)], ur.prototype, "heading", void 0), S([o({
	attribute: "id",
	type: String
}), x("design:type", Object)], ur.prototype, "_id", void 0), S([o({
	attribute: "aria-hidden",
	type: String
}), x("design:type", Object)], ur.prototype, "_hidden", void 0), ur = S([a("rtg-dropdown-menu-group")], ur);
//#endregion
//#region src/components/ui/dropdown-menu/dropdown-menu-item.ts
var dr = class extends C {
	constructor(...e) {
		super(...e), this._id = "", this._hidden = "", this.selected = !1, this.disabled = !1;
	}
	get _containerElement() {
		return this.querySelector("div[part=dropdown-menu-item]");
	}
	get value() {
		return this.textContent?.trim() || "";
	}
	get _dropdownMenu() {
		let e = this.parentElement;
		for (; e && !(e instanceof gr);) e = e.parentElement;
		return e;
	}
	handleMouseEvent(e) {
		console.log(e, this.value), (e.type === "mouseover" || e.type === "focus") && (this.selected = !0), e.type === "mouseleave" && (this.selected = !1);
	}
	handleClickDefault() {
		this._dropdownMenu.isOpen = !1;
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n` ${this._hidden === "true" ? r : n`
          <div
            rtgcmd-item
            part="dropdown-menu-item"
            role="option"
            data-selected="${this.selected}"
            data-value="${this.value}"
            ?data-disabled=${this.disabled}
            aria-selected="${this.selected}"
            aria-hidden="${this.hidden}"
            @mouseover="${this.handleMouseEvent}"
            @mouseleave="${this.handleMouseEvent}"
            @focus="${this.handleMouseEvent}"
            @click="${this.handleClickDefault}"
            class=${N(U.item, this.className)}
          ></div>
        `}`;
	}
};
S([o({ type: String }), x("design:type", Object)], dr.prototype, "_id", void 0), S([o({
	attribute: "aria-hidden",
	type: String
}), x("design:type", Object)], dr.prototype, "_hidden", void 0), S([
	o({
		attribute: "data-value",
		type: String
	}),
	x("design:type", Object),
	x("design:paramtypes", [])
], dr.prototype, "value", null), S([o({ type: Boolean }), x("design:type", Object)], dr.prototype, "selected", void 0), S([o({
	attribute: "data-disabled",
	type: Boolean
}), x("design:type", Object)], dr.prototype, "disabled", void 0), dr = S([a("rtg-dropdown-menu-item")], dr);
//#endregion
//#region src/components/ui/dropdown-menu/dropdown-menu-radio-item.ts
var fr = class extends C {
	constructor(...e) {
		super(...e), this._id = "", this._hidden = "", this.selected = !1, this.checked = !1, this.disabled = !1;
	}
	get value() {
		return this.textContent?.trim() || "";
	}
	get _containerElement() {
		return this.querySelector("div[part=dropdown-menu-radio-item-container]");
	}
	handleMouseEvent(e) {
		(e.type === "mouseover" || e.type === "focus") && (this.selected = !0), e.type === "mouseleave" && (this.selected = !1);
	}
	toggleChecked() {
		this.checked || (this.checked = !0, this.dispatchEvent(new CustomEvent("radio-selected", {
			bubbles: !0,
			composed: !0
		})));
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <div
        rtgcmd-item
        part="dropdown-menu-radio"
        role="option"
        data-selected="${this.selected}"
        data-value="${this.value}"
        ?data-disabled=${this.disabled}
        aria-selected="${this.selected}"
        aria-checked="${this.checked}"
        aria-hidden="${this.hidden}"
        @click=${this.toggleChecked}
        @mouseover="${this.handleMouseEvent}"
        @mouseleave="${this.handleMouseEvent}"
        @focus="${this.handleMouseEvent}"
        class=${N(U.radioItem.base, this.className)}
      >
        <span class=${N(U.radioItem.span)}>
          ${this.checked ? n`<svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class=${N(U.radioItem.icon, "lucide lucide-circle-icon lucide-circle")}
              >
                <circle cx="12" cy="12" r="10" />
              </svg>` : r}
        </span>
        <div part="dropdown-menu-radio-item-container"></div>
      </div>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], fr.prototype, "_id", void 0), S([o({
	attribute: "aria-hidden",
	type: String
}), x("design:type", Object)], fr.prototype, "_hidden", void 0), S([
	o({
		attribute: "data-value",
		type: String
	}),
	x("design:type", Object),
	x("design:paramtypes", [])
], fr.prototype, "value", null), S([o({ type: Boolean }), x("design:type", Object)], fr.prototype, "selected", void 0), S([o({ type: Boolean }), x("design:type", Object)], fr.prototype, "checked", void 0), S([o({
	attribute: "data-disabled",
	type: Boolean
}), x("design:type", Object)], fr.prototype, "disabled", void 0), fr = S([a("rtg-dropdown-menu-radio-item")], fr);
//#endregion
//#region src/components/ui/dropdown-menu/dropdown-menu-seperator.ts
var pr = class extends C {
	get _containerElement() {
		return this.querySelector("div[part=dropdown-menu-seperator]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`<div
      rtgcmd-separator
      part="dropdown-menu-seperator"
      role="separator"
      class=${N(U.separator, this.className)}
    ></div>`;
	}
};
pr = S([a("rtg-dropdown-menu-separator")], pr);
//#endregion
//#region src/components/ui/dropdown-menu/dropdown-menu-shortcut.ts
var mr = class extends C {
	get _containerElement() {
		return this.querySelector("span[part=dropdown-menu-shortcut]");
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	createRenderRoot() {
		return this.classList = N(U.shortcut), this;
	}
	render() {
		return n`
      <span
        part="dropdown-menu-shortcut"
        class=${N(U.shortcut, this.className)}
      >
      </span>
    `;
	}
};
mr = S([a("rtg-dropdown-menu-shortcut")], mr);
//#endregion
//#region src/components/ui/dropdown-menu/dropdown-menu-trigger.ts
var hr = class extends e {
	createRenderRoot() {
		return this;
	}
	render() {
		return n``;
	}
};
hr = S([a("rtg-dropdown-menu-trigger")], hr);
//#endregion
//#region src/components/ui/dropdown-menu/dropdown-menu.ts
var W, gr = class extends C {
	static {
		W = this;
	}
	constructor(...e) {
		super(...e), this.isOpen = !1, this.handleClickOutside = (e) => {
			let t = e.target;
			!this._containerElement?.contains(t) && !this._triggerElement?.contains(t) && (this.isOpen = !1, W._openInstance === this && (W._openInstance = null));
		};
	}
	static {
		this._openInstance = null;
	}
	get _triggerElement() {
		return this.querySelector("rtg-dropdown-menu-trigger");
	}
	get _containerElement() {
		return this.querySelector("div[part=dropdown-menu]");
	}
	get _content() {
		return this.querySelector("rtg-dropdown-menu-content");
	}
	connectedCallback() {
		super.connectedCallback(), document.addEventListener("click", this.handleClickOutside), this.addEventListener("radio-selected", this._handleRadioSelected);
	}
	toggleDropdown(e) {
		e.stopPropagation();
		let t = this.isOpen;
		this.isOpen = !this.isOpen, this.isOpen ? (W._openInstance && W._openInstance !== this && (W._openInstance.isOpen = !1), W._openInstance = this) : t && W._openInstance === this && (W._openInstance = null);
	}
	disconnectedCallback() {
		W._openInstance === this && (W._openInstance = null), document.removeEventListener("click", this.handleClickOutside), super.disconnectedCallback();
	}
	updated(e) {
		super.updated(e);
		let t = this._content;
		t && (t.dataset.state = this.isOpen ? "open" : "close");
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement), this._triggerElement?.addEventListener("click", (e) => this.toggleDropdown(e));
	}
	_handleRadioSelected(e) {
		this.isOpen = !1, this.querySelectorAll("rtg-dropdown-menu-radio-item").forEach((t) => {
			t !== e.target && (t.checked = !1);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="dropdown-menu"
        class=${N(U.root, this.className)}
      ></div>
    `;
	}
};
S([c(), x("design:type", Object)], gr.prototype, "isOpen", void 0), gr = W = S([a("rtg-dropdown-menu")], gr);
//#endregion
//#region src/components/ui/empty/_empty.ts
var _r = class extends e {
	createRenderRoot() {
		return this;
	}
	get _rootSlot() {
		return this.querySelector("[data-slot=\"empty\"]");
	}
	firstUpdated() {
		let e = this._rootSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="empty" ?data-border="${this.border}"></div>`;
	}
};
S([o({ type: Boolean }), x("design:type", Boolean)], _r.prototype, "border", void 0), _r = S([a("rtg-empty")], _r);
//#endregion
//#region src/components/ui/empty/_empty-content.ts
var vr = class extends e {
	createRenderRoot() {
		return this;
	}
	get _contentSlot() {
		return this.querySelector("[data-slot=\"empty-content\"]");
	}
	firstUpdated() {
		let e = this._contentSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="empty-content"></div>`;
	}
};
vr = S([a("rtg-empty-content")], vr);
//#endregion
//#region src/components/ui/empty/_empty-description.ts
var yr = class extends e {
	createRenderRoot() {
		return this;
	}
	get _descriptionSlot() {
		return this.querySelector("[data-slot=\"empty-description\"]");
	}
	firstUpdated() {
		let e = this._descriptionSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="empty-description"></div>`;
	}
};
yr = S([a("rtg-empty-description")], yr);
//#endregion
//#region src/components/ui/empty/_empty-header.ts
var br = class extends e {
	createRenderRoot() {
		return this;
	}
	get _headerSlot() {
		return this.querySelector("[data-slot=\"empty-header\"]");
	}
	firstUpdated() {
		let e = this._headerSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="empty-header"></div>`;
	}
};
br = S([a("rtg-empty-header")], br);
//#endregion
//#region src/components/ui/empty/_empty-media.ts
var xr = class extends e {
	constructor(...e) {
		super(...e), this.variant = "default";
	}
	createRenderRoot() {
		return this;
	}
	get _mediaSlot() {
		return this.querySelector("[data-slot=\"empty-media\"]");
	}
	firstUpdated() {
		let e = this._mediaSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`
      <div data-slot="empty-media" data-variant="${this.variant}"></div>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], xr.prototype, "variant", void 0), xr = S([a("rtg-empty-media")], xr);
//#endregion
//#region src/components/ui/empty/_empty-title.ts
var Sr = class extends e {
	createRenderRoot() {
		return this;
	}
	get _titleSlot() {
		return this.querySelector("[data-slot=\"empty-title\"]");
	}
	firstUpdated() {
		let e = this._titleSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="empty-title"></div>`;
	}
};
Sr = S([a("rtg-empty-title")], Sr);
//#endregion
//#region src/components/ui/field/_field-set.ts
var Cr = class extends e {
	createRenderRoot() {
		return this;
	}
	get _setSlot() {
		return this.querySelector("[data-slot=\"field-set\"]");
	}
	firstUpdated() {
		let e = this._setSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<fieldset data-slot="field-set"></fieldset>`;
	}
};
Cr = S([a("rtg-field-set")], Cr);
//#endregion
//#region src/components/ui/field/_field-legend.ts
var wr = class extends e {
	constructor(...e) {
		super(...e), this.variant = "legend";
	}
	createRenderRoot() {
		return this;
	}
	get _legendSlot() {
		return this.querySelector("[data-slot=\"field-legend\"]");
	}
	firstUpdated() {
		let e = this._legendSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`
      <legend data-slot="field-legend" data-variant=${this.variant}></legend>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], wr.prototype, "variant", void 0), wr = S([a("rtg-field-legend")], wr);
//#endregion
//#region src/components/ui/field/_field-group.ts
var Tr = class extends e {
	constructor(...e) {
		super(...e), this.type = "field";
	}
	createRenderRoot() {
		return this;
	}
	get _groupSlot() {
		return this.querySelector("[data-slot=\"field-group\"]");
	}
	firstUpdated() {
		let e = this._groupSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="field-group" data-type=${this.type}></div>`;
	}
};
S([o({ type: String }), x("design:type", Object)], Tr.prototype, "type", void 0), Tr = S([a("rtg-field-group")], Tr);
//#endregion
//#region src/components/ui/field/_field.ts
var Er = class extends e {
	constructor(...e) {
		super(...e), this.orientation = "vertical";
	}
	createRenderRoot() {
		return this;
	}
	get _rootSlot() {
		return this.querySelector("[data-slot=\"field\"]");
	}
	firstUpdated() {
		let e = this._rootSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`
      <div
        data-slot="field"
        data-orientation=${this.orientation}
        data-disabled=${this.disabled ? "true" : r}
        data-invalid=${this.invalid ? "true" : r}
        role="group"
      ></div>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], Er.prototype, "orientation", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], Er.prototype, "disabled", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], Er.prototype, "invalid", void 0), Er = S([a("rtg-field")], Er);
//#endregion
//#region src/components/ui/field/_field-content.ts
var Dr = class extends e {
	createRenderRoot() {
		return this;
	}
	get _contentSlot() {
		return this.querySelector("[data-slot=\"field-content\"]");
	}
	firstUpdated() {
		let e = this._contentSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="field-content"></div>`;
	}
};
Dr = S([a("rtg-field-content")], Dr);
//#endregion
//#region src/components/ui/label/_label.ts
var Or = class extends e {
	get _rootSlot() {
		return this.querySelector("[data-slot=\"label\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._rootSlot && this._rootSlot?.appendChild(e);
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`<label data-slot="label" for=${this.for ?? r}></label>`;
	}
};
S([o({ type: String }), x("design:type", String)], Or.prototype, "for", void 0), Or = S([a("rtg-label")], Or);
//#endregion
//#region src/components/ui/field/_field-label.ts
var kr = class extends e {
	createRenderRoot() {
		return this;
	}
	get _labelSlot() {
		return this.querySelector("[data-slot=\"field-label\"]");
	}
	firstUpdated() {
		let e = this._labelSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`
      <rtg-label data-slot="field-label" for=${this.for ?? r}></rtg-label>
    `;
	}
};
S([o({ type: String }), x("design:type", String)], kr.prototype, "for", void 0), kr = S([a("rtg-field-label")], kr);
//#endregion
//#region src/components/ui/field/_field-title.ts
var Ar = class extends e {
	createRenderRoot() {
		return this;
	}
	get _titleSlot() {
		return this.querySelector("[data-slot=\"field-label\"]");
	}
	firstUpdated() {
		let e = this._titleSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="field-label"></div>`;
	}
};
Ar = S([a("rtg-field-title")], Ar);
//#endregion
//#region src/components/ui/field/_field-description.ts
var jr = class extends e {
	createRenderRoot() {
		return this;
	}
	get _descriptionSlot() {
		return this.querySelector("[data-slot=\"field-description\"]");
	}
	firstUpdated() {
		let e = this._descriptionSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<p data-slot="field-description"></p>`;
	}
};
jr = S([a("rtg-field-description")], jr);
//#endregion
//#region src/components/ui/field/_field-separator.ts
var Mr = class extends e {
	constructor(...e) {
		super(...e), this._observer = null;
	}
	createRenderRoot() {
		return this;
	}
	get _separatorSlot() {
		return this.querySelector("[data-slot=\"field-separator\"]");
	}
	get _contentSlot() {
		return this.querySelector("[data-slot=\"field-separator-content\"]");
	}
	_getExternalNodes() {
		let e = this._separatorSlot;
		return Array.from(this.childNodes).filter((t) => !(t === e || t.nodeType === Node.COMMENT_NODE || t.nodeType === Node.TEXT_NODE && !t.textContent?.trim()));
	}
	_processChildren() {
		let e = this._separatorSlot;
		if (!e) return;
		let t = this._getExternalNodes();
		if (t.length > 0) {
			let n = this._contentSlot;
			n || (n = document.createElement("span"), n.setAttribute("data-slot", "field-separator-content"), e.appendChild(n)), t.forEach((e) => n.appendChild(e)), e.setAttribute("data-content", "true");
		} else {
			let t = this._contentSlot;
			t && e.removeChild(t), e.setAttribute("data-content", "false");
		}
	}
	firstUpdated() {
		this._processChildren(), this._observer = new MutationObserver(() => {
			this._observer.disconnect(), this._processChildren(), this._observer.observe(this, { childList: !0 });
		}), this._observer.observe(this, { childList: !0 });
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this._observer?.disconnect(), this._observer = null;
	}
	render() {
		return n`
      <div data-slot="field-separator">
        <rtg-separator></rtg-separator>
        <span data-slot="field-separator-content"></span>
      </div>
    `;
	}
};
Mr = S([a("rtg-field-separator")], Mr);
//#endregion
//#region src/components/ui/field/_field-error.ts
var Nr = class extends e {
	constructor(...e) {
		super(...e), this._hasUserContent = !1;
	}
	createRenderRoot() {
		return this;
	}
	connectedCallback() {
		super.connectedCallback(), this._hasUserContent = this.innerHTML.trim().length > 0;
	}
	_renderContent() {
		if (!this.errors?.length) return null;
		let e = [...new Map(this.errors.map((e) => [e?.message, e])).values()];
		return e.length === 1 ? e[0]?.message ? e[0].message : null : n`
      <ul data-slot="field-error-content">
        ${e.map((e, t) => e?.message ? n`<li key=${t}>${e.message}</li>` : r)}
      </ul>
    `;
	}
	render() {
		let e = this._hasUserContent, t = this._renderContent();
		return e ? n` <div data-slot="field-error" role="alert">${Array.from(this.childNodes)}</div>` : t ? n` <div data-slot="field-error" role="alert">${t}</div>` : (this.style.display = "none", r);
	}
};
S([o({ type: Array }), x("design:type", Array)], Nr.prototype, "errors", void 0), Nr = S([a("rtg-field-error")], Nr);
//#endregion
//#region src/components/ui/form/form-controller.ts
var Pr = class {
	constructor() {
		this.values = {}, this.errors = {}, this.validators = {}, this.subscribers = /* @__PURE__ */ new Set();
	}
	registerField({ name: e, defaultValue: t = "", validator: n }) {
		e in this.values || (this.values[e] = t), n && (this.validators[e] = n);
	}
	unregisterField(e) {
		delete this.values[e], delete this.errors[e], delete this.validators[e];
	}
	setValue(e, t) {
		e in this.validators || console.warn(`[FormController] setValue called before validator was registered for "${e}"`), this.values[e] = t, this.validateField(e), this.notify();
	}
	getValue(e) {
		return this.values[e];
	}
	getError(e) {
		return this.errors[e] ?? null;
	}
	validateField(e) {
		let t = this.validators[e], n = this.values[e], r = t ? t(n) : null;
		return this.errors[e] = r, this.notify(), !r;
	}
	validateAll() {
		let e = !0;
		return Object.keys(this.validators).forEach((t) => {
			this.validateField(t) || (e = !1);
		}), e;
	}
	subscribe(e) {
		return this.subscribers.add(e), () => this.subscribers.delete(e);
	}
	notify() {
		this.subscribers.forEach((e) => e());
	}
	getValues() {
		return { ...this.values };
	}
	getErrors() {
		return { ...this.errors };
	}
}, Fr = ee("rtg-form-context"), Ir = class extends C {
	constructor(...e) {
		super(...e), this.form = new Pr(), this.handleSubmit = (e) => {
			if (e.preventDefault(), this.form.validateAll()) {
				let e = this.form.getValues();
				alert(JSON.stringify(e, null, 2));
			}
		};
	}
	createRenderRoot() {
		return this;
	}
	async firstUpdated(e) {
		await this.updateComplete, Array.from(this.childNodes).forEach((e) => {
			e !== this.formElement && this.formElement.appendChild(e);
		}), this.querySelectorAll("rtg-form-field").forEach((e) => {
			let t = e.getAttribute("name"), n = e.validators?.[0];
			this.form.registerField({
				name: t,
				validator: n
			});
		});
	}
	render() {
		return n`
      <form
        part="form-controller"
        class="${N("", this.className)}"
        @submit=${this.handleSubmit}
        ${h((e) => this.formElement = e)}
      ></form>
    `;
	}
};
S([
	c(),
	m({ context: Fr }),
	x("design:type", Object)
], Ir.prototype, "form", void 0), Ir = S([a("rtg-form-controller")], Ir);
//#endregion
//#region src/components/ui/form/form-item-context.ts
var Lr = ee("rtg-form-item-context"), Rr = "rtg-space-form-space-y", zr = "rtg-text-form-description-font rtg-text-form-description-color-text rtg-mt-form-description-space-mt", Br = "rtg-space-y-form-field-space-y", Vr = "rtg-space-y-form-item-space-y", Hr = "rtg-text-form-label-font rtg-mb-form-label-space-mb rtg-font-form-label-font-weight rtg-peer-disabled:rtg-cursor-not-allowed peer-disabled:rtg-opacity-form-label-opacity-peer-disabled", Ur = "rtg-text-form-message-font-size rtg-text-form-message-color-text", Wr = class extends C {
	createRenderRoot() {
		return this;
	}
	get _desc() {
		return this.querySelector("p[part=form-description]");
	}
	firstUpdated() {
		this.moveLightDomChildrenInto(this._desc);
	}
	render() {
		return n`
      <p
        id="${this.itemContext.id}-description"
        part="form-description"
        class="${N(zr, this.className)}"
      ></p>
    `;
	}
};
S([p({ context: Lr }), x("design:type", Object)], Wr.prototype, "itemContext", void 0), Wr = S([a("rtg-form-description")], Wr);
//#endregion
//#region src/components/ui/form/form-field-context.ts
var Gr = ee("rtg-form-field-context"), Kr = class extends C {
	constructor(...e) {
		super(...e), this.name = "", this.validators = [], this.defaultValue = "", this.fieldName = "", this.registered = !1;
	}
	createRenderRoot() {
		return this;
	}
	get _container() {
		return this.querySelector("div[part=form-field]");
	}
	updated() {
		if (this.registered || !this.form || !this.name) return;
		this.form.registerField({
			name: this.name,
			validator: (e) => {
				for (let t of this.validators ?? []) {
					let n = t(e);
					if (n) return n;
				}
				return null;
			},
			defaultValue: this.defaultValue
		}), this.registered = !0, this.moveLightDomChildrenInto(this._container);
		let e = this._container?.querySelector("rtg-input, input, textarea, select");
		e && (e.value = this.defaultValue ?? "", this.form.setValue(this.name, this.defaultValue ?? ""), e.addEventListener("input", () => {
			this.form.setValue(this.name, e.value);
		}));
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.isConnected || this.form?.unregisterField(this.name);
	}
	render() {
		return n`<div
      part="form-field"
      class="${N(Br, this.className)}"
    ></div>`;
	}
};
S([p({ context: Fr }), x("design:type", Pr === void 0 ? Object : Pr)], Kr.prototype, "form", void 0), S([o({ type: String }), x("design:type", Object)], Kr.prototype, "name", void 0), S([o({ type: Array }), x("design:type", Array)], Kr.prototype, "validators", void 0), S([o({ type: String }), x("design:type", Object)], Kr.prototype, "defaultValue", void 0), S([m({ context: Gr }), x("design:type", Object)], Kr.prototype, "fieldName", void 0), Kr = S([a("rtg-form-field")], Kr);
//#endregion
//#region src/components/ui/form/rtg-form-item.ts
var qr = class extends C {
	constructor(...e) {
		super(...e), this._generatedId = crypto.randomUUID(), this.itemContext = { id: this._generatedId };
	}
	createRenderRoot() {
		return this;
	}
	get _container() {
		return this.querySelector("div[part=form-item]");
	}
	firstUpdated() {
		this.moveLightDomChildrenInto(this._container);
	}
	render() {
		return n`<div
      part="form-item"
      class="${N(Vr, this.className)}"
    ></div>`;
	}
};
S([m({ context: Lr }), x("design:type", Object)], qr.prototype, "itemContext", void 0), qr = S([a("rtg-form-item")], qr);
//#endregion
//#region src/components/ui/form/rtg-form-label.ts
var Jr = class extends C {
	constructor(...e) {
		super(...e), this.hasError = !1, this.unsubscribe = null;
	}
	get _field() {
		let e = this.parentElement;
		for (; e && !(e instanceof Kr);) e = e.parentElement;
		return e;
	}
	createRenderRoot() {
		return this;
	}
	get _label() {
		return this.querySelector("label[part=form-label]");
	}
	firstUpdated() {
		this.moveLightDomChildrenInto(this._label);
	}
	connectedCallback() {
		super.connectedCallback();
		let e = this._field.name;
		this.hasError = !!this.form.getError(e), this.unsubscribe = this.form.subscribe(() => {
			let t = this.form.getError(e);
			this.hasError = !!t, this.requestUpdate();
		});
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.unsubscribe && this.unsubscribe();
	}
	render() {
		return n`
      <label
        part="form-label"
        for="${this._field.name}"
        class="${N(Hr, this.hasError && "rtg-text-form-label-color-text-error", this.className)}"
      ></label>
    `;
	}
};
S([p({ context: Fr }), x("design:type", Pr === void 0 ? Object : Pr)], Jr.prototype, "form", void 0), S([c(), x("design:type", Object)], Jr.prototype, "hasError", void 0), Jr = S([a("rtg-form-label")], Jr);
//#endregion
//#region src/components/ui/form/rtg-form-message.ts
var Yr = class extends e {
	constructor(...e) {
		super(...e), this.error = null, this.unsubscribe = null;
	}
	get _field() {
		let e = this.parentElement;
		for (; e && !(e instanceof Kr);) e = e.parentElement;
		return e;
	}
	createRenderRoot() {
		return this;
	}
	connectedCallback() {
		super.connectedCallback(), this.error = this.form.getError(this._field.name), this.unsubscribe = this.form.subscribe(() => {
			this.error = this.form.getErrors()[this._field.name], this.requestUpdate();
		});
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.unsubscribe && this.unsubscribe();
	}
	render() {
		return this.error ? n`<p
      id="${this._field.name}-message"
      class="${N(Ur, this.className)}"
    >
      ${this.error}
    </p>` : null;
	}
};
S([p({ context: Fr }), x("design:type", Pr === void 0 ? Object : Pr)], Yr.prototype, "form", void 0), S([c(), x("design:type", Object)], Yr.prototype, "error", void 0), Yr = S([a("rtg-form-message")], Yr);
//#endregion
//#region src/components/ui/form/rtg-form.ts
var Xr = class extends C {
	constructor(...e) {
		super(...e), this.form = new Pr(), this.onSubmit = () => {}, this.handleSubmit = (e) => {
			e.preventDefault(), this.form.validateAll() && this.onSubmit(this.form.getValues());
		};
	}
	createRenderRoot() {
		return this;
	}
	get _formElement() {
		return this.querySelector("form[part=form-root]");
	}
	firstUpdated() {
		this.moveLightDomChildrenInto(this._formElement);
	}
	render() {
		return n`
      <form
        part="form-root"
        id="rtg-form"
        @submit=${this.handleSubmit}
        class="${N(Rr, this.className)}"
      ></form>
    `;
	}
};
S([m({ context: Fr }), x("design:type", Object)], Xr.prototype, "form", void 0), S([o({ type: Function }), x("design:type", Function)], Xr.prototype, "onSubmit", void 0), Xr = S([a("rtg-form")], Xr);
//#endregion
//#region src/components/ui/hoverCard/hover-card.styles.ts
var Zr = {
	root: [""],
	trigger: [""],
	content: [
		"rtg-fixed rtg-z-50",
		"rtg-p-hover-card-content-space-p",
		"rtg-w-hover-card-content-space-w",
		"rtg-text-hover-card-content-color-text",
		"rtg-bg-hover-card-content-color-bg",
		"rtg-rounded-hover-card-content-radius rtg-border-hover-card-content-width-border rtg-border-hover-card-content-color-border rtg-outline-hidden",
		"rtg-shadow-hover-card-content-shadow",
		"data-[state=open]:rtg-animate-in data-[state=open]:rtg-fade-in-0 data-[state=open]:rtg-zoom-in-95",
		"data-[state=closed]:rtg-animate-out data-[state=closed]:rtg-fade-out-0 data-[state=closed]:rtg-zoom-out-95",
		"data-[side=bottom]:rtg-slide-in-from-top-2 data-[side=left]:rtg-slide-in-from-right-2 data-[side=right]:rtg-slide-in-from-left-2 data-[side=top]:rtg-slide-in-from-bottom-2"
	]
}, Qr = class extends C {
	constructor(...e) {
		super(...e), this.state = "closed", this.isOpen = !1, this.onStateChange = (e) => {
			let t = e.detail.isOpen;
			this.state = t ? "open" : "closed";
		}, this.handlePointerLeaveCheck = (e) => {
			this.contains(e.relatedTarget) || (this.isOpen = !1);
		};
	}
	connectedCallback() {
		super.connectedCallback(), document.addEventListener("hover-card-state-change", this.onStateChange), this.addEventListener("mouseenter", this.handlePointerLeaveCheck), this.addEventListener("mouseleave", this.handlePointerLeaveCheck);
	}
	disconnectedCallback() {
		document.removeEventListener("hover-card-state-change", this.onStateChange), this.removeEventListener("mouseenter", this.handlePointerLeaveCheck), this.removeEventListener("mouseleave", this.handlePointerLeaveCheck), super.disconnectedCallback();
	}
	updated(e) {
		super.updated(e), this.isOpen = this.state === "open";
	}
	createRenderRoot() {
		return this;
	}
	getAttributesToExclude() {
		return [];
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this.renderRoot.querySelector("#rtg-hover-card-content"));
	}
	render() {
		return n`
      <div
        id="rtg-hover-card-content"
        part="hover-card-content"
        class=${N(Zr.content, this.className)}
        style="display: ${this.isOpen ? "block" : "none"};"
      ></div>
    `;
	}
};
S([o({
	attribute: "data-state",
	type: String
}), x("design:type", String)], Qr.prototype, "state", void 0), S([c(), x("design:type", Object)], Qr.prototype, "isOpen", void 0), Qr = S([a("rtg-hover-card-content")], Qr);
//#endregion
//#region src/components/ui/hoverCard/hover-card-trigger.ts
var $r = class extends C {
	getAttributesToExclude() {
		return ["value", "defaultValue"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.removeDuplicateContent();
	}
	render() {
		return n`
      <div
        id="rtg-hover-card-trigger"
        part="rtg-hover-card-trigger"
        class=${N(Zr.trigger, this.className)}
      >
        ${Array.from(this.children)}
      </div>
    `;
	}
};
$r = S([a("rtg-hover-card-trigger")], $r);
//#endregion
//#region src/components/ui/hoverCard/hover-card.ts
var ei = class extends C {
	constructor(...e) {
		super(...e), this.isOpen = !1, this.hoverTimeout = null, this.openCard = () => {
			this.hoverTimeout &&= (clearTimeout(this.hoverTimeout), null), this.isOpen || (this.isOpen = !0, this._content?.dispatchEvent(new CustomEvent("hover-card-state-change", { detail: { isOpen: !0 } })));
		}, this.closeCard = () => {
			this.hoverTimeout = setTimeout(() => {
				this.isOpen = !1, this._content?.dispatchEvent(new CustomEvent("hover-card-state-change", { detail: { isOpen: !1 } }));
			}, 150);
		};
	}
	get _containerElement() {
		return this.renderRoot.querySelector("#rtg-hover-card-container");
	}
	get _content() {
		return this.renderRoot.querySelector("rtg-hover-card-content");
	}
	get _trigger() {
		return this.renderRoot.querySelector("rtg-hover-card-trigger");
	}
	getAttributesToExclude() {
		return [];
	}
	updated(e) {
		super.updated(e);
		let t = this._content;
		t && (t.dataset.state = this.isOpen ? "open" : "closed");
	}
	connectedCallback() {
		super.connectedCallback();
	}
	disconnectedCallback() {
		let e = this._trigger, t = this._content;
		e?.removeEventListener("mouseenter", this.openCard), e?.removeEventListener("mouseleave", this.closeCard), t?.removeEventListener("mouseenter", this.openCard), t?.removeEventListener("mouseleave", this.closeCard), this.hoverTimeout && clearTimeout(this.hoverTimeout), super.disconnectedCallback();
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		let t = this._containerElement;
		this.moveLightDomChildrenInto(t);
		let n = this._trigger, r = this._content;
		n?.addEventListener("mouseenter", this.openCard), n?.addEventListener("mouseleave", this.closeCard), r?.addEventListener("mouseenter", this.openCard), r?.addEventListener("mouseleave", this.closeCard);
	}
	render() {
		return n`
      <div
        id="rtg-hover-card-container"
        part="hover-card"
        class=${N(Zr.root, this.className)}
      ></div>
    `;
	}
};
S([c(), x("design:type", Object)], ei.prototype, "isOpen", void 0), ei = S([a("rtg-hover-card")], ei);
//#endregion
//#region src/components/ui/input-group/_input-group.ts
var ti = class extends e {
	createRenderRoot() {
		return this;
	}
	get _rootSlot() {
		return this.querySelector("[data-slot=\"input-group\"]");
	}
	firstUpdated() {
		let e = this._rootSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="input-group" role="group"></div>`;
	}
};
ti = S([a("rtg-input-group")], ti);
//#endregion
//#region src/components/ui/input-group/_input-group-addon.ts
var ni = class extends e {
	constructor(...e) {
		super(...e), this.align = "inline-start";
	}
	createRenderRoot() {
		return this;
	}
	get _addonSlot() {
		return this.querySelector("[data-slot=\"input-group-addon\"]");
	}
	firstUpdated() {
		let e = this._addonSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`
      <div
        data-slot="input-group-addon"
        data-align="${this.align}"
        ?data-border="${this.border}"
        role="group"
      ></div>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], ni.prototype, "align", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], ni.prototype, "border", void 0), ni = S([a("rtg-input-group-addon")], ni);
//#endregion
//#region src/components/ui/input-group/_input-group-button.ts
var ri = class extends e {
	constructor(...e) {
		super(...e), this.variant = "ghost", this.size = "xs", this.type = "button";
	}
	createRenderRoot() {
		return this;
	}
	get _buttonSlot() {
		return this.querySelector("[data-slot=\"input-group-button\"]");
	}
	firstUpdated() {
		let e = this._buttonSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`
      <rtg-button
        data-slot="input-group-button"
        .variant=${this.variant}
        .size=${this.size}
        .type=${this.type}
        ?disabled=${this.disabled}
        ?invalid=${this.invalid}
        .href=${this.href}
        .target=${this.target}
        .onclick=${this.onClick}
      ></rtg-button>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], ri.prototype, "variant", void 0), S([o({ type: String }), x("design:type", Object)], ri.prototype, "size", void 0), S([o({ type: String }), x("design:type", Object)], ri.prototype, "type", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], ri.prototype, "disabled", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], ri.prototype, "invalid", void 0), S([o({ type: String }), x("design:type", String)], ri.prototype, "href", void 0), S([o({ type: String }), x("design:type", Object)], ri.prototype, "target", void 0), S([o({
	attribute: !1,
	type: Function
}), x("design:type", Function)], ri.prototype, "onClick", void 0), ri = S([a("rtg-input-group-button")], ri);
//#endregion
//#region src/components/ui/input/_input.ts
var G = class extends e {
	constructor(...e) {
		super(...e), this.id = "", this.type = "text", this._onClick = (e) => {
			this.onClick && this.onClick(e);
		}, this._onInput = (e) => {
			let t = e.target;
			this.value = t.value, this.onInput && this.onInput(e);
		}, this._onChange = (e) => {
			let t = e.target;
			this.value = t.value, this.onChange && this.onChange(e);
		}, this._onFocus = (e) => {
			this.dispatchEvent(new FocusEvent("focus", {
				bubbles: !0,
				composed: !0,
				relatedTarget: e.relatedTarget
			})), this.onFocus && this.onFocus(e);
		}, this._onBlur = (e) => {
			this.dispatchEvent(new FocusEvent("blur", {
				bubbles: !0,
				composed: !0,
				relatedTarget: e.relatedTarget
			})), this.onBlur && this.onBlur(e);
		};
	}
	createRenderRoot() {
		return this;
	}
	updated(e) {
		e.has("id") && (this.id && (this._inputId = this.id), this.removeAttribute("id"));
	}
	firstUpdated() {
		this._inputId = this.id, this.removeAttribute("id");
	}
	render() {
		return n`
      <input
        data-slot="input"
        accept=${this.type === "file" && this.accept ? this.accept : r}
        autocomplete=${this.autocomplete ?? r}
        ?disabled=${this.disabled}
        form=${this.form ?? r}
        id=${this._inputId && this._inputId !== "" ? this._inputId : r}
        max=${this.max ?? r}
        maxlength=${this.maxlength ?? r}
        min=${this.min ?? r}
        minlength=${this.minlength ?? r}
        multiple=${this.multiple ?? r}
        name=${this.name ?? r}
        pattern=${this.max ?? r}
        placeholder=${this.placeholder ?? r}
        ?readonly=${this.readonly}
        ?required=${this.required}
        step=${this.step ?? r}
        type=${this.type}
        value=${this.value ?? r}
        aria-invalid=${this.invalid || this.ariaInvalid === "true" ? "true" : r}
        aria-label=${this.ariaLabel ?? r}
        aria-required=${this.required ? "true" : r}
        @click=${this._onClick}
        @input=${this._onInput}
        @change=${this._onChange}
        @focus=${this._onFocus}
        @blur=${this._onBlur}
      />
    `;
	}
};
S([o({ type: String }), x("design:type", String)], G.prototype, "accept", void 0), S([o({ type: String }), x("design:type", Object)], G.prototype, "autocomplete", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], G.prototype, "disabled", void 0), S([o({ type: String }), x("design:type", String)], G.prototype, "form", void 0), S([o({ type: String }), x("design:type", Object)], G.prototype, "id", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], G.prototype, "invalid", void 0), S([o({ type: Number }), x("design:type", Number)], G.prototype, "max", void 0), S([o({ type: Number }), x("design:type", Number)], G.prototype, "maxlength", void 0), S([o({ type: Number }), x("design:type", Number)], G.prototype, "min", void 0), S([o({ type: Number }), x("design:type", Number)], G.prototype, "minlength", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], G.prototype, "multiple", void 0), S([o({ type: String }), x("design:type", String)], G.prototype, "name", void 0), S([o({ type: String }), x("design:type", String)], G.prototype, "pattern", void 0), S([o({ type: String }), x("design:type", String)], G.prototype, "placeholder", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], G.prototype, "readonly", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], G.prototype, "required", void 0), S([o({ type: Number }), x("design:type", Number)], G.prototype, "step", void 0), S([o({ type: String }), x("design:type", Object)], G.prototype, "type", void 0), S([o({ type: String }), x("design:type", String)], G.prototype, "value", void 0), S([o({ attribute: !1 }), x("design:type", Function)], G.prototype, "onClick", void 0), S([o({ attribute: !1 }), x("design:type", Function)], G.prototype, "onInput", void 0), S([o({ attribute: !1 }), x("design:type", Function)], G.prototype, "onChange", void 0), S([o({ attribute: !1 }), x("design:type", Function)], G.prototype, "onFocus", void 0), S([o({ attribute: !1 }), x("design:type", Function)], G.prototype, "onBlur", void 0), G = S([a("rtg-input")], G);
//#endregion
//#region src/components/ui/input-group/_input-group-input.ts
var K = class extends e {
	constructor(...e) {
		super(...e), this.id = "", this.type = "text";
	}
	createRenderRoot() {
		return this;
	}
	updated(e) {
		e.has("id") && (this.id && (this._inputId = this.id), this.removeAttribute("id"));
	}
	firstUpdated() {
		this._inputId = this.id, this.removeAttribute("id");
	}
	render() {
		return n`
      <rtg-input
        data-slot="input-group-input"
        .accept=${this.accept}
        .autocomplete=${this.autocomplete}
        ?disabled=${this.disabled}
        .form=${this.form}
        id=${this._inputId && this._inputId !== "" ? this._inputId : r}
        ?invalid=${this.invalid}
        .max=${this.max}
        .maxlength=${this.maxlength}
        .min=${this.min}
        .minlength=${this.minlength}
        ?multiple=${this.multiple}
        .name=${this.name}
        .pattern=${this.pattern}
        .placeholder=${this.placeholder}
        ?readonly=${this.readonly}
        ?required=${this.required}
        .step=${this.step}
        .type=${this.type}
        .value=${this.value}
        .onClick=${this.onClick}
        .onInput=${this.onInput}
        .onChange=${this.onChange}
        .onFocus=${this.onFocus}
        .onBlur=${this.onBlur}
      ></rtg-input>
    `;
	}
};
S([o({ type: String }), x("design:type", String)], K.prototype, "accept", void 0), S([o({ type: String }), x("design:type", Object)], K.prototype, "autocomplete", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], K.prototype, "disabled", void 0), S([o({ type: String }), x("design:type", String)], K.prototype, "form", void 0), S([o({ type: String }), x("design:type", Object)], K.prototype, "id", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], K.prototype, "invalid", void 0), S([o({ type: Number }), x("design:type", Number)], K.prototype, "max", void 0), S([o({ type: Number }), x("design:type", Number)], K.prototype, "maxlength", void 0), S([o({ type: Number }), x("design:type", Number)], K.prototype, "min", void 0), S([o({ type: Number }), x("design:type", Number)], K.prototype, "minlength", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], K.prototype, "multiple", void 0), S([o({ type: String }), x("design:type", String)], K.prototype, "name", void 0), S([o({ type: String }), x("design:type", String)], K.prototype, "pattern", void 0), S([o({ type: String }), x("design:type", String)], K.prototype, "placeholder", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], K.prototype, "readonly", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], K.prototype, "required", void 0), S([o({ type: Number }), x("design:type", Number)], K.prototype, "step", void 0), S([o({ type: String }), x("design:type", Object)], K.prototype, "type", void 0), S([o({ type: String }), x("design:type", String)], K.prototype, "value", void 0), S([o({ attribute: !1 }), x("design:type", Function)], K.prototype, "onClick", void 0), S([o({ attribute: !1 }), x("design:type", Function)], K.prototype, "onInput", void 0), S([o({ attribute: !1 }), x("design:type", Function)], K.prototype, "onChange", void 0), S([o({ attribute: !1 }), x("design:type", Function)], K.prototype, "onFocus", void 0), S([o({ attribute: !1 }), x("design:type", Function)], K.prototype, "onBlur", void 0), K = S([a("rtg-input-group-input")], K);
//#endregion
//#region src/components/ui/input-group/_input-group-text.ts
var ii = class extends e {
	createRenderRoot() {
		return this;
	}
	get _textSlot() {
		return this.querySelector("[data-slot=\"input-group-text\"]");
	}
	firstUpdated() {
		let e = this._textSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<span data-slot="input-group-text"></span>`;
	}
};
ii = S([a("rtg-input-group-text")], ii);
//#endregion
//#region src/components/ui/textarea/_textarea.ts
var q = class extends e {
	constructor(...e) {
		super(...e), this.id = "", this._onInput = (e) => {
			let t = e.target;
			this.value = t.value, this.onInput && this.onInput(e);
		}, this._onChange = (e) => {
			let t = e.target;
			this.value = t.value, this.onChange && this.onChange(e);
		}, this._onFocus = (e) => {
			this.dispatchEvent(new FocusEvent("focus", {
				bubbles: !0,
				composed: !0,
				relatedTarget: e.relatedTarget
			})), this.onFocus && this.onFocus(e);
		}, this._onBlur = (e) => {
			this.dispatchEvent(new FocusEvent("blur", {
				bubbles: !0,
				composed: !0,
				relatedTarget: e.relatedTarget
			})), this.onBlur && this.onBlur(e);
		};
	}
	createRenderRoot() {
		return this;
	}
	updated(e) {
		e.has("id") && (this.id && (this._textareaId = this.id), this.removeAttribute("id"));
	}
	firstUpdated() {
		this._textareaId = this.id, this.removeAttribute("id");
	}
	render() {
		return n`
      <textarea
        data-slot="textarea"
        autocapitalize=${this.autocapitalize ? this.autocapitalize : r}
        autocomplete=${this.autocomplete ?? r}
        autocorrect=${this.autocorrect ?? r}
        autofocus=${this.autofocus ?? r}
        cols=${this.cols ?? r}
        ?disabled=${this.disabled}
        form=${this.form ?? r}
        id=${this._textareaId && this._textareaId !== "" ? this._textareaId : r}
        maxlength=${this.maxlength ?? r}
        minlength=${this.minlength ?? r}
        name=${this.name ?? r}
        placeholder=${this.placeholder ?? r}
        ?readonly=${this.readonly}
        ?required=${this.required}
        rows=${this.rows ?? r}
        spellcheck=${this.spellcheck ?? r}
        wrap=${this.wrap ?? r}
        value=${this.value ? this.value : r}
        aria-invalid=${this.invalid || this.ariaInvalid === "true" ? "true" : r}
        aria-label=${this.ariaLabel ?? r}
        aria-required=${this.required ? "true" : r}
        @input=${this._onInput}
        @change=${this._onChange}
        @focus=${this._onFocus}
        @blur=${this._onBlur}
      ></textarea>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], q.prototype, "autocomplete", void 0), S([o({ type: Number }), x("design:type", Number)], q.prototype, "cols", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], q.prototype, "disabled", void 0), S([o({ type: String }), x("design:type", String)], q.prototype, "form", void 0), S([o({ type: String }), x("design:type", Object)], q.prototype, "id", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], q.prototype, "invalid", void 0), S([o({ type: Number }), x("design:type", Number)], q.prototype, "maxlength", void 0), S([o({ type: Number }), x("design:type", Number)], q.prototype, "minlength", void 0), S([o({ type: String }), x("design:type", String)], q.prototype, "name", void 0), S([o({ type: String }), x("design:type", String)], q.prototype, "placeholder", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], q.prototype, "readonly", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], q.prototype, "required", void 0), S([o({ type: Number }), x("design:type", Number)], q.prototype, "rows", void 0), S([o({ type: String }), x("design:type", Object)], q.prototype, "wrap", void 0), S([o({ type: String }), x("design:type", String)], q.prototype, "value", void 0), S([o({ attribute: !1 }), x("design:type", Function)], q.prototype, "onInput", void 0), S([o({ attribute: !1 }), x("design:type", Function)], q.prototype, "onChange", void 0), S([o({ attribute: !1 }), x("design:type", Function)], q.prototype, "onFocus", void 0), S([o({ attribute: !1 }), x("design:type", Function)], q.prototype, "onBlur", void 0), q = S([a("rtg-textarea")], q);
//#endregion
//#region src/components/ui/input-group/_input-group-textarea.ts
var J = class extends e {
	constructor(...e) {
		super(...e), this.id = "";
	}
	createRenderRoot() {
		return this;
	}
	updated(e) {
		e.has("id") && (this.id && (this._textareaId = this.id), this.removeAttribute("id"));
	}
	firstUpdated() {
		this._textareaId = this.id, this.removeAttribute("id");
	}
	render() {
		return n`
      <rtg-textarea
        data-slot="input-group-textarea"
        autocapitalize=${this.autocapitalize ? this.autocapitalize : r}
        autocomplete=${this.autocomplete ?? r}
        autocorrect=${this.autocorrect ?? r}
        autofocus=${this.autofocus ?? r}
        cols=${this.cols ?? r}
        ?disabled=${this.disabled}
        form=${this.form ?? r}
        id=${this._textareaId && this._textareaId !== "" ? this._textareaId : r}
        ?invalid=${this.invalid}
        maxlength=${this.maxlength ?? r}
        minlength=${this.minlength ?? r}
        name=${this.name ?? r}
        placeholder=${this.placeholder ?? r}
        ?readonly=${this.readonly}
        ?required=${this.required}
        rows=${this.rows ?? r}
        spellcheck=${this.spellcheck ?? r}
        wrap=${this.wrap ?? r}
        value=${this.value ? this.value : r}
        .oninput=${this.onInput}
        .onchange=${this.onChange}
        .onfocus=${this.onFocus}
        .onblur=${this.onBlur}
      ></rtg-textarea>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], J.prototype, "autocomplete", void 0), S([o({ type: Number }), x("design:type", Number)], J.prototype, "cols", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], J.prototype, "disabled", void 0), S([o({ type: String }), x("design:type", String)], J.prototype, "form", void 0), S([o({ type: String }), x("design:type", Object)], J.prototype, "id", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], J.prototype, "invalid", void 0), S([o({ type: Number }), x("design:type", Number)], J.prototype, "maxlength", void 0), S([o({ type: Number }), x("design:type", Number)], J.prototype, "minlength", void 0), S([o({ type: String }), x("design:type", String)], J.prototype, "name", void 0), S([o({ type: String }), x("design:type", String)], J.prototype, "placeholder", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], J.prototype, "readonly", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], J.prototype, "required", void 0), S([o({ type: Number }), x("design:type", Number)], J.prototype, "rows", void 0), S([o({ type: String }), x("design:type", Object)], J.prototype, "wrap", void 0), S([o({ type: String }), x("design:type", String)], J.prototype, "value", void 0), S([o({ attribute: !1 }), x("design:type", Function)], J.prototype, "onInput", void 0), S([o({ attribute: !1 }), x("design:type", Function)], J.prototype, "onChange", void 0), S([o({ attribute: !1 }), x("design:type", Function)], J.prototype, "onFocus", void 0), S([o({ attribute: !1 }), x("design:type", Function)], J.prototype, "onBlur", void 0), J = S([a("rtg-input-group-textarea")], J);
//#endregion
//#region src/components/ui/input-otp/_input-otp.ts
var Y = class extends e {
	constructor() {
		super(), this.autocomplete = "one-time-code", this.id = "", this.inputmode = "numeric", this._activeSlot = null, this._hasFocus = !1, this._value = "", this._children = [], this._handleBlur = (e) => {
			this._hasFocus = !1, this._activeSlot = null, this._sync(), this.dispatchEvent(new FocusEvent("blur", {
				bubbles: !0,
				composed: !0,
				relatedTarget: e.relatedTarget
			})), this.onBlur?.(e);
		}, this._handleFocus = (e) => {
			this._hasFocus = !0, this._activeSlot === null && (this._activeSlot = this._computeInitialActiveSlot()), this._sync(), this.dispatchEvent(new FocusEvent("focus", {
				bubbles: !0,
				composed: !0,
				relatedTarget: e.relatedTarget
			})), this.onFocus?.(e);
		}, this._handleKeyDown = (e) => {
			if (this.disabled || !this._hasFocus) return;
			this._activeSlot === null && (this._activeSlot = this._computeInitialActiveSlot());
			let t = e.key, n = this._currentValue ?? "";
			if (t === "ArrowLeft") {
				e.preventDefault(), this._activeSlot = this._clampIndex(this._activeSlot - 1), this._sync();
				return;
			}
			if (t === "ArrowRight") {
				e.preventDefault(), this._activeSlot = this._clampIndex(this._activeSlot + 1), this._sync();
				return;
			}
			if (t === "Home") {
				e.preventDefault(), this._activeSlot = 0, this._sync();
				return;
			}
			if (t === "End") {
				e.preventDefault(), this._activeSlot = Math.max(0, n.length - 1), this._sync();
				return;
			}
			if (t === "Backspace") {
				e.preventDefault(), this._deleteChar();
				return;
			}
			if (t === "Delete") {
				if (e.preventDefault(), this._activeSlot !== null) {
					let e = n.split("");
					e[this._activeSlot] = "", this._updateValue(e.join("")), this._sync();
				}
				return;
			}
			if (e.ctrlKey || e.metaKey || t.length !== 1) return;
			let r = this._regex();
			r && !r.test(t) || (e.preventDefault(), this._insertChar(t));
		}, this._handlePaste = (e) => {
			if (this.disabled) return;
			e.preventDefault();
			let t = e.clipboardData?.getData("text") ?? "";
			this.pasteTransformer && (t = this.pasteTransformer(t));
			let n = this._regex(), r = Array.from(t).filter((e) => n ? n.test(e) : !0);
			if (!r.length) return;
			let i = (this._currentValue ?? "").split("").slice(0, this.maxlength);
			for (; i.length < this.maxlength;) i.push("");
			let a = this._activeSlot ?? this._computeInitialActiveSlot();
			for (let e of r) {
				if (a >= this.maxlength) break;
				i[a] = e, a++;
			}
			let o = i.join("");
			this._updateValue(o), this._activeSlot = Math.min(a, this.maxlength - 1), this._checkComplete(), this._sync(), this.onPaste?.(e);
		}, this._children = Array.from(this.childNodes);
	}
	createRenderRoot() {
		return this;
	}
	get _containerSlot() {
		return this.querySelector("[data-slot=\"input-otp-container\"]");
	}
	get _wrapperSlot() {
		return this.querySelector("[data-slot=\"input-otp-wrapper\"]");
	}
	get _slots() {
		return Array.from(this.querySelectorAll("rtg-input-otp-slot"));
	}
	get _isControlled() {
		return this.value !== void 0;
	}
	get _currentValue() {
		return this._isControlled ? this.value : this._value;
	}
	_inputEl() {
		return this.querySelector("[data-slot=\"input-otp\"]");
	}
	_regex() {
		return this.pattern ? new RegExp(this.pattern) : null;
	}
	_clampIndex(e) {
		return Math.max(0, Math.min(e, this.maxlength - 1));
	}
	_computeInitialActiveSlot() {
		let e = (this._currentValue ?? "").length;
		return e >= this.maxlength ? this.maxlength - 1 : e;
	}
	_createCaret() {
		let e = document.createElement("div");
		e.dataset.slot = "input-otp-slot-caret-wrapper";
		let t = document.createElement("div");
		return t.dataset.slot = "input-otp-slot-caret", e.appendChild(t), e;
	}
	_sync() {
		let e = this._currentValue ?? "";
		this._slots.forEach((t) => {
			let n = t._slotSlot;
			if (!n) return;
			let r = e[t.index] ?? "", i = this._hasFocus && !this.disabled && t.index === this._activeSlot;
			n.dataset.state = i ? "active" : "inactive", r ? n.textContent = r : n.textContent = "";
			let a = i && !r, o = n.querySelector("[data-slot=\"input-otp-caret-wrapper\"]");
			a && !o && n.appendChild(this._createCaret()), !a && o && o.remove();
		});
	}
	_updateValue(e) {
		this._isControlled || (this._value = e), this.onChange?.(e);
	}
	_checkComplete() {
		this._currentValue?.length === this.maxlength && this.onComplete?.(this._currentValue);
	}
	_insertChar(e) {
		if (this._activeSlot === null) return;
		let t = this._activeSlot, n = (this._currentValue ?? "").split("");
		n[t] = e;
		let r = n.join("").slice(0, this.maxlength);
		this._updateValue(r), this._activeSlot = this._clampIndex(this._activeSlot + 1), this._checkComplete();
	}
	_deleteChar() {
		if (this._activeSlot === null) return;
		let e = this._activeSlot, t = (this._currentValue ?? "").split("");
		e > 0 && !t[e] && e--, t[e] = "", this._activeSlot = e, this._updateValue(t.join(""));
	}
	updated(e) {
		e.has("id") && (this.id && (this._inputId = this.id), this.removeAttribute("id")), e.has("value") && this._isControlled && (this._value = this.value ?? ""), this._sync();
	}
	firstUpdated() {
		this._inputId = this.id, this.removeAttribute("id"), this._value = this.value ?? this.defaultValue ?? "";
		let e = this._containerSlot, t = this._wrapperSlot;
		!e || !t || (this._children.forEach((n) => {
			e.insertBefore(n, t);
		}), this.addEventListener("rtg-input-otp-slot:focus", (e) => {
			if (this.disabled) return;
			let { index: t } = e.detail;
			this._activeSlot = t, this._hasFocus = !0, this._inputEl()?.focus(), this._sync();
		}));
	}
	render() {
		return n`
      <div data-slot="input-otp-container">
        <div data-slot="input-otp-wrapper">
          <input
            data-slot="input-otp"
            autocomplete=${this.autocomplete}
            ?disabled=${this.disabled}
            form=${this.form ?? r}
            id=${this._inputId && this._inputId !== "" ? this._inputId : r}
            inputmode=${this.inputmode}
            maxlength=${this.maxlength}
            name=${this.name ?? r}
            pattern=${this.pattern ?? r}
            ?required=${this.required}
            spellcheck="false"
            value=${this._currentValue ?? r}
            @blur=${this._handleBlur}
            @focus=${this._handleFocus}
            @keydown=${this._handleKeyDown}
            @paste=${this._handlePaste}
          />
        </div>
      </div>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], Y.prototype, "autocomplete", void 0), S([o({
	attribute: "default-value",
	type: String
}), x("design:type", String)], Y.prototype, "defaultValue", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], Y.prototype, "disabled", void 0), S([o({ type: String }), x("design:type", String)], Y.prototype, "form", void 0), S([o({ type: String }), x("design:type", Object)], Y.prototype, "id", void 0), S([o({ type: String }), x("design:type", Object)], Y.prototype, "inputmode", void 0), S([o({ type: Number }), x("design:type", Number)], Y.prototype, "maxlength", void 0), S([o({ type: String }), x("design:type", String)], Y.prototype, "name", void 0), S([o({ type: String }), x("design:type", String)], Y.prototype, "pattern", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], Y.prototype, "required", void 0), S([o({ type: String }), x("design:type", String)], Y.prototype, "value", void 0), S([o({ attribute: !1 }), x("design:type", Function)], Y.prototype, "onChange", void 0), S([o({ attribute: !1 }), x("design:type", Function)], Y.prototype, "onComplete", void 0), S([o({ attribute: !1 }), x("design:type", Function)], Y.prototype, "onBlur", void 0), S([o({ attribute: !1 }), x("design:type", Function)], Y.prototype, "onFocus", void 0), S([o({ attribute: !1 }), x("design:type", Function)], Y.prototype, "onPaste", void 0), S([o({ attribute: !1 }), x("design:type", Function)], Y.prototype, "pasteTransformer", void 0), S([c(), x("design:type", Object)], Y.prototype, "_activeSlot", void 0), S([c(), x("design:type", Object)], Y.prototype, "_hasFocus", void 0), S([c(), x("design:type", Object)], Y.prototype, "_value", void 0), Y = S([a("rtg-input-otp"), x("design:paramtypes", [])], Y);
//#endregion
//#region src/components/ui/input-otp/_input-otp-group.ts
var ai = class extends e {
	createRenderRoot() {
		return this;
	}
	get _groupSlot() {
		return this.querySelector("[data-slot=\"input-otp-group\"]");
	}
	firstUpdated() {
		let e = this._groupSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="input-otp-group"></div>`;
	}
};
ai = S([a("rtg-input-otp-group")], ai);
//#endregion
//#region src/components/ui/input-otp/_input-otp-slot.ts
var oi = class extends e {
	constructor(...e) {
		super(...e), this._handleClick = () => {
			this.dispatchEvent(new CustomEvent("rtg-input-otp-slot:focus", {
				detail: { index: this.index },
				bubbles: !0
			}));
		};
	}
	createRenderRoot() {
		return this;
	}
	get _slotSlot() {
		return this.querySelector("[data-slot=\"input-otp-slot\"]");
	}
	render() {
		return n`
      <div
        data-slot="input-otp-slot"
        aria-invalid=${this.invalid || this.ariaInvalid === "true" ? "true" : r}
        @click=${this._handleClick}
      ></div>
    `;
	}
};
S([o({ type: Number }), x("design:type", Number)], oi.prototype, "index", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], oi.prototype, "invalid", void 0), oi = S([a("rtg-input-otp-slot")], oi);
//#endregion
//#region src/components/ui/input-otp/_input-otp-separator.ts
var si = class extends e {
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div data-slot="input-otp-separator" role="separator">
        ${qt()}
      </div>
    `;
	}
};
si = S([a("rtg-input-otp-separator")], si);
//#endregion
//#region src/components/ui/item/_item.ts
var ci = class extends e {
	constructor(...e) {
		super(...e), this.variant = "default", this.size = "default";
	}
	createRenderRoot() {
		return this;
	}
	get _rootSlot() {
		return this.querySelector("[data-slot=\"item\"]");
	}
	firstUpdated() {
		let e = this._rootSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return this.href ? n`
        <a
          data-slot="item"
          data-variant="${this.variant}"
          data-size="${this.size}"
          href="${this.href}"
          target="${this.target ?? r}"
        ></a>
      ` : n`
      <div
        data-slot="item"
        data-variant="${this.variant}"
        data-size="${this.size}"
      ></div>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], ci.prototype, "variant", void 0), S([o({ type: String }), x("design:type", Object)], ci.prototype, "size", void 0), S([o({ type: String }), x("design:type", String)], ci.prototype, "href", void 0), S([o({ type: String }), x("design:type", Object)], ci.prototype, "target", void 0), ci = S([a("rtg-item")], ci);
//#endregion
//#region src/components/ui/item/_item-actions.ts
var li = class extends e {
	createRenderRoot() {
		return this;
	}
	get _actionsSlot() {
		return this.querySelector("[data-slot=\"item-actions\"]");
	}
	firstUpdated() {
		let e = this._actionsSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="item-actions"></div>`;
	}
};
li = S([a("rtg-item-actions")], li);
//#endregion
//#region src/components/ui/item/_item-content.ts
var ui = class extends e {
	createRenderRoot() {
		return this;
	}
	get _contentSlot() {
		return this.querySelector("[data-slot=\"item-content\"]");
	}
	firstUpdated() {
		let e = this._contentSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="item-content"></div>`;
	}
};
ui = S([a("rtg-item-content")], ui);
//#endregion
//#region src/components/ui/item/_item-description.ts
var di = class extends e {
	createRenderRoot() {
		return this;
	}
	get _descriptionSlot() {
		return this.querySelector("[data-slot=\"item-description\"]");
	}
	firstUpdated() {
		let e = this._descriptionSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<p data-slot="item-description"></p>`;
	}
};
di = S([a("rtg-item-description")], di);
//#endregion
//#region src/components/ui/item/_item-footer.ts
var fi = class extends e {
	createRenderRoot() {
		return this;
	}
	get _footerSlot() {
		return this.querySelector("[data-slot=\"item-footer\"]");
	}
	firstUpdated() {
		let e = this._footerSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="item-footer"></div>`;
	}
};
fi = S([a("rtg-item-footer")], fi);
//#endregion
//#region src/components/ui/item/_item-group.ts
var pi = class extends e {
	createRenderRoot() {
		return this;
	}
	get _groupSlot() {
		return this.querySelector("[data-slot=\"item-group\"]");
	}
	firstUpdated() {
		let e = this._groupSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="item-group" role="list"></div>`;
	}
};
pi = S([a("rtg-item-group")], pi);
//#endregion
//#region src/components/ui/item/_item-header.ts
var mi = class extends e {
	createRenderRoot() {
		return this;
	}
	get _headerSlot() {
		return this.querySelector("[data-slot=\"item-header\"]");
	}
	firstUpdated() {
		let e = this._headerSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="item-header"></div>`;
	}
};
mi = S([a("rtg-item-header")], mi);
//#endregion
//#region src/components/ui/item/_item-media.ts
var hi = class extends e {
	constructor(...e) {
		super(...e), this.variant = "default";
	}
	createRenderRoot() {
		return this;
	}
	get _mediaSlot() {
		return this.querySelector("[data-slot=\"item-media\"]");
	}
	firstUpdated() {
		let e = this._mediaSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`
      <div data-slot="item-media" data-variant="${this.variant}"></div>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], hi.prototype, "variant", void 0), hi = S([a("rtg-item-media")], hi);
//#endregion
//#region src/components/ui/item/_item-separator.ts
var gi = class extends e {
	createRenderRoot() {
		return this;
	}
	get _separatorSlot() {
		return this.querySelector("[data-slot=\"item-separator\"]");
	}
	firstUpdated() {
		let e = this._separatorSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`
      <rtg-separator
        data-slot="item-separator"
        orientation="horizontal"
      ></rtg-separator>
    `;
	}
};
gi = S([a("rtg-item-separator")], gi);
//#endregion
//#region src/components/ui/item/_item-title.ts
var _i = class extends e {
	createRenderRoot() {
		return this;
	}
	get _titleSlot() {
		return this.querySelector("[data-slot=\"item-title\"]");
	}
	firstUpdated() {
		let e = this._titleSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="item-title"></div>`;
	}
};
_i = S([a("rtg-item-title")], _i);
//#endregion
//#region src/components/ui/kbd/_kbd.ts
var vi = class extends e {
	createRenderRoot() {
		return this;
	}
	get _rootSlot() {
		return this.querySelector("[data-slot=\"kbd\"]");
	}
	firstUpdated() {
		let e = this._rootSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<kbd data-slot="kbd"></kbd>`;
	}
};
vi = S([a("rtg-kbd")], vi);
//#endregion
//#region src/components/ui/kbd/_kbd-group.ts
var yi = class extends e {
	createRenderRoot() {
		return this;
	}
	get _groupSlot() {
		return this.querySelector("[data-slot=\"kbd-group\"]");
	}
	firstUpdated() {
		let e = this._groupSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<kbd data-slot="kbd-group"></kbd>`;
	}
};
yi = S([a("rtg-kbd-group")], yi);
//#endregion
//#region src/components/ui/menubar/menubar.styles.ts
var X = {
	root: [
		"rtg-flex",
		"rtg-gap-menubar-space-gap rtg-items-center",
		"rtg-p-menubar-space-p",
		"rtg-h-menubar-space-h",
		"rtg-bg-menubar-color-bg",
		"rtg-rounded-menubar-radius rtg-border-menubar-width-border rtg-border-menubar-color-border"
	],
	menu: [""],
	group: [""],
	trigger: [
		"rtg-flex",
		"rtg-items-center",
		"rtg-px-menubar-trigger-space-px rtg-py-menubar-trigger-space-py",
		"rtg-text-menubar-trigger-font rtg-font-menubar-trigger-font-weight",
		"rtg-rounded-menubar-trigger-radius rtg-outline-hidden",
		"rtg-select-none",
		"focus:rtg-text-menubar-trigger-color-text-focus focus:rtg-bg-menubar-trigger-color-bg-focus",
		"hover:rtg-text-menubar-trigger-color-text-active hover:rtg-bg-menubar-trigger-color-bg-active"
	],
	content: [
		"rtg-absolute rtg-overflow-hidden rtg-z-50",
		"rtg-p-menubar-content-space-p",
		"rtg-min-w-menubar-content-space-min-w",
		"rtg-text-menubar-content-color-text",
		"rtg-bg-menubar-content-color-bg",
		"rtg-rounded-menubar-content-radius rtg-border-menubar-content-width-border rtg-border-menubar-content-color-border",
		"rtg-shadow-menubar-content-shadow",
		"rtg-translate-y-2",
		"rtg-slide-in-from-top-2",
		"data-[state=open]:rtg-animate-in data-[state=open]:rtg-fade-in-0 data-[state=open]:rtg-zoom-in-95",
		"data-[state=closed]:rtg-animate-out data-[state=closed]:rtg-fade-out-0 data-[state=closed]:rtg-zoom-out-95"
	],
	item: [
		"rtg-flex rtg-relative",
		"rtg-gap-menubar-item-space-gap rtg-items-center",
		"rtg-px-menubar-item-space-px rtg-py-menubar-item-space-py",
		"rtg-text-menubar-item-font",
		"rtg-rounded-menubar-item-radius rtg-outline-hidden",
		"rtg-cursor-default rtg-select-none",
		"aria-selected:rtg-text-menubar-item-color-text-active aria-selected:rtg-bg-menubar-item-color-bg-active",
		"data-[disabled]:rtg-opacity-menubar-item-opacity-disabled data-[disabled]:rtg-pointer-events-none",
		"[&_svg]:rtg-shrink-0 [&_svg:not([class*=\"rtg-size-\"])]:rtg-size-menubar-item-icon-space-size [&_svg:not([class*=\"rtg-text-\"])]:rtg-text-menubar-item-icon-color-text [&_svg]:rtg-pointer-events-none"
	],
	checkboxItem: {
		base: [
			"rtg-flex rtg-relative",
			"rtg-gap-menubar-checkbox-item-space-gap rtg-items-center",
			"rtg-pl-menubar-checkbox-item-space-pl rtg-pr-menubar-checkbox-item-space-pr rtg-py-menubar-checkbox-item-space-py",
			"rtg-text-menubar-checkbox-item-font",
			"rtg-rounded-menubar-checkbox-item-radius rtg-outline-hidden",
			"rtg-cursor-default rtg-select-none",
			"aria-selected:rtg-text-menubar-checkbox-item-color-text-active aria-selected:rtg-bg-menubar-checkbox-item-color-bg-active",
			"data-[disabled]:rtg-opacity-menubar-checkbox-item-opacity-disabled data-[disabled]:rtg-pointer-events-none"
		],
		indicator: [
			"rtg-flex rtg-absolute rtg-left-2",
			"rtg-justify-center rtg-items-center",
			"rtg-size-menubar-checkbox-item-indicator-space-size",
			"rtg-pointer-events-none"
		],
		icon: [
			"rtg-shrink-0",
			"rtg-size-menubar-checkbox-item-icon-space-size",
			"rtg-pointer-events-none"
		]
	},
	radioItem: {
		base: [
			"rtg-flex rtg-relative",
			"rtg-gap-menubar-radio-item-space-gap rtg-items-center",
			"rtg-pl-menubar-radio-item-space-pl rtg-pr-menubar-radio-item-space-pr rtg-py-menubar-radio-item-space-py",
			"rtg-text-menubar-radio-item-font",
			"rtg-rounded-menubar-radio-item-radius rtg-outline-hidden",
			"rtg-cursor-default rtg-select-none",
			"aria-selected:rtg-text-menubar-radio-item-color-text-active aria-selected:rtg-bg-menubar-radio-item-color-bg-active",
			"data-[disabled]:rtg-opacity-menubar-radio-item-opacity-disabled data-[disabled]:rtg-pointer-events-none"
		],
		indicator: [
			"rtg-flex rtg-absolute rtg-left-2",
			"rtg-justify-center rtg-items-center",
			"rtg-size-menubar-radio-item-indicator-space-size",
			"rtg-pointer-events-none"
		],
		icon: [
			"rtg-shrink-0",
			"rtg-size-menubar-radio-item-icon-space-size",
			"rtg-pointer-events-none",
			"rtg-fill-current"
		]
	},
	label: ["rtg-px-menubar-label-space-px rtg-py-menubar-label-space-py", "rtg-text-menubar-label-font rtg-font-menubar-label-font-weight"],
	separator: [
		"rtg-mx-menubar-separator-space-mx rtg-my-menubar-separator-space-my",
		"rtg-h-menubar-separator-space-h",
		"rtg-bg-menubar-separator-color-bg"
	],
	shortcut: ["rtg-ml-auto", "rtg-text-menubar-shortcut-font rtg-text-menubar-shortcut-color-text"]
}, bi, xi = class extends C {
	static {
		bi = this;
	}
	constructor(...e) {
		super(...e), this._id = "", this._hidden = "", this.selected = !1, this.checked = !1, this.disabled = !1;
	}
	static {
		this._counter = 0;
	}
	get _containerElement() {
		return this.querySelector("div[part=menubar-checkbox-item]");
	}
	getAttributesToExclude() {
		return ["date-testid"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	get identifier() {
		if (this._id !== "") return this._id;
		let e = this.parentElement?.shadowRoot?.querySelector("div[rtgcmd-group]");
		return e ? this._id = `${e.getAttribute("id")}li${bi._counter++}` : this._id = `rtgcmdrxgxli${bi._counter++}`, this._id;
	}
	get value() {
		return this.textContent?.trim() || "";
	}
	handleMouseEvent(e) {
		(e.type === "mouseover" || e.type === "focus") && (this.selected = !0), e.type === "mouseleave" && (this.selected = !1);
	}
	toggleChecked() {
		this.checked = !this.checked;
	}
	render() {
		return n`
      <div
        part="menubar-checkbox-item"
        class=${N(X.checkboxItem.base, this.disabled && "rtg-opacity-menubar-item-opacity-disabled rtg-pointer-events-none", this.className)}
        @click=${this.toggleChecked}
        @mouseover="${this.handleMouseEvent}"
        @mouseleave="${this.handleMouseEvent}"
        @focus="${this.handleMouseEvent}"
        rtgcmd-item
        role="option"
        aria-selected="${this.selected}"
        data-selected="${this.selected}"
        data-value="${this.value}"
        id="${this.identifier}"
        aria-hidden="${this.hidden}"
      >
        <span class=${N(X.checkboxItem.indicator)}>
          ${this.checked ? n`
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class=${N(X.checkboxItem.icon, "lucide lucide-check-icon lucide-check")}
                >
                  <path d="M20 6 9 17l-5-5" />
                </svg>
              ` : r}
        </span>
      </div>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], xi.prototype, "_id", void 0), S([o({
	attribute: "aria-hidden",
	type: String
}), x("design:type", Object)], xi.prototype, "_hidden", void 0), S([
	o({
		attribute: "data-value",
		type: String
	}),
	x("design:type", Object),
	x("design:paramtypes", [])
], xi.prototype, "value", null), S([o({ type: Boolean }), x("design:type", Object)], xi.prototype, "selected", void 0), S([o({ type: Boolean }), x("design:type", Object)], xi.prototype, "checked", void 0), S([o({ type: Boolean }), x("design:type", Object)], xi.prototype, "disabled", void 0), xi = bi = S([a("rtg-menubar-checkbox-item")], xi);
//#endregion
//#region src/components/ui/menubar/menubar-menu.ts
var Si = class extends C {
	constructor(...e) {
		super(...e), this.isOpen = !1, this.uniqueIds = [], this.selectedMenu = "", this.isHovering = !1, this.id = "", this.closeTimeout = null, this.toggleMenubar = (e) => {
			e.stopPropagation(), document.querySelectorAll("rtg-menubar-menu").forEach((e) => {
				e !== this && (e.isOpen = !1);
			}), this.isOpen = !this.isOpen;
		}, this.handleClickOutside = (e) => {
			let t = e.target;
			this.contains(t) || (this.isOpen = !1);
		}, this.handleMenuMouseEnter = () => {
			this.clearCloseTimeout(), this.closeAllMenus(), this.isOpen = !0, this.isHovering = !0;
		}, this.handleMenuMouseLeave = (e) => {
			let t = e.relatedTarget;
			if (this.isDescendant(t, "rtg-menubar-content")) {
				this.clearCloseTimeout();
				return;
			}
			this.scheduleClose();
		};
	}
	get _content() {
		return this.querySelector("rtg-menubar-content");
	}
	get _button() {
		return this.querySelector("rtg-menubar-trigger");
	}
	getAttributesToExclude() {
		return ["date-testid"];
	}
	createRenderRoot() {
		return this;
	}
	connectedCallback() {
		super.connectedCallback(), document.addEventListener("click", this.handleClickOutside), this.addEventListener("radio-selected", this._handleRadioSelected);
	}
	disconnectedCallback() {
		document.removeEventListener("click", this.handleClickOutside), this.clearCloseTimeout(), super.disconnectedCallback();
	}
	clearCloseTimeout() {
		this.closeTimeout !== null && (clearTimeout(this.closeTimeout), this.closeTimeout = null);
	}
	updated(e) {
		super.updated(e);
		let t = this._content;
		t && (t.dataset.state = this.isOpen ? "open" : "close");
	}
	_handleRadioSelected(e) {
		this.querySelectorAll("rtg-menubar-radio-item").forEach((t) => {
			let n = t;
			t !== e.target && (n.checked = !1);
		});
	}
	firstUpdated() {
		this.setupContentListeners();
		let e = this.querySelector("div[part=menubar-menu-slot]"), t = this.querySelector("div[part=button-slot]");
		e && this._content && e.appendChild(this._content), t && this._button && t.appendChild(this._button);
	}
	raiseEvent() {
		let e = new CustomEvent("unique-ids-generated", {
			detail: { ids: this.uniqueIds },
			bubbles: !0,
			composed: !0
		});
		this.dispatchEvent(e);
	}
	closeAllMenus() {
		document.querySelectorAll("rtg-menubar-menu").forEach((e) => {
			e.isOpen = !1, e.isHovering = !1;
		});
	}
	scheduleClose() {
		this.clearCloseTimeout(), this.closeTimeout = window.setTimeout(() => {
			this.isOpen = !1, this.isHovering = !1, this.closeTimeout = null;
		}, 150);
	}
	isDescendant(e, t) {
		let n = e.parentElement;
		for (; n;) {
			if (n.tagName.toLowerCase() === t.toLowerCase()) return !0;
			n = n.parentElement;
		}
		return !1;
	}
	setupContentListeners() {
		let e = this._content;
		e && (e.addEventListener("mouseenter", () => {
			this.clearCloseTimeout(), this.isOpen = !0;
		}), e.addEventListener("mouseleave", () => {
			this.scheduleClose();
		}));
	}
	render() {
		return n`
      <div class=${N(X.menu, this.className)}>
        <div
          id="${this.id}"
          data-state="${this.isOpen}"
          data-orientation="horizontal"
          role="menuitem"
          part="menuitem"
          aria-haspopup="menu"
          aria-expanded="${!!this.isOpen}"
          @mouseenter="${this.handleMenuMouseEnter}"
          @mouseleave="${this.handleMenuMouseLeave}"
          @click="${this.toggleMenubar}"
        >
          <div part="button-slot"></div>
        </div>

        <div part="menubar-menu-slot"></div>
      </div>
    `;
	}
};
S([c(), x("design:type", Object)], Si.prototype, "isOpen", void 0), S([c(), x("design:type", Array)], Si.prototype, "uniqueIds", void 0), S([c(), x("design:type", String)], Si.prototype, "selectedMenu", void 0), S([c(), x("design:type", Object)], Si.prototype, "isHovering", void 0), S([o({ type: String }), x("design:type", Object)], Si.prototype, "id", void 0), Si = S([a("rtg-menubar-menu")], Si);
//#endregion
//#region src/components/ui/menubar/menubar-content.ts
var Ci = class extends C {
	constructor(...e) {
		super(...e), this.state = cr, this.id = "", this.side = "bottom", this.isOpen = !1;
	}
	get _menubarMenu() {
		let e = this.parentElement;
		for (; e && !(e instanceof Si);) e = e.parentElement;
		return e;
	}
	get _containerElement() {
		return this.querySelector("div[part=menubar-content]");
	}
	getAttributesToExclude() {
		return ["date-testid"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		requestAnimationFrame(() => {
			this.moveLightDomChildrenInto(this._containerElement);
		});
	}
	connectedCallback() {
		super.connectedCallback(), this.isOpen && document.addEventListener("mousedown", this.handleClickOutside);
	}
	disconnectedCallback() {
		document.removeEventListener("mousedown", this.handleClickOutside), super.disconnectedCallback();
	}
	updated(e) {
		super.updated(e), this.state === "open" ? this.isOpen = !0 : this.isOpen = !1, e.has("isOpen") && (this.isOpen ? document.addEventListener("mousedown", this.handleClickOutside) : document.removeEventListener("mousedown", this.handleClickOutside));
	}
	handleClickOutside(e) {
		let t = this.querySelector("button");
		this && !this.contains(e.target) && !t?.contains(e.target) && (this.isOpen = !1);
	}
	render() {
		return n`
      <div
        class=${N(X.content, this.className)}
        id="${this.id}"
        data-side="${this.side}"
        data-align="start"
        data-state="${this.isOpen}"
        role="menu"
        part="menubar-content"
        aria-orientation="vertical"
        aria-labelledby="${this.id}"
        dir="ltr"
        style="display: ${this.isOpen ? "block" : "none"};"
      ></div>
    `;
	}
};
S([o({
	attribute: "data-state",
	type: String
}), x("design:type", Object)], Ci.prototype, "state", void 0), S([o({ type: String }), x("design:type", Object)], Ci.prototype, "id", void 0), S([o({ type: String }), x("design:type", Object)], Ci.prototype, "side", void 0), S([c(), x("design:type", Object)], Ci.prototype, "isOpen", void 0), Ci = S([a("rtg-menubar-content")], Ci);
//#endregion
//#region src/components/ui/menubar/menubar-group.ts
var wi, Ti = class extends C {
	static {
		wi = this;
	}
	constructor(...e) {
		super(...e), this.heading = "", this._id = "", this._hidden = "";
	}
	static {
		this._counter = 0;
	}
	get _containerElement() {
		return this.querySelector("div[part=menubar-group-slot]");
	}
	getAttributesToExclude() {
		return ["date-testid"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	get identifier() {
		if (this._id !== "") return this._id;
		let e = this.parentElement?.shadowRoot?.querySelector("div[rtgcmd-list]");
		return e ? this._id = `${e.getAttribute("id")}g${wi._counter++}` : this._id = `rtgcmdrxlxg${wi._counter++}`, this._id;
	}
	render() {
		return n`${this._hidden === "true" ? r : n`
          <div
            class=${N(X.group, this.className)}
            id="${this.identifier}"
            role="presentation"
            part="menubar-group"
          >
            <div
              class=${N(X.label)}
              id="${this.identifier}h"
              aria-hidden="true"
            >
              ${this.heading}
            </div>

            <div
              role="group"
              part="menubar-group-slot"
              aria-labelledby="${this.identifier}h"
            ></div>
          </div>
        `}`;
	}
};
S([o({ type: String }), x("design:type", Object)], Ti.prototype, "heading", void 0), S([o({
	attribute: "id",
	type: String
}), x("design:type", Object)], Ti.prototype, "_id", void 0), S([o({
	attribute: "aria-hidden",
	type: String
}), x("design:type", Object)], Ti.prototype, "_hidden", void 0), Ti = wi = S([a("rtg-menubar-group")], Ti);
//#endregion
//#region src/components/ui/menubar/menubar-item.ts
var Ei, Di = class extends C {
	static {
		Ei = this;
	}
	constructor(...e) {
		super(...e), this._id = "", this._hidden = "", this.disabled = !1, this.selected = !1;
	}
	static {
		this._counter = 0;
	}
	get _containerElement() {
		return this.querySelector("div[part=menubar-item]");
	}
	getAttributesToExclude() {
		return ["date-testid"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	get identifier() {
		if (this._id !== "") return this._id;
		let e = this.parentElement?.shadowRoot?.querySelector("div[rtgcmd-group]");
		return e ? this._id = `${e.getAttribute("id")}li${Ei._counter++}` : this._id = `rtgcmdrxgxli${Ei._counter++}`, this._id;
	}
	get value() {
		return this.textContent?.trim() || "";
	}
	handleMouseEvent(e) {
		(e.type === "mouseover" || e.type === "focus") && (this.selected = !0), e.type === "mouseleave" && (this.selected = !1);
	}
	render() {
		return n` ${this._hidden === "true" ? r : n`
          <div
            part="menubar-item"
            class=${N(X.item, this.disabled && "rtg-opacity-menubar-item-opacity-disabled rtg-pointer-events-none", this.className)}
            @mouseover="${this.handleMouseEvent}"
            @mouseleave="${this.handleMouseEvent}"
            @focus="${this.handleMouseEvent}"
            role="option"
            aria-selected="${this.selected}"
            data-selected="${this.selected}"
            data-value="${this.value}"
            id="${this.identifier}"
            aria-hidden="${this.hidden}"
          ></div>
        `}`;
	}
};
S([o({ type: String }), x("design:type", Object)], Di.prototype, "_id", void 0), S([o({
	attribute: "aria-hidden",
	type: String
}), x("design:type", Object)], Di.prototype, "_hidden", void 0), S([o({ type: Boolean }), x("design:type", Object)], Di.prototype, "disabled", void 0), S([
	o({
		attribute: "data-value",
		type: String
	}),
	x("design:type", Object),
	x("design:paramtypes", [])
], Di.prototype, "value", null), S([o({ type: Boolean }), x("design:type", Object)], Di.prototype, "selected", void 0), Di = Ei = S([a("rtg-menubar-item")], Di);
//#endregion
//#region src/components/ui/menubar/menubar-radio-item.ts
var Oi, ki = class extends C {
	static {
		Oi = this;
	}
	constructor(...e) {
		super(...e), this._id = "", this._hidden = "", this.selected = !1, this.checked = !1, this.disabled = !1;
	}
	static {
		this._counter = 0;
	}
	get _containerElement() {
		return this.querySelector("div[part=menubar-radio-item]");
	}
	getAttributesToExclude() {
		return ["date-testid"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	get identifier() {
		if (this._id !== "") return this._id;
		let e = this.parentElement?.shadowRoot?.querySelector("div[rtgcmd-group]");
		return e ? this._id = `${e.getAttribute("id")}li${Oi._counter++}` : this._id = `rtgcmdrxgxli${Oi._counter++}`, this._id;
	}
	get value() {
		return this.textContent?.trim() || "";
	}
	handleMouseEvent(e) {
		(e.type === "mouseover" || e.type === "focus") && (this.selected = !0), e.type === "mouseleave" && (this.selected = !1);
	}
	toggleChecked() {
		this.checked || (this.checked = !0, this.dispatchEvent(new CustomEvent("radio-selected", {
			bubbles: !0,
			composed: !0
		})));
	}
	render() {
		return n`
      <div
        part="menubar-radio-item"
        class=${N(X.radioItem.base, this.disabled && "rtg-opacity-menubar-item-opacity-disabled rtg-pointer-events-none", this.className)}
        @click=${this.toggleChecked}
        @mouseover="${this.handleMouseEvent}"
        @mouseleave="${this.handleMouseEvent}"
        @focus="${this.handleMouseEvent}"
        rtgcmd-item
        role="option"
        aria-selected="${this.selected}"
        data-selected="${this.selected}"
        data-value="${this.value}"
        id="${this.identifier}"
        aria-hidden="${this.hidden}"
      >
        <span class=${N(X.radioItem.indicator)}>
          ${this.checked ? n`<svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class=${N(X.radioItem.icon, "lucide lucide-circle-icon lucide-circle")}
              >
                <circle cx="12" cy="12" r="10" />
              </svg>` : r}
        </span>
      </div>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], ki.prototype, "_id", void 0), S([o({
	attribute: "aria-hidden",
	type: String
}), x("design:type", Object)], ki.prototype, "_hidden", void 0), S([
	o({
		attribute: "data-value",
		type: String
	}),
	x("design:type", Object),
	x("design:paramtypes", [])
], ki.prototype, "value", null), S([o({ type: Boolean }), x("design:type", Object)], ki.prototype, "selected", void 0), S([o({ type: Boolean }), x("design:type", Object)], ki.prototype, "checked", void 0), S([o({ type: Boolean }), x("design:type", Object)], ki.prototype, "disabled", void 0), ki = Oi = S([a("rtg-menubar-radio-item")], ki);
//#endregion
//#region src/components/ui/menubar/menubar-separator.ts
var Ai, ji = class extends C {
	static {
		Ai = this;
	}
	constructor(...e) {
		super(...e), this._id = "", this._hidden = "";
	}
	static {
		this._counter = 0;
	}
	get _containerElement() {
		return this.querySelector("div[part=menubar-separator]");
	}
	getAttributesToExclude() {
		return ["date-testid"];
	}
	createRenderRoot() {
		return this;
	}
	get identifier() {
		if (this._id !== "") return this._id;
		let e = this.parentElement?.querySelector("div[rtgcmd-list]");
		return e ? this._id = `${e.getAttribute("id")}s${Ai._counter++}` : this._id = `rtgcmdrxlxs${Ai._counter++}`, this._id;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`${this._hidden === "true" ? r : n`
          <div
            class=${N(X.separator, this.className)}
            id="${this.identifier}"
            role="separator"
            part="menubar-separator"
            rtgcmd-separator
          ></div>
        `}`;
	}
};
S([o({ type: String }), x("design:type", Object)], ji.prototype, "_id", void 0), S([o({
	attribute: "aria-hidden",
	type: String
}), x("design:type", Object)], ji.prototype, "_hidden", void 0), ji = Ai = S([a("rtg-menubar-separator")], ji);
//#endregion
//#region src/components/ui/menubar/menubar-shortcut.ts
var Mi = class extends C {
	get _containerElement() {
		return this.querySelector("span[part=menubar-shortcut]");
	}
	getAttributesToExclude() {
		return ["date-testid"];
	}
	createRenderRoot() {
		return this.classList = N(X.shortcut), this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <span
        class=${N(X.shortcut, this.className)}
        part="menubar-shortcut"
      >
      </span>
    `;
	}
};
Mi = S([a("rtg-menubar-shortcut")], Mi);
//#endregion
//#region src/components/ui/menubar/menubar-trigger.ts
var Ni = class extends C {
	get _containerElement() {
		return this.querySelector("button[part=menubar-trigger]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	getAttributesToExclude() {
		return ["data-testid"];
	}
	render() {
		return n`
      <button
        class=${N(X.trigger, this.className)}
        type="button"
        role="menuitem"
        part="menubar-trigger"
      ></button>
    `;
	}
};
Ni = S([a("rtg-menubar-trigger")], Ni);
//#endregion
//#region src/components/ui/menubar/menubar.ts
var Pi = class extends C {
	get _containerElement() {
		return this.querySelector("div[part=menubar]");
	}
	getAttributesToExclude() {
		return ["date-testid"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <div
        role="menubar"
        part="menubar"
        class=${N(X.root, this.className)}
        tabindex="0"
        data-orientation="horizontal"
      ></div>
    `;
	}
};
Pi = S([a("rtg-menubar")], Pi);
//#endregion
//#region src/components/ui/navigation-menu/navigation-menu.styles.ts
var Fi = {
	content: [
		"rtg-absolute",
		"rtg-top-navigation-menu-content-space-top",
		"rtg-flex",
		"rtg-justify-center"
	],
	menu: [
		"rtg-relative",
		"rtg-z-10",
		"rtg-flex",
		"rtg-max-w-navigation-menu-space-max-w",
		"rtg-flex-1",
		"rtg-items-center",
		"rtg-justify-center"
	],
	menuList: [
		"rtg-flex",
		"rtg-flex-1",
		"rtg-list-none",
		"rtg-items-center",
		"rtg-justify-center",
		"rtg-space-x-navigation-menu-list-space-x",
		"group"
	],
	menuItem: [
		"rtg-flex",
		"rtg-cursor-pointer",
		"rtg-items-center",
		"rtg-rounded-navigation-menu-item-radius",
		"rtg-bg-navigation-menu-item-color-bg",
		"rtg-py-navigation-menu-list-space-py",
		"rtg-px-navigation-menu-list-space-px",
		"hover:rtg-bg-navigation-menu-item-color-bg-hover"
	],
	menuItemIcon: [
		"lucide",
		"lucide-chevron-down",
		"rtg-relative",
		"rtg-ml-navigation-menu-item-icon-space-ml",
		"rtg-h-navigation-menu-item-icon-space-h",
		"rtg-w-navigation-menu-item-icon-space-w",
		"rtg-transition-transform",
		"rtg-duration-navigation-menu-item-icon-motion-duration"
	],
	link: [
		"rtg-flex",
		"rtg-h-navigation-menu-link-space-h",
		"rtg-bg-navigation-menu-link-color-bg",
		"hover:rtg-bg-navigation-menu-link-color-bg-hover",
		"rtg-rounded-navigation-menu-link-radius",
		"rtg-px-navigation-menu-link-space-px",
		"rtg-py-navigation-menu-link-space-py",
		"rtg-w-navigation-menu-link-space-w",
		"rtg-select-none",
		"rtg-flex-col",
		"rtg-justify-end",
		"rtg-no-underline",
		"rtg-outline-none"
	],
	contentContainer: [
		"rtg-bg-navigation-menu-content-container-color-bg",
		"origin-top-center",
		"rtg-relative",
		"rtg-mt-navigation-menu-content-container-space-mt",
		"rtg-w-navigation-menu-content-container-space-w",
		"rtg-overflow-hidden",
		"rtg-rounded-navigation-menu-content-container-radius",
		"rtg-border-navigation-menu-content-container-width-border",
		"rtg-border-navigation-menu-content-container-color-border",
		"rtg-navigation-menu-content-container-shadow"
	]
}, Ii = class extends C {
	get _containerElement() {
		return this.querySelector("ul[part=navigation-menu-list]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <div class="${N("relative", this.className)}">
        <ul
          part="navigation-menu-list"
          data-orientation="horizontal"
          class=${N(Fi.menuList)}
          dir="ltr"
        ></ul>
        <div></div>
      </div>
    `;
	}
};
Ii = S([a("rtg-navigation-menu-list")], Ii);
//#endregion
//#region src/components/ui/navigation-menu/navigation-menu-item.ts
var Li = class extends C {
	constructor(...e) {
		super(...e), this.value = "", this.navigationLink = !0, this.isOpen = !1, this.uniqueIds = [], this.isHovering = !1, this.handleClickOutside = (e) => {
			let t = e.target;
			this.contains(t) || (this.isOpen = !1);
		};
	}
	raiseEvent() {
		let e = new CustomEvent("unique-ids-generated", {
			detail: { ids: this.uniqueIds },
			bubbles: !0,
			composed: !0
		});
		this.dispatchEvent(e);
	}
	firstUpdated() {
		this.moveLightDomChildrenInto(this.querySelector("div[part=content-slot]"), [this._content]), this.moveLightDomChildrenInto(this.querySelector("div[part=button-slot]"), [this._button]);
	}
	closeAllMenus() {
		document.querySelectorAll("rtg-navigation-menu-item").forEach((e) => {
			e.isOpen = !1, e.isHovering = !1;
		});
	}
	toggleMenubar(e) {
		e.stopPropagation(), document.querySelectorAll("rtg-navigation-menu-item").forEach((e) => {
			e !== this && (e.isOpen = !1);
		}), this.isOpen = !this.isOpen;
	}
	get _content() {
		return this.querySelector("rtg-navigation-menu-content");
	}
	get _button() {
		return this.querySelector("rtg-navigation-menu-trigger");
	}
	updated(e) {
		super.updated(e);
		let t = this._content;
		t && (t.dataset.state = this.isOpen ? "open" : "close");
	}
	connectedCallback() {
		super.connectedCallback(), document.addEventListener("click", this.handleClickOutside);
	}
	disconnectedCallback() {
		document.removeEventListener("click", this.handleClickOutside), super.disconnectedCallback();
	}
	handleHover() {
		this.closeAllMenus(), this.isHovering || (this.isHovering = !0, this.isOpen = !0);
	}
	handleMouseLeave() {
		this.isHovering = !1, this.isOpen = !1;
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <li
        @mouseenter="${this.handleHover}"
        @mouseleave="${this.handleMouseLeave}"
        part="navigation-menu-item"
        class="${N("rtg-relative", this.className)}"
      >
        ${this.navigationLink ? n`<div
                class=${N(Fi.menuItem)}
                @click="${this.toggleMenubar}"
              >
                <div part="button-slot"></div>
                ${this.navigationLink ? n`<svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class=${N(Fi.menuItemIcon, this.isOpen ? "rtg-rotate-180" : "")}
                      aria-hidden="true"
                    >
                      <path d="m6 9 6 6 6-6"></path>
                    </svg>` : r}
              </div>
              <div part="content-slot" style="position:absolute"></div>` : ""}
      </li>
    `;
	}
};
S([o({ type: String }), x("design:type", String)], Li.prototype, "value", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], Li.prototype, "navigationLink", void 0), S([c(), x("design:type", Object)], Li.prototype, "isOpen", void 0), S([c(), x("design:type", Array)], Li.prototype, "uniqueIds", void 0), S([c(), x("design:type", Object)], Li.prototype, "isHovering", void 0), Li = S([a("rtg-navigation-menu-item")], Li);
//#endregion
//#region src/components/ui/navigation-menu/navigation-menu-content.ts
var Ri = class extends C {
	constructor(...e) {
		super(...e), this.state = "close", this.id = "", this.side = "bottom", this.isOpen = !0;
	}
	get _menubarMenu() {
		let e = this.parentElement;
		for (; e && !(e instanceof Li);) e = e.parentElement;
		return e;
	}
	get _containerElement() {
		return this.querySelector("div[part=navigation-menu-content-container]");
	}
	getAttributesToExclude() {
		return ["data-testid"];
	}
	connectedCallback() {
		super.connectedCallback(), this.isOpen && document.addEventListener("mousedown", this.handleClickOutside);
	}
	disconnectedCallback() {
		document.removeEventListener("mousedown", this.handleClickOutside), super.disconnectedCallback();
	}
	updated(e) {
		super.updated(e), this.state === "open" ? this.isOpen = !0 : this.isOpen = !1, e.has("isOpen") && (this.isOpen ? document.addEventListener("mousedown", this.handleClickOutside) : document.removeEventListener("mousedown", this.handleClickOutside));
	}
	handleClickOutside(e) {
		let t = this.querySelector("button");
		this && !this.contains(e.target) && !t?.contains(e.target) && (this.isOpen = !1);
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		requestAnimationFrame(() => {
			this.moveLightDomChildrenInto(this._containerElement);
		});
	}
	render() {
		return n`
      <div
        class="${N(Fi.content, this.className)}"
        style="display: ${this.isOpen ? "block" : "none"};top:0px;left:0px;"
        part="navigation-menu-content"
      >
        <div
          data-state="${this.isOpen}"
          data-orientation="horizontal"
          class="${N(Fi.contentContainer, this.className)}"
        >
          <div
            id="${this.id}"
            aria-labelledby="${this.id}"
            data-orientation="horizontal"
            dir="ltr"
            part="navigation-menu-content-container"
          ></div>
        </div>
      </div>
    `;
	}
};
S([o({
	attribute: "data-state",
	type: String
}), x("design:type", Object)], Ri.prototype, "state", void 0), S([o({ type: String }), x("design:type", Object)], Ri.prototype, "id", void 0), S([o({ type: String }), x("design:type", Object)], Ri.prototype, "side", void 0), S([c(), x("design:type", Object)], Ri.prototype, "isOpen", void 0), Ri = S([a("rtg-navigation-menu-content")], Ri);
//#endregion
//#region src/components/ui/navigation-menu/navigation-menu-link.ts
var zi = class extends C {
	constructor(...e) {
		super(...e), this.href = "/";
	}
	get _containerElement() {
		return this.querySelector("a[part=navigation-menu-link]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <a
        part="navigation-menu-link"
        class="${N(Fi.link, this.className)}"
        href="${this.href}"
        data-radix-collection-item=""
        data-tabindex=""
        tabindex="-1"
      >
      </a>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], zi.prototype, "href", void 0), zi = S([a("rtg-navigation-menu-link")], zi);
//#endregion
//#region src/components/ui/navigation-menu/navigation-menu-trigger.ts
var Bi = class extends C {
	get _containerElement() {
		return this.querySelector("div[part=navigation-menu-trigger]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	getAttributesToExclude() {
		return ["data-testid"];
	}
	render() {
		return n`
      <div part="navigation-menu-trigger" class="${N(this.className)}"></div>
    `;
	}
};
Bi = S([a("rtg-navigation-menu-trigger")], Bi);
//#endregion
//#region src/components/ui/navigation-menu/navigation-menu.ts
var Vi = class extends C {
	get _containerElement() {
		return this.querySelector("nav[part=navigation-menu]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {}
	render() {
		return n`
      <nav
        part="navigation-menu"
        aria-label="Main"
        data-orientation="horizontal"
        dir="ltr"
        class="${N(Fi.menu, this.className)}"
      ></nav>
    `;
	}
};
Vi = S([a("rtg-navigation-menu")], Vi);
//#endregion
//#region src/components/ui/pagination/pagination.styles.ts
var Hi = {
	root: [
		"rtg-flex",
		"rtg-justify-center",
		"rtg-mx-auto",
		"rtg-w-full"
	],
	content: ["rtg-flex", "rtg-flex-row rtg-gap-pagination-content-space-gap rtg-items-center"],
	item: [""],
	link: Pt,
	previous: {
		base: ["rtg-gap-pagination-previous-space-gap", "rtg-px-pagination-previous-space-px sm:rtg-pl-pagination-previous-space-px"],
		span: ["rtg-hidden sm:rtg-block"]
	},
	next: {
		base: ["rtg-gap-pagination-next-space-gap", "rtg-px-pagination-next-space-px sm:rtg-pr-pagination-next-space-px"],
		span: ["rtg-hidden sm:rtg-block"]
	},
	ellipsis: {
		base: ["rtg-flex rtg-justify-center rtg-items-center", "rtg-size-pagination-ellipsis-space-size"],
		icon: ["rtg-size-pagination-ellipsis-icon-space-size"],
		span: ["rtg-sr-only"]
	}
}, Ui = class extends C {
	get _containerElement() {
		return this.querySelector("ul[part=pagination-content]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <ul
        data-slot="pagination-content"
        part="pagination-content"
        class=${N(Hi.content, this.className)}
      ></ul>
    `;
	}
};
Ui = S([a("rtg-pagination-content")], Ui);
//#endregion
//#region src/components/ui/pagination/pagination-ellipsis.ts
var Wi = class extends C {
	get _containerElement() {
		return this.querySelector("span[part=pagination-ellipsis]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <span
        aria-hidden
        data-slot="pagination-ellipsis"
        part="pagination-ellipsis"
        class=${N(Hi.ellipsis.base, this.className)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class=${N(Hi.ellipsis.icon, "lucide lucide-ellipsis-icon lucide-ellipsis")}
        >
          <circle cx="12" cy="12" r="1" />
          <circle cx="19" cy="12" r="1" />
          <circle cx="5" cy="12" r="1" />
        </svg>

        <span class=${N(Hi.ellipsis.span)}>More pages</span>
      </span>
    `;
	}
};
Wi = S([a("rtg-pagination-ellipsis")], Wi);
//#endregion
//#region src/components/ui/pagination/pagination-link.ts
var Gi = class extends C {
	constructor(...e) {
		super(...e), this.state = "close", this.isActive = !1, this.size = "icon", this.href = "javascript:void(0)";
	}
	get _containerElement() {
		return this.querySelector("a[part=pagination-link]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	updated(e) {
		super.updated(e), this.state === "open" ? this.isActive = !0 : this.isActive = !1;
	}
	render() {
		return n`
      <a
        aria-current=${this.isActive ? "page" : void 0}
        data-slot="pagination-link"
        data-state=${this.isActive}
        part="pagination-link"
        id="${this.id}"
        href="${this.href}"
        class=${N(Hi.link({
			variant: this.isActive ? "outline" : "ghost",
			size: this.size
		}), this.className)}
      >
      </a>
    `;
	}
};
S([o({
	attribute: "data-state",
	type: String
}), x("design:type", Object)], Gi.prototype, "state", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], Gi.prototype, "isActive", void 0), S([o({ type: String }), x("design:type", typeof Exclude > "u" ? Object : Exclude)], Gi.prototype, "size", void 0), S([o({ type: String }), x("design:type", String)], Gi.prototype, "href", void 0), Gi = S([a("rtg-pagination-link")], Gi);
//#endregion
//#region src/components/ui/pagination/pagination-item.ts
var Ki = class extends C {
	constructor(...e) {
		super(...e), this.uniqueIds = [], this.isActive = !1;
	}
	get _containerElement() {
		return this.querySelector("li[part=pagination-item]");
	}
	get _content() {
		let e = this._containerElement?.children;
		if (e) {
			for (let t = 0; t < e.length; t++) if (e[t] instanceof Gi) return e[t];
		}
		return null;
	}
	updated(e) {
		super.updated(e);
		let t = this._content;
		t && (t.dataset.state = this.isActive ? "open" : "close");
	}
	handleClick(e) {
		e.stopPropagation(), document.querySelectorAll("rtg-pagination-item").forEach((e) => {
			e !== this && (e.isActive = !1);
		}), this.isActive = !this.isActive;
	}
	firstUpdated() {
		this.moveLightDomChildrenInto(this._containerElement);
		let e = this._containerElement?.children, t = [];
		for (let n = 0; n < e.length - 1; n += 1) {
			let r = e[n], i = crypto.randomUUID();
			t.push(i), r.dataset.pairId = i;
		}
		this.uniqueIds = t, this._content && this._content.removeEventListener("unique-ids-generated", () => {
			this.requestUpdate();
		});
	}
	raiseEvent() {
		let e = new CustomEvent("unique-ids-generated", {
			detail: { ids: this.uniqueIds },
			bubbles: !0,
			composed: !0
		});
		this.dispatchEvent(e);
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <li
        data-slot="pagination-item"
        part="pagination-item"
        class=${N(Hi.item, this.className)}
        @click="${this.handleClick}"
      ></li>
    `;
	}
};
S([c(), x("design:type", Array)], Ki.prototype, "uniqueIds", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], Ki.prototype, "isActive", void 0), Ki = S([a("rtg-pagination-item")], Ki);
//#endregion
//#region src/components/ui/pagination/pagination-next.ts
var qi = class extends C {
	constructor(...e) {
		super(...e), this.href = "javascript:void(0)";
	}
	get _containerElement() {
		return this.querySelector("div[part=pagination-next]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <rtg-pagination-link
        aria-label="Go to next page"
        size="default"
        href=${this.href}
        class=${N(Hi.next.base, this.className)}
      >
        <span class=${N(Hi.next.span)}>Next</span>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-chevron-right-icon lucide-chevron-right"
        >
          <path d="m9 18 6-6-6-6" />
        </svg>

        <div part="pagination-next"></div>
      </rtg-pagination-link>
    `;
	}
};
S([o({ type: String }), x("design:type", String)], qi.prototype, "href", void 0), qi = S([a("rtg-pagination-next")], qi);
//#endregion
//#region src/components/ui/pagination/pagination-previous.ts
var Ji = class extends C {
	constructor(...e) {
		super(...e), this.href = "javascript:void(0)";
	}
	get _containerElement() {
		return this.querySelector("div[part=pagination-previous]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <rtg-pagination-link
        aria-label="Go to previous page"
        size="default"
        href=${this.href}
        class=${N(Hi.previous.base, this.className)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-chevron-left-icon lucide-chevron-left"
        >
          <path d="m15 18-6-6 6-6" />
        </svg>

        <span class=${N(Hi.previous.span)}>Previous</span>

        <div part="pagination-previous"></div>
      </rtg-pagination-link>
    `;
	}
};
S([o({ type: String }), x("design:type", String)], Ji.prototype, "href", void 0), Ji = S([a("rtg-pagination-previous")], Ji);
//#endregion
//#region src/components/ui/pagination/pagination.ts
var Yi = class extends C {
	get _containerElement() {
		return this.querySelector("nav[part=pagination]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <nav
        role="navigation"
        aria-label="pagination"
        data-slot="pagination"
        part="pagination"
        class=${N(Hi.root, this.className)}
      ></nav>
    `;
	}
};
Yi = S([a("rtg-pagination")], Yi);
//#endregion
//#region src/components/ui/password-input/_password-input.ts
var Z = class extends e {
	constructor(...e) {
		super(...e), this.id = "", this._showPassword = !1, this._handleToggle = () => {
			this._showPassword = !this._showPassword;
		};
	}
	createRenderRoot() {
		return this;
	}
	updated(e) {
		e.has("id") && (this.id && (this._inputId = this.id), this.removeAttribute("id"));
	}
	firstUpdated() {
		this._inputId = this.id, this.removeAttribute("id");
	}
	_renderIcon() {
		return this._showPassword ? n`
        <svg
          data-slot="password-input-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-eye-icon lucide-eye"
        >
          <path
            d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"
          />
          <circle cx="12" cy="12" r="3" />
        </svg>
      ` : n`
      <svg
        data-slot="password-input-icon"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="lucide lucide-eye-off-icon lucide-eye-off"
      >
        <path
          d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49"
        />
        <path d="M14.084 14.158a3 3 0 0 1-4.242-4.242" />
        <path
          d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143"
        />
        <path d="m2 2 20 20" />
      </svg>
    `;
	}
	render() {
		return n`
      <rtg-input-group
        data-slot="password-input"
        data-state=${this._showPassword ? "show" : "hide"}
      >
        <rtg-input-group-input
          data-slot="password-input-input"
          .autocomplete=${this.autocomplete}
          ?disabled=${this.disabled}
          .form=${this.form}
          id=${this._inputId && this._inputId !== "" ? this._inputId : r}
          ?invalid=${this.invalid}
          .maxlength=${this.maxlength}
          .minlength=${this.minlength}
          .name=${this.name}
          .pattern=${this.pattern}
          .placeholder=${this.placeholder}
          ?readonly=${this.readonly}
          ?required=${this.required}
          .type=${this._showPassword ? "text" : "password"}
          .value=${this.value}
          .onClick=${this.onClick}
          .onInput=${this.onInput}
          .onChange=${this.onChange}
          .onFocus=${this.onFocus}
          .onBlur=${this.onBlur}
        ></rtg-input-group-input>

        <rtg-input-group-addon
          data-slot="password-input-addon"
          align="inline-end"
        >
          <rtg-input-group-button
            data-slot="password-input-button"
            variant="ghost"
            size="icon-xs"
            ?disabled=${this.disabled}
            aria-label=${this._showPassword ? "Hide password" : "Show password"}
            .onClick=${this._handleToggle}
          >
            ${this._renderIcon()}
          </rtg-input-group-button>
        </rtg-input-group-addon>
      </rtg-input-group>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], Z.prototype, "autocomplete", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], Z.prototype, "disabled", void 0), S([o({ type: String }), x("design:type", String)], Z.prototype, "form", void 0), S([o({ type: String }), x("design:type", Object)], Z.prototype, "id", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], Z.prototype, "invalid", void 0), S([o({ type: Number }), x("design:type", Number)], Z.prototype, "maxlength", void 0), S([o({ type: Number }), x("design:type", Number)], Z.prototype, "minlength", void 0), S([o({ type: String }), x("design:type", String)], Z.prototype, "name", void 0), S([o({ type: String }), x("design:type", String)], Z.prototype, "pattern", void 0), S([o({ type: String }), x("design:type", String)], Z.prototype, "placeholder", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], Z.prototype, "readonly", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], Z.prototype, "required", void 0), S([o({ type: String }), x("design:type", String)], Z.prototype, "value", void 0), S([o({ attribute: !1 }), x("design:type", Function)], Z.prototype, "onClick", void 0), S([o({ attribute: !1 }), x("design:type", Function)], Z.prototype, "onInput", void 0), S([o({ attribute: !1 }), x("design:type", Function)], Z.prototype, "onChange", void 0), S([o({ attribute: !1 }), x("design:type", Function)], Z.prototype, "onFocus", void 0), S([o({ attribute: !1 }), x("design:type", Function)], Z.prototype, "onBlur", void 0), S([c(), x("design:type", Object)], Z.prototype, "_showPassword", void 0), Z = S([a("rtg-password-input")], Z);
//#endregion
//#region src/components/ui/progress/progress.styles.ts
var Xi = {
	root: [
		"rtg-relative rtg-overflow-hidden",
		"rtg-w-progress-space-w rtg-h-progress-space-h",
		"rtg-bg-progress-color-bg",
		"rtg-rounded-progress-radius"
	],
	indicator: [
		"rtg-flex-1",
		"rtg-w-progress-indicator-space-w rtg-h-progress-indicator-space-h",
		"rtg-bg-progress-indicator-color-bg",
		"rtg-transition-all"
	]
}, Zi = class extends e {
	constructor(...e) {
		super(...e), this.value = 15;
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="progress"
        aria-valuenow="${this.value}"
        aria-valuemax="100"
        aria-valuemin="0"
        role="progressbar"
        data-state="indeterminate"
        data-max="100"
        class="${N(Xi.root, this.className)}"
      >
        <div
          data-state="indeterminate"
          data-max="100"
          class="${N(Xi.indicator, this.className)}"
          style="transform: translateX(-${100 - (this.value || 0)}%);"
        ></div>
      </div>
    `;
	}
};
S([o({ type: Number }), x("design:type", Number)], Zi.prototype, "value", void 0), Zi = S([a("rtg-progress")], Zi);
//#endregion
//#region src/components/ui/radio-group/radio-group.styles.ts
var Qi = {
	root: ["rtg-grid", "rtg-gap-radio-group-space-gap"],
	item: {
		wrapper: [
			"rtg-inline-flex",
			"rtg-justify-center rtg-items-center",
			"rtg-size-radio-group-item-space-size"
		],
		item: [
			"rtg-aspect-square",
			"rtg-shrink-0",
			"rtg-size-radio-group-item-space-size",
			"rtg-bg-radio-group-item-color-bg",
			"rtg-rounded-radio-group-item-radius rtg-border-radio-group-item-width-border rtg-border-radio-group-item-color-border rtg-outline-none",
			"rtg-transition-[color,box-shadow]",
			"focus-visible:rtg-border-radio-group-item-color-border-focus focus-visible:rtg-ring-radio-group-item-width-ring-focus focus-visible:rtg-ring-radio-group-item-color-ring-focus",
			"disabled:rtg-opacity-radio-group-item-opacity-disabled disabled:rtg-cursor-not-allowed",
			"aria-invalid:rtg-border-radio-group-item-color-border-invalid aria-invalid:rtg-ring-radio-group-item-width-ring-invalid aria-invalid:rtg-ring-radio-group-item-color-ring-invalid"
		],
		indicator: ["rtg-flex rtg-relative", "rtg-justify-center rtg-items-center"],
		icon: [
			"rtg-absolute rtg-top-1/2 rtg-left-1/2",
			"rtg-size-radio-group-indicator-space-size",
			"rtg--translate-x-1/2 rtg--translate-y-1/2",
			"rtg-fill-radio-group-indicator-color-fill"
		]
	}
}, $i = "unChecked", ea = class extends C {
	constructor(...e) {
		super(...e), this.checked = !1, this.tabindex = 0, this.value = "", this.id = "radio-group-item", this.state = $i, this.disabled = !1, this.invalid = !1;
	}
	get _containerElement() {
		return this.querySelector("button[part=radio-group-item]");
	}
	_onClick(e) {
		e.defaultPrevented || this.checked || (this.checked = !0, this.dispatchEvent(new CustomEvent("radio-selected", {
			bubbles: !0,
			composed: !0
		})));
	}
	createRenderRoot() {
		return this.classList = N(Qi.item.wrapper), this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <button
        type="button"
        part="radio-group-item"
        role="radio"
        aria-checked="${this.checked}"
        aria-invalid=${this.invalid}
        data-state=${this.checked ? "checked" : "unchecked"}
        value="${this.value}"
        ?disabled=${this.disabled}
        @click="${this._onClick}"
        class=${N(Qi.item.item, this.className)}
        id="${this.id}"
        tabindex="${this.tabindex}"
      >
        ${this.checked ? n`<span
              data-slot="radio-group-indicator"
              part="radio-group-indicator"
              class=${N(Qi.item.indicator)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class=${N(Qi.item.icon, "lucide lucide-circle-icon lucide-circle")}
              >
                <circle cx="12" cy="12" r="10" />
              </svg>
            </span>` : r}
      </button>
    `;
	}
};
S([o({
	type: Boolean,
	reflect: !0
}), x("design:type", Object)], ea.prototype, "checked", void 0), S([o({ type: Number }), x("design:type", Object)], ea.prototype, "tabindex", void 0), S([o({ type: String }), x("design:type", Object)], ea.prototype, "value", void 0), S([o({ type: String }), x("design:type", Object)], ea.prototype, "id", void 0), S([o({
	attribute: "data-state",
	type: String
}), x("design:type", Object)], ea.prototype, "state", void 0), S([o({ type: Boolean }), x("design:type", Object)], ea.prototype, "disabled", void 0), S([o({
	attribute: "aria-invalid",
	type: Boolean
}), x("design:type", Object)], ea.prototype, "invalid", void 0), ea = S([a("rtg-radio-group-item")], ea);
//#endregion
//#region src/components/ui/radio-group/radio-group.ts
var ta = class extends C {
	constructor(...e) {
		super(...e), this.defaultValue = "";
	}
	get _containerElement() {
		return this.querySelector("div[part=radio-group]");
	}
	connectedCallback() {
		super.connectedCallback(), this.addEventListener("radio-selected", this._handleRadioSelected);
	}
	_handleRadioSelected(e) {
		this.querySelectorAll("rtg-radio-group-item").forEach((t) => {
			t !== e.target && (t.checked = !1);
		});
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return this.querySelectorAll("rtg-radio-group-item").forEach((e) => {
			e.checked = e.value == this.defaultValue;
		}), n`
      <div
        part="radio-group"
        class=${N(Qi.root, this.className)}
      ></div>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], ta.prototype, "defaultValue", void 0), ta = S([a("rtg-radio-group")], ta);
//#endregion
//#region src/components/ui/scroll-area/scroll-area.style.ts
var na = [
	"rtg-relative",
	"rtg-border rtg-border-scrollarea-color-border",
	"rtg-bg-scrollarea-color-bg"
], ra = class extends C {
	createRenderRoot() {
		return this;
	}
	firstUpdated() {
		this.moveLightDomChildrenInto(this.viewportEl);
	}
	render() {
		return n`
      <div
        dir="ltr"
        data-slot="scroll-area"
        class=${N(na, this.className)}
      >
        <style>
          [data-radix-scroll-area-viewport] {
            -webkit-overflow-scrolling: touch;
          }

          /* Webkit scrollbar (Chrome/Safari) */
          [data-radix-scroll-area-viewport]::-webkit-scrollbar {
            width: 0px;
            height: 0px;
          }

          [data-radix-scroll-area-viewport]:hover::-webkit-scrollbar {
            width: var(--sb-sem-width-scrollbar-hover);
          }

          [data-radix-scroll-area-viewport]::-webkit-scrollbar-thumb {
            background-color: hsl(var(--sb-sem-color-border));
            border-radius: var(--sb-sem-radius-indicator);
          }

          [data-radix-scroll-area-viewport]::-webkit-scrollbar-track {
            background: transparent;
          }
        </style>
        <div
          data-radix-scroll-area-viewport
          data-slot="scroll-area-viewport"
          class="rtg-size-full"
          style="overflow: hidden scroll;"
        ></div>
      </div>
    `;
	}
};
S([s("[data-radix-scroll-area-viewport]"), x("design:type", typeof HTMLElement > "u" ? Object : HTMLElement)], ra.prototype, "viewportEl", void 0), ra = S([a("rtg-scroll-area")], ra);
//#endregion
//#region src/components/ui/select/select-controller.ts
var ia = class {
	constructor() {
		this.state = {
			isOpen: !1,
			selectedValue: "",
			selectedText: ""
		}, this.listeners = /* @__PURE__ */ new Set();
	}
	subscribe(e) {
		this.listeners.add(e);
	}
	unsubscribe(e) {
		this.listeners.delete(e);
	}
	notify() {
		this.listeners.forEach((e) => e());
	}
	get isOpen() {
		return this.state.isOpen;
	}
	get selectedValue() {
		return this.state.selectedValue;
	}
	get selectedText() {
		return this.state.selectedText;
	}
	open() {
		this.state.isOpen || (this.state.isOpen = !0, this.notify());
	}
	close() {
		this.state.isOpen && (this.state.isOpen = !1, this.notify());
	}
	toggle() {
		this.state.isOpen = !this.state.isOpen, this.notify();
	}
	select(e, t, n) {
		this.state.selectedValue = e, this.state.selectedText = t, this.state.isOpen = !1, this.notify();
	}
}, aa = {
	root: [""],
	group: [""],
	value: [
		"rtg-flex",
		"rtg-gap-select-value-space-gap rtg-items-center",
		"rtg-line-clamp-1"
	],
	trigger: {
		trigger: [
			"rtg-flex",
			"rtg-gap-select-trigger-space-gap rtg-justify-between rtg-items-center",
			"rtg-px-select-trigger-space-px rtg-py-select-trigger-space-py",
			"rtg-w-full rtg-h-select-trigger-space-h",
			"rtg-text-select-trigger-font rtg-whitespace-nowrap",
			"rtg-bg-select-trigger-color-bg",
			"rtg-rounded-select-trigger-radius rtg-border-select-trigger-width-border rtg-border-select-trigger-color-border rtg-outline-none",
			"rtg-transition-[color,box-shadow]",
			"hover:rtg-bg-select-trigger-color-bg-hover",
			"focus-visible:rtg-border-select-trigger-color-border-focus focus-visible:rtg-ring-select-trigger-width-ring-focus focus-visible:rtg-ring-select-trigger-color-ring-focus",
			"rtg-select-disabled:rtg-opacity-select-trigger-opacity-disabled rtg-select-disabled:rtg-cursor-not-allowed",
			"aria-invalid:rtg-border-select-trigger-color-border-invalid aria-invalid:rtg-ring-select-trigger-width-ring-invalid aria-invalid:rtg-ring-select-trigger-color-ring-invalid",
			"data-[placeholder]:rtg-text-select-trigger-placeholder-color-text"
		],
		icon: [
			"rtg-shrink-0",
			"rtg-size-select-trigger-icon-space-size",
			"rtg-text-select-trigger-icon-color-text",
			"rtg-opacity-select-trigger-icon-opacity",
			"rtg-pointer-events-none"
		]
	},
	content: {
		content: [
			"rtg-fixed rtg-overflow-x-hidden rtg-overflow-y-auto rtg-z-50",
			"rtg-w-fit",
			"rtg-text-select-content-color-text",
			"rtg-bg-select-content-color-bg",
			"rtg-rounded-select-content-radius rtg-border-select-content-width-border rtg-border-select-content-color-border",
			"rtg-shadow-select-content-shadow",
			"rtg-slide-in-from-top-2",
			"rtg-translate-y-1",
			"data-[state=open]:rtg-animate-in data-[state=open]:rtg-fade-in-0 data-[state=open]:rtg-zoom-in-95",
			"data-[state=closed]:rtg-animate-out data-[state=closed]:rtg-fade-out-0 data-[state=closed]:rtg-zoom-out-95"
		],
		viewport: [
			"rtg-p-select-content-viewport-space-p",
			"rtg-w-full",
			"rtg-scroll-my-1"
		]
	},
	label: ["rtg-px-select-label-space-px rtg-py-select-label-space-py", "rtg-text-select-label-font rtg-text-select-label-color-text"],
	item: {
		item: [
			"rtg-flex rtg-relative",
			"rtg-gap-select-item-space-gap rtg-items-center",
			"rtg-pl-select-item-space-pl rtg-pr-select-item-space-pr rtg-py-select-item-space-py",
			"rtg-w-full",
			"rtg-text-select-item-font",
			"rtg-rounded-select-item-radius rtg-outline-hidden",
			"rtg-cursor-default rtg-select-none",
			"hover:rtg-text-select-item-color-text-hover hover:rtg-bg-select-item-color-bg-hover",
			"focus:rtg-text-select-item-color-text-focus focus:rtg-bg-select-item-color-bg-focus",
			"data-[disabled]:rtg-opacity-select-item-opacity-disabled data-[disabled]:rtg-pointer-events-none"
		],
		indicator: [
			"rtg-flex rtg-absolute rtg-right-2",
			"rtg-justify-center rtg-items-center",
			"rtg-size-select-item-indicator-space-size"
		],
		icon: [
			"rtg-shrink-0",
			"rtg-size-select-item-icon-space-size",
			"rtg-text-select-item-icon-color-text",
			"rtg-pointer-events-none"
		]
	},
	separator: [
		"rtg-mx-select-separator-space-mx rtg-my-select-separator-space-my",
		"rtg-h-select-separator-space-h",
		"rtg-bg-select-separator-color-bg",
		"rtg-pointer-events-none"
	]
}, oa = class extends C {
	constructor(...e) {
		super(...e), this.uuid = w(), this.selectStore = new ia(), this.value = "", this.disabled = !1, this.handleClickOutside = (e) => {
			let t = this.querySelector("[data-select-uuid]"), n = e.target;
			t?.contains(n) || this.selectStore.close();
		};
	}
	updated(e) {
		super.updated(e), e.has("value") && this.value !== this.selectStore.selectedValue && this.syncValueToStore();
	}
	connectedCallback() {
		super.connectedCallback(), document.addEventListener("mousedown", this.handleClickOutside);
	}
	disconnectedCallback() {
		document.removeEventListener("mousedown", this.handleClickOutside), super.disconnectedCallback();
	}
	firstUpdated() {
		let e = this.querySelector("div[part=select]");
		this.moveLightDomChildrenInto(e), this.syncValueToStore();
	}
	syncValueToStore() {
		if (this.value) {
			let e = this.querySelector(`rtg-select-item[value="${this.value}"]`)?.textContent?.trim() || this.value;
			this.selectStore.select(this.value, e);
		} else this.selectStore.select("", "");
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="select"
        data-select-uuid=${this.uuid}
        class=${N(aa.root, this.className)}
      ></div>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], oa.prototype, "value", void 0), S([o({
	type: Boolean,
	reflect: !0
}), x("design:type", Object)], oa.prototype, "disabled", void 0), oa = S([a("rtg-select")], oa);
//#endregion
//#region src/components/ui/select/select-group.ts
var sa = class extends C {
	constructor(...e) {
		super(...e), this.focusedIndex = 0, this._dropdownStyle = {
			display: "none",
			top: "0px",
			left: "0px",
			minWidth: "128px"
		}, this.childrenArray = [], this._handleScrollResize = () => {
			this._select.selectStore.isOpen && this._updateDropdownPosition();
		}, this.onStoreChange = () => {
			let e = this._containerElement;
			e && (e.style.display = this._select.selectStore.isOpen ? "block" : "none"), this._select.selectStore.isOpen ? (requestAnimationFrame(() => {
				this._updateDropdownPosition();
			}), window.addEventListener("scroll", this._handleScrollResize, !0), window.addEventListener("resize", this._handleScrollResize)) : (window.removeEventListener("scroll", this._handleScrollResize, !0), window.removeEventListener("resize", this._handleScrollResize), this._dropdownStyle = {
				...this._dropdownStyle,
				display: "none"
			}), this._select.selectStore.isOpen && this._select.selectStore.selectedValue && (this.focusedIndex = this.childrenArray.findIndex((e) => e.value === this._select.selectStore.selectedValue)), this.updateFocusedItem(), this.requestUpdate();
		}, this.handleKeyDown = (e) => {
			if (this._select.selectStore.isOpen) switch (e.preventDefault(), e.key) {
				case "ArrowDown":
					this.focusedIndex = (this.focusedIndex + 1) % this.childrenArray.length, this.updateFocusedItem();
					break;
				case "ArrowUp":
					this.focusedIndex = (this.focusedIndex - 1 + this.childrenArray.length) % this.childrenArray.length, this.updateFocusedItem();
					break;
				case "Enter":
					let e = this.childrenArray[this.focusedIndex], t = e.value, n = e.textContent?.trim() || "";
					this._select.selectStore.select(t, n);
					break;
			}
		};
	}
	get _select() {
		let e = this.parentElement;
		for (; e && !(e instanceof oa);) e = e.parentElement;
		return e;
	}
	connectedCallback() {
		super.connectedCallback(), this._select.selectStore.subscribe(this.onStoreChange), document.addEventListener("keydown", this.handleKeyDown);
	}
	disconnectedCallback() {
		this._select.selectStore.unsubscribe(this.onStoreChange), document.removeEventListener("keydown", this.handleKeyDown), window.removeEventListener("scroll", this._handleScrollResize, !0), window.removeEventListener("resize", this._handleScrollResize), super.disconnectedCallback();
	}
	getTriggerButton() {
		let e = this._select;
		return e ? e.querySelector("button[part=select-trigger]") : null;
	}
	_updateDropdownPosition() {
		let e = this.getTriggerButton();
		if (!e) return;
		let t = e.getBoundingClientRect(), n = Math.max(128, t.width);
		this._dropdownStyle = {
			display: this._select.selectStore.isOpen ? "block" : "none",
			top: `${t.bottom}px`,
			left: `${t.left}px`,
			minWidth: `${n}px`
		};
	}
	get _containerElement() {
		return this.querySelector("div[part=select-viewport]");
	}
	firstUpdated() {
		let e = Array.from(this.children).filter((e) => e.tagName.toLowerCase() === "rtg-select-item");
		this.childrenArray = e, e.forEach((e, t) => {
			e.tabIndex = t, e.selectItemIndex = t, e.isFocus = t === this.focusedIndex || e.value === this._select.selectStore.selectedValue, e.addEventListener("mouseover", (e) => this.handleMouseOver(e, t));
		}), this.moveLightDomChildrenInto(this._containerElement), this._select.selectStore.isOpen && requestAnimationFrame(() => {
			this._updateDropdownPosition();
		});
	}
	updateFocusedItem() {
		this.childrenArray.forEach((e, t) => {
			e.isFocus = t === this.focusedIndex, e.requestUpdate?.();
		});
	}
	handleMouseOver(e, t) {
		e.preventDefault(), this.focusedIndex = t;
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="select-group"
        data-slot="select-content"
        class="${N(aa.content.content, this.className)}"
        style="${g(this._dropdownStyle)}"
      >
        <div
          part="select-viewport"
          class="${N(aa.content.viewport)}"
        ></div>
      </div>
    `;
	}
};
S([c(), x("design:type", Object)], sa.prototype, "focusedIndex", void 0), S([c(), x("design:type", Object)], sa.prototype, "_dropdownStyle", void 0), sa = S([a("rtg-select-group")], sa);
//#endregion
//#region src/components/ui/select/select-item.ts
var ca = class extends C {
	constructor(...e) {
		super(...e), this.value = "", this.isSelected = !1, this.isFocus = !1, this.selectItemIndex = -1, this.onSelect = (e, t) => {}, this.class = "", this._onStoreChange = () => {
			this.isSelected = this.value.toLowerCase() === this._select.selectStore.selectedValue?.toLowerCase?.(), this.requestUpdate();
		}, this.handleClick = (e) => {
			e.stopPropagation();
			let t = this.getTextContent();
			this._select.selectStore.select(this.value, t), this.onSelect(this.value, this.selectItemIndex), this.dispatchEvent(new CustomEvent("change", {
				detail: { value: this.value },
				bubbles: !0,
				composed: !0
			}));
		};
	}
	get _select() {
		let e = this.parentElement;
		for (; e && !(e instanceof oa);) e = e.parentElement;
		return e;
	}
	connectedCallback() {
		super.connectedCallback(), this._select.selectStore.subscribe(this._onStoreChange);
	}
	disconnectedCallback() {
		this._select.selectStore.unsubscribe(this._onStoreChange), super.disconnectedCallback();
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	get _containerElement() {
		return this.querySelector("div[part=select-item-container]");
	}
	createRenderRoot() {
		return this;
	}
	getTextContent() {
		let e = this._containerElement;
		if (e && e.textContent) return e.textContent.trim();
		let t = this.querySelector("[part=select-item-indicator]"), n = this.cloneNode(!0);
		return t && n.querySelector("[part=select-item-indicator]")?.remove(), n.textContent?.trim() || "";
	}
	render() {
		return n`
      <div
        ${P(this.getFilteredAttributes())}
        part="select-item"
        @click=${this.handleClick}
        class=${N(aa.item.item, this.className)}
        data-hs-select-value=${this.value}
        aria-selected="${this.isSelected}"
        data-selected="${this.isSelected}"
      >
        ${this.isSelected ? n`
              <span
                part="select-item-indicator"
                class=${N(aa.item.indicator)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class=${N(aa.item.icon, "lucide lucide-check-icon lucide-check")}
                >
                  <path d="M20 6 9 17l-5-5" />
                </svg>
              </span>
            ` : ""}

        <div part="select-item-container"></div>
      </div>
    `;
	}
};
S([o(), x("design:type", Object)], ca.prototype, "value", void 0), S([o(), x("design:type", Object)], ca.prototype, "isSelected", void 0), S([o(), x("design:type", Object)], ca.prototype, "isFocus", void 0), S([o(), x("design:type", Object)], ca.prototype, "selectItemIndex", void 0), S([o({ type: Function }), x("design:type", Object)], ca.prototype, "onSelect", void 0), S([o(), x("design:type", Object)], ca.prototype, "class", void 0), ca = S([a("rtg-select-item")], ca);
//#endregion
//#region src/components/ui/select/select-label.ts
var la = class extends C {
	get _containerElement() {
		return this.querySelector("div[part=select-label]");
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="select-label"
        class=${N(aa.label, this.className)}
      ></div>
    `;
	}
};
la = S([a("rtg-select-label")], la);
//#endregion
//#region src/components/ui/select/select-list.ts
var ua = class extends C {
	constructor(...e) {
		super(...e), this.state = cr, this.isOpen = !1;
	}
	get _containerElement() {
		return this.querySelector("div[part=select-list]");
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        part="select-list"
        class="${N("rtg-absolute rtg-z-50 rtg-max-h-72 rtg-w-full rtg-overflow-hidden rtg-overflow-y-auto rtg-rounded-lg rtg-border rtg-border-input rtg-bg-background p-1 [&::-webkit-scrollbar-thumb]:rtg-rounded-full [&::-webkit-scrollbar-thumb]:rtg-bg-accent [&::-webkit-scrollbar-track]:rtg-bg-gray-100 [&::-webkit-scrollbar]:rtg-w-2", this.className)}"
        data-hs-combo-box-output=""
        data-state="${this.state}"
        style="display: ${this.isOpen ? "block" : "none"}; top:115%"
      ></div>
    `;
	}
};
S([o({
	attribute: "data-state",
	type: String
}), x("design:type", Object)], ua.prototype, "state", void 0), S([c(), x("design:type", Object)], ua.prototype, "isOpen", void 0), ua = S([a("rtg-select-list")], ua);
//#endregion
//#region src/components/ui/select/select-seperator.ts
var da = class extends e {
	constructor(...e) {
		super(...e), this._id = "", this._hidden = "";
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div
        rtgcmd-separator
        part="select-separator"
        role="separator"
        class=${N(aa.separator, this.className)}
      ></div>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], da.prototype, "_id", void 0), S([o({
	attribute: "aria-hidden",
	type: String
}), x("design:type", Object)], da.prototype, "_hidden", void 0), da = S([a("rtg-select-separator")], da);
//#endregion
//#region src/components/ui/select/select-trigger.ts
var fa = class extends C {
	constructor(...e) {
		super(...e), this.onStoreChange = () => {
			this.requestUpdate();
		}, this.handleClick = (e) => {
			e.stopPropagation(), !(this._select && this._select.disabled) && this._select && this._select.selectStore.toggle();
		};
	}
	get _select() {
		let e = this.parentElement;
		for (; e && !(e instanceof oa);) e = e.parentElement;
		return e;
	}
	connectedCallback() {
		super.connectedCallback(), this._select.selectStore.subscribe(this.onStoreChange), this.classObserver = new MutationObserver(() => {
			this.requestUpdate();
		}), this.classObserver.observe(this, {
			attributes: !0,
			attributeFilter: ["class"]
		}), this._select && (this.parentObserver = new MutationObserver(() => {
			this.requestUpdate();
		}), this.parentObserver.observe(this._select, {
			attributes: !0,
			attributeFilter: ["disabled"]
		}));
	}
	disconnectedCallback() {
		this._select.selectStore.unsubscribe(this.onStoreChange), this.classObserver?.disconnect(), this.parentObserver?.disconnect();
	}
	get _containerElement() {
		return this.querySelector("span[part=select-trigger-container]");
	}
	firstUpdated(e) {
		super.firstUpdated(e), this.moveLightDomChildrenInto(this._containerElement), this._containerElement?.addEventListener("click", this.handleClick);
	}
	createRenderRoot() {
		return this;
	}
	getAttributesToExclude() {
		return ["data-testid"];
	}
	getClassAttribute() {
		let e = this.getAttribute("class") || "", t = this.customClass || "", n = this.className || "";
		return e || t || n || "";
	}
	filterConflictingWidthClasses(e, t) {
		let n = /rtg-w-[\w-[\]]+/;
		return n.test(t) ? e.map((e) => e.split(/\s+/).filter((e) => !n.test(e)).join(" ")) : e;
	}
	render() {
		let e = this.getClassAttribute(), t = this.filterConflictingWidthClasses(aa.trigger.trigger, e), r = this._select?.disabled || !1;
		return n`
      <button
        type="button"
        part="select-trigger"
        role="tab"
        class=${N(...t, e, r ? "rtg-opacity-select-trigger-opacity-disabled rtg-cursor-not-allowed" : "")}
        tabindex=${r ? "-1" : "0"}
        ?disabled=${r}
        data-orientation="horizontal"
        data-radix-collection-item=""
        ?data-placeholder=${this._select.selectStore.selectedValue.length === 0}
        @click="${this.handleClick}"
      >
        <span part="select-trigger-container"></span>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class=${N(aa.trigger.icon, "lucide lucide-chevron-down-icon lucide-chevron-down")}
        >
          <path d="m6 9 6 6 6-6" />
        </svg>
      </button>
    `;
	}
};
fa = S([a("rtg-select-trigger")], fa);
//#endregion
//#region src/components/ui/select/select-value.ts
var pa = class extends C {
	constructor(...e) {
		super(...e), this.placeholder = "select a value", this.onStoreChange = () => {
			this.requestUpdate();
		}, this.renderLabel = () => {
			let e = this._select?.selectStore;
			return e && e.selectedValue !== void 0 && e.selectedValue !== "" ? e.selectedText || e.selectedValue : this.placeholder;
		};
	}
	get _select() {
		let e = this.parentElement;
		for (; e && !(e instanceof oa);) e = e.parentElement;
		return e;
	}
	connectedCallback() {
		super.connectedCallback(), this._select.selectStore.subscribe(this.onStoreChange), document.addEventListener("clicked-select-item", () => {
			this.requestUpdate();
		});
	}
	disconnectedCallback() {
		this._select.selectStore.unsubscribe(this.onStoreChange);
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <span part="select-value" class=${N(aa.value, this.className)}>
        ${this.renderLabel()}
      </span>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], pa.prototype, "placeholder", void 0), pa = S([a("rtg-select-value")], pa);
//#endregion
//#region src/components/ui/skeleton/skeleton.style.ts
var ma = "rtg-bg-skeleton-color-bg rtg-animate-skeleton-animate rtg-rounded-skeleton-radius", ha = class extends C {
	createRenderRoot() {
		return this;
	}
	render() {
		return n` <div class=${N(ma, this.className)}></div> `;
	}
};
ha = S([a("rtg-skeleton")], ha);
//#endregion
//#region src/components/ui/spinner/_spinner.ts
var ga = class extends e {
	constructor(...e) {
		super(...e), this.variant = "circle";
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return this.variant === "basic" ? n`
        <svg
          data-slot="spinner"
          data-variant="basic"
          role="status"
          aria-label="Loading"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-loader-icon lucide-loader"
        >
          <path d="M12 2v4" />
          <path d="m16.2 7.8 2.9-2.9" />
          <path d="M18 12h4" />
          <path d="m16.2 16.2 2.9 2.9" />
          <path d="M12 18v4" />
          <path d="m4.9 19.1 2.9-2.9" />
          <path d="M2 12h4" />
          <path d="m4.9 4.9 2.9 2.9" />
        </svg>
      ` : this.variant === "pinwheel" ? n`
        <svg
          data-slot="spinner"
          data-variant="pinwheel"
          role="status"
          aria-label="Loading"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-loader-pinwheel-icon lucide-loader-pinwheel"
        >
          <path d="M22 12a1 1 0 0 1-10 0 1 1 0 0 0-10 0" />
          <path d="M7 20.7a1 1 0 1 1 5-8.7 1 1 0 1 0 5-8.6" />
          <path d="M7 3.3a1 1 0 1 1 5 8.6 1 1 0 1 0 5 8.6" />
          <circle cx="12" cy="12" r="10" />
        </svg>
      ` : n`
      <svg
        data-slot="spinner"
        data-variant="circle"
        role="status"
        aria-label="Loading"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="lucide lucide-loader-circle-icon lucide-loader-circle"
      >
        <path d="M21 12a9 9 0 1 1-6.219-8.56" />
      </svg>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], ga.prototype, "variant", void 0), ga = S([a("rtg-spinner")], ga);
//#endregion
//#region src/components/ui/switch/switch.style.ts
var _a = {
	root: [
		"rtg-inline-flex",
		"rtg-shrink-0 rtg-items-center",
		"rtg-w-switch-space-w rtg-h-switch-space-h",
		"rtg-rounded-switch-radius rtg-border-switch-width-border rtg-border-switch-color-border rtg-outline-none",
		"rtg-transition-all",
		"focus-visible:rtg-border-switch-color-border-focus focus-visible:rtg-ring-switch-width-ring-focus focus-visible:rtg-ring-switch-color-ring-focus",
		"data-[state=\"checked\"]:rtg-bg-switch-color-bg-checked data-[state=\"unchecked\"]:rtg-bg-switch-color-bg-unchecked",
		"data-[disabled=\"true\"]:rtg-opacity-switch-opacity-disabled data-[disabled=\"true\"]:rtg-cursor-not-allowed"
	],
	thumb: [
		"rtg-pointer-events-none",
		"rtg-block",
		"rtg-size-switch-thumb-space-size",
		"rtg-rounded-switch-thumb-radius",
		"rtg-ring-0",
		"rtg-transition-transform",
		"data-[state=\"checked\"]:rtg-bg-switch-thumb-color-bg-checked data-[state=\"unchecked\"]:rtg-bg-switch-thumb-color-bg-unchecked",
		"data-[state=\"checked\"]:rtg-translate-x-[calc(100%-2px)] data-[state=\"unchecked\"]:rtg-translate-x-0"
	]
}, va = class extends e {
	constructor(...e) {
		super(...e), this.disabled = "false", this.state = "unchecked";
	}
	_toggleChecked() {
		this.disabled === "false" && (this.state = this.state === "checked" ? "unchecked" : "checked", this.dispatchEvent(new CustomEvent("change", { detail: this.state })));
	}
	createRenderRoot() {
		return this.classList = "rtg-w-switch-space-w rtg-h-switch-space-h", this;
	}
	render() {
		return n`
      <div
        part="switch"
        role="switch"
        data-testid="switch-atom"
        data-disabled=${this.disabled}
        data-state=${this.state}
        @click="${this._toggleChecked}"
        class=${N(_a.root, this.className)}
      >
        <div
          part="switch-thumb"
          data-state=${this.state}
          class=${N(_a.thumb)}
        ></div>
      </div>
    `;
	}
};
S([o({
	attribute: "data-disabled",
	type: String
}), x("design:type", String)], va.prototype, "disabled", void 0), S([o({
	attribute: "data-state",
	type: String
}), x("design:type", String)], va.prototype, "state", void 0), va = S([a("rtg-switch")], va);
//#endregion
//#region src/components/ui/table/table.styles.ts
var Q = {
	preview: ["rtg-flex rtg-bg-table-preview-color-bg rtg-w-table-preview-space-w rtg-items-center rtg-justify-center rtg-px-table-preview-space-px rtg-py-table-preview-space-py"],
	container: ["rtg-relative rtg-w-table-container-space-w rtg-overflow-auto"],
	table: ["rtg-w-table-space-w rtg-caption-bottom rtg-text-table-font"],
	caption: ["rtg-mt-table-caption-space-mt rtg-text-table-caption-font rtg-text-table-caption-color-text"],
	head: {
		root: ["[&_tr]:rtg-border-table-head-color-border [&_tr]:rtg-border-b-table-head-width-border"],
		row: ["rtg-border-b-table-head-width-border rtg-border-table-head-color-border rtg-transition-colors hover:rtg-bg-table-head-row-color-bg-hover"],
		cell: {
			base: ["rtg-h-table-head-cell-space-h rtg-px-table-head-cell-space-px rtg-align-middle rtg-font-table-head-cell-font-weight rtg-text-table-head-cell-color-text"],
			align: {
				left: "rtg-text-left",
				right: "rtg-text-right"
			}
		}
	},
	body: {
		root: ["[&_tr:last-child]:rtg-border-0"],
		row: ["rtg-border-b-table-body-width-border rtg-border-table-body-color-border rtg-transition-colors hover:rtg-bg-table-body-row-color-bg-hover"],
		cell: {
			base: ["rtg-px-table-body-cell-space-px rtg-py-table-body-cell-space-py rtg-align-middle"],
			align: {
				right: "rtg-text-right",
				left: "rtg-text-left"
			}
		}
	},
	footer: {
		root: ["rtg-border-t-table-footer-width-border rtg-border-table-footer-color-border rtg-bg-table-footer-color-bg rtg-font-table-footer-font-weight [&>tr]:rtg-last:border-b-0"],
		row: ["rtg-border-b-table-footer-width-border rtg-border-table-footer-color-border rtg-transition-colors hover:rtg-bg-table-footer-row-color-bg-hover"],
		cell: {
			base: ["rtg-px-table-footer-cell-space-px rtg-py-table-footer-cell-space-py rtg-align-middle"],
			align: {
				right: "rtg-text-right",
				left: "rtg-text-left"
			}
		}
	}
}, ya = class extends C {
	constructor(...e) {
		super(...e), this.dataTable = [], this.footerData = [], this.captionText = "";
	}
	get _containerElement() {
		return this.querySelector("table[part=table]");
	}
	getAttributesToExclude() {
		return ["data-testid"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	get columnKeys() {
		let e = this.dataTable?.[0];
		return e ? Object.keys(e).filter((e) => e !== "id") : [];
	}
	capitalizeLabel(e) {
		return e.charAt(0).toUpperCase() + e.slice(1);
	}
	render() {
		let e = this.columnKeys;
		return n`
      <div class=${N(Q.preview)}>
        <div class=${N(Q.container)}>
          <table part="table" class=${N(Q.table)}>
            ${this.captionText ? n`
                  <caption class=${N(Q.caption)}>
                    ${this.captionText}
                  </caption>
                ` : null}

            <thead class=${N(Q.head.root)}>
              <tr class=${N(Q.head.row)}>
                ${e.map((e, t, r) => {
			let i = t === r.length - 1;
			return n`
                    <th
                      class=${N(Q.head.cell.base, i ? Q.head.cell.align.right : Q.head.cell.align.left)}
                    >
                      ${this.capitalizeLabel(e)}
                    </th>
                  `;
		})}
              </tr>
            </thead>

            <tbody class=${N(Q.body.root)}>
              ${this.dataTable.map((t) => n`
                  <tr
                    data-id=${t.id ?? ""}
                    class=${N(Q.body.row)}
                  >
                    ${e.map((e, r, i) => {
			let a = r === i.length - 1;
			return n`
                        <td
                          class=${N(Q.body.cell.base, a && Q.body.cell.align.right)}
                        >
                          ${t[e] ?? ""}
                        </td>
                      `;
		})}
                  </tr>
                `)}
            </tbody>

            ${this.footerData.length ? n`
                  <tfoot class=${N(Q.footer.root)}>
                    <tr class=${N(Q.footer.row)}>
                      ${e.map((e, t, r) => {
			let i = t === r.length - 1, a = this.footerData.find((t) => t.key === e);
			return n`
                          <td
                            class=${N(Q.footer.cell.base, i && Q.footer.cell.align.right)}
                          >
                            ${a?.value ?? ""}
                          </td>
                        `;
		})}
                    </tr>
                  </tfoot>
                ` : null}
          </table>
        </div>
      </div>
    `;
	}
};
S([o({ type: Array }), x("design:type", typeof Array > "u" ? Object : Array)], ya.prototype, "dataTable", void 0), S([o({ type: Array }), x("design:type", typeof Array > "u" ? Object : Array)], ya.prototype, "footerData", void 0), S([o({ type: String }), x("design:type", String)], ya.prototype, "captionText", void 0), ya = S([a("rtg-table")], ya);
//#endregion
//#region src/components/ui/tabs/tabs.helpers.ts
function ba() {
	return `rtg-${Date.now().toString(36)}${Math.random().toString(36).substring(2, 7)}`;
}
function xa(e, t) {
	return `${e}-trigger-${t}`;
}
function Sa(e, t) {
	return `${e}-content-${t}`;
}
//#endregion
//#region src/components/ui/tabs/_tabs.ts
var Ca = class extends e {
	constructor(...e) {
		super(...e), this._initialSyncDone = !1, this.orientation = "horizontal", this.dir = "ltr", this.activationMode = "automatic", this._baseId = ba(), this._onTriggerSelect = (e) => {
			let t = e.detail.value;
			this._isControlled ? this.onValueChange?.(t) : this._activeValue = t;
		};
	}
	connectedCallback() {
		super.connectedCallback(), this._mutationObserver = new MutationObserver(() => {
			this._sync();
		}), this._mutationObserver.observe(this, {
			childList: !0,
			subtree: !0
		});
	}
	disconnectedCallback() {
		this._mutationObserver?.disconnect(), super.disconnectedCallback();
	}
	createRenderRoot() {
		return this;
	}
	get _rootSlot() {
		return this.querySelector("[data-slot=\"tabs\"]");
	}
	get _list() {
		return this.querySelector("rtg-tabs-list");
	}
	get _triggers() {
		return Array.from(this.querySelectorAll("rtg-tabs-trigger"));
	}
	get _contents() {
		return Array.from(this.querySelectorAll("rtg-tabs-content"));
	}
	get _isControlled() {
		return this.value !== void 0;
	}
	get _currentValue() {
		return this._isControlled ? this.value : this._activeValue;
	}
	_sync() {
		if (!this._rootSlot) return;
		if (this._list?._listSlot) {
			let e = this._list._listSlot;
			e.setAttribute("data-orientation", this.orientation), e.setAttribute("aria-orientation", this.orientation);
		}
		let e = this._triggers, t = this._contents;
		e.length !== 0 && (!this._initialSyncDone && !this._isControlled && !this._activeValue && (this._activeValue = this.defaultValue ?? e[0]?.value, this._initialSyncDone = !0), e.forEach((e) => {
			let n = e._triggerSlot;
			if (!n) return;
			n.setAttribute("data-orientation", this.orientation), n.id ||= xa(this._baseId, e.value);
			let r = e.value === this._currentValue;
			n.setAttribute("data-state", r ? "active" : "inactive"), n.tabIndex = r ? 0 : -1, n.setAttribute("aria-selected", String(r));
			let i = t.find((t) => t.value === e.value);
			i?._contentSlot && (i._contentSlot.id ||= Sa(this._baseId, i.value), i._contentSlot.setAttribute("aria-labelledby", n.id), n.setAttribute("aria-controls", i._contentSlot.id));
		}), t.forEach((e) => {
			let t = e._contentSlot;
			if (!t) return;
			t.setAttribute("data-orientation", this.orientation);
			let n = e.value === this._currentValue;
			t.setAttribute("data-state", n ? "active" : "inactive"), t.toggleAttribute("hidden", !n);
		}));
	}
	async firstUpdated() {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._rootSlot && this._rootSlot?.appendChild(e);
		}), this.addEventListener("rtg-tabs:trigger-select", this._onTriggerSelect), await this.updateComplete, await new Promise((e) => setTimeout(e, 0)), this._sync();
	}
	updated(e) {
		e.has("value") && this._isControlled && (this._activeValue = this.value), this._sync();
	}
	render() {
		return n`
      <div
        data-slot="tabs"
        data-orientation=${this.orientation}
        dir=${this.dir}
      ></div>
    `;
	}
};
S([o({
	attribute: "default-value",
	type: String
}), x("design:type", String)], Ca.prototype, "defaultValue", void 0), S([o({ type: String }), x("design:type", String)], Ca.prototype, "value", void 0), S([o({ attribute: !1 }), x("design:type", Function)], Ca.prototype, "onValueChange", void 0), S([o({ type: String }), x("design:type", Object)], Ca.prototype, "orientation", void 0), S([o({ type: String }), x("design:type", Object)], Ca.prototype, "dir", void 0), S([o({
	attribute: "activation-mode",
	type: String
}), x("design:type", Object)], Ca.prototype, "activationMode", void 0), S([c(), x("design:type", String)], Ca.prototype, "_activeValue", void 0), Ca = S([a("rtg-tabs")], Ca);
//#endregion
//#region src/components/ui/tabs/_tabs-list.ts
var wa = class extends e {
	constructor(...e) {
		super(...e), this.variant = "default";
	}
	createRenderRoot() {
		return this;
	}
	get _listSlot() {
		return this.querySelector("[data-slot=\"tabs-list\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._listSlot && this._listSlot?.appendChild(e);
		});
	}
	render() {
		return n`
      <div
        data-slot="tabs-list"
        data-variant=${this.variant}
        role="tablist"
        tabindex="0"
      ></div>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], wa.prototype, "variant", void 0), wa = S([a("rtg-tabs-list")], wa);
//#endregion
//#region src/components/ui/tabs/_tabs-trigger.ts
var Ta = class extends e {
	constructor(...e) {
		super(...e), this.value = "", this._onClick = () => {
			this._emitSelect();
		}, this._onKeyDown = (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), this._emitSelect());
		};
	}
	createRenderRoot() {
		return this;
	}
	get _triggerSlot() {
		return this.querySelector("[data-slot=\"tabs-trigger\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._triggerSlot && this._triggerSlot?.appendChild(e);
		});
	}
	_emitSelect() {
		this.disabled || this.dispatchEvent(new CustomEvent("rtg-tabs:trigger-select", {
			detail: { value: this.value },
			bubbles: !0
		}));
	}
	render() {
		return n`
      <button
        data-slot="tabs-trigger"
        ?data-disabled=${this.disabled}
        role="tab"
        type="button"
        ?disabled=${this.disabled}
        @click=${this._onClick}
        @keydown=${this._onKeyDown}
      ></button>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], Ta.prototype, "value", void 0), S([o({ type: Boolean }), x("design:type", Boolean)], Ta.prototype, "disabled", void 0), Ta = S([a("rtg-tabs-trigger")], Ta);
//#endregion
//#region src/components/ui/tabs/_tabs-content.ts
var Ea = class extends e {
	constructor(...e) {
		super(...e), this.value = "";
	}
	createRenderRoot() {
		return this;
	}
	get _contentSlot() {
		return this.querySelector("[data-slot=\"tabs-content\"]");
	}
	firstUpdated(e) {
		Array.from(this.childNodes).forEach((e) => {
			e !== this._contentSlot && this._contentSlot?.appendChild(e);
		});
	}
	render() {
		return n`
      <div
        data-slot="tabs-content"
        role="tabpanel"
        tabindex="0"
        hidden
      ></div>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], Ea.prototype, "value", void 0), Ea = S([a("rtg-tabs-content")], Ea);
//#endregion
//#region src/components/ui/toast/toast.style.ts
var Da = {
	viewportRoot: ["rtg-fixed rtg-top-0 rtg-z-[100] rtg-flex rtg-max-h-screen rtg-w-toast-viewport-root-space-w rtg-flex-col-reverse rtg-px-toast-viewport-root-space-px rtg-py-toast-viewport-root-space-py sm:rtg-bottom-0 sm:rtg-right-0 sm:rtg-top-auto sm:rtg-flex-col md:rtg-max-w-toast-viewport-root-space-w-md"],
	viewportItem: {
		base: [
			"group rtg-pointer-events-auto rtg-relative rtg-flex rtg-w-toast-viewport-item-space-w rtg-items-center rtg-justify-between rtg-gap-toast-viewport-item-space-gap rtg-overflow-hidden rtg-rounded-toast-viewport-item-radius rtg-px-toast-viewport-item-space-px rtg-py-toast-viewport-item-space-py rtg-shadow-toast-viewport-item-shadow rtg-transition-all",
			"data-[swipe=cancel]:rtg-translate-x-0",
			"data-[swipe=end]:rtg-translate-x-[var(--radix-toast-swipe-end-x)]",
			"data-[swipe=move]:rtg-translate-x-[var(--radix-toast-swipe-move-x)]",
			"data-[swipe=move]:rtg-transition-none",
			"data-[state=open]:rtg-animate-toast-animate-in",
			"data-[state=closed]:rtg-animate-toast-animate-out",
			"data-[swipe=end]:rtg-animate-toast-animate-out",
			"data-[state=closed]:rtg-opacity-80",
			"data-[state=open]:rtg-translate-y-toast-viewport-item-translate-y-enter-desktop",
			"data-[state=open]:sm:rtg-translate-y-toast-viewport-item-translate-y-enter-mobile",
			"data-[state=closed]:rtg-translate-x-toast-viewport-item-translate-x-exit"
		],
		variants: {
			default: ["rtg-border rtg-border-toast-viewport-default-color-border rtg-bg-toast-viewport-default-color-bg rtg-text-toast-viewport-default-color-text"],
			destructive: ["rtg-bg-toast-viewport-destructive-color-bg rtg-text-toast-viewport-destructive-color-text"]
		}
	},
	action: {
		base: [
			"rtg-text-toast-action-font rtg-font-toast-action-font-weight rtg-text-toast-action-color-text",
			"rtg-h-toast-action-space-h rtg-px-toast-action-space-px rtg-py-toast-action-space-py",
			"rtg-inline-flex rtg-border rtg-border-toast-action-color-border rtg-shrink-0 rtg-items-center rtg-justify-center rtg-rounded-toast-action-radius rtg-transition-colors",
			"focus:rtg-outline-none focus:rtg-ring-toast-action-width-ring-focus focus:rtg-ring-toast-action-color-ring-focus",
			"disabled:rtg-pointer-events-none disabled:rtg-opacity-toast-action-opacity-disabled"
		],
		variants: {
			default: ["rtg-bg-toast-action-default-color-bg hover:rtg-bg-toast-action-default-color-bg-hover"],
			destructive: ["rtg-bg-toast-action-destructive-color-bg hover:rtg-bg-toast-action-destructive-color-bg-hover rtg-text-toast-action-destructive-color-text focus:rtg-ring-toast-action-destructive-color-ring-focus"]
		}
	},
	title: ["rtg-text-toast-title-font rtg-font-toast-title-font-weight [&+div]:rtg-text-toast-title-font"],
	description: ["rtg-text-toast-description-font rtg-opacity-toast-description-opacity"]
}, Oa, ka = "closed", Aa = class extends C {
	static {
		Oa = this;
	}
	constructor(...e) {
		super(...e), this.variant = "default", this.state = ka;
	}
	static {
		this.toastVariants = Da.viewportItem;
	}
	get _containerElement() {
		return this.querySelector("li[part=toast-view-port-li]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n` <ol
      part="toast-view-port"
      tabindex="-1"
      @click="${(e) => e.stopPropagation()}"
      class="${N(Da.viewportRoot, this.className, `${this.state === ka ? "hidden" : "block"}  `)}"
    >
      <li
        part="toast-view-port-li"
        role="status"
        aria-live="off"
        aria-atomic="true"
        tabindex="0"
        data-state="${this.state}"
        data-swipe-direction="right"
        class="${N(Oa.toastVariants.base, Oa.toastVariants.variants[this.variant], this.className)}"
        data-radix-collection-item=""
        style="user-select: none; touch-action: none;"
      ></li>
    </ol>`;
	}
};
S([o({ type: String }), x("design:type", Object)], Aa.prototype, "variant", void 0), S([o({
	attribute: "data-state",
	type: String
}), x("design:type", Object)], Aa.prototype, "state", void 0), Aa = Oa = S([a("rtg-toast-view-port")], Aa);
//#endregion
//#region src/components/ui/toast/toast-action.ts
var ja, Ma = class extends C {
	static {
		ja = this;
	}
	constructor(...e) {
		super(...e), this.variant = "default";
	}
	static {
		this.toastVariants = Da.action;
	}
	get _containerElement() {
		return this.querySelector("button[part=toast-action]");
	}
	getAttributesToExclude() {
		return [
			"click",
			"type",
			"variant"
		];
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	getFilteredAttributes() {
		let e = this.getAttributesToExclude(), t = {};
		for (let n of this.attributes) e.includes(n.name) || (t[n.name] = n.value);
		return t;
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <button
        ${P(this.getFilteredAttributes())}
        part="toast-action"
        type="button"
        class="${N(ja.toastVariants.base, ja.toastVariants.variants[this.variant], this.className, "rtg-w-max")}"
      ></button>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], Ma.prototype, "variant", void 0), Ma = ja = S([a("rtg-toast-action")], Ma);
//#endregion
//#region src/components/ui/toast/toast-description.ts
var Na = class extends C {
	get _containerElement() {
		return this.querySelector("div[part=toast-description]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <div
        class="${N(Da.description, this.className)}"
        part="toast-description"
      >
        <slot></slot>
      </div>
    `;
	}
};
Na = S([a("rtg-toast-description")], Na);
//#endregion
//#region src/components/ui/toast/toast-title.ts
var Pa = class extends C {
	get _containerElement() {
		return this.querySelector("div[part=toast-title]");
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		return n`
      <div
        part="toast-title"
        class="${N(Da.title, this.className)}"
      ></div>
    `;
	}
};
Pa = S([a("rtg-toast-title")], Pa);
//#endregion
//#region src/components/ui/toast/toast-trigger.ts
var Fa = class extends C {
	constructor() {
		super(), this.handleClick = this.handleClick.bind(this);
	}
	get _containerElement() {
		return this.querySelector("div[part=toast-trigger]");
	}
	get _toast() {
		let e = this.parentElement;
		for (; e && !(e instanceof Ia);) e = e.parentElement;
		return e;
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	handleClick(e) {
		e.stopPropagation(), this.dispatchEvent(new CustomEvent("open-toast", { bubbles: !0 })), this._toast.isOpen = !0;
	}
	render() {
		return n`
      <div
        @click=${this.handleClick}
        part="toast-trigger"
        class="${N(this.className)}"
      ></div>
    `;
	}
};
Fa = S([a("rtg-toast-trigger"), x("design:paramtypes", [])], Fa);
//#endregion
//#region src/components/ui/toast/toast.ts
var Ia = class extends C {
	constructor(...e) {
		super(...e), this.isOpen = !1;
	}
	get _containerElement() {
		return this.querySelector("div[part=toast]");
	}
	onClick() {
		this.isOpen = !this.isOpen;
	}
	connectedCallback() {
		super.connectedCallback(), this.addEventListener("close-toast", () => {
			this.isOpen = !1;
		}), this.addEventListener("open-toast", () => {
			this.isOpen = !0;
		});
	}
	get _content() {
		return this.querySelector("rtg-toast-view-port");
	}
	updated(e) {
		super.updated(e);
		let t = this._content;
		t && (t.dataset.state = this.isOpen ? "open" : "closed");
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n` <div class="${N("", this.className)}" part="toast"></div> `;
	}
};
S([c(), x("design:type", Object)], Ia.prototype, "isOpen", void 0), Ia = S([a("rtg-toast")], Ia);
//#endregion
//#region src/components/ui/toggle-group/toggle-group.defs.ts
var La = /* @__PURE__ */ function(e) {
	return e.MULTIPLE = "multiple", e.SINGLE = "single", e;
}({}), Ra = /* @__PURE__ */ function(e) {
	return e.DEFAULT = "default", e.OUTLINE = "outline", e;
}({}), za = /* @__PURE__ */ function(e) {
	return e.SMALL = "sm", e.MEDIUM = "md", e.LARGE = "lg", e;
}({}), Ba = Nt("rtg-inline-flex rtg-items-center rtg-justify-center rtg-rounded-toggle-group-item-radius rtg-text-toggle-group-item-font rtg-font-toggle-group-item-font-weight rtg-transition-colors focus-visible:rtg-outline-none focus-visible:rtg-ring-toggle-group-item-width-ring-focus focus-visible:rtg-ring-toggle-group-item-color-ring-focus focus-visible:rtg-ring-offset-toggle-group-item-width-ring-offset-focus disabled:rtg-pointer-events-none disabled:rtg-opacity-toggle-group-item-opacity-disabled data-[state=on]:rtg-bg-toggle-group-item-color-bg-on data-[state=on]:rtg-text-toggle-group-item-color-text-on rtg-bg-transparent", { variants: {
	variant: {
		default: "hover:rtg-bg-toggle-group-item-default-color-bg-hover hover:rtg-text-toggle-group-item-default-color-text-hover",
		outline: "rtg-border rtg-border-toggle-group-item-outline-color-border hover:rtg-bg-toggle-group-item-outline-color-bg-hover hover:rtg-text-toggle-group-item-outline-color-text-hover"
	},
	size: {
		sm: "rtg-h-toggle-group-item-space-h-sm rtg-px-toggle-group-item-space-px-sm",
		md: "rtg-h-toggle-group-item-space-h-md rtg-px-toggle-group-item-space-px-md",
		lg: "rtg-h-toggle-group-item-space-h-lg rtg-px-toggle-group-item-space-px-lg"
	}
} }), Va = "rtg-flex rtg-items-center rtg-justify-center rtg-gap-toggle-group-space-gap", Ha, Ua = class extends C {
	static {
		Ha = this;
	}
	get _parent() {
		let e = this.parentElement;
		for (; e && !(e instanceof Wa);) e = e.parentElement;
		return e;
	}
	get _containerElement() {
		return this.querySelector("button[part=toggle-group-item]");
	}
	get _siblings() {
		return Array.from(this.parentElement?.children || []).filter((e) => e !== this);
	}
	static {
		this.toggleGroupVariants = Ba;
	}
	getAttributesToExclude() {
		return ["disabled", "type"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.syncFromParent(), this.moveLightDomChildrenInto(this._containerElement);
	}
	constructor() {
		super(), this.checked = !1, this.id = w(), this.variant = Ra.DEFAULT, this.size = za.SMALL, this.disabled = !1, this.type = La.SINGLE, this.variant = Ra.DEFAULT, this.size = za.SMALL;
	}
	syncFromParent() {
		let e = this._parent;
		if (!e) return;
		this.variant !== e.variant && (this.variant = e.variant), this.size !== e.size && (this.size = e.size);
		let t = e.selectedItems.includes(this.id);
		this.checked !== t && (this.checked = t), this.type !== e.type && (this.type = e.type);
	}
	syncSelection() {
		let e = this._parent;
		if (!e) return;
		let t = e.selectedItems.includes(this.id);
		this.checked !== t && (this.checked = t);
	}
	toggleSelection(e) {
		if (this.disabled || !this._parent) return;
		let t = this._parent, n = t.selectedItems.indexOf(e);
		this.type === La.SINGLE ? (n === -1 ? t.selectedItems[0] = e : t.selectedItems.splice(n, 1), this._siblings.forEach((e) => e.syncSelection())) : n === -1 ? t.selectedItems.push(e) : t.selectedItems.splice(n, 1), this.syncSelection();
	}
	render() {
		return console.log({
			variant: this.variant,
			size: this.size,
			className: this.className
		}), _`
      <button
        part="toggle-group-item"
        id=${this.id}
        type="button"
        class="${N(Ha.toggleGroupVariants({
			variant: this.variant,
			size: this.size,
			className: this.className
		}))}"
        aria-pressed=${this.checked}
        data-state="${this.checked ? "on" : "off"}"
        ?disabled=${this.disabled}
        @click=${() => this.toggleSelection(this.id)}
      ></button>
    `;
	}
};
S([o({
	attribute: !0,
	type: Boolean,
	reflect: !0
}), x("design:type", Object)], Ua.prototype, "checked", void 0), S([o({
	attribute: !0,
	type: String,
	reflect: !0
}), x("design:type", Object)], Ua.prototype, "id", void 0), S([o(), x("design:type", Ra === void 0 ? Object : Ra)], Ua.prototype, "variant", void 0), S([o(), x("design:type", za === void 0 ? Object : za)], Ua.prototype, "size", void 0), S([o({ type: Boolean }), x("design:type", Object)], Ua.prototype, "disabled", void 0), S([o({ type: String }), x("design:type", La === void 0 ? Object : La)], Ua.prototype, "type", void 0), Ua = Ha = S([a("rtg-toggle-group-item"), x("design:paramtypes", [])], Ua);
//#endregion
//#region src/components/ui/toggle-group/toggle-group.ts
var Wa = class extends C {
	constructor(...e) {
		super(...e), this.disabled = !1, this.type = La.SINGLE, this.required = !1, this.variant = Ra.DEFAULT, this.size = za.SMALL, this.selectedItems = [];
	}
	get _containerElement() {
		return this.querySelector("div[part=toggle-group]");
	}
	getAttributesToExclude() {
		return [
			"disabled",
			"type",
			"data-testid"
		];
	}
	connectedCallback() {
		super.connectedCallback();
	}
	firstUpdated(e) {
		super.firstUpdated(e), this.moveLightDomChildrenInto(this._containerElement);
	}
	updated(e) {
		(e.has("variant") || e.has("size") || e.has("disabled") || e.has("type")) && this.querySelectorAll("rtg-toggle-group-item").forEach((e) => {
			e.variant = this.variant, e.size = this.size, e.disabled = this.disabled, e.type = this.type;
		});
	}
	createRenderRoot() {
		return this;
	}
	render() {
		let e = this.getFilteredAttributes();
		return console.log({
			variant: this.variant,
			size: this.size,
			className: this.className
		}), _`
      <div
        part="toggle-group"
        role="group"
        ${P(e)}
        class="${N(Va, this.className)}"
        ?disable="${this.disabled}"
      ></div>
    `;
	}
};
S([o({ type: Boolean }), x("design:type", Object)], Wa.prototype, "disabled", void 0), S([o({ type: String }), x("design:type", La === void 0 ? Object : La)], Wa.prototype, "type", void 0), S([o({
	attribute: !0,
	type: Boolean,
	reflect: !0
}), x("design:type", Object)], Wa.prototype, "required", void 0), S([o(), x("design:type", Ra === void 0 ? Object : Ra)], Wa.prototype, "variant", void 0), S([o(), x("design:type", za === void 0 ? Object : za)], Wa.prototype, "size", void 0), S([o({ type: Array }), x("design:type", Array)], Wa.prototype, "selectedItems", void 0), Wa = S([a("rtg-toggle-group")], Wa);
//#endregion
//#region src/components/ui/toggle/toggle.defs.ts
var Ga = /* @__PURE__ */ function(e) {
	return e.SMALL = "sm", e.MEDIUM = "md", e.LARGE = "lg", e;
}({}), Ka = /* @__PURE__ */ function(e) {
	return e.DEFAULT = "default", e.OUTLINE = "outline", e;
}({}), qa = Nt("rtg-inline-flex rtg-items-center rtg-justify-center rtg-rounded-toggle-radius rtg-text-toggle-font rtg-font-toggle-font-weight rtg-transition-colors focus-visible:rtg-outline-none focus-visible:rtg-ring-toggle-width-ring-focus focus-visible:rtg-ring-toggle-color-ring-focus focus-visible:rtg-ring-offset-toggle-width-ring-offset-focus disabled:rtg-pointer-events-none disabled:rtg-opacity-toggle-opacity-disabled data-[state=on]:rtg-bg-toggle-color-bg-on data-[state=on]:rtg-text-toggle-color-text-on rtg-bg-transparent", { variants: {
	variant: {
		default: "hover:rtg-bg-toggle-default-color-bg-hover hover:rtg-text-toggle-default-color-text-hover",
		outline: "rtg-border rtg-border-toggle-outline-color-border hover:rtg-bg-toggle-outline-color-bg-hover hover:rtg-text-toggle-outline-color-text-hover"
	},
	size: {
		sm: "rtg-h-toggle-space-h-sm rtg-px-toggle-space-px-sm",
		md: "rtg-h-toggle-space-h-md rtg-px-toggle-space-px-md",
		lg: "rtg-h-toggle-space-h-lg rtg-px-toggle-space-px-lg"
	}
} }), Ja, Ya = class extends C {
	static {
		Ja = this;
	}
	constructor(...e) {
		super(...e), this.disabled = !1, this.checked = !1, this.required = !1, this.variant = Ka.DEFAULT, this.size = Ga.SMALL;
	}
	willUpdate(e) {
		e.has("variant") && (this.variant = this.normalizeEnum(this.variant, Ka, Ka.DEFAULT)), e.has("size") && (this.size = this.normalizeEnum(this.size, Ga, Ga.SMALL));
	}
	get _containerElement() {
		return this.querySelector("button[part=toggle]");
	}
	static {
		this.toggleVariants = qa;
	}
	getAttributesToExclude() {
		return [
			"disabled",
			"checked",
			"variant",
			"size",
			"required",
			"data-testid"
		];
	}
	toggle() {
		this.disabled || (this.checked = !this.checked);
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this._containerElement);
	}
	render() {
		let e = this.getFilteredAttributes();
		return _`
      <button
        type="button"
        part="toggle"
        class="${N(Ja.toggleVariants({
			variant: this.variant,
			size: this.size,
			className: this.className
		}))}"
        aria-pressed=${this.checked}
        data-state="${this.checked ? "on" : "off"}"
        aria-label="Toggle bold"
        @click=${this.toggle}
        ?required=${this.required}
        ?disabled=${this.disabled}
        ${P(e)}
      ></button>
    `;
	}
};
S([o({ type: Boolean }), x("design:type", Object)], Ya.prototype, "disabled", void 0), S([o({
	attribute: !0,
	type: Boolean,
	reflect: !0
}), x("design:type", Object)], Ya.prototype, "checked", void 0), S([o({
	attribute: !0,
	type: Boolean,
	reflect: !0
}), x("design:type", Object)], Ya.prototype, "required", void 0), S([o({
	attribute: !0,
	type: String
}), x("design:type", Ka === void 0 ? Object : Ka)], Ya.prototype, "variant", void 0), S([o({
	attribute: !0,
	type: String
}), x("design:type", Ga === void 0 ? Object : Ga)], Ya.prototype, "size", void 0), Ya = Ja = S([a("rtg-toggle")], Ya);
//#endregion
//#region src/components/ui/typography/_typography-blockquote.ts
var Xa = class extends e {
	createRenderRoot() {
		return this;
	}
	get _blockquoteSlot() {
		return this.querySelector("[data-slot=\"typography-blockquote\"]");
	}
	firstUpdated() {
		let e = this._blockquoteSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<blockquote data-slot="typography-blockquote"></blockquote>`;
	}
};
Xa = S([a("rtg-typography-blockquote")], Xa);
//#endregion
//#region src/components/ui/typography/_typography-code.ts
var Za = class extends e {
	createRenderRoot() {
		return this;
	}
	get _codeSlot() {
		return this.querySelector("[data-slot=\"typography-code\"]");
	}
	firstUpdated() {
		let e = this._codeSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<code data-slot="typography-code"></code>`;
	}
};
Za = S([a("rtg-typography-code")], Za);
//#endregion
//#region src/components/ui/typography/_typography-h.ts
var Qa = class extends e {
	constructor(...e) {
		super(...e), this.level = "h1";
	}
	createRenderRoot() {
		return this;
	}
	get _hSlot() {
		return this.querySelector("[data-slot=\"typography-h\"]");
	}
	firstUpdated() {
		let e = this._hSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return this.level === "h2" ? n`
        <h2 data-slot="typography-h" data-level="${this.level}"></h2>
      ` : this.level === "h3" ? n`
        <h3 data-slot="typography-h" data-level="${this.level}"></h3>
      ` : this.level === "h4" ? n`
        <h4 data-slot="typography-h" data-level="${this.level}"></h4>
      ` : n`<h1 data-slot="typography-h" data-level="${this.level}"></h1>`;
	}
};
S([o({ type: String }), x("design:type", Object)], Qa.prototype, "level", void 0), Qa = S([a("rtg-typography-h")], Qa);
//#endregion
//#region src/components/ui/typography/_typography-large.ts
var $a = class extends e {
	createRenderRoot() {
		return this;
	}
	get _largeSlot() {
		return this.querySelector("[data-slot=\"typography-large\"]");
	}
	firstUpdated() {
		let e = this._largeSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<div data-slot="typography-large"></div>`;
	}
};
$a = S([a("rtg-typography-large")], $a);
//#endregion
//#region src/components/ui/typography/_typography-lead.ts
var eo = class extends e {
	createRenderRoot() {
		return this;
	}
	get _leadSlot() {
		return this.querySelector("[data-slot=\"typography-lead\"]");
	}
	firstUpdated() {
		let e = this._leadSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<p data-slot="typography-lead"></p>`;
	}
};
eo = S([a("rtg-typography-lead")], eo);
//#endregion
//#region src/components/ui/typography/_typography-list.ts
var to = class extends e {
	createRenderRoot() {
		return this;
	}
	get _listSlot() {
		return this.querySelector("[data-slot=\"typography-list\"]");
	}
	firstUpdated() {
		let e = this._listSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<ul data-slot="typography-list"></ul>`;
	}
};
to = S([a("rtg-typography-list")], to);
//#endregion
//#region src/components/ui/typography/_typography-muted.ts
var no = class extends e {
	createRenderRoot() {
		return this;
	}
	get _mutedSlot() {
		return this.querySelector("[data-slot=\"typography-muted\"]");
	}
	firstUpdated() {
		let e = this._mutedSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<p data-slot="typography-muted"></p>`;
	}
};
no = S([a("rtg-typography-muted")], no);
//#endregion
//#region src/components/ui/typography/_typography-p.ts
var ro = class extends e {
	createRenderRoot() {
		return this;
	}
	get _pSlot() {
		return this.querySelector("[data-slot=\"typography-p\"]");
	}
	firstUpdated() {
		let e = this._pSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<p data-slot="typography-p"></p>`;
	}
};
ro = S([a("rtg-typography-p")], ro);
//#endregion
//#region src/components/ui/typography/_typography-small.ts
var io = class extends e {
	createRenderRoot() {
		return this;
	}
	get _smallSlot() {
		return this.querySelector("[data-slot=\"typography-small\"]");
	}
	firstUpdated() {
		let e = this._smallSlot;
		e && Array.from(this.childNodes).filter((t) => t !== e).forEach((t) => e.appendChild(t));
	}
	render() {
		return n`<small data-slot="typography-small"></small>`;
	}
};
io = S([a("rtg-typography-small")], io);
//#endregion
//#region src/components/ui/typography/_typography-table.ts
var ao = class extends e {
	createRenderRoot() {
		return this;
	}
};
ao = S([a("rtg-typography-table")], ao);
//#endregion
//#region src/components/ui/data-table/data-table.ts
var $ = class extends C {
	constructor(...e) {
		super(...e), this.placeholder = "Filter emails...", this.dataTable = [], this.hasDefaultSelect = !0, this.hasDefaultPagination = !0, this.hasDefaultSearch = !0, this.checkedRows = {}, this.searchTerm = "", this.columnVisibility = {}, this.sortColumn = null, this.sortDirection = "asc", this.cellRenderers = {}, this.rowActions = [], this.paginationLabels = ["Previous", "Next"], this.pageSize = 5, this.currentPage = 1, this.sortableColumns = ["email"], this.columnOrder = [];
	}
	get _chevronDownIcon() {
		return n`
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="lucide lucide-chevron-down rtg-icon-inline-end"
      >
        <path d="m6 9 6 6 6-6"></path>
      </svg>
    `;
	}
	get _ellipsisIcon() {
		return n`
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="lucide lucide-ellipsis"
      >
        <circle cx="12" cy="12" r="1"></circle>
        <circle cx="19" cy="12" r="1"></circle>
        <circle cx="5" cy="12" r="1"></circle>
      </svg>
    `;
	}
	getAttributesToExclude() {
		return ["date-testid"];
	}
	createRenderRoot() {
		return this;
	}
	firstUpdated(e) {
		this.moveLightDomChildrenInto(this.querySelector("table[part=table]")), this.dataTable.forEach((e) => {
			this.checkedRows[e.id] = !1;
		}), this.columnKeys.forEach((e) => {
			this.cellRenderers && this.cellRenderers[e] && this.columnVisibility[e] === void 0 && (this.columnVisibility[e] = !0);
		});
	}
	_handleSearchInput(e) {
		let t = e.target;
		this.searchTerm = t.value;
	}
	_handleHeaderCheckboxChange(e) {
		let t = e.target.checked, n = {};
		this.dataTable.forEach((e) => {
			this.isRowDisabled && this.isRowDisabled(e) ? n[e.id] = !1 : n[e.id] = t;
		}), this.checkedRows = n, this.requestUpdate();
	}
	_handleRowCheckboxChange(e, t) {
		let n = t.target.checked;
		this.checkedRows = {
			...this.checkedRows,
			[e]: n
		}, this.requestUpdate();
	}
	_handleRowAction(e, t) {
		e.action(t);
	}
	_handlePreviousPage() {
		this._goToPage(this.currentPage - 1);
	}
	_handleNextPage() {
		this._goToPage(this.currentPage + 1);
	}
	_handleSortToggle(e) {
		this.sortColumn === e ? this.sortDirection === "asc" ? this.sortDirection = "desc" : this.sortDirection === "desc" && (this.sortColumn = null, this.sortDirection = "asc") : (this.sortColumn = e, this.sortDirection = "asc"), this.requestUpdate();
	}
	_handleColumnVisibilityToggle(e) {
		this.columnVisibility = {
			...this.columnVisibility,
			[e]: !this.columnVisibility[e]
		}, this.requestUpdate();
	}
	get totalPages() {
		return Math.ceil(this.filteredData.length / this.pageSize);
	}
	_goToPage(e) {
		e >= 1 && e <= this.totalPages && (this.currentPage = e, this.requestUpdate());
	}
	get paginatedData() {
		let e = (this.currentPage - 1) * this.pageSize;
		return this.filteredData.slice(e, e + this.pageSize);
	}
	isColumnVisible(e) {
		return this.columnVisibility[e] !== !1;
	}
	get filteredData() {
		let e = this.dataTable;
		if (this.searchTerm.trim() && (e = e.filter((e) => e.email.toLowerCase().includes(this.searchTerm.toLowerCase()))), this.sortColumn) {
			let t = this.sortColumn;
			e = [...e].sort((e, n) => {
				let r = e[t], i = n[t];
				return r < i ? this.sortDirection === "asc" ? -1 : 1 : r > i ? this.sortDirection === "asc" ? 1 : -1 : 0;
			});
		}
		return e;
	}
	get columnKeys() {
		let e = this.dataTable?.[0];
		if (!e) return [];
		let t = Object.keys(e).filter((e) => e !== "id");
		if (this.columnOrder && this.columnOrder.length > 0) {
			let e = this.columnOrder.filter((e) => t.includes(e) && this.cellRenderers?.[e]), n = t.filter((t) => this.cellRenderers?.[t] && !e.includes(t));
			return [...e, ...n];
		}
		return t.filter((e) => this.cellRenderers?.[e]);
	}
	get visibleKeys() {
		return this.columnKeys.filter((e) => this.isColumnVisible(e));
	}
	areAllRowsChecked() {
		let e = Object.entries(this.checkedRows).filter(([e]) => {
			let t = this.dataTable.find((t) => t.id === e);
			return t ? !(this.isRowDisabled && this.isRowDisabled(t)) : !0;
		}).map(([, e]) => e);
		return e.length > 0 && e.every((e) => e);
	}
	get selectedRowCount() {
		return Object.values(this.checkedRows).filter(Boolean).length;
	}
	capitalizeLabel(e) {
		return e.charAt(0).toUpperCase() + e.slice(1);
	}
	_renderSearch() {
		return this.hasDefaultSearch ? n`
      <div part="search-and-columns">
        <div>
          <rtg-input
            data-testid="input-id"
            placeholder=${this.placeholder}
            @input=${this._handleSearchInput}
          ></rtg-input>
        </div>
        <rtg-dropdown-menu>
          <rtg-dropdown-menu-trigger>
            <rtg-button variant="outline">
              Columns ${this._chevronDownIcon}
            </rtg-button>
          </rtg-dropdown-menu-trigger>
          <rtg-dropdown-menu-content class="rtg-flex rtg-justify-end">
            ${this.columnKeys.filter((e) => this.cellRenderers && this.cellRenderers[e]).map((e) => n`
                  <rtg-dropdown-menu-checkbox-item
                    .checked=${this.isColumnVisible(e)}
                    @click=${() => this._handleColumnVisibilityToggle(e)}
                  >
                    <span>${this.capitalizeLabel(e)}</span>
                  </rtg-dropdown-menu-checkbox-item>
                `)}
          </rtg-dropdown-menu-content>
        </rtg-dropdown-menu>
      </div>
    ` : r;
	}
	_renderTableHead() {
		let e = this.rowActions && this.rowActions.length > 0;
		return n`
      <thead>
        <tr class="rtg-transition-colors">
          ${this.hasDefaultSelect ? n`<th class="rtg-w-[40px] rtg-px-2">
                <rtg-checkbox
                  id="header-checkbox"
                  data-testid="header-checkbox-id"
                  .checked=${this.areAllRowsChecked()}
                  @change=${this._handleHeaderCheckboxChange}
                ></rtg-checkbox>
              </th>` : r}
          ${this.visibleKeys.map((e, t, r) => {
			let i = t === 0, a = t === r.length - 1, o = a ? "rtg-text-right" : "rtg-text-left", s = this.headerRenderers?.[e], c = this.sortableColumns.includes(e), l = this.sortColumn === e, u = a ? "rtg-justify-end" : "", d = null;
			return c && (d = l ? this.sortDirection === "asc" ? Xt() : Zt() : n`
                  <div part="sort-icon-wrapper">
                    <div part="sort-icon-default">${Xt()}</div>
                  </div>
                `), n`
              <th class=${o}>
                ${c ? n`
                      <div
                        @click=${() => this._handleSortToggle(e)}
                        class="${u} rtg-flex rtg-cursor-pointer rtg-items-center rtg-gap-2"
                        part="sortable-header"
                        data-sortable="${e}"
                      >
                        ${s ? s({
				key: e,
				index: t,
				isFirst: i,
				isLast: a
			}) : this.capitalizeLabel(e)}
                        <div part="sort-icon-container">${d}</div>
                      </div>
                    ` : s ? s({
				key: e,
				index: t,
				isFirst: i,
				isLast: a
			}) : this.capitalizeLabel(e)}
              </th>
            `;
		})}
          ${e ? n`<th class="rtg-text-right"></th>` : r}
        </tr>
      </thead>
    `;
	}
	_renderTableBody() {
		let e = this.visibleKeys, t = this.rowActions && this.rowActions.length > 0, i = +!!this.hasDefaultSelect, a = +!!t, o = i + e.length + a;
		return n`
      <tbody>
        ${this.filteredData.length > 0 ? this.paginatedData.map((i) => {
			let a = this.isRowDisabled ? this.isRowDisabled(i) : !1, o = this.rowActions?.filter((e) => e.condition ? e.condition(i) : !0) || [];
			return n`
                <tr
                  data-id=${i.id ?? ""}
                  data-state=${this.checkedRows[i.id] ? "selected" : r}
                  class="rtg-transition-colors"
                  ?disabled=${a}
                >
                  ${this.hasDefaultSelect ? n`<td class="rtg-w-[40px] rtg-px-4">
                        <rtg-checkbox
                          id="terms-${i.id}"
                          data-testid="checkbox-id"
                          .checked=${this.checkedRows[i.id]}
                          ?disabled=${a}
                          @change=${(e) => !a && this._handleRowCheckboxChange(i.id, e)}
                        ></rtg-checkbox>
                      </td>` : r}
                  ${e.map((e, t, r) => n`
                      <td class=${t === r.length - 1 ? "rtg-text-right" : ""}>
                        ${this.cellRenderers[e] ? this.cellRenderers[e](i[e], i) : i[e] ?? ""}
                      </td>
                    `)}
                  ${t ? n`
                        <td>
                          <div class="rtg-flex rtg-justify-end">
                            <rtg-dropdown-menu>
                              <rtg-dropdown-menu-trigger>
                                <rtg-button
                                  variant="ghost"
                                  data-slot="dropdown-menu-trigger"
                                >
                                  <span class="rtg-sr-only">Open menu</span>
                                  ${this._ellipsisIcon}
                                </rtg-button>
                              </rtg-dropdown-menu-trigger>
                              <rtg-dropdown-menu-content
                                class="rtg-flex rtg-justify-end"
                              >
                                ${o.map((e) => n`
                                    <rtg-dropdown-menu-item
                                      @click=${() => !a && this._handleRowAction(e, i)}
                                    >
                                      ${e.render ? e.render(i) : e.label ?? ""}
                                    </rtg-dropdown-menu-item>
                                  `)}
                              </rtg-dropdown-menu-content>
                            </rtg-dropdown-menu>
                          </div>
                        </td>
                      ` : r}
                </tr>
              `;
		}) : n`
              <tr>
                <td part="empty" colspan="${o}">No results.</td>
              </tr>
            `}
      </tbody>
    `;
	}
	_renderPagination() {
		return n`
      <div part="pagination">
        ${this.hasDefaultSelect ? n`<div part="selected-items">
              ${this.selectedRowCount} of ${this.filteredData.length} row(s)
              selected. Page ${this.currentPage} of ${this.totalPages}
            </div>` : r}
        ${this.hasDefaultPagination ? n`<div class="rtg-flex rtg-space-x-2">
              <span
                class="${this.currentPage === 1 ? "rtg-pointer-events-none rtg-opacity-50" : ""}"
              >
                <rtg-pagination-previous
                  @click=${this._handlePreviousPage}
                ></rtg-pagination-previous>
              </span>
              <span
                class="${this.currentPage === this.totalPages ? "rtg-pointer-events-none rtg-opacity-50" : ""}"
              >
                <rtg-pagination-next
                  @click=${this._handleNextPage}
                ></rtg-pagination-next>
              </span>
            </div>` : r}
      </div>
    `;
	}
	render() {
		return n`
      <div class="w-full rtg-flex-grow">
        ${this._renderSearch()}
        <div part="main">
          <div class="rtg-w-full rtg-overflow-auto">
            <table part="table" class="rtg-w-full rtg-caption-bottom">
              ${this._renderTableHead()} ${this._renderTableBody()}
            </table>
          </div>
        </div>
        ${this.hasDefaultPagination && this.hasDefaultSelect ? this._renderPagination() : r}
      </div>
    `;
	}
};
S([o({ type: String }), x("design:type", Object)], $.prototype, "placeholder", void 0), S([o({ type: Array }), x("design:type", typeof Array > "u" ? Object : Array)], $.prototype, "dataTable", void 0), S([o({ type: Boolean }), x("design:type", typeof Boolean > "u" ? Object : Boolean)], $.prototype, "hasDefaultSelect", void 0), S([o({ type: Boolean }), x("design:type", typeof Boolean > "u" ? Object : Boolean)], $.prototype, "hasDefaultPagination", void 0), S([o({ type: Boolean }), x("design:type", typeof Boolean > "u" ? Object : Boolean)], $.prototype, "hasDefaultSearch", void 0), S([o({ type: Object }), x("design:type", typeof Record > "u" ? Object : Record)], $.prototype, "checkedRows", void 0), S([o({ type: String }), x("design:type", String)], $.prototype, "searchTerm", void 0), S([o({ type: Object }), x("design:type", typeof Record > "u" ? Object : Record)], $.prototype, "columnVisibility", void 0), S([o({ type: String }), x("design:type", Object)], $.prototype, "sortColumn", void 0), S([o({ type: String }), x("design:type", String)], $.prototype, "sortDirection", void 0), S([o({ type: Object }), x("design:type", typeof Record > "u" ? Object : Record)], $.prototype, "cellRenderers", void 0), S([o({ type: Object }), x("design:type", typeof Record > "u" ? Object : Record)], $.prototype, "headerRenderers", void 0), S([o({ type: Array }), x("design:type", typeof Array > "u" ? Object : Array)], $.prototype, "rowActions", void 0), S([o({ type: Array }), x("design:type", Array)], $.prototype, "paginationLabels", void 0), S([o({ type: Number }), x("design:type", Number)], $.prototype, "pageSize", void 0), S([o({ type: Number }), x("design:type", Number)], $.prototype, "currentPage", void 0), S([o({ type: Array }), x("design:type", Array)], $.prototype, "sortableColumns", void 0), S([o({ type: Array }), x("design:type", Array)], $.prototype, "columnOrder", void 0), S([o({ type: Function }), x("design:type", Function)], $.prototype, "isRowDisabled", void 0), $ = S([a("rtg-data-table")], $);
//#endregion
//#region src/components/widgets/light-sample-demo/light-sample.demo.ts
var oo = class extends C {
	constructor() {
		super(), this.defaultValue = "account";
	}
	getAttributesToExclude() {
		return [
			"disabled",
			"type",
			"placeholder",
			"value",
			"data-testid"
		];
	}
	createRenderRoot() {
		return this;
	}
	render() {
		return n`
      <div class="sb-flex sb-flex-col sb-gap-4">
        <rtg-tabs .defaultValue=${this.defaultValue} class="rtg-w-[400px]">
          <rtg-tabs-list customClass="rtg-h-10 rtg-rounded-2xl" slot="tab-list">
            <rtg-tabs-trigger
              id="account"
              value="account"
              @click=${() => console.log("clicked account")}
            >
              account
            </rtg-tabs-trigger>
            <rtg-tabs-trigger
              data-testid="Password"
              id="password"
              value="password"
              @click=${() => console.log("clicked Password")}
            >
              Password
            </rtg-tabs-trigger>
          </rtg-tabs-list>
          <div slot="tab-content" class="rtg-pt-2">
            <rtg-tabs-content value="password">
              <rtg-card>
                <rtg-card-header class="rtg-space-y-1.5 rtg-p-6">
                  <rtg-card-title>
                    <h3
                      class="rtg-text-2xl rtg-font-semibold rtg-leading-none rtg-tracking-tight"
                    >
                      Password
                    </h3>
                  </rtg-card-title>
                  <rtg-card-description>
                    <div class="rtg-pt-2 rtg-text-sm rtg-text-muted-foreground">
                      Change your password here. After saving, you'll be logged
                      out.
                    </div>
                  </rtg-card-description>
                </rtg-card-header>
                <rtg-card-content>
                  <div>
                    <rtg-label htmlFor="name">Current password</rtg-label>
                  </div>
                  <div class="rtg-py-2">
                    <rtg-label htmlFor="username">New password</rtg-label>
                  </div>
                </rtg-card-content>

                <div class="py-2">
                  <rtg-button> Save password </rtg-button>
                </div>
              </rtg-card>
            </rtg-tabs-content>
            <rtg-tabs-content value="account">
              <rtg-card>
                <rtg-card-header class="rtg-space-y-1.5 rtg-p-6">
                  <rtg-card-title>
                    <h3
                      class="rtg-text-2xl rtg-font-semibold rtg-leading-none rtg-tracking-tight"
                    >
                      Account
                    </h3>
                  </rtg-card-title>
                  <rtg-card-description>
                    <div class="rtg-pt-2 rtg-text-sm rtg-text-muted-foreground">
                      Make changes to your account here. Click save when you're
                      done.
                    </div>
                  </rtg-card-description>
                </rtg-card-header>
                <rtg-card-content>
                  <div>
                    <rtg-label htmlFor="name">Name</rtg-label>
                  </div>
                  <div class="rtg-py-2">
                    <rtg-label htmlFor="username">Username</rtg-label>
                  </div>
                </rtg-card-content>

                <div class="rtg-py-2">
                  <rtg-button> Save changes </rtg-button>
                </div>
              </rtg-card>
            </rtg-tabs-content>
          </div>
        </rtg-tabs>

        <rtg-avatar customClass="rtg-h-20 rtg-w-20">
          <rtg-avatar-image
            src="https://github.com/shadcn.png"
          ></rtg-avatar-image>
        </rtg-avatar>

        <rtg-card class="rtg-rounded-2xl">
          <rtg-card-header data-testid="card-header-id">
            <rtg-card-title data-testid="card-title-id">
              <h3>Create project</h3>
            </rtg-card-title>
            <rtg-card-description data-testid="card-description-id">
              <p class="rtg-text-sm rtg-text-muted-foreground">
                Deploy your new project in one-click.
              </p>
            </rtg-card-description>
          </rtg-card-header>
          <rtg-card-content data-testid="card-content-id">
            <form class="rtg-pt-4">
              <div class="gap-4 rtg-grid rtg-w-full rtg-items-center">
                <div class="rtg-flex rtg-flex-col rtg-space-y-1.5">
                  <label
                    class="rtg-text-sm rtg-font-medium rtg-leading-none peer-disabled:rtg-cursor-not-allowed peer-disabled:rtg-opacity-70"
                    for="name"
                    >Name</label
                  >
                  <input
                    id="name"
                    class="disabled:opacity-50 rtg-flex rtg-h-10 rtg-w-full rtg-rounded-md rtg-border rtg-border-input rtg-bg-background rtg-px-3 rtg-py-2 rtg-text-sm rtg-ring-offset-background placeholder:rtg-text-muted-foreground focus-visible:rtg-outline-none focus-visible:rtg-ring-2 focus-visible:rtg-ring-ring focus-visible:rtg-ring-offset-2 disabled:rtg-cursor-not-allowed"
                    placeholder="Name of your project"
                  />
                </div>
                <div class="rtg-flex rtg-flex-col rtg-space-y-1.5">
                  <label
                    class="rtg-text-sm rtg-font-medium rtg-leading-none peer-disabled:rtg-cursor-not-allowed peer-disabled:rtg-opacity-70"
                    for="framework"
                    >Framework</label
                  >
                  <input
                    id="framework"
                    class="focus-visible:ring-2 rtg-flex rtg-h-10 rtg-w-full rtg-rounded-md rtg-border rtg-border-input rtg-bg-background rtg-px-3 rtg-py-2 rtg-text-sm rtg-ring-offset-background placeholder:rtg-text-muted-foreground focus-visible:rtg-outline-none focus-visible:rtg-ring-ring focus-visible:rtg-ring-offset-2 disabled:rtg-cursor-not-allowed disabled:rtg-opacity-50"
                    placeholder="What framework you be going to use?"
                  />
                </div>
              </div>
            </form>
          </rtg-card-content>
          <rtg-card-footer data-testid="card-footer-id">
            <div class="rtg-flex rtg-items-center rtg-justify-between rtg-pt-4">
              <button
                class="rtg-inline-flex rtg-h-10 rtg-items-center rtg-justify-center rtg-whitespace-nowrap rtg-rounded-md rtg-border rtg-border-input rtg-bg-background rtg-px-4 rtg-py-2 rtg-text-sm rtg-font-medium rtg-ring-offset-background rtg-transition-colors hover:rtg-bg-accent hover:rtg-text-accent-foreground focus-visible:rtg-outline-none focus-visible:rtg-ring-2 focus-visible:rtg-ring-ring focus-visible:rtg-ring-offset-2 disabled:rtg-pointer-events-none disabled:rtg-opacity-50"
              >
                Cancel
              </button>
              <button
                class="rtg-inline-flex rtg-h-10 rtg-items-center rtg-justify-center rtg-whitespace-nowrap rtg-rounded-md rtg-bg-primary rtg-px-4 rtg-py-2 rtg-text-sm rtg-font-medium rtg-text-primary-foreground rtg-ring-offset-background rtg-transition-colors hover:rtg-bg-primary/90 focus-visible:rtg-outline-none focus-visible:rtg-ring-2 focus-visible:rtg-ring-ring focus-visible:rtg-ring-offset-2 disabled:rtg-pointer-events-none disabled:rtg-opacity-50"
              >
                Deploy
              </button>
            </div>
          </rtg-card-footer>
        </rtg-card>

        <rtg-tabs orientation="vertical" defaultValue="account">
          <rtg-tabs-list customClass="!rtg-rounded-2xl" orientation="vertical">
            <rtg-tabs-trigger value="account">Account</rtg-tabs-trigger>
            <rtg-tabs-trigger value="password">Password</rtg-tabs-trigger>
          </rtg-tabs-list>

          <rtg-tabs-content customClass="rtg-rounded-2xl" value="account">
            <rtg-card>
              <rtg-card-header class="rtg-space-y-1.5 rtg-p-6">
                <rtg-card-title>
                  <h3
                    class="rtg-text-2xl rtg-font-semibold rtg-leading-none rtg-tracking-tight"
                  >
                    Account
                  </h3>
                </rtg-card-title>
                <rtg-card-description>
                  <div class="rtg-pt-2 rtg-text-sm rtg-text-muted-foreground">
                    Make changes to your account here. Click save when you're
                    done.
                  </div>
                </rtg-card-description>
              </rtg-card-header>
              <rtg-card-content>
                <div>
                  <rtg-label htmlFor="name">Name</rtg-label>
                </div>
                <div class="rtg-py-2">
                  <rtg-label htmlFor="username">Username</rtg-label>
                </div>
              </rtg-card-content>

              <div class="rtg-py-2">
                <rtg-button> Save changes </rtg-button>
              </div>
            </rtg-card>
          </rtg-tabs-content>

          <rtg-tabs-content customClass="rtg-rounded-2xl" value="password">
            <rtg-card customClass="rtg-rounded-2xl">
              <rtg-card-header class="rtg-space-y-1.5 rtg-p-6">
                <rtg-card-title>
                  <h3
                    class="rtg-text-2xl rtg-font-semibold rtg-leading-none rtg-tracking-tight"
                  >
                    Password
                  </h3>
                </rtg-card-title>
                <rtg-card-description>
                  <div class="rtg-pt-2 rtg-text-sm rtg-text-muted-foreground">
                    Change your password here. After saving, you'll be logged
                    out.
                  </div>
                </rtg-card-description>
              </rtg-card-header>
              <rtg-card-content>
                <div>
                  <rtg-label htmlFor="name">Current password</rtg-label>
                </div>
                <div class="rtg-py-2">
                  <rtg-label htmlFor="username">New password</rtg-label>
                </div>
              </rtg-card-content>

              <div class="py-2">
                <rtg-button> Save password </rtg-button>
              </div>
            </rtg-card>
          </rtg-tabs-content>
        </rtg-tabs>
      </div>
    `;
	}
};
S([o({ type: String }), x("design:type", String)], oo.prototype, "defaultValue", void 0), oo = S([a("light-sample-demo"), x("design:paramtypes", [])], oo);
//#endregion
//#region node_modules/@lit-labs/react/create-component.js
var so = new Set([
	"children",
	"localName",
	"ref",
	"style",
	"className"
]), co = /* @__PURE__ */ new WeakMap(), lo = (e, t, n, r, i) => {
	let a = i?.[t];
	a === void 0 || n === r ? n == null && t in HTMLElement.prototype ? e.removeAttribute(t) : e[t] = n : ((e, t, n) => {
		let r = co.get(e);
		r === void 0 && co.set(e, r = /* @__PURE__ */ new Map());
		let i = r.get(t);
		n === void 0 ? i !== void 0 && (r.delete(t), e.removeEventListener(t, i)) : i === void 0 ? (r.set(t, i = { handleEvent: n }), e.addEventListener(t, i)) : i.handleEvent = n;
	})(e, a, n);
}, uo = (e, t) => {
	typeof e == "function" ? e(t) : e.current = t;
};
function fo(e = window.React, t, n, r, i) {
	let a, o, s;
	if (t === void 0) {
		let t = e;
		({tagName: o, elementClass: s, events: r, displayName: i} = t), a = t.react;
	} else a = e, s = n, o = t;
	let c = a.Component, l = a.createElement, u = new Set(Object.keys(r ?? {}));
	class d extends c {
		constructor() {
			super(...arguments), this.o = null;
		}
		t(e) {
			if (this.o !== null) for (let t in this.i) lo(this.o, t, this.props[t], e ? e[t] : void 0, r);
		}
		componentDidMount() {
			var e;
			this.t(), (e = this.o) == null || e.removeAttribute("defer-hydration");
		}
		componentDidUpdate(e) {
			this.t(e);
		}
		render() {
			let { _$Gl: e, ...t } = this.props;
			this.h !== e && (this.u = (t) => {
				e !== null && uo(e, t), this.o = t, this.h = e;
			}), this.i = {};
			let n = { ref: this.u };
			for (let [e, r] of Object.entries(t)) so.has(e) ? n[e === "className" ? "class" : e] = r : u.has(e) || e in s.prototype ? this.i[e] = r : n[e] = r;
			return n.suppressHydrationWarning = !0, l(o, n);
		}
	}
	d.displayName = i ?? s.name;
	let f = a.forwardRef(((e, t) => l(d, {
		...e,
		_$Gl: t
	}, e?.children)));
	return f.displayName = d.displayName, f;
}
//#endregion
//#region node_modules/react/cjs/react.production.js
var po = /* @__PURE__ */ b(((e) => {
	var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.consumer"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), f = Symbol.for("react.activity"), p = Symbol.iterator;
	function ee(e) {
		return typeof e != "object" || !e ? null : (e = p && e[p] || e["@@iterator"], typeof e == "function" ? e : null);
	}
	var m = {
		isMounted: function() {
			return !1;
		},
		enqueueForceUpdate: function() {},
		enqueueReplaceState: function() {},
		enqueueSetState: function() {}
	}, h = Object.assign, g = {};
	function _(e, t, n) {
		this.props = e, this.context = t, this.refs = g, this.updater = n || m;
	}
	_.prototype.isReactComponent = {}, _.prototype.setState = function(e, t) {
		if (typeof e != "object" && typeof e != "function" && e != null) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
		this.updater.enqueueSetState(this, e, t, "setState");
	}, _.prototype.forceUpdate = function(e) {
		this.updater.enqueueForceUpdate(this, e, "forceUpdate");
	};
	function te() {}
	te.prototype = _.prototype;
	function ne(e, t, n) {
		this.props = e, this.context = t, this.refs = g, this.updater = n || m;
	}
	var v = ne.prototype = new te();
	v.constructor = ne, h(v, _.prototype), v.isPureReactComponent = !0;
	var re = Array.isArray;
	function ie() {}
	var y = {
		H: null,
		A: null,
		T: null,
		S: null
	}, b = Object.prototype.hasOwnProperty;
	function ae(e, n, r) {
		var i = r.ref;
		return {
			$$typeof: t,
			type: e,
			key: n,
			ref: i === void 0 ? null : i,
			props: r
		};
	}
	function oe(e, t) {
		return ae(e.type, t, e.props);
	}
	function x(e) {
		return typeof e == "object" && !!e && e.$$typeof === t;
	}
	function S(e) {
		var t = {
			"=": "=0",
			":": "=2"
		};
		return "$" + e.replace(/[=:]/g, function(e) {
			return t[e];
		});
	}
	var C = /\/+/g;
	function w(e, t) {
		return typeof e == "object" && e && e.key != null ? S("" + e.key) : t.toString(36);
	}
	function se(e) {
		switch (e.status) {
			case "fulfilled": return e.value;
			case "rejected": throw e.reason;
			default: switch (typeof e.status == "string" ? e.then(ie, ie) : (e.status = "pending", e.then(function(t) {
				e.status === "pending" && (e.status = "fulfilled", e.value = t);
			}, function(t) {
				e.status === "pending" && (e.status = "rejected", e.reason = t);
			})), e.status) {
				case "fulfilled": return e.value;
				case "rejected": throw e.reason;
			}
		}
		throw e;
	}
	function T(e, r, i, a, o) {
		var s = typeof e;
		(s === "undefined" || s === "boolean") && (e = null);
		var c = !1;
		if (e === null) c = !0;
		else switch (s) {
			case "bigint":
			case "string":
			case "number":
				c = !0;
				break;
			case "object": switch (e.$$typeof) {
				case t:
				case n:
					c = !0;
					break;
				case d: return c = e._init, T(c(e._payload), r, i, a, o);
			}
		}
		if (c) return o = o(e), c = a === "" ? "." + w(e, 0) : a, re(o) ? (i = "", c != null && (i = c.replace(C, "$&/") + "/"), T(o, r, i, "", function(e) {
			return e;
		})) : o != null && (x(o) && (o = oe(o, i + (o.key == null || e && e.key === o.key ? "" : ("" + o.key).replace(C, "$&/") + "/") + c)), r.push(o)), 1;
		c = 0;
		var l = a === "" ? "." : a + ":";
		if (re(e)) for (var u = 0; u < e.length; u++) a = e[u], s = l + w(a, u), c += T(a, r, i, s, o);
		else if (u = ee(e), typeof u == "function") for (e = u.call(e), u = 0; !(a = e.next()).done;) a = a.value, s = l + w(a, u++), c += T(a, r, i, s, o);
		else if (s === "object") {
			if (typeof e.then == "function") return T(se(e), r, i, a, o);
			throw r = String(e), Error("Objects are not valid as a React child (found: " + (r === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : r) + "). If you meant to render a collection of children, use an array instead.");
		}
		return c;
	}
	function E(e, t, n) {
		if (e == null) return e;
		var r = [], i = 0;
		return T(e, r, "", "", function(e) {
			return t.call(n, e, i++);
		}), r;
	}
	function ce(e) {
		if (e._status === -1) {
			var t = e._result;
			t = t(), t.then(function(t) {
				(e._status === 0 || e._status === -1) && (e._status = 1, e._result = t);
			}, function(t) {
				(e._status === 0 || e._status === -1) && (e._status = 2, e._result = t);
			}), e._status === -1 && (e._status = 0, e._result = t);
		}
		if (e._status === 1) return e._result.default;
		throw e._result;
	}
	var le = typeof reportError == "function" ? reportError : function(e) {
		if (typeof window == "object" && typeof window.ErrorEvent == "function") {
			var t = new window.ErrorEvent("error", {
				bubbles: !0,
				cancelable: !0,
				message: typeof e == "object" && e && typeof e.message == "string" ? String(e.message) : String(e),
				error: e
			});
			if (!window.dispatchEvent(t)) return;
		} else if (typeof process == "object" && typeof process.emit == "function") {
			process.emit("uncaughtException", e);
			return;
		}
		console.error(e);
	}, D = {
		map: E,
		forEach: function(e, t, n) {
			E(e, function() {
				t.apply(this, arguments);
			}, n);
		},
		count: function(e) {
			var t = 0;
			return E(e, function() {
				t++;
			}), t;
		},
		toArray: function(e) {
			return E(e, function(e) {
				return e;
			}) || [];
		},
		only: function(e) {
			if (!x(e)) throw Error("React.Children.only expected to receive a single React element child.");
			return e;
		}
	};
	e.Activity = f, e.Children = D, e.Component = _, e.Fragment = r, e.Profiler = a, e.PureComponent = ne, e.StrictMode = i, e.Suspense = l, e.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = y, e.__COMPILER_RUNTIME = {
		__proto__: null,
		c: function(e) {
			return y.H.useMemoCache(e);
		}
	}, e.cache = function(e) {
		return function() {
			return e.apply(null, arguments);
		};
	}, e.cacheSignal = function() {
		return null;
	}, e.cloneElement = function(e, t, n) {
		if (e == null) throw Error("The argument must be a React element, but you passed " + e + ".");
		var r = h({}, e.props), i = e.key;
		if (t != null) for (a in t.key !== void 0 && (i = "" + t.key), t) !b.call(t, a) || a === "key" || a === "__self" || a === "__source" || a === "ref" && t.ref === void 0 || (r[a] = t[a]);
		var a = arguments.length - 2;
		if (a === 1) r.children = n;
		else if (1 < a) {
			for (var o = Array(a), s = 0; s < a; s++) o[s] = arguments[s + 2];
			r.children = o;
		}
		return ae(e.type, i, r);
	}, e.createContext = function(e) {
		return e = {
			$$typeof: s,
			_currentValue: e,
			_currentValue2: e,
			_threadCount: 0,
			Provider: null,
			Consumer: null
		}, e.Provider = e, e.Consumer = {
			$$typeof: o,
			_context: e
		}, e;
	}, e.createElement = function(e, t, n) {
		var r, i = {}, a = null;
		if (t != null) for (r in t.key !== void 0 && (a = "" + t.key), t) b.call(t, r) && r !== "key" && r !== "__self" && r !== "__source" && (i[r] = t[r]);
		var o = arguments.length - 2;
		if (o === 1) i.children = n;
		else if (1 < o) {
			for (var s = Array(o), c = 0; c < o; c++) s[c] = arguments[c + 2];
			i.children = s;
		}
		if (e && e.defaultProps) for (r in o = e.defaultProps, o) i[r] === void 0 && (i[r] = o[r]);
		return ae(e, a, i);
	}, e.createRef = function() {
		return { current: null };
	}, e.forwardRef = function(e) {
		return {
			$$typeof: c,
			render: e
		};
	}, e.isValidElement = x, e.lazy = function(e) {
		return {
			$$typeof: d,
			_payload: {
				_status: -1,
				_result: e
			},
			_init: ce
		};
	}, e.memo = function(e, t) {
		return {
			$$typeof: u,
			type: e,
			compare: t === void 0 ? null : t
		};
	}, e.startTransition = function(e) {
		var t = y.T, n = {};
		y.T = n;
		try {
			var r = e(), i = y.S;
			i !== null && i(n, r), typeof r == "object" && r && typeof r.then == "function" && r.then(ie, le);
		} catch (e) {
			le(e);
		} finally {
			t !== null && n.types !== null && (t.types = n.types), y.T = t;
		}
	}, e.unstable_useCacheRefresh = function() {
		return y.H.useCacheRefresh();
	}, e.use = function(e) {
		return y.H.use(e);
	}, e.useActionState = function(e, t, n) {
		return y.H.useActionState(e, t, n);
	}, e.useCallback = function(e, t) {
		return y.H.useCallback(e, t);
	}, e.useContext = function(e) {
		return y.H.useContext(e);
	}, e.useDebugValue = function() {}, e.useDeferredValue = function(e, t) {
		return y.H.useDeferredValue(e, t);
	}, e.useEffect = function(e, t) {
		return y.H.useEffect(e, t);
	}, e.useEffectEvent = function(e) {
		return y.H.useEffectEvent(e);
	}, e.useId = function() {
		return y.H.useId();
	}, e.useImperativeHandle = function(e, t, n) {
		return y.H.useImperativeHandle(e, t, n);
	}, e.useInsertionEffect = function(e, t) {
		return y.H.useInsertionEffect(e, t);
	}, e.useLayoutEffect = function(e, t) {
		return y.H.useLayoutEffect(e, t);
	}, e.useMemo = function(e, t) {
		return y.H.useMemo(e, t);
	}, e.useOptimistic = function(e, t) {
		return y.H.useOptimistic(e, t);
	}, e.useReducer = function(e, t, n) {
		return y.H.useReducer(e, t, n);
	}, e.useRef = function(e) {
		return y.H.useRef(e);
	}, e.useState = function(e) {
		return y.H.useState(e);
	}, e.useSyncExternalStore = function(e, t, n) {
		return y.H.useSyncExternalStore(e, t, n);
	}, e.useTransition = function() {
		return y.H.useTransition();
	}, e.version = "19.2.6";
})), mo = /* @__PURE__ */ b(((e, t) => {
	process.env.NODE_ENV !== "production" && (function() {
		function n(e, t) {
			Object.defineProperty(a.prototype, e, { get: function() {
				console.warn("%s(...) is deprecated in plain JavaScript React classes. %s", t[0], t[1]);
			} });
		}
		function r(e) {
			return typeof e != "object" || !e ? null : (e = be && e[be] || e["@@iterator"], typeof e == "function" ? e : null);
		}
		function i(e, t) {
			e = (e = e.constructor) && (e.displayName || e.name) || "ReactClass";
			var n = e + "." + t;
			xe[n] || (console.error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", t, e), xe[n] = !0);
		}
		function a(e, t, n) {
			this.props = e, this.context = t, this.refs = we, this.updater = n || Se;
		}
		function o() {}
		function s(e, t, n) {
			this.props = e, this.context = t, this.refs = we, this.updater = n || Se;
		}
		function c() {}
		function l(e) {
			return "" + e;
		}
		function u(e) {
			try {
				l(e);
				var t = !1;
			} catch {
				t = !0;
			}
			if (t) {
				t = console;
				var n = t.error, r = typeof Symbol == "function" && Symbol.toStringTag && e[Symbol.toStringTag] || e.constructor.name || "Object";
				return n.call(t, "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", r), l(e);
			}
		}
		function d(e) {
			if (e == null) return null;
			if (typeof e == "function") return e.$$typeof === Ee ? null : e.displayName || e.name || null;
			if (typeof e == "string") return e;
			switch (e) {
				case D: return "Fragment";
				case de: return "Profiler";
				case ue: return "StrictMode";
				case he: return "Suspense";
				case ge: return "SuspenseList";
				case ye: return "Activity";
			}
			if (typeof e == "object") switch (typeof e.tag == "number" && console.error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), e.$$typeof) {
				case le: return "Portal";
				case pe: return e.displayName || "Context";
				case fe: return (e._context.displayName || "Context") + ".Consumer";
				case me:
					var t = e.render;
					return e = e.displayName, e ||= (e = t.displayName || t.name || "", e === "" ? "ForwardRef" : "ForwardRef(" + e + ")"), e;
				case _e: return t = e.displayName || null, t === null ? d(e.type) || "Memo" : t;
				case ve:
					t = e._payload, e = e._init;
					try {
						return d(e(t));
					} catch {}
			}
			return null;
		}
		function f(e) {
			if (e === D) return "<>";
			if (typeof e == "object" && e && e.$$typeof === ve) return "<...>";
			try {
				var t = d(e);
				return t ? "<" + t + ">" : "<...>";
			} catch {
				return "<...>";
			}
		}
		function p() {
			var e = k.A;
			return e === null ? null : e.getOwner();
		}
		function ee() {
			return Error("react-stack-top-frame");
		}
		function m(e) {
			if (A.call(e, "key")) {
				var t = Object.getOwnPropertyDescriptor(e, "key").get;
				if (t && t.isReactWarning) return !1;
			}
			return e.key !== void 0;
		}
		function h(e, t) {
			function n() {
				Oe || (Oe = !0, console.error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)", t));
			}
			n.isReactWarning = !0, Object.defineProperty(e, "key", {
				get: n,
				configurable: !0
			});
		}
		function g() {
			var e = d(this.type);
			return Ae[e] || (Ae[e] = !0, console.error("Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release.")), e = this.props.ref, e === void 0 ? null : e;
		}
		function _(e, t, n, r, i, a) {
			var o = n.ref;
			return e = {
				$$typeof: ce,
				type: e,
				key: t,
				props: n,
				_owner: r
			}, (o === void 0 ? null : o) === null ? Object.defineProperty(e, "ref", {
				enumerable: !1,
				value: null
			}) : Object.defineProperty(e, "ref", {
				enumerable: !1,
				get: g
			}), e._store = {}, Object.defineProperty(e._store, "validated", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: 0
			}), Object.defineProperty(e, "_debugInfo", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: null
			}), Object.defineProperty(e, "_debugStack", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: i
			}), Object.defineProperty(e, "_debugTask", {
				configurable: !1,
				enumerable: !1,
				writable: !0,
				value: a
			}), Object.freeze && (Object.freeze(e.props), Object.freeze(e)), e;
		}
		function te(e, t) {
			return t = _(e.type, t, e.props, e._owner, e._debugStack, e._debugTask), e._store && (t._store.validated = e._store.validated), t;
		}
		function ne(e) {
			v(e) ? e._store && (e._store.validated = 1) : typeof e == "object" && e && e.$$typeof === ve && (e._payload.status === "fulfilled" ? v(e._payload.value) && e._payload.value._store && (e._payload.value._store.validated = 1) : e._store && (e._store.validated = 1));
		}
		function v(e) {
			return typeof e == "object" && !!e && e.$$typeof === ce;
		}
		function re(e) {
			var t = {
				"=": "=0",
				":": "=2"
			};
			return "$" + e.replace(/[=:]/g, function(e) {
				return t[e];
			});
		}
		function ie(e, t) {
			return typeof e == "object" && e && e.key != null ? (u(e.key), re("" + e.key)) : t.toString(36);
		}
		function y(e) {
			switch (e.status) {
				case "fulfilled": return e.value;
				case "rejected": throw e.reason;
				default: switch (typeof e.status == "string" ? e.then(c, c) : (e.status = "pending", e.then(function(t) {
					e.status === "pending" && (e.status = "fulfilled", e.value = t);
				}, function(t) {
					e.status === "pending" && (e.status = "rejected", e.reason = t);
				})), e.status) {
					case "fulfilled": return e.value;
					case "rejected": throw e.reason;
				}
			}
			throw e;
		}
		function b(e, t, n, i, a) {
			var o = typeof e;
			(o === "undefined" || o === "boolean") && (e = null);
			var s = !1;
			if (e === null) s = !0;
			else switch (o) {
				case "bigint":
				case "string":
				case "number":
					s = !0;
					break;
				case "object": switch (e.$$typeof) {
					case ce:
					case le:
						s = !0;
						break;
					case ve: return s = e._init, b(s(e._payload), t, n, i, a);
				}
			}
			if (s) {
				s = e, a = a(s);
				var c = i === "" ? "." + ie(s, 0) : i;
				return Te(a) ? (n = "", c != null && (n = c.replace(Pe, "$&/") + "/"), b(a, t, n, "", function(e) {
					return e;
				})) : a != null && (v(a) && (a.key != null && (s && s.key === a.key || u(a.key)), n = te(a, n + (a.key == null || s && s.key === a.key ? "" : ("" + a.key).replace(Pe, "$&/") + "/") + c), i !== "" && s != null && v(s) && s.key == null && s._store && !s._store.validated && (n._store.validated = 2), a = n), t.push(a)), 1;
			}
			if (s = 0, c = i === "" ? "." : i + ":", Te(e)) for (var l = 0; l < e.length; l++) i = e[l], o = c + ie(i, l), s += b(i, t, n, o, a);
			else if (l = r(e), typeof l == "function") for (l === e.entries && (Ne || console.warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), Ne = !0), e = l.call(e), l = 0; !(i = e.next()).done;) i = i.value, o = c + ie(i, l++), s += b(i, t, n, o, a);
			else if (o === "object") {
				if (typeof e.then == "function") return b(y(e), t, n, i, a);
				throw t = String(e), Error("Objects are not valid as a React child (found: " + (t === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : t) + "). If you meant to render a collection of children, use an array instead.");
			}
			return s;
		}
		function ae(e, t, n) {
			if (e == null) return e;
			var r = [], i = 0;
			return b(e, r, "", "", function(e) {
				return t.call(n, e, i++);
			}), r;
		}
		function oe(e) {
			if (e._status === -1) {
				var t = e._ioInfo;
				t != null && (t.start = t.end = performance.now()), t = e._result;
				var n = t();
				if (n.then(function(t) {
					if (e._status === 0 || e._status === -1) {
						e._status = 1, e._result = t;
						var r = e._ioInfo;
						r != null && (r.end = performance.now()), n.status === void 0 && (n.status = "fulfilled", n.value = t);
					}
				}, function(t) {
					if (e._status === 0 || e._status === -1) {
						e._status = 2, e._result = t;
						var r = e._ioInfo;
						r != null && (r.end = performance.now()), n.status === void 0 && (n.status = "rejected", n.reason = t);
					}
				}), t = e._ioInfo, t != null) {
					t.value = n;
					var r = n.displayName;
					typeof r == "string" && (t.name = r);
				}
				e._status === -1 && (e._status = 0, e._result = n);
			}
			if (e._status === 1) return t = e._result, t === void 0 && console.error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?", t), "default" in t || console.error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", t), t.default;
			throw e._result;
		}
		function x() {
			var e = k.H;
			return e === null && console.error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem."), e;
		}
		function S() {
			k.asyncTransitions--;
		}
		function C(e) {
			if (Le === null) try {
				var n = ("require" + Math.random()).slice(0, 7);
				Le = (t && t[n]).call(t, "timers").setImmediate;
			} catch {
				Le = function(e) {
					!1 === Ie && (Ie = !0, typeof MessageChannel > "u" && console.error("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
					var t = new MessageChannel();
					t.port1.onmessage = e, t.port2.postMessage(void 0);
				};
			}
			return Le(e);
		}
		function w(e) {
			return 1 < e.length && typeof AggregateError == "function" ? AggregateError(e) : e[0];
		}
		function se(e, t) {
			t !== Re - 1 && console.error("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "), Re = t;
		}
		function T(e, t, n) {
			var r = k.actQueue;
			if (r !== null) if (r.length !== 0) try {
				E(r), C(function() {
					return T(e, t, n);
				});
				return;
			} catch (e) {
				k.thrownErrors.push(e);
			}
			else k.actQueue = null;
			0 < k.thrownErrors.length ? (r = w(k.thrownErrors), k.thrownErrors.length = 0, n(r)) : t(e);
		}
		function E(e) {
			if (!Be) {
				Be = !0;
				var t = 0;
				try {
					for (; t < e.length; t++) {
						var n = e[t];
						do {
							k.didUsePromise = !1;
							var r = n(!1);
							if (r !== null) {
								if (k.didUsePromise) {
									e[t] = n, e.splice(0, t);
									return;
								}
								n = r;
							} else break;
						} while (1);
					}
					e.length = 0;
				} catch (n) {
					e.splice(0, t + 1), k.thrownErrors.push(n);
				} finally {
					Be = !1;
				}
			}
		}
		typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
		var ce = Symbol.for("react.transitional.element"), le = Symbol.for("react.portal"), D = Symbol.for("react.fragment"), ue = Symbol.for("react.strict_mode"), de = Symbol.for("react.profiler"), fe = Symbol.for("react.consumer"), pe = Symbol.for("react.context"), me = Symbol.for("react.forward_ref"), he = Symbol.for("react.suspense"), ge = Symbol.for("react.suspense_list"), _e = Symbol.for("react.memo"), ve = Symbol.for("react.lazy"), ye = Symbol.for("react.activity"), be = Symbol.iterator, xe = {}, Se = {
			isMounted: function() {
				return !1;
			},
			enqueueForceUpdate: function(e) {
				i(e, "forceUpdate");
			},
			enqueueReplaceState: function(e) {
				i(e, "replaceState");
			},
			enqueueSetState: function(e) {
				i(e, "setState");
			}
		}, Ce = Object.assign, we = {};
		Object.freeze(we), a.prototype.isReactComponent = {}, a.prototype.setState = function(e, t) {
			if (typeof e != "object" && typeof e != "function" && e != null) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
			this.updater.enqueueSetState(this, e, t, "setState");
		}, a.prototype.forceUpdate = function(e) {
			this.updater.enqueueForceUpdate(this, e, "forceUpdate");
		};
		var O = {
			isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
			replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
		};
		for (M in O) O.hasOwnProperty(M) && n(M, O[M]);
		o.prototype = a.prototype, O = s.prototype = new o(), O.constructor = s, Ce(O, a.prototype), O.isPureReactComponent = !0;
		var Te = Array.isArray, Ee = Symbol.for("react.client.reference"), k = {
			H: null,
			A: null,
			T: null,
			S: null,
			actQueue: null,
			asyncTransitions: 0,
			isBatchingLegacy: !1,
			didScheduleLegacyUpdate: !1,
			didUsePromise: !1,
			thrownErrors: [],
			getCurrentStack: null,
			recentlyCreatedOwnerStacks: 0
		}, A = Object.prototype.hasOwnProperty, De = console.createTask ? console.createTask : function() {
			return null;
		};
		O = { react_stack_bottom_frame: function(e) {
			return e();
		} };
		var Oe, ke, Ae = {}, je = O.react_stack_bottom_frame.bind(O, ee)(), Me = De(f(ee)), Ne = !1, Pe = /\/+/g, Fe = typeof reportError == "function" ? reportError : function(e) {
			if (typeof window == "object" && typeof window.ErrorEvent == "function") {
				var t = new window.ErrorEvent("error", {
					bubbles: !0,
					cancelable: !0,
					message: typeof e == "object" && e && typeof e.message == "string" ? String(e.message) : String(e),
					error: e
				});
				if (!window.dispatchEvent(t)) return;
			} else if (typeof process == "object" && typeof process.emit == "function") {
				process.emit("uncaughtException", e);
				return;
			}
			console.error(e);
		}, Ie = !1, Le = null, Re = 0, ze = !1, Be = !1, j = typeof queueMicrotask == "function" ? function(e) {
			queueMicrotask(function() {
				return queueMicrotask(e);
			});
		} : C;
		O = Object.freeze({
			__proto__: null,
			c: function(e) {
				return x().useMemoCache(e);
			}
		});
		var M = {
			map: ae,
			forEach: function(e, t, n) {
				ae(e, function() {
					t.apply(this, arguments);
				}, n);
			},
			count: function(e) {
				var t = 0;
				return ae(e, function() {
					t++;
				}), t;
			},
			toArray: function(e) {
				return ae(e, function(e) {
					return e;
				}) || [];
			},
			only: function(e) {
				if (!v(e)) throw Error("React.Children.only expected to receive a single React element child.");
				return e;
			}
		};
		e.Activity = ye, e.Children = M, e.Component = a, e.Fragment = D, e.Profiler = de, e.PureComponent = s, e.StrictMode = ue, e.Suspense = he, e.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = k, e.__COMPILER_RUNTIME = O, e.act = function(e) {
			var t = k.actQueue, n = Re;
			Re++;
			var r = k.actQueue = t === null ? [] : t, i = !1;
			try {
				var a = e();
			} catch (e) {
				k.thrownErrors.push(e);
			}
			if (0 < k.thrownErrors.length) throw se(t, n), e = w(k.thrownErrors), k.thrownErrors.length = 0, e;
			if (typeof a == "object" && a && typeof a.then == "function") {
				var o = a;
				return j(function() {
					i || ze || (ze = !0, console.error("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
				}), { then: function(e, a) {
					i = !0, o.then(function(i) {
						if (se(t, n), n === 0) {
							try {
								E(r), C(function() {
									return T(i, e, a);
								});
							} catch (e) {
								k.thrownErrors.push(e);
							}
							if (0 < k.thrownErrors.length) {
								var o = w(k.thrownErrors);
								k.thrownErrors.length = 0, a(o);
							}
						} else e(i);
					}, function(e) {
						se(t, n), 0 < k.thrownErrors.length ? (e = w(k.thrownErrors), k.thrownErrors.length = 0, a(e)) : a(e);
					});
				} };
			}
			var s = a;
			if (se(t, n), n === 0 && (E(r), r.length !== 0 && j(function() {
				i || ze || (ze = !0, console.error("A component suspended inside an `act` scope, but the `act` call was not awaited. When testing React components that depend on asynchronous data, you must await the result:\n\nawait act(() => ...)"));
			}), k.actQueue = null), 0 < k.thrownErrors.length) throw e = w(k.thrownErrors), k.thrownErrors.length = 0, e;
			return { then: function(e, t) {
				i = !0, n === 0 ? (k.actQueue = r, C(function() {
					return T(s, e, t);
				})) : e(s);
			} };
		}, e.cache = function(e) {
			return function() {
				return e.apply(null, arguments);
			};
		}, e.cacheSignal = function() {
			return null;
		}, e.captureOwnerStack = function() {
			var e = k.getCurrentStack;
			return e === null ? null : e();
		}, e.cloneElement = function(e, t, n) {
			if (e == null) throw Error("The argument must be a React element, but you passed " + e + ".");
			var r = Ce({}, e.props), i = e.key, a = e._owner;
			if (t != null) {
				var o;
				a: {
					if (A.call(t, "ref") && (o = Object.getOwnPropertyDescriptor(t, "ref").get) && o.isReactWarning) {
						o = !1;
						break a;
					}
					o = t.ref !== void 0;
				}
				for (s in o && (a = p()), m(t) && (u(t.key), i = "" + t.key), t) !A.call(t, s) || s === "key" || s === "__self" || s === "__source" || s === "ref" && t.ref === void 0 || (r[s] = t[s]);
			}
			var s = arguments.length - 2;
			if (s === 1) r.children = n;
			else if (1 < s) {
				o = Array(s);
				for (var c = 0; c < s; c++) o[c] = arguments[c + 2];
				r.children = o;
			}
			for (r = _(e.type, i, r, a, e._debugStack, e._debugTask), i = 2; i < arguments.length; i++) ne(arguments[i]);
			return r;
		}, e.createContext = function(e) {
			return e = {
				$$typeof: pe,
				_currentValue: e,
				_currentValue2: e,
				_threadCount: 0,
				Provider: null,
				Consumer: null
			}, e.Provider = e, e.Consumer = {
				$$typeof: fe,
				_context: e
			}, e._currentRenderer = null, e._currentRenderer2 = null, e;
		}, e.createElement = function(e, t, n) {
			for (var r = 2; r < arguments.length; r++) ne(arguments[r]);
			r = {};
			var i = null;
			if (t != null) for (c in ke || !("__self" in t) || "key" in t || (ke = !0, console.warn("Your app (or one of its dependencies) is using an outdated JSX transform. Update to the modern JSX transform for faster performance: https://react.dev/link/new-jsx-transform")), m(t) && (u(t.key), i = "" + t.key), t) A.call(t, c) && c !== "key" && c !== "__self" && c !== "__source" && (r[c] = t[c]);
			var a = arguments.length - 2;
			if (a === 1) r.children = n;
			else if (1 < a) {
				for (var o = Array(a), s = 0; s < a; s++) o[s] = arguments[s + 2];
				Object.freeze && Object.freeze(o), r.children = o;
			}
			if (e && e.defaultProps) for (c in a = e.defaultProps, a) r[c] === void 0 && (r[c] = a[c]);
			i && h(r, typeof e == "function" ? e.displayName || e.name || "Unknown" : e);
			var c = 1e4 > k.recentlyCreatedOwnerStacks++;
			return _(e, i, r, p(), c ? Error("react-stack-top-frame") : je, c ? De(f(e)) : Me);
		}, e.createRef = function() {
			var e = { current: null };
			return Object.seal(e), e;
		}, e.forwardRef = function(e) {
			e != null && e.$$typeof === _e ? console.error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof e == "function" ? e.length !== 0 && e.length !== 2 && console.error("forwardRef render functions accept exactly two parameters: props and ref. %s", e.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined.") : console.error("forwardRef requires a render function but was given %s.", e === null ? "null" : typeof e), e != null && e.defaultProps != null && console.error("forwardRef render functions do not support defaultProps. Did you accidentally pass a React component?");
			var t = {
				$$typeof: me,
				render: e
			}, n;
			return Object.defineProperty(t, "displayName", {
				enumerable: !1,
				configurable: !0,
				get: function() {
					return n;
				},
				set: function(t) {
					n = t, e.name || e.displayName || (Object.defineProperty(e, "name", { value: t }), e.displayName = t);
				}
			}), t;
		}, e.isValidElement = v, e.lazy = function(e) {
			e = {
				_status: -1,
				_result: e
			};
			var t = {
				$$typeof: ve,
				_payload: e,
				_init: oe
			}, n = {
				name: "lazy",
				start: -1,
				end: -1,
				value: null,
				owner: null,
				debugStack: Error("react-stack-top-frame"),
				debugTask: console.createTask ? console.createTask("lazy()") : null
			};
			return e._ioInfo = n, t._debugInfo = [{ awaited: n }], t;
		}, e.memo = function(e, t) {
			e ?? console.error("memo: The first argument must be a component. Instead received: %s", e === null ? "null" : typeof e), t = {
				$$typeof: _e,
				type: e,
				compare: t === void 0 ? null : t
			};
			var n;
			return Object.defineProperty(t, "displayName", {
				enumerable: !1,
				configurable: !0,
				get: function() {
					return n;
				},
				set: function(t) {
					n = t, e.name || e.displayName || (Object.defineProperty(e, "name", { value: t }), e.displayName = t);
				}
			}), t;
		}, e.startTransition = function(e) {
			var t = k.T, n = {};
			n._updatedFibers = /* @__PURE__ */ new Set(), k.T = n;
			try {
				var r = e(), i = k.S;
				i !== null && i(n, r), typeof r == "object" && r && typeof r.then == "function" && (k.asyncTransitions++, r.then(S, S), r.then(c, Fe));
			} catch (e) {
				Fe(e);
			} finally {
				t === null && n._updatedFibers && (e = n._updatedFibers.size, n._updatedFibers.clear(), 10 < e && console.warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.")), t !== null && n.types !== null && (t.types !== null && t.types !== n.types && console.error("We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."), t.types = n.types), k.T = t;
			}
		}, e.unstable_useCacheRefresh = function() {
			return x().useCacheRefresh();
		}, e.use = function(e) {
			return x().use(e);
		}, e.useActionState = function(e, t, n) {
			return x().useActionState(e, t, n);
		}, e.useCallback = function(e, t) {
			return x().useCallback(e, t);
		}, e.useContext = function(e) {
			var t = x();
			return e.$$typeof === fe && console.error("Calling useContext(Context.Consumer) is not supported and will cause bugs. Did you mean to call useContext(Context) instead?"), t.useContext(e);
		}, e.useDebugValue = function(e, t) {
			return x().useDebugValue(e, t);
		}, e.useDeferredValue = function(e, t) {
			return x().useDeferredValue(e, t);
		}, e.useEffect = function(e, t) {
			return e ?? console.warn("React Hook useEffect requires an effect callback. Did you forget to pass a callback to the hook?"), x().useEffect(e, t);
		}, e.useEffectEvent = function(e) {
			return x().useEffectEvent(e);
		}, e.useId = function() {
			return x().useId();
		}, e.useImperativeHandle = function(e, t, n) {
			return x().useImperativeHandle(e, t, n);
		}, e.useInsertionEffect = function(e, t) {
			return e ?? console.warn("React Hook useInsertionEffect requires an effect callback. Did you forget to pass a callback to the hook?"), x().useInsertionEffect(e, t);
		}, e.useLayoutEffect = function(e, t) {
			return e ?? console.warn("React Hook useLayoutEffect requires an effect callback. Did you forget to pass a callback to the hook?"), x().useLayoutEffect(e, t);
		}, e.useMemo = function(e, t) {
			return x().useMemo(e, t);
		}, e.useOptimistic = function(e, t) {
			return x().useOptimistic(e, t);
		}, e.useReducer = function(e, t, n) {
			return x().useReducer(e, t, n);
		}, e.useRef = function(e) {
			return x().useRef(e);
		}, e.useState = function(e) {
			return x().useState(e);
		}, e.useSyncExternalStore = function(e, t, n) {
			return x().useSyncExternalStore(e, t, n);
		}, e.useTransition = function() {
			return x().useTransition();
		}, e.version = "19.2.6", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
	})();
})), ho = /* @__PURE__ */ oe((/* @__PURE__ */ b(((e, t) => {
	process.env.NODE_ENV === "production" ? t.exports = po() : t.exports = mo();
})))(), 1), go = fo({
	tagName: "rtg-button",
	elementClass: I,
	react: ho.default
}), _o = fo({
	tagName: "rtg-checkbox",
	elementClass: z,
	react: ho.default
});
//#endregion
export { ot as Accordion, rt as AccordionContent, F as AccordionItem, it as AccordionTrigger, st as Alert, ut as AlertAction, lt as AlertDescription, ct as AlertTitle, ft as AspectRatio, pt as Avatar, gt as AvatarBadge, ht as AvatarFallback, _t as AvatarGroup, vt as AvatarGroupCount, mt as AvatarImage, yt as Badge, Dt as BreadCrumb, xt as BreadCrumbEllipsis, St as BreadCrumbItem, Ct as BreadCrumbLink, wt as BreadCrumbList, Tt as BreadCrumbSeparator, Et as BreadCrumbText, I as Button, go as ButtonReact, Ft as Calendar, It as Card, Bt as CardAction, Vt as CardContent, zt as CardDescription, Ht as CardFooter, Lt as CardHeader, Rt as CardTitle, Qt as Carousel, z as Checkbox, _o as CheckboxReact, tn as Collapsible, en as CollapsibleContent, $t as CollapsibleTrigger, V as ComboBox, ln as ComboBoxEmpty, sn as ComboBoxGroup, cn as ComboBoxInput, B as ComboBoxItem, rn as ComboBoxTrigger, an as ComboBoxValue, xn as Command, fn as CommandEmpty, mn as CommandGroup, hn as CommandInput, _n as CommandItem, vn as CommandList, bn as CommandSeparator, An as ContextMenu, Sn as ContextMenuCheckboxItem, Cn as ContextMenuContent, wn as ContextMenuGroup, Tn as ContextMenuItem, En as ContextMenuRadioItem, Dn as ContextMenuSeparator, On as ContextMenuShortcut, kn as ContextTrigger, $ as DataTable, In as DatePicker, Yn as Dialog, zn as DialogClose, Vn as DialogContent, Hn as DialogFooter, Un as DialogHeader, Wn as DialogOverlay, Kn as DialogTrigger, or as Drawer, Qn as DrawerClose, $n as DrawerContent, er as DrawerDescription, tr as DrawerFooter, nr as DrawerHeader, rr as DrawerOverlay, ir as DrawerTitle, ar as DrawerTrigger, gr as DropdownMenu, sr as DropdownMenuCheckboxItem, lr as DropdownMenuContent, ur as DropdownMenuGroup, dr as DropdownMenuItem, fr as DropdownMenuRadioItem, pr as DropdownMenuSeparator, mr as DropdownMenuShortcut, hr as DropdownMenuTrigger, _r as Empty, vr as EmptyContent, yr as EmptyDescription, br as EmptyHeader, xr as EmptyMedia, Sr as EmptyTitle, Er as Field, Dr as FieldContent, jr as FieldDescription, Nr as FieldError, Tr as FieldGroup, kr as FieldLabel, wr as FieldLegend, Mr as FieldSeparator, Cr as FieldSet, Ar as FieldTitle, ei as HoverCard, $r as HoverCardTrigger, Qr as HoverContent, G as Input, ti as InputGroup, ni as InputGroupAddon, ri as InputGroupButton, K as InputGroupInput, ii as InputGroupText, J as InputGroupTextarea, Y as InputOTP, ai as InputOTPGroup, si as InputOTPSeparator, oi as InputOTPSlot, ci as Item, li as ItemActions, ui as ItemContent, di as ItemDescription, fi as ItemFooter, pi as ItemGroup, mi as ItemHeader, hi as ItemMedia, gi as ItemSeparator, _i as ItemTitle, vi as Kbd, yi as KbdGroup, Or as Label, oo as LightSampleDemo, Pi as Menubar, xi as MenubarCheckboxItem, Ci as MenubarContent, Ti as MenubarGroup, Di as MenubarItem, Si as MenubarMenu, ki as MenubarRadioItem, ji as MenubarSeparator, Mi as MenubarShortcut, Ni as MenubarTrigger, Vi as NavigationMenu, Ri as NavigationMenuContent, Li as NavigationMenuItem, zi as NavigationMenuLink, Ii as NavigationMenuList, Bi as NavigationMenuTrigger, Yi as Pagination, Ui as PaginationContent, Wi as PaginationEllipsis, Ki as PaginationItem, Gi as PaginationLink, qi as PaginationNext, Ji as PaginationPrevious, Z as PasswordInput, Pn as Popover, Mn as PopoverContent, Nn as PopoverTrigger, Zi as Progress, ta as RadioGroup, ea as RadioGroupItem, Xr as RtgForm, Ir as RtgFormController, Wr as RtgFormDescription, Kr as RtgFormField, qr as RtgFormItem, Jr as RtgFormLabel, Yr as RtgFormMessage, ra as RtgScrollArea, ha as RtgSkeleton, oa as Select, sa as SelectGroup, ca as SelectItem, la as SelectLabel, ua as SelectList, da as SelectSeperator, fa as SelectTrigger, pa as SelectValue, on as Separator, ga as Spinner, va as Switch, za as TOGGLE_GROUP_SIZE, La as TOGGLE_GROUP_TYPE, Ra as TOGGLE_GROUP_VARIANT, Ga as TOGGLE_SIZE, Ka as TOGGLE_VARIANT, ya as Table, Ca as Tabs, Ea as TabsContent, wa as TabsList, Ta as TabsTrigger, q as Textarea, Ia as Toast, Ma as ToastAction, Na as ToastDescription, Pa as ToastTitle, Fa as ToastTrigger, Aa as ToastViewPort, Ya as Toggle, Wa as ToggleGroup, Xa as TypographyBlockquote, Za as TypographyCode, Qa as TypographyH, $a as TypographyLarge, eo as TypographyLead, to as TypographyList, no as TypographyMuted, ro as TypographyP, io as TypographySmall, ao as TypographyTable };
